var Ri = Object.defineProperty;
var ki = (t, o, n) => o in t ? Ri(t, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[o] = n;
var we = (t, o, n) => ki(t, typeof o != "symbol" ? o + "" : o, n);
import { jsx as c, Fragment as ee, jsxs as X } from "react/jsx-runtime";
import * as oe from "react";
import ne, { useRef as xe, useCallback as Y, useEffect as ie, useState as U, createContext as gt, useContext as kt, useMemo as re, memo as tn, Fragment as Lt, cloneElement as Li, forwardRef as rr, useImperativeHandle as Oi, Component as zi, createElement as uo } from "react";
import { chunk as Rn, some as ir, toNumber as ut, sortBy as Mi, first as Tt, take as Pi, isNaN as lr, isEmpty as sr, trim as ho, toString as Ei, find as ar, last as cn, range as dn } from "lodash";
import { GetScrapsExistenceGateway as Ni, GetScrapsCountGateway as $i, DeleteScrapGateway as Gi, CreateScrapGateway as Di, GetScrapCategoriesGateway as Ai, GetScrapsGateway as Wi, GetRemodelingComponentData as Ui, GetRemodelingComponentList as Hi, GetRemodelingTemplateInfo as Bi, GetRemodelingGnbList as ji, GetRemodelingDisplayInfo as Fi, GetPopupLists as Vi, GetTemplateComponentsPreview as qi, GetTemplateComponents as cr, GetTemplateComponentsPreviewData as Ki, GetTemplateComponentsData as dr, GetTemplateInfiniteComponentsData as ur, GetScraps as hr, PostScraps as fr, DeleteScraps as pr, makeAppLink as Oe, getCdnImage as bt, UnlikeGoodsEvaluationGateway as Yi, LikeGoodsEvaluationGateway as Xi, GetGoodsEvaluationDetailGateway as Qi, getResizeImage as gr } from "@display-component/shared";
import { parse as Zi, format as vr, differenceInDays as Ji } from "date-fns";
import Qt from "query-string";
import Zt from "swr";
import mr from "swr/infinite";
import q, { css as Fe } from "styled-components";
import { v4 as Ot } from "uuid";
import { Swiper as vt, SwiperSlide as mt } from "swiper/react";
import yr from "react-is";
import { Autoplay as Wn, Navigation as el, EffectCreative as tl } from "swiper";
import { Box as J, HStack as De, Icongraphy as fo, VStack as Me, IconButton as Jt, Text as St, NewContentButton as Un, BasicPopup as nl, CapsuleQuickLinkUnit as ol, SquareQuickLinkUnit as rl, CirecleQuickLinkUnit as il, MovePagination as ze, FilterChip as ll, ImgChip as sl, LineBannerUnit as wr, ThumbnailContentUnit as al, CircleHorizontalityContentUnit as cl, SquareHorizontalityContentUnit as dl, SquareVerticalContentUnit as ul, VerticalContentUnit as hl, LineIndicator as Hn, NumberIndicator as Sr, dimmed as fl, FullBannerUnit as pl, TimeBannerUnit as kn, CoordinatedSquareBannerUnit as po, ThumbnailProductUnit as Cr, FreeBannerUnit as gl, BandBannerUnit as Ln, HorizontalBannerUnit as vl, SquareBannerUnit as On, HorizontalityProductUnit as ml, VerticalProductUnit as yl, TitleUnit as wl } from "@design-system/pc";
function Sl() {
  var t = xe(!1), o = Y(function() {
    return t.current;
  }, []);
  return ie(function() {
    return t.current = !0, function() {
      t.current = !1;
    };
  }, []), o;
}
var Cl = function(t) {
  t === void 0 && (t = {});
  var o = U(t), n = o[0], e = o[1], r = Y(function(i) {
    e(function(l) {
      return Object.assign({}, l, i instanceof Function ? i(l) : i);
    });
  }, []);
  return [n, r];
};
function _r(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var _l = function() {
  var t = document.getSelection();
  if (!t.rangeCount)
    return function() {
    };
  for (var o = document.activeElement, n = [], e = 0; e < t.rangeCount; e++)
    n.push(t.getRangeAt(e));
  switch (o.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      o.blur();
      break;
    default:
      o = null;
      break;
  }
  return t.removeAllRanges(), function() {
    t.type === "Caret" && t.removeAllRanges(), t.rangeCount || n.forEach(function(r) {
      t.addRange(r);
    }), o && o.focus();
  };
}, bl = _l, go = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, xl = "Copy to clipboard: #{key}, Enter";
function Tl(t) {
  var o = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return t.replace(/#{\s*key\s*}/g, o);
}
function Il(t, o) {
  var n, e, r, i, l, s, a = !1;
  o || (o = {}), n = o.debug || !1;
  try {
    r = bl(), i = document.createRange(), l = document.getSelection(), s = document.createElement("span"), s.textContent = t, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(u) {
      if (u.stopPropagation(), o.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var f = go[o.format] || go.default;
          window.clipboardData.setData(f, t);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(o.format, t);
      o.onCopy && (u.preventDefault(), o.onCopy(u.clipboardData));
    }), document.body.appendChild(s), i.selectNodeContents(s), l.addRange(i);
    var d = document.execCommand("copy");
    if (!d)
      throw new Error("copy command was unsuccessful");
    a = !0;
  } catch (u) {
    n && console.error("unable to copy using execCommand: ", u), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(o.format || "text", t), o.onCopy && o.onCopy(window.clipboardData), a = !0;
    } catch (f) {
      n && console.error("unable to copy using clipboardData: ", f), n && console.error("falling back to prompt"), e = Tl("message" in o ? o.message : xl), window.prompt(e, t);
    }
  } finally {
    l && (typeof l.removeRange == "function" ? l.removeRange(i) : l.removeAllRanges()), s && document.body.removeChild(s), r();
  }
  return a;
}
var Rl = Il;
const kl = /* @__PURE__ */ _r(Rl);
var Ll = function() {
  var t = Sl(), o = Cl({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), n = o[0], e = o[1], r = Y(function(i) {
    if (t()) {
      var l, s;
      try {
        if (typeof i != "string" && typeof i != "number") {
          var a = new Error("Cannot copy typeof " + typeof i + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(a), e({
            value: i,
            error: a,
            noUserInteraction: !0
          });
          return;
        } else if (i === "") {
          var a = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(a), e({
            value: i,
            error: a,
            noUserInteraction: !0
          });
          return;
        }
        s = i.toString(), l = kl(s), e({
          value: s,
          error: void 0,
          noUserInteraction: l
        });
      } catch (d) {
        e({
          value: s,
          error: d,
          noUserInteraction: l
        });
      }
    }
  }, []);
  return [n, r];
};
const tf = () => {
  const [{ error: t }, o] = Ll();
  return { handleCopy: Y(
    (e) => (o(e), t),
    [o, t]
  ) };
}, zn = gt({
  hosts: null,
  httpClient: null,
  tagGTM: null
}), le = () => {
  const t = kt(zn);
  if (t === void 0)
    throw new Error(
      "useDisplayComponent must be used within a DisplayComponentContext"
    );
  return t;
}, nf = ({
  hosts: t,
  httpClient: o,
  tagGTM: n,
  children: e
}) => /* @__PURE__ */ c(zn.Provider, { value: { hosts: t, httpClient: o, tagGTM: n }, children: /* @__PURE__ */ c(zn.Consumer, { children: (r) => /* @__PURE__ */ c(ee, { children: e }) }) }), br = gt({ indicatorPercent: 0, setIndicatorPercent: () => {
} }), zt = () => {
  const t = kt(br);
  if (t === void 0)
    throw new Error(
      "useHorizontalPercent must be used within a HorizontalPercentContext"
    );
  return t;
}, Ol = ({
  children: t
}) => {
  const [o, n] = U(0);
  return /* @__PURE__ */ c(
    br.Provider,
    {
      value: { indicatorPercent: o, setIndicatorPercent: n },
      children: t
    }
  );
}, of = (t, o) => ({
  getScraps: new Wi(t, o),
  getScrapCategories: new Ai(t, o),
  createScraps: new Di(t, o),
  deleteScraps: new Gi(t, o),
  getCount: new $i(t, o),
  isScraps: new Ni(t, o)
}), xr = (t, o) => ({
  getRemodelingComponentList: new Hi(
    t,
    o
  ),
  getRemodelingComponentData: new Ui(
    t,
    o
  )
}), Bn = (t, o) => ({
  getRemodelingDisplayInfo: new Fi(t, o),
  getRemodelingGnbList: new ji(t, o),
  getRemodelingTemplateInfo: new Bi(t, o)
}), zl = (t) => typeof t == "number" ? `${t}px` : t, Mn = (t) => String(t).replace(/\B(?=(\d{3})+(?!\d))/g, ","), Be = (t) => {
  for (const o in t)
    t[o] === void 0 ? delete t[o] : typeof t[o] == "object" && t[o] !== null && Be(t[o]);
  return t;
}, Dt = (t, o) => {
  console.error(`${t.message} - ${o.componentStack} - display`);
}, rf = (t) => {
  const o = {};
  return t && Object.keys(t).forEach((n) => {
    n in {} && (o[n] = t[n]);
  }), o;
}, Ml = (t) => {
  const o = t && (t == null ? void 0 : t.indexOf(".")) > 0 ? t == null ? void 0 : t.replaceAll(".", "-") : t;
  return o ? Zi(o, "yyyy-MM-dd HH:mm:ss", /* @__PURE__ */ new Date()) : void 0;
}, Pl = (t, o) => {
  const n = Ml(t);
  return n ? vr(n, o) : void 0;
}, vo = (t, o, n, e) => {
  if (n === "vertical" || o === 2 && t === 2)
    return Rn(e, Math.ceil(o));
  {
    const r = Math.ceil(e.length / t), i = Array.from({ length: r }, () => []);
    return e.forEach((l, s) => {
      i[Math.floor(s / t)].push(l);
    }), i;
  }
}, lf = (t, o) => Ji(new Date(o), new Date(t)), mo = (t, o) => {
  const n = new Date(t), e = o || ".";
  return vr(n, `yy${e}MM${e}dd`);
}, El = (t) => `#${t}`, it = (t, o) => ({
  getTemplateComponents: new Nl(
    t,
    o
  ),
  getTemplateInfiniteComponentsData: new $l(t, o),
  getScraps: new Gl(t, o),
  requestScraps: new Dl(t, o),
  getPopupList: new Vi(t, o)
}), at = (t) => t.map((n) => ({
  content: n.name,
  variant: n.style.toLowerCase(),
  color: n.styleColor,
  textColor: n.textColor
}));
class Nl {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    const n = document.cookie;
    let e = o;
    if (o.isPreview) {
      if (e = o, !e.templateId || !e.componentIdList)
        return { code: 10500, message: "error" };
    } else if (e = o, e != null && e.rdId && (e.pageIdentificationValue = "RD_PC", e.detailCode = e.rdId, e.rdId = void 0), !e.pageIdentificationValue)
      return { code: 10500, message: "error" };
    return await Promise.all([
      o.isPreview ? new qi(this.host, this.httpClient).exec(
        e
      ) : new cr(this.host, this.httpClient).exec(
        e,
        n
      ),
      o.isPreview ? new Ki(this.host, this.httpClient).exec(
        e
      ) : new dr(this.host, this.httpClient).exec(
        e,
        n
      )
    ]).then((i) => {
      var h, p, g, m, C, w, S, M, z, R, P, A, _;
      const [l, s] = i, a = s != null && s.data ? [...s == null ? void 0 : s.data] : [], d = ((h = l == null ? void 0 : l.data) == null ? void 0 : h.displayComponentList) || [], u = [];
      e: for (let $ = 0; $ < d.length; $++) {
        const E = d[$].componentId;
        if (!ir(a, { componentId: E }))
          continue;
        const W = d[$].componentType, v = {
          ...d[$]
        };
        let G = "quicklinkResponse", b = "퀵링크 속성";
        switch (W) {
          case "BANNER":
            G = "bannerResponse", b = "배너 속성";
            break;
          case "CONTENTS":
            G = "contentsResponse", b = "콘텐츠 속성";
            break;
          case "GOODS":
            G = "goodsResponse", b = "굿즈 속성";
            break;
        }
        const L = d[$].componentAttributeInfo, x = L[G];
        if (x.header.title && (x.header.title.data1 = x.header.title.data1 ?? "", x.header.title.data2 = x.header.title.data2 ?? ""), x.header.subTitle && (x.header.subTitle.data1 = x.header.subTitle.data1 ?? "", x.header.subTitle.data2 = x.header.subTitle.data2 ?? ""), x.header.tooltip) {
          x.header.tooltip.title = x.header.tooltip.title ?? "", x.header.tooltip.desc = x.header.tooltip.desc ?? "";
          let y = x.header.tooltip.iconType || "";
          switch (y) {
            case "INFORMATION":
            case "NOTICE":
              y = "ic_information";
              break;
            case "QUESTION":
              y = "ic_question";
              break;
          }
          x.header.tooltip.iconType = y;
        }
        if (x.header.moreView && x.header.moreView.isUse && (x.header.moreView.buttonName = x.header.moreView.buttonName || "더보기"), o.isPreview)
          Object.assign(x.header, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_header`,
              "template-id": (g = l.data) == null ? void 0 : g.templateId,
              "component-id": E
            })
          });
        else {
          const y = o;
          Object.assign(x.header, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_header`,
              "template-id": (p = l.data) == null ? void 0 : p.templateId,
              "component-id": E,
              "page-id-value": y.pageIdentificationValue,
              "category-id": (y == null ? void 0 : y.categoryNo) || void 0
            })
          });
        }
        const Z = (x.body.display.displayType || "").toLowerCase();
        if (x.body.display) {
          const y = (x.body.display.displayType || "GALLERY").toLowerCase();
          Object.assign(x.body, { display: y });
        }
        if (x.body.paging) {
          const y = x.body.paging.pagingType === "INFINITY" ? "infinity" : "default";
          Object.assign(x.body, {
            paging: y,
            isInfinity: y === "infinity"
          });
        }
        if (x.body.viewForm) {
          if (x.body.viewForm.horizontalType) {
            const y = ut(
              x.body.viewForm.horizontalType.replace("HORIZONTAL_", "").replace("_", ".")
            );
            Object.assign(x.body, { horizontalType: y });
          }
          if (x.body.viewForm.verticalType) {
            const y = ut(
              x.body.viewForm.verticalType.split("VERTICAL_")[1]
            );
            Object.assign(x.body, { verticalType: y });
          }
        }
        if (x.body.scroll) {
          const y = x.body.scroll.scrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(x.body, { scroll: y });
        }
        if (x.body.unit) {
          let y = x.body.unit.unitType;
          switch (W) {
            case "QUICKLINK":
              switch (x.body.unit.unitType) {
                case "ICON_CIRCLE":
                  y = "circle";
                  break;
                case "ICON_SQUARE":
                  y = "square";
                  break;
                case "CAPSULE":
                  y = "capsule";
                  break;
              }
              break;
            case "BANNER":
              y = (x.body.unit.unitType || "vertical").replace("_BANNER", "").toLocaleLowerCase();
              break;
            case "CONTENTS":
              y = (x.body.unit.unitType || "normal").toLocaleLowerCase();
              break;
            case "GOODS":
              y = (x.body.unit.unitType || "").toLocaleLowerCase();
              break;
          }
          Object.assign(x.body, { unit: y });
        }
        if (x.body.chipUnit && Object.assign(x.body, {
          chipUnit: {
            ...x.body.chipUnit,
            chipUnitType: x.body.chipUnit.chipUnitType === "TEXT" ? "filter" : "image"
          }
        }), (m = x.body) != null && m.thumbnail) {
          const y = x.body.thumbnail.ratio.split("_");
          Object.assign(x.body, {
            thumbnail: y[0].toLowerCase()
          });
        }
        if (x.body.leftRightSpace && Object.assign(x.body, {
          leftRightSpace: x.body.leftRightSpace.isLeftRightSpace
        }), x.body.groupScroll) {
          const y = x.body.groupScroll.groupScrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(x.body, { groupScroll: y });
        }
        if ((C = x.body) != null && C.textLocation) {
          const y = ((w = x.body) == null ? void 0 : w.textLocation.textLocationType) === "BANNER_INNER" ? "in" : "out";
          Object.assign(x.body, {
            titleType: y,
            titleOutBgColor: (S = x.body) == null ? void 0 : S.textLocation.textBackGroundColor
          });
        }
        if (o.isPreview)
          Object.assign(x.body, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_body`,
              "template-id": (z = l.data) == null ? void 0 : z.templateId,
              "component-id": E
            })
          });
        else {
          const y = o;
          Object.assign(x.body, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_body`,
              "template-id": (M = l.data) == null ? void 0 : M.templateId,
              "component-id": E,
              "page-id-value": y.pageIdentificationValue,
              "category-id": (y == null ? void 0 : y.categoryNo) || void 0
            })
          });
        }
        if (!o.isPreview && (e != null && e.detailCode)) {
          let y = "R";
          if (x.body.dataRegistration.homeIdeaSortType)
            switch (x.body.dataRegistration.homeIdeaSortType) {
              case "LATEST":
                y = "R";
                break;
              case "ALLTIME":
                y = "F";
                break;
              case "RECENT":
                y = "N";
                break;
            }
          x.header.moreView.appLinkInfoDto.linkUrl = `${(R = x.header.moreView.appLinkInfoDto.linkUrl) == null ? void 0 : R.replace(
            "{id}",
            e == null ? void 0 : e.detailCode
          )}?sort=${y}`;
        }
        let j = "groupDataList";
        if (Z === "gallery")
          switch (W) {
            case "QUICKLINK":
              j = "quicklinkDataList";
              break;
            case "BANNER":
              j = "bannerDataList";
              break;
            case "CONTENTS":
              j = "contentsDataList";
              break;
            case "GOODS":
              j = "goodsDataList";
              break;
          }
        if (x.footer.landing && x.footer.landing.isUse && (x.footer.landing.buttonName = x.footer.landing.buttonName || "더보기"), o.isPreview)
          Object.assign(x.footer, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_footer`,
              "template-id": (A = l.data) == null ? void 0 : A.templateId,
              "component-id": E
            })
          });
        else {
          const y = o;
          Object.assign(x.footer, {
            gtm: Be({
              taggtm: `display_${W.toLocaleLowerCase()}_footer`,
              "template-id": (P = l.data) == null ? void 0 : P.templateId,
              "component-id": E,
              "page-id-value": y.pageIdentificationValue,
              "category-id": (y == null ? void 0 : y.categoryNo) || void 0
            })
          });
        }
        Object.assign(v, {
          dataType: j === "groupDataList" ? "group" : "default"
        }), Object.assign(x, { attributeResponse: b }), Object.assign(v, { attribute: x }), delete L.quicklinkResponse, delete L.bannerResponse, delete L.contentsResponse, delete L.goodsResponse;
        for (let y = 0; y < a.length; y++)
          if (a[y].componentId === E) {
            if (j === "goodsDataList") {
              if (a[y].goodsDataList.content)
                for (let N = 0; N < a[y].goodsDataList.content.length; N++) {
                  const K = a[y].goodsDataList.content[N];
                  if (K.goodsTagInfoDtoList && K.goodsTagInfoDtoList.length > 0) {
                    const H = at(
                      K.goodsTagInfoDtoList
                    );
                    Object.assign(K, { goodsTagInfoDtoList: H });
                  }
                }
            } else if (j === "contentsDataList" && a[y].contentsDataList.content)
              for (let N = 0; N < a[y].contentsDataList.content.length; N++) {
                const K = a[y].contentsDataList.content[N];
                if (K.tagInfoDto && K.tagInfoDto.length > 0) {
                  const H = at(
                    K.tagInfoDto
                  );
                  Object.assign(K, { goodsTagInfoDtoList: H });
                }
                if (K.imageInfo.tagInfo && K.imageInfo.tagInfo.length > 0) {
                  const H = at(K.imageInfo.tagInfo);
                  Object.assign(K.imageInfo, {
                    tagInfo: H
                  });
                }
              }
            if (Z === "gallery") {
              if (!(((_ = a[y][j]) == null ? void 0 : _.content) || []).length)
                continue e;
              Object.assign(v, {
                data: a[y][j] ?? {
                  content: []
                }
              });
            } else {
              if (!(a[y][j] || []).length)
                continue e;
              Object.assign(v, {
                data: {
                  content: a[y][j] ?? []
                }
              });
            }
            if (j === "groupDataList" && a[y][j])
              for (let N = 0; N < a[y][j].length; N++) {
                const K = a[y].groupUnitType || "", H = a[y][j][N];
                let B, I, V = "";
                if (W === "BANNER" && Z === "group" && K === "COORDINATE" ? (B = H.goodsListResponse, V = "goods", I = "나는 배너 리스펀스에서 나왔지롱") : W === "BANNER" ? (B = H.bannerListResponse, V = "banner", I = "나는 배너 리스펀스에서 나왔지롱") : W === "CONTENTS" ? (B = H.contentsListResponse, V = "contents", I = "나는 콘텐츠 리스펀스에서 나왔지롱") : W === "GOODS" && (V = "goods", B = H.goodsListResponse, I = "나는 굿즈 리스펀스에서 나왔지롱"), B && (B != null && B.content) && (B == null ? void 0 : B.content.length) > 0 && (V === "goods" || V === "contents"))
                  for (let T = 0; T < B.content.length; T++) {
                    const F = B.content[T];
                    if (V === "goods") {
                      if (F.goodsTagInfoDtoList && F.goodsTagInfoDtoList.length > 0) {
                        const Q = at(
                          F.goodsTagInfoDtoList
                        );
                        Object.assign(F, { goodsTagInfoDtoList: Q });
                      }
                    } else if (V === "contents") {
                      if (F.tagInfoDto && F.tagInfoDto.length > 0) {
                        const Q = at(
                          F.tagInfoDto
                        );
                        Object.assign(F, { goodsTagInfoDtoList: Q });
                      }
                      if (F.imageInfo.tagInfo && F.imageInfo.tagInfo.length > 0) {
                        const Q = at(
                          F.imageInfo.tagInfo
                        );
                        Object.assign(F.imageInfo, {
                          tagInfo: Q
                        });
                      }
                    }
                  }
                delete H.bannerListResponse, delete H.contentsListResponse, delete H.goodsListResponse, B && (B != null && B.content) && (B.content = B.content.map((T) => (!(T != null && T.appLinkTarget) && (T != null && T.linkUrl) && Object.assign(T, {
                  appLinkTarget: "URL",
                  linkUrl: T.linkUrl
                }), T))), Object.assign(H, {
                  data: B && (B != null && B.content) ? B : { ...B, content: [] },
                  TEST_RESPONSE: I
                });
              }
            a.splice(y, 1);
          }
        u.push(v);
      }
      return i.filter(($) => $.code === 200).length < 2 ? { code: 10500, message: "error" } : { ...i[0], data: u };
    });
  }
}
class $l {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    const n = document.cookie, e = await new ur(
      this.host,
      this.httpClient
    ).exec(o, n);
    if (e.code === 200) {
      let r;
      e.data && (r = e.data.map(
        (i) => {
          let l = "";
          switch (i.componentType) {
            case "QUICKLINK":
              l = "quicklinkDataList";
              break;
            case "BANNER":
              l = "bannerDataList";
              break;
            case "CONTENTS":
              l = "contentsDataList";
              break;
            case "GOODS":
              l = "goodsDataList";
              break;
          }
          const s = (i.displayType || "").toLowerCase(), a = i[l];
          return Object.assign(i, {
            display: s
          }), delete i.displayType, delete i.quicklinkDataList, delete i.bannerDataList, delete i.contentsDataList, delete i.goodsDataList, Object.assign(i, { ...a });
        }
      )), Object.assign(e, {
        data: r
      });
    }
    return e;
  }
}
class Gl {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    const n = await new hr(this.host, this.httpClient).exec();
    if (o && n.code === 200 && n.data) {
      const e = n.data.reduce((r, i) => {
        const l = `${i.scrapGbnCd}_${i.targetNo}${i.targetSubNo ? `_${i.targetSubNo}` : ""}`;
        return r[l] = !0, r;
      }, {});
      return { response: n, data: e };
    }
    return n;
  }
}
class Dl {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    return o.isUse ? await new fr(this.host, this.httpClient).exec({
      scrapGbnCd: o.scrapGbnCd,
      targetNo: o.targetNo,
      targetSubNo: o.targetSubNo
    }) : await new pr(this.host, this.httpClient).exec({
      scrapGbnCd: o.scrapGbnCd,
      targetNo: o.targetNo,
      targetSubNo: o.targetSubNo
    });
  }
}
const sf = (t, o) => ({
  getTemplateComponents: new Al(
    t,
    o
  ),
  getTemplateInfiniteComponentsData: new Wl(t, o),
  getScraps: new Ul(t, o),
  requestScraps: new Hl(t, o)
});
class Al {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o, n) {
    return o != null && o.rdId && (o.pageIdentificationValue = "RD_PC", o.detailCode = o.rdId, o.rdId = void 0), await Promise.all([
      new cr(this.host, this.httpClient).exec(o, n),
      new dr(this.host, this.httpClient).exec(
        o,
        n
      )
    ]).then((r) => {
      var f, h, p, g, m, C, w, S, M, z;
      const [i, l] = r, s = l != null && l.data ? [...l == null ? void 0 : l.data] : [], a = ((f = i == null ? void 0 : i.data) == null ? void 0 : f.displayComponentList) || [], d = [];
      e: for (let R = 0; R < a.length; R++) {
        const P = a[R].componentId;
        if (!ir(s, { componentId: P }))
          continue;
        const _ = a[R].componentType, $ = { ...a[R] };
        let E = "quicklinkResponse", k = "퀵링크 속성";
        switch (_) {
          case "BANNER":
            E = "bannerResponse", k = "배너 속성";
            break;
          case "CONTENTS":
            E = "contentsResponse", k = "콘텐츠 속성";
            break;
          case "GOODS":
            E = "goodsResponse", k = "굿즈 속성";
            break;
        }
        const W = a[R].componentAttributeInfo, v = W[E];
        if (v.header.title && (v.header.title.data1 = v.header.title.data1 ?? "", v.header.title.data2 = v.header.title.data2 ?? ""), v.header.subTitle && (v.header.subTitle.data1 = v.header.subTitle.data1 ?? "", v.header.subTitle.data2 = v.header.subTitle.data2 ?? ""), v.header.tooltip) {
          v.header.tooltip.title = v.header.tooltip.title ?? "", v.header.tooltip.desc = v.header.tooltip.desc ?? "";
          let L = v.header.tooltip.iconType || "";
          switch (L) {
            case "INFORMATION":
            case "NOTICE":
              L = "ic_information";
              break;
            case "QUESTION":
              L = "ic_question";
              break;
          }
          v.header.tooltip.iconType = L;
        }
        v.header.moreView && v.header.moreView.isUse && (v.header.moreView.buttonName = v.header.moreView.buttonName || "더보기"), Object.assign(v.header, {
          gtm: Be({
            tagGTM: `display_${_.toLocaleLowerCase()}_header`,
            taggtm: `display_${_.toLocaleLowerCase()}_header`,
            "template-id": (h = i.data) == null ? void 0 : h.templateId,
            "component-id": P,
            "page-id-value": o.pageIdentificationValue,
            "category-id": (o == null ? void 0 : o.categoryNo) || void 0
          })
        });
        const G = (v.body.display.displayType || "").toLowerCase();
        if (v.body.display) {
          const L = (v.body.display.displayType || "GALLERY").toLowerCase();
          Object.assign(v.body, { display: L });
        }
        if (v.body.paging) {
          const L = v.body.paging.pagingType === "INFINITY" ? "infinity" : "default";
          Object.assign(v.body, {
            paging: L,
            isInfinity: L === "infinity"
          });
        }
        if (v.body.viewForm) {
          if (v.body.viewForm.horizontalType) {
            const L = ut(
              v.body.viewForm.horizontalType.replace("HORIZONTAL_", "").replace("_", ".")
            );
            Object.assign(v.body, { horizontalType: L });
          }
          if (v.body.viewForm.verticalType) {
            const L = ut(
              v.body.viewForm.verticalType.split("VERTICAL_")[1]
            );
            Object.assign(v.body, { verticalType: L });
          }
        }
        if (v.body.scroll) {
          const L = v.body.scroll.scrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(v.body, { scroll: L });
        }
        if (v.body.unit) {
          let L = v.body.unit.unitType;
          switch (_) {
            case "QUICKLINK":
              switch (v.body.unit.unitType) {
                case "ICON_CIRCLE":
                  L = "circle";
                  break;
                case "ICON_SQUARE":
                  L = "square";
                  break;
                case "CAPSULE":
                  L = "capsule";
                  break;
              }
              break;
            case "BANNER":
              L = (v.body.unit.unitType || "vertical").replace("_BANNER", "").toLocaleLowerCase();
              break;
            case "CONTENTS":
              L = (v.body.unit.unitType || "normal").toLocaleLowerCase();
              break;
            case "GOODS":
              L = (v.body.unit.unitType || "").toLocaleLowerCase();
              break;
          }
          Object.assign(v.body, { unit: L });
        }
        if (v.body.chipUnit && Object.assign(v.body, {
          chipUnit: {
            ...v.body.chipUnit,
            chipUnitType: v.body.chipUnit.chipUnitType === "TEXT" ? "filter" : "image"
          }
        }), v.body.leftRightSpace && Object.assign(v.body, {
          leftRightSpace: v.body.leftRightSpace.isLeftRightSpace
        }), v.body.groupScroll) {
          const L = v.body.groupScroll.groupScrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(v.body, { groupScroll: L });
        }
        if ((p = v.body) != null && p.textLocation) {
          const L = ((g = v.body) == null ? void 0 : g.textLocation.textLocationType) === "BANNER_INNER" ? "in" : "out";
          Object.assign(v.body, {
            titleType: L,
            titleOutBgColor: (m = v.body) == null ? void 0 : m.textLocation.textBackGroundColor
          });
        }
        if (o != null && o.detailCode) {
          let L = "R";
          if (v.body.dataRegistration.homeIdeaSortType)
            switch (v.body.dataRegistration.homeIdeaSortType) {
              case "LATEST":
                L = "R";
                break;
              case "ALLTIME":
                L = "F";
                break;
              case "RECENT":
                L = "N";
                break;
            }
          v.header.moreView.appLinkInfoDto.linkUrl = `${(C = v.header.moreView.appLinkInfoDto.linkUrl) == null ? void 0 : C.replace(
            "{id}",
            o == null ? void 0 : o.detailCode
          )}?sort=${L}`;
        }
        Object.assign(v.body, {
          gtm: Be({
            tagGTM: `display_${_.toLocaleLowerCase()}_body`,
            taggtm: `display_${_.toLocaleLowerCase()}_body`,
            "template-id": (w = i.data) == null ? void 0 : w.templateId,
            "component-id": P,
            "page-id-value": o.pageIdentificationValue,
            "category-id": (o == null ? void 0 : o.categoryNo) || void 0
          })
        });
        let b = "groupDataList";
        if (G === "gallery")
          switch (_) {
            case "QUICKLINK":
              b = "quicklinkDataList";
              break;
            case "BANNER":
              b = "bannerDataList";
              break;
            case "CONTENTS":
              b = "contentsDataList";
              break;
            case "GOODS":
              b = "goodsDataList";
              break;
          }
        v.footer.landing && v.footer.landing.isUse && (v.footer.landing.buttonName = v.footer.landing.buttonName || "더보기"), Object.assign(v.footer, {
          gtm: Be({
            tagGTM: `display_${_.toLocaleLowerCase()}_footer`,
            taggtm: `display_${_.toLocaleLowerCase()}_footer`,
            "template-id": (S = i.data) == null ? void 0 : S.templateId,
            "component-id": P,
            "page-id-value": o.pageIdentificationValue,
            "category-id": (o == null ? void 0 : o.categoryNo) || void 0
          })
        }), Object.assign($, {
          dataType: b === "groupDataList" ? "group" : "default"
        }), Object.assign(v, { attributeResponse: k }), Object.assign($, { attribute: v }), delete W.quicklinkResponse, delete W.bannerResponse, delete W.contentsResponse, delete W.goodsResponse;
        for (let L = 0; L < s.length; L++)
          if (s[L].componentId === P) {
            if (b === "contentsDataList" && s[L].contentsDataList.content)
              for (let x = 0; x < s[L].contentsDataList.content.length; x++) {
                const Z = s[L].contentsDataList.content[x];
                if (Z.imageInfo.tagInfo && Z.imageInfo.tagInfo.length > 0) {
                  const j = Z.imageInfo.tagInfo.map((y) => ({
                    content: y.name,
                    variant: y.style.toLowerCase(),
                    color: y.styleColor,
                    textColor: y.textColor
                  }));
                  Object.assign(
                    Z.imageInfo.tagInfo,
                    j
                  );
                }
              }
            if (b === "goodsDataList" && s[L].goodsDataList.content)
              for (let x = 0; x < s[L].goodsDataList.content.length; x++) {
                const Z = s[L].goodsDataList.content[x];
                if (Z.goodsTagInfoDtoList && Z.goodsTagInfoDtoList.length > 0) {
                  const j = Z.goodsTagInfoDtoList.map(
                    (y) => ({
                      content: y.name,
                      variant: y.style.toLowerCase(),
                      color: y.styleColor,
                      textColor: y.textColor
                    })
                  );
                  Object.assign(Z, { goodsTagInfoDtoList: j });
                }
              }
            if (G === "gallery") {
              if (!(((M = s[L][b]) == null ? void 0 : M.content) || []).length)
                continue e;
              Object.assign($, {
                data: s[L][b] ?? {
                  content: []
                }
              });
            } else {
              if (!(s[L][b] || []).length)
                continue e;
              Object.assign($, {
                data: {
                  content: s[L][b] ?? []
                }
              });
            }
            if (b === "groupDataList" && s[L][b])
              for (let x = 0; x < s[L][b].length; x++) {
                const Z = s[L].groupUnitType || "", j = s[L][b][x];
                let y, N, K = !1;
                if (_ === "BANNER" && G === "group" && Z === "COORDINATE" ? (y = j.goodsListResponse, K = !0, N = "나는 배너 리스펀스에서 나왔지롱") : _ === "BANNER" ? (y = j.bannerListResponse, N = "나는 배너 리스펀스에서 나왔지롱") : _ === "CONTENTS" ? (y = j.contentsListResponse, N = "나는 콘텐츠 리스펀스에서 나왔지롱") : _ === "GOODS" && (K = !0, y = j.goodsListResponse, N = "나는 굿즈 리스펀스에서 나왔지롱"), y && (y != null && y.content) && K)
                  for (let H = 0; H < y.content.length; H++) {
                    const B = y.content[H];
                    if (B.goodsTagInfoDtoList && B.goodsTagInfoDtoList.length > 0) {
                      const I = B.goodsTagInfoDtoList.map(
                        (V) => ({
                          content: V.name,
                          variant: V.style.toLowerCase(),
                          color: V.styleColor,
                          textColor: V.textColor
                        })
                      );
                      Object.assign(B, { goodsTagInfoDtoList: I });
                    }
                  }
                delete j.bannerListResponse, delete j.contentsListResponse, delete j.goodsListResponse, Object.assign(j, {
                  data: y && (y != null && y.content) ? y : { ...y, content: [] },
                  TEST_RESPONSE: N
                });
              }
            s.splice(L, 1);
          }
        d.push($);
      }
      return r.filter((R) => R.code === 200).length < 2 ? { code: 10500, message: "error" } : o.hasTemplateInfo ? {
        ...r[0],
        data: {
          templateData: { templateName: (z = i.data) == null ? void 0 : z.templateName },
          componentData: d
        }
      } : { ...r[0], data: d };
    });
  }
}
class Wl {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o, n) {
    const e = await new ur(
      this.host,
      this.httpClient
    ).exec(o, n);
    if (e.code === 200) {
      let r;
      e.data && (r = e.data.map(
        (i) => {
          let l = "";
          switch (i.componentType) {
            case "QUICKLINK":
              l = "quicklinkDataList";
              break;
            case "BANNER":
              l = "bannerDataList";
              break;
            case "CONTENTS":
              l = "contentsDataList";
              break;
            case "GOODS":
              l = "goodsDataList";
              break;
          }
          const s = (i.displayType || "").toLowerCase(), a = i[l];
          return Object.assign(i, {
            display: s
          }), delete i.displayType, delete i.quicklinkDataList, delete i.bannerDataList, delete i.contentsDataList, delete i.goodsDataList, {
            ...i,
            data: a
          };
        }
      )), Object.assign(e, {
        data: r
      });
    }
    return e;
  }
}
class Ul {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    const n = o || {
      scrapGbnCd: "GA"
    };
    return o != null && o.scrapGbnCd || (n.scrapGbnCd = "GA"), await new hr(this.host, this.httpClient).exec();
  }
}
class Hl {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    return o.isUse ? await new fr(this.host, this.httpClient).exec(
      o
    ) : await new pr(this.host, this.httpClient).exec(
      o
    );
  }
}
const Ee = ({ component: t }) => {
  const [o, n] = U(), [e, r] = U(!1);
  ie(() => {
    t.componentData ? n(t.componentData) : r(!0);
  }, [t.componentData]);
  const { hosts: i, httpClient: l } = le();
  ie(() => {
    e && xr(i.hanssemApiGateway, l).getRemodelingComponentData.exec({
      dispComponentType: t.dispComponentType,
      dispComponentNo: t.dispComponentNo,
      ctgNo: t.ctgNo,
      componentLayoutCd: t.componentLayoutCd
    }).then((d) => {
      d && (d == null ? void 0 : d.code) === 200 && n(d == null ? void 0 : d.data), r(!1);
    });
  }, [
    t.componentLayoutCd,
    t.ctgNo,
    t.dispComponentNo,
    t.dispComponentType,
    i.hanssemApiGateway,
    l,
    e
  ]);
  const s = Y(
    () => Mi(o == null ? void 0 : o.componentDataList, "rNum"),
    [o == null ? void 0 : o.componentDataList]
  ), a = re(
    () => o == null ? void 0 : o.componentInfo.wiseLogParam,
    [o == null ? void 0 : o.componentInfo.wiseLogParam]
  );
  return {
    component: t,
    componentData: o,
    getComponentDataList: s,
    wiseLogParam: a
  };
}, Bl = ({ viewType: t, typeValue: o, dedupingInterval: n = 3e3 }) => {
  const { hosts: e, httpClient: r } = le(), i = re(() => {
    if (!(t && o && e.hanssemApiGateway)) return null;
    const a = Qt.stringify({ viewType: t, typeValue: o });
    return `${e.hanssemApiGateway}/hanssem/content-service/api/v1/display/gnb-list?${a}`;
  }, [e.hanssemApiGateway, o, t]), { data: l } = Zt(
    i,
    () => Bn(
      e.hanssemApiGateway,
      r
    ).getRemodelingGnbList.exec({ viewType: t, typeValue: o }),
    { dedupingInterval: n }
  );
  return {
    gnbList: re(() => (l == null ? void 0 : l.code) !== 200 ? null : l == null ? void 0 : l.data, [l == null ? void 0 : l.code, l == null ? void 0 : l.data])
  };
}, jl = ({
  apiType: t,
  dispTemplateNo: o,
  templateApiCd: n,
  ctgNo: e,
  custNo: r,
  pcId: i,
  snbCd: l,
  sort: s,
  channelCd: a,
  abTestGroup: d
}) => {
  const { hosts: u, httpClient: f } = le(), [h, p] = U();
  return ie(() => {
    t === "component-list" ? xr(u.hanssemApiGateway, f).getRemodelingComponentList.exec({
      dispTemplateNo: o,
      templateApiCd: n,
      ctgNo: e,
      abTestGroup: d
    }).then((g) => {
      (g == null ? void 0 : g.code) === 200 && p(g == null ? void 0 : g.data);
    }) : Bn(u.hanssemApiGateway, f).getRemodelingDisplayInfo.exec({
      dispTemplateNo: o,
      templateApiCd: n,
      ctgNo: e,
      custNo: r,
      pcId: i,
      snbCd: l,
      sort: s,
      channelCd: a,
      abTestGroup: d
    }).then((g) => {
      (g == null ? void 0 : g.code) === 200 && p(g == null ? void 0 : g.data);
    });
  }, [
    t,
    a,
    e,
    r,
    o,
    u.hanssemApiGateway,
    f,
    i,
    p,
    l,
    s,
    n
  ]), {
    template: h
  };
}, Fl = ({ typeValue: t }) => {
  const { hosts: o, httpClient: n } = le(), [e, r] = U();
  return ie(() => {
    Bn(o.hanssemApiGateway, n).getRemodelingTemplateInfo.exec({ typeValue: t }).then((i) => {
      (i == null ? void 0 : i.code) === 200 ? r(i == null ? void 0 : i.data) : r(null);
    });
  }, [o.hanssemApiGateway, n, t]), {
    templateInfo: e
  };
}, yt = ({
  autoConfigData: t,
  fetchSize: o = 50
}) => {
  const { httpClient: n } = le(), e = (h) => {
    const p = Qt.stringify({
      page: h + 1,
      size: o
    });
    return `${t == null ? void 0 : t.url}&${p}`;
  }, { data: r, size: i, setSize: l, isValidating: s } = mr(e, (h) => n.request({ url: h, method: "GET" })), a = re(() => {
    const h = r != null && r.map ? r == null ? void 0 : r.map((p) => {
      var g;
      return (g = p.data) == null ? void 0 : g.content;
    }) : void 0;
    return (h == null ? void 0 : h.reduce(
      (p = [], g = []) => p == null ? void 0 : p.concat(g)
    )) || [];
  }, [r]), d = re(
    () => {
      var h, p;
      return ((p = (h = Tt(r)) == null ? void 0 : h.data) == null ? void 0 : p.totalElements) || 0;
    },
    [r]
  ), u = Y(async () => {
    !s && a.length < d && i === (r == null ? void 0 : r.length) && await l(i + 1);
  }, [r == null ? void 0 : r.length, s, a.length, l, i, d]), f = Y(async () => {
    await l(1);
  }, [l]);
  return {
    items: a,
    totalItems: d,
    handleMore: u,
    handleInit: f
  };
}, jn = ({
  autoConfigData: t
}) => {
  const { httpClient: o } = le(), { data: n } = Zt(
    t == null ? void 0 : t.url,
    (r) => o.request({ url: r, method: "GET" })
  );
  return {
    categories: re(
      () => (n == null ? void 0 : n.code) === 200 ? n == null ? void 0 : n.data : void 0,
      [n]
    )
  };
}, af = () => {
  const t = xe(), [o, n] = U(null), [e, r] = U(null), i = Y(() => {
    t.current != null && (t.current > scrollY ? n("UP") : t.current < scrollY ? n("DOWN") : n(null)), t.current = scrollY, r(scrollY);
  }, [n]);
  return ie(() => (window.addEventListener("scroll", i), () => window.removeEventListener("scroll", i)), [i]), { direction: o, y: e };
}, Vl = (t) => {
  const o = xe(), n = xe(!1), e = xe(!1), [r, i] = U(0);
  n.current && (e.current = !0), ie(() => (n.current || (o.current = t(), n.current = !0), i((l) => l + 1), () => {
    e.current && o.current && o.current();
  }), []);
}, cf = ({
  pageIdentificationValue: t,
  categoryNo: o
}) => {
  const { hosts: n, httpClient: e } = le(), [r, i] = U([]);
  return ie(() => {
    it(n.hanssemApiGateway, e).getTemplateComponents.exec({ pageIdentificationValue: t, categoryNo: o }).then((l) => {
      i((l == null ? void 0 : l.data) || []);
    });
  }, [
    o,
    n.hanssemApiGateway,
    e,
    t
  ]), { data: r };
}, df = ({
  componentId: t,
  componentGroupDataId: o,
  page: n,
  size: e
}) => {
  const { hosts: r, httpClient: i } = le(), [l, s] = U([]);
  return ie(() => {
    it(r.hanssemApiGateway, i).getTemplateInfiniteComponentsData.exec({
      componentId: t,
      componentGroupDataId: o,
      page: n,
      size: e
    }).then((a) => {
      s(
        a.data || []
      );
    });
  }, [
    o,
    t,
    r.hanssemApiGateway,
    i,
    n,
    e
  ]), { data: l };
}, nn = ({
  verticalLineNumber: t,
  horizontalColumnLength: o,
  scrollDirection: n,
  unitData: e
}) => {
  const r = re(() => e.map((a, d) => ({ ...a, gtmIndex: d + 1 })), [e]), i = Y(() => {
    const a = Math.ceil(
      r.length / t
    ), d = Array.from({ length: a }, () => []);
    return Rn(r, t).forEach((f, h) => d[h] = f), d;
  }, [r, t]), l = Y(() => Pi(
    Rn(r, Math.ceil(o)),
    t
  ), [r, o, t]);
  return { convertedUnitData: re(() => n === "vertical" ? l() : i(), [l, i, n]) };
}, ge = ({
  space: t = "default",
  children: o,
  ...n
}) => {
  const e = re(() => {
    switch (t) {
      case "bottom_20":
        return [0, 0, 20, 0];
      case "none":
        return [0, 0, 0, 0];
      default:
        return [50, 0, 50, 0];
    }
  }, [t]);
  return /* @__PURE__ */ c(
    ql,
    {
      pt: e[0],
      pr: e[1],
      pb: e[2],
      pl: e[3],
      ...n,
      children: o
    }
  );
}, ql = q.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  padding-top: ${({ pt: t }) => t}px;
  padding-right: ${({ pr: t }) => t}px;
  padding-bottom: ${({ pb: t }) => t}px;
  padding-left: ${({ pl: t }) => t}px;
`, Te = ({ imgState: t = "square", ...o }) => {
  const { hosts: n } = le();
  return /* @__PURE__ */ c(Kl, { width: o.width, height: o.height, children: /* @__PURE__ */ c(
    Yl,
    {
      width: o.width,
      height: o.height,
      src: o.src,
      imgState: t,
      objectFit: o.objectFit,
      props: o,
      onError: ({ currentTarget: e }) => {
        e.src = `${n.remodelingAsset}/web/pc/assets/images/no_image.png`;
      }
    }
  ) });
}, Kl = q.div`
  display: flex;
  align-items: center;
  justify-items: center;
  width: ${({ width: t }) => t};
  height: ${({ height: t }) => t};
`, Yl = q.img`
  object-fit: ${({ objectFit: t }) => t || "contain"};
  object-position: center;
  border-radius: ${({ imgState: t }) => t === "circle" ? "50%" : "0% "};
`, Xl = {
  // neutral_colors
  neutral_colors: {
    primary: "#121212",
    gray: {
      700: "#666666",
      600: "#999999",
      500: "#B3B3B3",
      200: "#E2E2E2",
      100: "#EFEFEF",
      50: "#f7f7f7"
    },
    white: "#ffffff"
  },
  // accent_colors
  accent_colors: {
    primary: {
      default: "#121212",
      light: "#F9F9F9"
    },
    red: {
      default: "#FF3C3C",
      light: "#FFEEE9"
    },
    blue: {
      default: "#0064FF",
      light: "#ECF4FF"
    },
    yellow: {
      default: "#FFB43C",
      light: "#FFF4CB"
    },
    // dimmed
    dimmed: {
      1: "rgba(0, 0, 0, 0.5)",
      // BG
      2: "rgba(0, 0, 0, 0.74)",
      // toast
      3: "rgba(0, 0, 0, 0.20)",
      // img thumbnail
      4: "rgba(0, 0, 0, 0.70)"
      // img preview
    },
    // error
    error: "#FF3C3C"
  },
  favorite_color_chip: {
    black: "#121212",
    white: "#FFFFFF",
    gray: "#D9D9D9",
    beige: "#FFE9D6",
    oak: "#C9AD97",
    walnut: "#8F5D50",
    red: "#FF3C3C",
    pink: "#F9C3C7",
    yellow: "#F7D25F",
    green: "#006E3B",
    mint: "#BCE4DD",
    blue: "#71B0F0",
    navy: "#000F74"
  }
}, de = (t, o, n, e) => ({
  fontSize: t,
  fontWeight: o,
  lineHeight: n,
  letterSpacing: e
}), Ql = {
  // headline
  headline1: de("32px", 700, 1.2, "0em"),
  headline2: de("28px", 700, 1.4, "0em"),
  headline3: de("24px", 700, 1.4, "0em"),
  headline4: de("20px", 700, 1.4, "0em"),
  headline5: de("18px", 600, 1.4, "0em"),
  headline6: de("16px", 600, 1.4, "0em"),
  headline7: de("14px", 600, 1.4, "0em"),
  // subtitle
  subtitle1: de("32px", 500, 1.4, "0em"),
  subtitle2: de("28px", 500, 1.4, "0em"),
  subtitle3: de("24px", 500, 1.4, "0em"),
  subtitle4: de("20px", 500, 1.4, "0em"),
  subtitle5: de("18px", 500, 1.4, "0em"),
  subtitle6: de("16px", 500, 1.4, "0em"),
  subtitle7: de("14px", 500, 1.4, "0em"),
  // body
  body1: de("16px", 400, 1.4, "0em"),
  body2: de("14px", 400, 1.4, "0em"),
  // caption
  caption1: de("12px", 400, 1.4, "0em"),
  caption2: de("10px", 400, 1.4, "0em"),
  // button
  button: {
    xxlg_sb: de("20px", 500, 1, "0em"),
    xlg_sb: de("18px", 600, 1, "0em"),
    xlg_m: de("18px", 500, 1, "0em"),
    xlg_r: de("18px", 400, 1, "0em"),
    lg_b: de("16px", 700, 1, "0em"),
    lg_m: de("16px", 500, 1, "0em"),
    lg_r: de("16px", 400, 1, "0em"),
    md_b: de("14px", 700, 1, "0em"),
    md_m: de("14px", 500, 1, "0em"),
    md_r: de("14px", 400, 1, "0em"),
    sm_b: de("12px", 700, 1, "0em"),
    sm_m: de("12px", 500, 1, "0em"),
    sm_r: de("12px", 400, 1, "0em")
  },
  label: {
    lg_r: de("16px", 400, 1, "0em"),
    md_r: de("14px", 400, 1, "0em"),
    sm_r: de("12px", 400, 1, "0em")
  },
  // etc
  etc1: de("40px", 700, 1.4, "0em")
}, se = {
  colors: Xl,
  typography: Ql
}, Zl = {
  dividerGray: "#D9D9D9",
  center: {
    display: "flex",
    "justify-content": "center",
    "align-items": "center"
  }
}, uf = Fe`
  overflow: overlay;
  ::-webkit-scrollbar {
    width: 16px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    width: 4px;
    box-shadow: inset 6px 6px ${se.colors.neutral_colors.gray[200]};
    outline: none;
    border: 6px solid transparent;
    border-radius: 12px;
  }
`;
function Jl({ flagType: t = "default", children: o }) {
  return /* @__PURE__ */ c(es, { flagType: t, children: o });
}
const es = q.div`
  /* common */
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ flagType: t }) => t === "line" ? se.colors.neutral_colors.white : se.colors.neutral_colors.primary};
  border: 1px solid
    ${({ flagType: t }) => t === "line" ? se.colors.neutral_colors.gray[200] : se.colors.neutral_colors.primary};
  border-radius: 2px;
  width: fit-content;
  height: 21px;
  padding: 2px 6px;

  color: ${({ flagType: t }) => t === "line" ? se.colors.neutral_colors.primary : se.colors.neutral_colors.white};

  /* typography */
  ${se.typography.caption1};
`, ot = {
  c_lg_auto: {
    width: 376,
    height: 250
  },
  c_md_auto: {
    width: 376,
    height: 250
  },
  c_sm_auto: {
    width: 277,
    height: 184
  },
  d_md_tit: {
    width: 376,
    height: 376
  },
  d_md_auto: {
    width: 277,
    height: 277
  },
  d_sm_auto: {
    width: 277,
    height: 277
  }
}, Fn = "no-swiping", yo = 9, ts = 9999, hf = 1050, ff = 1100, ns = ts - 100, Pn = 24, Tr = 32, os = 8, rs = 12, is = 1170, qt = 32, Ye = 24, ls = ({
  item: t,
  imageSize: o = "c_lg_auto",
  isRecommendTagListVisible: n = !0
}) => {
  var e;
  return t ? /* @__PURE__ */ X(ss, { children: [
    /* @__PURE__ */ X(as, { imageSize: o, children: [
      t.goodsBadgeTypeCodeName && /* @__PURE__ */ c(cs, { children: /* @__PURE__ */ c(Jl, { flagType: "default", children: t.goodsBadgeTypeCodeName }) }),
      /* @__PURE__ */ c(
        Te,
        {
          src: t == null ? void 0 : t.imageUrl,
          alt: t == null ? void 0 : t.imageUrl,
          width: "100%",
          height: "100%",
          objectFit: "cover"
        }
      )
    ] }),
    /* @__PURE__ */ c(us, { children: t.goodsName }),
    n && (t == null ? void 0 : t.recommendationTagList) && ((e = t.recommendationTagList) == null ? void 0 : e.length) > 1 && /* @__PURE__ */ c(ds, { children: t.recommendationTagList.map((r, i) => /* @__PURE__ */ X(Lt, { children: [
      /* @__PURE__ */ c(hs, { children: r.keywordName }),
      i !== t.recommendationTagList.length - 1 && /* @__PURE__ */ c(fs, {})
    ] }, `recommendationTagList-${i}`)) })
  ] }) : /* @__PURE__ */ c(ee, {});
}, Ve = tn(ls), ss = q.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`, as = q.div`
  position: relative;
  border-radius: 2px;

  ${({ imageSize: t }) => Fe`
      height: ${() => {
  switch (t) {
    case "c_lg_auto":
      return ot.c_lg_auto.height;
    case "c_md_auto":
      return ot.c_md_auto.height;
    case "c_sm_auto":
      return ot.c_sm_auto.height;
    case "d_md_auto":
      return ot.d_md_auto.height;
    case "d_md_tit":
      return ot.d_md_tit.height;
    case "d_sm_auto":
      return ot.d_sm_auto.height;
    default:
      return ot.c_lg_auto.height;
  }
}}px;
    `};
`, cs = q.div`
  position: absolute;
  z-index: 9;
  top: 12px;
  left: 12px;
`, ds = q.div`
  display: inline-block;
  padding-top: 8px;
`, us = q.div`
  ${se.typography.body1};
  color: ${se.colors.accent_colors.primary.default};
  padding-top: 14px;
`, hs = q.span`
  ${se.typography.body2};
  color: ${se.colors.neutral_colors.gray[600]};
`, fs = q.span`
  width: 1px;
  height: 10px;
  margin: 0 8px;
  background-color: ${Zl.dividerGray};
  display: inline-block;
`;
function ve(t, o) {
  if (!(t instanceof o)) throw new TypeError("Cannot call a class as a function");
}
function st(t) {
  "@babel/helpers - typeof";
  return st = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, st(t);
}
function ps(t, o) {
  if (st(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var e = n.call(t, o);
    if (st(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(t);
}
function Ir(t) {
  var o = ps(t, "string");
  return st(o) == "symbol" ? o : o + "";
}
function wo(t, o) {
  for (var n = 0; n < o.length; n++) {
    var e = o[n];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, Ir(e.key), e);
  }
}
function me(t, o, n) {
  return o && wo(t.prototype, o), n && wo(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function gs(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ie(t, o) {
  if (o && (st(o) == "object" || typeof o == "function")) return o;
  if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return gs(t);
}
function he(t) {
  return he = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, he(t);
}
function En(t, o) {
  return En = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, e) {
    return n.__proto__ = e, n;
  }, En(t, o);
}
function Re(t, o) {
  if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(o && o.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), o && En(t, o);
}
function O(t, o, n) {
  return (o = Ir(o)) in t ? Object.defineProperty(t, o, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[o] = n, t;
}
function Rr() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  t != null && this.setState(t);
}
function kr(t) {
  function o(n) {
    var e = this.constructor.getDerivedStateFromProps(t, n);
    return e ?? null;
  }
  this.setState(o.bind(this));
}
function Lr(t, o) {
  try {
    var n = this.props, e = this.state;
    this.props = t, this.state = o, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      e
    );
  } finally {
    this.props = n, this.state = e;
  }
}
Rr.__suppressDeprecationWarning = !0;
kr.__suppressDeprecationWarning = !0;
Lr.__suppressDeprecationWarning = !0;
function Mt(t) {
  var o = t.prototype;
  if (!o || !o.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof t.getDerivedStateFromProps != "function" && typeof o.getSnapshotBeforeUpdate != "function")
    return t;
  var n = null, e = null, r = null;
  if (typeof o.componentWillMount == "function" ? n = "componentWillMount" : typeof o.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof o.componentWillReceiveProps == "function" ? e = "componentWillReceiveProps" : typeof o.UNSAFE_componentWillReceiveProps == "function" && (e = "UNSAFE_componentWillReceiveProps"), typeof o.componentWillUpdate == "function" ? r = "componentWillUpdate" : typeof o.UNSAFE_componentWillUpdate == "function" && (r = "UNSAFE_componentWillUpdate"), n !== null || e !== null || r !== null) {
    var i = t.displayName || t.name, l = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + i + " uses " + l + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (e !== null ? `
  ` + e : "") + (r !== null ? `
  ` + r : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof t.getDerivedStateFromProps == "function" && (o.componentWillMount = Rr, o.componentWillReceiveProps = kr), typeof o.getSnapshotBeforeUpdate == "function") {
    if (typeof o.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    o.componentWillUpdate = Lr;
    var s = o.componentDidUpdate;
    o.componentDidUpdate = function(d, u, f) {
      var h = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : f;
      s.call(this, d, u, h);
    };
  }
  return t;
}
function So(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function Co(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? So(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : So(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function vs(t, o, n) {
  return o = he(o), Ie(t, Or() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Or() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Or = function() {
    return !!t;
  })();
}
var zr = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = vs(this, o, [].concat(r)), O(n, "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    }), O(n, "_columnStartIndex", 0), O(n, "_columnStopIndex", 0), O(n, "_rowStartIndex", 0), O(n, "_rowStopIndex", 0), O(n, "_onKeyDown", function(l) {
      var s = n.props, a = s.columnCount, d = s.disabled, u = s.mode, f = s.rowCount;
      if (!d) {
        var h = n._getScrollState(), p = h.scrollToColumn, g = h.scrollToRow, m = n._getScrollState(), C = m.scrollToColumn, w = m.scrollToRow;
        switch (l.key) {
          case "ArrowDown":
            w = Math.min(u === "cells" ? w + 1 : n._rowStopIndex + 1, f - 1);
            break;
          case "ArrowLeft":
            C = Math.max(u === "cells" ? C - 1 : n._columnStartIndex - 1, 0);
            break;
          case "ArrowRight":
            C = Math.min(u === "cells" ? C + 1 : n._columnStopIndex + 1, a - 1);
            break;
          case "ArrowUp":
            w = Math.max(u === "cells" ? w - 1 : n._rowStartIndex - 1, 0);
            break;
        }
        (C !== p || w !== g) && (l.preventDefault(), n._updateScrollState({
          scrollToColumn: C,
          scrollToRow: w
        }));
      }
    }), O(n, "_onSectionRendered", function(l) {
      var s = l.columnStartIndex, a = l.columnStopIndex, d = l.rowStartIndex, u = l.rowStopIndex;
      n._columnStartIndex = s, n._columnStopIndex = a, n._rowStartIndex = d, n._rowStopIndex = u;
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "setScrollIndexes",
    value: function(e) {
      var r = e.scrollToColumn, i = e.scrollToRow;
      this.setState({
        scrollToRow: i,
        scrollToColumn: r
      });
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.className, i = e.children, l = this._getScrollState(), s = l.scrollToColumn, a = l.scrollToRow;
      return /* @__PURE__ */ oe.createElement("div", {
        className: r,
        onKeyDown: this._onKeyDown
      }, i({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: s,
        scrollToRow: a
      }));
    }
  }, {
    key: "_getScrollState",
    value: function() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function(e) {
      var r = e.scrollToColumn, i = e.scrollToRow, l = this.props, s = l.isControlled, a = l.onScrollToChange;
      typeof a == "function" && a({
        scrollToColumn: r,
        scrollToRow: i
      }), s || this.setState({
        scrollToColumn: r,
        scrollToRow: i
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, r) {
      return e.isControlled ? {} : e.scrollToColumn !== r.instanceProps.prevScrollToColumn || e.scrollToRow !== r.instanceProps.prevScrollToRow ? Co(Co({}, r), {}, {
        scrollToColumn: e.scrollToColumn,
        scrollToRow: e.scrollToRow,
        instanceProps: {
          prevScrollToColumn: e.scrollToColumn,
          prevScrollToRow: e.scrollToRow
        }
      }) : {};
    }
  }]);
}(oe.PureComponent);
O(zr, "defaultProps", {
  disabled: !1,
  isControlled: !1,
  mode: "edges",
  scrollToColumn: 0,
  scrollToRow: 0
});
Mt(zr);
function Mr(t, o) {
  var n;
  typeof o < "u" ? n = o : typeof window < "u" ? n = window : typeof self < "u" ? n = self : n = global;
  var e = typeof n.document < "u" && n.document.attachEvent;
  if (!e) {
    var r = function() {
      var A = n.requestAnimationFrame || n.mozRequestAnimationFrame || n.webkitRequestAnimationFrame || function(_) {
        return n.setTimeout(_, 20);
      };
      return function(_) {
        return A(_);
      };
    }(), i = function() {
      var A = n.cancelAnimationFrame || n.mozCancelAnimationFrame || n.webkitCancelAnimationFrame || n.clearTimeout;
      return function(_) {
        return A(_);
      };
    }(), l = function(_) {
      var $ = _.__resizeTriggers__, E = $.firstElementChild, k = $.lastElementChild, W = E.firstElementChild;
      k.scrollLeft = k.scrollWidth, k.scrollTop = k.scrollHeight, W.style.width = E.offsetWidth + 1 + "px", W.style.height = E.offsetHeight + 1 + "px", E.scrollLeft = E.scrollWidth, E.scrollTop = E.scrollHeight;
    }, s = function(_) {
      return _.offsetWidth != _.__resizeLast__.width || _.offsetHeight != _.__resizeLast__.height;
    }, a = function(_) {
      if (!(_.target.className && typeof _.target.className.indexOf == "function" && _.target.className.indexOf("contract-trigger") < 0 && _.target.className.indexOf("expand-trigger") < 0)) {
        var $ = this;
        l(this), this.__resizeRAF__ && i(this.__resizeRAF__), this.__resizeRAF__ = r(function() {
          s($) && ($.__resizeLast__.width = $.offsetWidth, $.__resizeLast__.height = $.offsetHeight, $.__resizeListeners__.forEach(function(E) {
            E.call($, _);
          }));
        });
      }
    }, d = !1, u = "", f = "animationstart", h = "Webkit Moz O ms".split(" "), p = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), g = "";
    {
      var m = n.document.createElement("fakeelement");
      if (m.style.animationName !== void 0 && (d = !0), d === !1) {
        for (var C = 0; C < h.length; C++)
          if (m.style[h[C] + "AnimationName"] !== void 0) {
            g = h[C], u = "-" + g.toLowerCase() + "-", f = p[C], d = !0;
            break;
          }
      }
    }
    var w = "resizeanim", S = "@" + u + "keyframes " + w + " { from { opacity: 0; } to { opacity: 0; } } ", M = u + "animation: 1ms " + w + "; ";
  }
  var z = function(_) {
    if (!_.getElementById("detectElementResize")) {
      var $ = (S || "") + ".resize-triggers { " + (M || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', E = _.head || _.getElementsByTagName("head")[0], k = _.createElement("style");
      k.id = "detectElementResize", k.type = "text/css", t != null && k.setAttribute("nonce", t), k.styleSheet ? k.styleSheet.cssText = $ : k.appendChild(_.createTextNode($)), E.appendChild(k);
    }
  }, R = function(_, $) {
    if (e)
      _.attachEvent("onresize", $);
    else {
      if (!_.__resizeTriggers__) {
        var E = _.ownerDocument, k = n.getComputedStyle(_);
        k && k.position == "static" && (_.style.position = "relative"), z(E), _.__resizeLast__ = {}, _.__resizeListeners__ = [], (_.__resizeTriggers__ = E.createElement("div")).className = "resize-triggers";
        var W = E.createElement("div");
        W.className = "expand-trigger", W.appendChild(E.createElement("div"));
        var v = E.createElement("div");
        v.className = "contract-trigger", _.__resizeTriggers__.appendChild(W), _.__resizeTriggers__.appendChild(v), _.appendChild(_.__resizeTriggers__), l(_), _.addEventListener("scroll", a, !0), f && (_.__resizeTriggers__.__animationListener__ = function(b) {
          b.animationName == w && l(_);
        }, _.__resizeTriggers__.addEventListener(f, _.__resizeTriggers__.__animationListener__));
      }
      _.__resizeListeners__.push($);
    }
  }, P = function(_, $) {
    if (e)
      _.detachEvent("onresize", $);
    else if (_.__resizeListeners__.splice(_.__resizeListeners__.indexOf($), 1), !_.__resizeListeners__.length) {
      _.removeEventListener("scroll", a, !0), _.__resizeTriggers__.__animationListener__ && (_.__resizeTriggers__.removeEventListener(f, _.__resizeTriggers__.__animationListener__), _.__resizeTriggers__.__animationListener__ = null);
      try {
        _.__resizeTriggers__ = !_.removeChild(_.__resizeTriggers__);
      } catch {
      }
    }
  };
  return {
    addResizeListener: R,
    removeResizeListener: P
  };
}
function _o(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function bo(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? _o(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : _o(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function ms(t, o, n) {
  return o = he(o), Ie(t, Pr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Pr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Pr = function() {
    return !!t;
  })();
}
var qe = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = ms(this, o, [].concat(r)), O(n, "state", {
      height: n.props.defaultHeight || 0,
      width: n.props.defaultWidth || 0
    }), O(n, "_parentNode", void 0), O(n, "_autoSizer", void 0), O(n, "_window", void 0), O(n, "_detectElementResize", void 0), O(n, "_onResize", function() {
      var l = n.props, s = l.disableHeight, a = l.disableWidth, d = l.onResize;
      if (n._parentNode) {
        var u = n._parentNode.offsetHeight || 0, f = n._parentNode.offsetWidth || 0, h = n._window || window, p = h.getComputedStyle(n._parentNode) || {}, g = parseInt(p.paddingLeft, 10) || 0, m = parseInt(p.paddingRight, 10) || 0, C = parseInt(p.paddingTop, 10) || 0, w = parseInt(p.paddingBottom, 10) || 0, S = u - C - w, M = f - g - m;
        (!s && n.state.height !== S || !a && n.state.width !== M) && (n.setState({
          height: u - C - w,
          width: f - g - m
        }), d({
          height: u,
          width: f
        }));
      }
    }), O(n, "_setRef", function(l) {
      n._autoSizer = l;
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "componentDidMount",
    value: function() {
      var e = this.props.nonce;
      this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._window = this._autoSizer.parentNode.ownerDocument.defaultView, this._detectElementResize = Mr(e, this._window), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.children, i = e.className, l = e.disableHeight, s = e.disableWidth, a = e.style, d = this.state, u = d.height, f = d.width, h = {
        overflow: "visible"
      }, p = {};
      return l || (h.height = 0, p.height = u), s || (h.width = 0, p.width = f), /* @__PURE__ */ oe.createElement("div", {
        className: i,
        ref: this._setRef,
        style: bo(bo({}, h), a)
      }, r(p));
    }
  }]);
}(oe.Component);
O(qe, "defaultProps", {
  onResize: function() {
  },
  disableHeight: !1,
  disableWidth: !1,
  style: {}
});
function ys(t, o, n) {
  return o = he(o), Ie(t, Er() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Er() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Er = function() {
    return !!t;
  })();
}
var Pt = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = ys(this, o, [].concat(r)), O(n, "_child", /* @__PURE__ */ oe.createRef()), O(n, "_measure", function() {
      var l = n.props, s = l.cache, a = l.columnIndex, d = a === void 0 ? 0 : a, u = l.parent, f = l.rowIndex, h = f === void 0 ? n.props.index || 0 : f, p = n._getCellMeasurements(), g = p.height, m = p.width;
      (g !== s.getHeight(h, d) || m !== s.getWidth(h, d)) && (s.set(h, d, m, g), u && typeof u.recomputeGridSize == "function" && u.recomputeGridSize({
        columnIndex: d,
        rowIndex: h
      }));
    }), O(n, "_registerChild", function(l) {
      l && !(l instanceof Element) && console.warn("CellMeasurer registerChild expects to be passed Element or null"), n._child.current = l, l && n._maybeMeasureCell();
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "componentDidMount",
    value: function() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function() {
      var e = this, r = this.props.children, i = typeof r == "function" ? r({
        measure: this._measure,
        registerChild: this._registerChild
      }) : r;
      return i === null ? i : /* @__PURE__ */ Li(i, {
        ref: function(s) {
          typeof i.ref == "function" ? i.ref(s) : i.ref && (i.ref.current = s), e._child.current = s;
        }
      });
    }
  }, {
    key: "_getCellMeasurements",
    value: function() {
      var e = this.props.cache, r = this._child.current;
      if (r && r.ownerDocument && r.ownerDocument.defaultView && r instanceof r.ownerDocument.defaultView.HTMLElement) {
        var i = r.style.width, l = r.style.height;
        e.hasFixedWidth() || (r.style.width = "auto"), e.hasFixedHeight() || (r.style.height = "auto");
        var s = Math.ceil(r.offsetHeight), a = Math.ceil(r.offsetWidth);
        return i && (r.style.width = i), l && (r.style.height = l), {
          height: s,
          width: a
        };
      } else
        return {
          height: 0,
          width: 0
        };
    }
  }, {
    key: "_maybeMeasureCell",
    value: function() {
      var e = this.props, r = e.cache, i = e.columnIndex, l = i === void 0 ? 0 : i, s = e.parent, a = e.rowIndex, d = a === void 0 ? this.props.index || 0 : a;
      if (!r.has(d, l)) {
        var u = this._getCellMeasurements(), f = u.height, h = u.width;
        r.set(d, l, h, f), s && typeof s.invalidateCellSizeAfterRender == "function" && s.invalidateCellSizeAfterRender({
          columnIndex: l,
          rowIndex: d
        });
      }
    }
  }]);
}(oe.PureComponent);
O(Pt, "__internalCellMeasurerFlag", !1);
process.env.NODE_ENV !== "production" && (Pt.__internalCellMeasurerFlag = !0);
var ws = 30, Ss = 100, Vn = /* @__PURE__ */ function() {
  function t() {
    var o = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ve(this, t), O(this, "_cellHeightCache", {}), O(this, "_cellWidthCache", {}), O(this, "_columnWidthCache", {}), O(this, "_rowHeightCache", {}), O(this, "_defaultHeight", void 0), O(this, "_defaultWidth", void 0), O(this, "_minHeight", void 0), O(this, "_minWidth", void 0), O(this, "_keyMapper", void 0), O(this, "_hasFixedHeight", void 0), O(this, "_hasFixedWidth", void 0), O(this, "_columnCount", 0), O(this, "_rowCount", 0), O(this, "columnWidth", function(u) {
      var f = u.index, h = o._keyMapper(0, f);
      return o._columnWidthCache[h] !== void 0 ? o._columnWidthCache[h] : o._defaultWidth;
    }), O(this, "rowHeight", function(u) {
      var f = u.index, h = o._keyMapper(f, 0);
      return o._rowHeightCache[h] !== void 0 ? o._rowHeightCache[h] : o._defaultHeight;
    });
    var e = n.defaultHeight, r = n.defaultWidth, i = n.fixedHeight, l = n.fixedWidth, s = n.keyMapper, a = n.minHeight, d = n.minWidth;
    this._hasFixedHeight = i === !0, this._hasFixedWidth = l === !0, this._minHeight = a || 0, this._minWidth = d || 0, this._keyMapper = s || Cs, this._defaultHeight = Math.max(this._minHeight, typeof e == "number" ? e : ws), this._defaultWidth = Math.max(this._minWidth, typeof r == "number" ? r : Ss), process.env.NODE_ENV !== "production" && (this._hasFixedHeight === !1 && this._hasFixedWidth === !1 && console.warn("CellMeasurerCache should only measure a cell's width or height. You have configured CellMeasurerCache to measure both. This will result in poor performance."), this._hasFixedHeight === !1 && this._defaultHeight === 0 && console.warn("Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. Failing to do so will lead to unnecessary layout and poor performance."), this._hasFixedWidth === !1 && this._defaultWidth === 0 && console.warn("Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. Failing to do so will lead to unnecessary layout and poor performance."));
  }
  return me(t, [{
    key: "clear",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._keyMapper(n, e);
      delete this._cellHeightCache[r], delete this._cellWidthCache[r], this._updateCachedColumnAndRowSizes(n, e);
    }
  }, {
    key: "clearAll",
    value: function() {
      this._cellHeightCache = {}, this._cellWidthCache = {}, this._columnWidthCache = {}, this._rowHeightCache = {}, this._rowCount = 0, this._columnCount = 0;
    }
  }, {
    key: "defaultHeight",
    get: function() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function() {
      return this._defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedHeight)
        return this._defaultHeight;
      var r = this._keyMapper(n, e);
      return this._cellHeightCache[r] !== void 0 ? Math.max(this._minHeight, this._cellHeightCache[r]) : this._defaultHeight;
    }
  }, {
    key: "getWidth",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedWidth)
        return this._defaultWidth;
      var r = this._keyMapper(n, e);
      return this._cellWidthCache[r] !== void 0 ? Math.max(this._minWidth, this._cellWidthCache[r]) : this._defaultWidth;
    }
  }, {
    key: "has",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._keyMapper(n, e);
      return this._cellHeightCache[r] !== void 0;
    }
  }, {
    key: "set",
    value: function(n, e, r, i) {
      var l = this._keyMapper(n, e);
      e >= this._columnCount && (this._columnCount = e + 1), n >= this._rowCount && (this._rowCount = n + 1), this._cellHeightCache[l] = i, this._cellWidthCache[l] = r, this._updateCachedColumnAndRowSizes(n, e);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function(n, e) {
      if (!this._hasFixedWidth) {
        for (var r = 0, i = 0; i < this._rowCount; i++)
          r = Math.max(r, this.getWidth(i, e));
        var l = this._keyMapper(0, e);
        this._columnWidthCache[l] = r;
      }
      if (!this._hasFixedHeight) {
        for (var s = 0, a = 0; a < this._columnCount; a++)
          s = Math.max(s, this.getHeight(n, a));
        var d = this._keyMapper(n, 0);
        this._rowHeightCache[d] = s;
      }
    }
  }]);
}();
function Cs(t, o) {
  return "".concat(t, "-").concat(o);
}
function _s(t) {
  if (t == null) throw new TypeError("Cannot destructure " + t);
}
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(t) {
    for (var o = 1; o < arguments.length; o++) {
      var n = arguments[o];
      for (var e in n) ({}).hasOwnProperty.call(n, e) && (t[e] = n[e]);
    }
    return t;
  }, Pe.apply(null, arguments);
}
var Nn = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var un, xo;
function bs() {
  if (xo) return un;
  xo = 1;
  var t = Object.getOwnPropertySymbols, o = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function e(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var a = Object.getOwnPropertyNames(l).map(function(u) {
        return l[u];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        d[u] = u;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return un = r() ? Object.assign : function(i, l) {
    for (var s, a = e(i), d, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        o.call(s, f) && (a[f] = s[f]);
      if (t) {
        d = t(s);
        for (var h = 0; h < d.length; h++)
          n.call(s, d[h]) && (a[d[h]] = s[d[h]]);
      }
    }
    return a;
  }, un;
}
var hn, To;
function qn() {
  if (To) return hn;
  To = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return hn = t, hn;
}
var fn, Io;
function Nr() {
  return Io || (Io = 1, fn = Function.call.bind(Object.prototype.hasOwnProperty)), fn;
}
var pn, Ro;
function xs() {
  if (Ro) return pn;
  Ro = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var o = qn(), n = {}, e = Nr();
    t = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function r(i, l, s, a, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (e(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (a || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[u](l, u, a, s, null, o);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && t(
            (a || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = d ? d() : "";
            t(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, pn = r, pn;
}
var gn, ko;
function Ts() {
  if (ko) return gn;
  ko = 1;
  var t = yr, o = bs(), n = qn(), e = Nr(), r = xs(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var a = "Warning: " + s;
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return gn = function(s, a) {
    var d = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(y) {
      var N = y && (d && y[d] || y[u]);
      if (typeof N == "function")
        return N;
    }
    var h = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: S(),
      arrayOf: M,
      element: z(),
      elementType: R(),
      instanceOf: P,
      node: E(),
      objectOf: _,
      oneOf: A,
      oneOfType: $,
      shape: W,
      exact: v
    };
    function g(y, N) {
      return y === N ? y !== 0 || 1 / y === 1 / N : y !== y && N !== N;
    }
    function m(y, N) {
      this.message = y, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function C(y) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, K = 0;
      function H(I, V, T, F, Q, te, ce) {
        if (F = F || h, te = te || T, ce !== n) {
          if (a) {
            var ae = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ae.name = "Invariant Violation", ae;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ce = F + ":" + T;
            !N[Ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + F + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[Ce] = !0, K++);
          }
        }
        return V[T] == null ? I ? V[T] === null ? new m("The " + Q + " `" + te + "` is marked as required " + ("in `" + F + "`, but its value is `null`.")) : new m("The " + Q + " `" + te + "` is marked as required in " + ("`" + F + "`, but its value is `undefined`.")) : null : y(V, T, F, Q, te);
      }
      var B = H.bind(null, !1);
      return B.isRequired = H.bind(null, !0), B;
    }
    function w(y) {
      function N(K, H, B, I, V, T) {
        var F = K[H], Q = L(F);
        if (Q !== y) {
          var te = x(F);
          return new m(
            "Invalid " + I + " `" + V + "` of type " + ("`" + te + "` supplied to `" + B + "`, expected ") + ("`" + y + "`."),
            { expectedType: y }
          );
        }
        return null;
      }
      return C(N);
    }
    function S() {
      return C(l);
    }
    function M(y) {
      function N(K, H, B, I, V) {
        if (typeof y != "function")
          return new m("Property `" + V + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var T = K[H];
        if (!Array.isArray(T)) {
          var F = L(T);
          return new m("Invalid " + I + " `" + V + "` of type " + ("`" + F + "` supplied to `" + B + "`, expected an array."));
        }
        for (var Q = 0; Q < T.length; Q++) {
          var te = y(T, Q, B, I, V + "[" + Q + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return C(N);
    }
    function z() {
      function y(N, K, H, B, I) {
        var V = N[K];
        if (!s(V)) {
          var T = L(V);
          return new m("Invalid " + B + " `" + I + "` of type " + ("`" + T + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(y);
    }
    function R() {
      function y(N, K, H, B, I) {
        var V = N[K];
        if (!t.isValidElementType(V)) {
          var T = L(V);
          return new m("Invalid " + B + " `" + I + "` of type " + ("`" + T + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(y);
    }
    function P(y) {
      function N(K, H, B, I, V) {
        if (!(K[H] instanceof y)) {
          var T = y.name || h, F = j(K[H]);
          return new m("Invalid " + I + " `" + V + "` of type " + ("`" + F + "` supplied to `" + B + "`, expected ") + ("instance of `" + T + "`."));
        }
        return null;
      }
      return C(N);
    }
    function A(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function N(K, H, B, I, V) {
        for (var T = K[H], F = 0; F < y.length; F++)
          if (g(T, y[F]))
            return null;
        var Q = JSON.stringify(y, function(ce, ae) {
          var Ce = x(ae);
          return Ce === "symbol" ? String(ae) : ae;
        });
        return new m("Invalid " + I + " `" + V + "` of value `" + String(T) + "` " + ("supplied to `" + B + "`, expected one of " + Q + "."));
      }
      return C(N);
    }
    function _(y) {
      function N(K, H, B, I, V) {
        if (typeof y != "function")
          return new m("Property `" + V + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var T = K[H], F = L(T);
        if (F !== "object")
          return new m("Invalid " + I + " `" + V + "` of type " + ("`" + F + "` supplied to `" + B + "`, expected an object."));
        for (var Q in T)
          if (e(T, Q)) {
            var te = y(T, Q, B, I, V + "." + Q, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return C(N);
    }
    function $(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var N = 0; N < y.length; N++) {
        var K = y[N];
        if (typeof K != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Z(K) + " at index " + N + "."
          ), l;
      }
      function H(B, I, V, T, F) {
        for (var Q = [], te = 0; te < y.length; te++) {
          var ce = y[te], ae = ce(B, I, V, T, F, n);
          if (ae == null)
            return null;
          ae.data && e(ae.data, "expectedType") && Q.push(ae.data.expectedType);
        }
        var Ce = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new m("Invalid " + T + " `" + F + "` supplied to " + ("`" + V + "`" + Ce + "."));
      }
      return C(H);
    }
    function E() {
      function y(N, K, H, B, I) {
        return G(N[K]) ? null : new m("Invalid " + B + " `" + I + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return C(y);
    }
    function k(y, N, K, H, B) {
      return new m(
        (y || "React class") + ": " + N + " type `" + K + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function W(y) {
      function N(K, H, B, I, V) {
        var T = K[H], F = L(T);
        if (F !== "object")
          return new m("Invalid " + I + " `" + V + "` of type `" + F + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var Q in y) {
          var te = y[Q];
          if (typeof te != "function")
            return k(B, I, V, Q, x(te));
          var ce = te(T, Q, B, I, V + "." + Q, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return C(N);
    }
    function v(y) {
      function N(K, H, B, I, V) {
        var T = K[H], F = L(T);
        if (F !== "object")
          return new m("Invalid " + I + " `" + V + "` of type `" + F + "` " + ("supplied to `" + B + "`, expected `object`."));
        var Q = o({}, K[H], y);
        for (var te in Q) {
          var ce = y[te];
          if (e(y, te) && typeof ce != "function")
            return k(B, I, V, te, x(ce));
          if (!ce)
            return new m(
              "Invalid " + I + " `" + V + "` key `" + te + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(K[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(y), null, "  ")
            );
          var ae = ce(T, te, B, I, V + "." + te, n);
          if (ae)
            return ae;
        }
        return null;
      }
      return C(N);
    }
    function G(y) {
      switch (typeof y) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !y;
        case "object":
          if (Array.isArray(y))
            return y.every(G);
          if (y === null || s(y))
            return !0;
          var N = f(y);
          if (N) {
            var K = N.call(y), H;
            if (N !== y.entries) {
              for (; !(H = K.next()).done; )
                if (!G(H.value))
                  return !1;
            } else
              for (; !(H = K.next()).done; ) {
                var B = H.value;
                if (B && !G(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function b(y, N) {
      return y === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function L(y) {
      var N = typeof y;
      return Array.isArray(y) ? "array" : y instanceof RegExp ? "object" : b(N, y) ? "symbol" : N;
    }
    function x(y) {
      if (typeof y > "u" || y === null)
        return "" + y;
      var N = L(y);
      if (N === "object") {
        if (y instanceof Date)
          return "date";
        if (y instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function Z(y) {
      var N = x(y);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function j(y) {
      return !y.constructor || !y.constructor.name ? h : y.constructor.name;
    }
    return p.checkPropTypes = r, p.resetWarningCache = r.resetWarningCache, p.PropTypes = p, p;
  }, gn;
}
var vn, Lo;
function Is() {
  if (Lo) return vn;
  Lo = 1;
  var t = qn();
  function o() {
  }
  function n() {
  }
  return n.resetWarningCache = o, vn = function() {
    function e(l, s, a, d, u, f) {
      if (f !== t) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    e.isRequired = e;
    function r() {
      return e;
    }
    var i = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      elementType: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: o
    };
    return i.PropTypes = i, i;
  }, vn;
}
if (process.env.NODE_ENV !== "production") {
  var Rs = yr, ks = !0;
  Nn.exports = Ts()(Rs.isElement, ks);
} else
  Nn.exports = Is()();
var Ls = Nn.exports;
const D = /* @__PURE__ */ _r(Ls);
function $r(t) {
  var o, n, e = "";
  if (typeof t == "string" || typeof t == "number") e += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (o = 0; o < t.length; o++) t[o] && (n = $r(t[o])) && (e && (e += " "), e += n);
  else for (o in t) t[o] && (e && (e += " "), e += o);
  return e;
}
function Ge() {
  for (var t, o, n = 0, e = ""; n < arguments.length; ) (t = arguments[n++]) && (o = $r(t)) && (e && (e += " "), e += o);
  return e;
}
function ht() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, o = {};
  return function(n) {
    var e = n.callback, r = n.indices, i = Object.keys(r), l = !t || i.every(function(a) {
      var d = r[a];
      return Array.isArray(d) ? d.length > 0 : d >= 0;
    }), s = i.length !== Object.keys(o).length || i.some(function(a) {
      var d = o[a], u = r[a];
      return Array.isArray(u) ? d.join(",") !== u.join(",") : d !== u;
    });
    o = r, l && s && e(r);
  };
}
const Os = !!(typeof window < "u" && window.document && window.document.createElement);
var At;
function $n(t) {
  if ((!At && At !== 0 || t) && Os) {
    var o = document.createElement("div");
    o.style.position = "absolute", o.style.top = "-9999px", o.style.width = "50px", o.style.height = "50px", o.style.overflow = "scroll", document.body.appendChild(o), At = o.offsetWidth - o.clientWidth, document.body.removeChild(o);
  }
  return At;
}
function Oo(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function zo(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Oo(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Oo(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function zs(t, o, n) {
  return o = he(o), Ie(t, Gr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Gr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gr = function() {
    return !!t;
  })();
}
var Ms = 150, ct = {
  OBSERVED: "observed",
  REQUESTED: "requested"
}, on = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = zs(this, o, [].concat(r)), O(n, "state", {
      isScrolling: !1,
      scrollLeft: 0,
      scrollTop: 0
    }), O(n, "_calculateSizeAndPositionDataOnNextUpdate", !1), O(n, "_onSectionRenderedMemoizer", ht()), O(n, "_onScrollMemoizer", ht(!1)), O(n, "_invokeOnSectionRenderedHelper", function() {
      var l = n.props, s = l.cellLayoutManager, a = l.onSectionRendered;
      n._onSectionRenderedMemoizer({
        callback: a,
        indices: {
          indices: s.getLastRenderedIndices()
        }
      });
    }), O(n, "_setScrollingContainerRef", function(l) {
      n._scrollingContainer = l;
    }), O(n, "_updateScrollPositionForScrollToCell", function() {
      var l = n.props, s = l.cellLayoutManager, a = l.height, d = l.scrollToAlignment, u = l.scrollToCell, f = l.width, h = n.state, p = h.scrollLeft, g = h.scrollTop;
      if (u >= 0) {
        var m = s.getScrollPositionForCell({
          align: d,
          cellIndex: u,
          height: a,
          scrollLeft: p,
          scrollTop: g,
          width: f
        });
        (m.scrollLeft !== p || m.scrollTop !== g) && n._setScrollPosition(m);
      }
    }), O(n, "_onScroll", function(l) {
      if (l.target === n._scrollingContainer) {
        n._enablePointerEventsAfterDelay();
        var s = n.props, a = s.cellLayoutManager, d = s.height, u = s.isScrollingChange, f = s.width, h = n._scrollbarSize, p = a.getTotalSize(), g = p.height, m = p.width, C = Math.max(0, Math.min(m - f + h, l.target.scrollLeft)), w = Math.max(0, Math.min(g - d + h, l.target.scrollTop));
        if (n.state.scrollLeft !== C || n.state.scrollTop !== w) {
          var S = l.cancelable ? ct.OBSERVED : ct.REQUESTED;
          n.state.isScrolling || u(!0), n.setState({
            isScrolling: !0,
            scrollLeft: C,
            scrollPositionChangeReason: S,
            scrollTop: w
          });
        }
        n._invokeOnScrollMemoizer({
          scrollLeft: C,
          scrollTop: w,
          totalWidth: m,
          totalHeight: g
        });
      }
    }), n._scrollbarSize = $n(), n._scrollbarSize === void 0 ? (n._scrollbarSizeMeasured = !1, n._scrollbarSize = 0) : n._scrollbarSizeMeasured = !0, n;
  }
  return Re(o, t), me(o, [{
    key: "recomputeCellSizesAndPositions",
    value: function() {
      this._calculateSizeAndPositionDataOnNextUpdate = !0, this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props, r = e.cellLayoutManager, i = e.scrollLeft, l = e.scrollToCell, s = e.scrollTop;
      this._scrollbarSizeMeasured || (this._scrollbarSize = $n(), this._scrollbarSizeMeasured = !0, this.setState({})), l >= 0 ? this._updateScrollPositionForScrollToCell() : (i >= 0 || s >= 0) && this._setScrollPosition({
        scrollLeft: i,
        scrollTop: s
      }), this._invokeOnSectionRenderedHelper();
      var a = r.getTotalSize(), d = a.height, u = a.width;
      this._invokeOnScrollMemoizer({
        scrollLeft: i || 0,
        scrollTop: s || 0,
        totalHeight: d,
        totalWidth: u
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, r) {
      var i = this.props, l = i.height, s = i.scrollToAlignment, a = i.scrollToCell, d = i.width, u = this.state, f = u.scrollLeft, h = u.scrollPositionChangeReason, p = u.scrollTop;
      h === ct.REQUESTED && (f >= 0 && f !== r.scrollLeft && f !== this._scrollingContainer.scrollLeft && (this._scrollingContainer.scrollLeft = f), p >= 0 && p !== r.scrollTop && p !== this._scrollingContainer.scrollTop && (this._scrollingContainer.scrollTop = p)), (l !== e.height || s !== e.scrollToAlignment || a !== e.scrollToCell || d !== e.width) && this._updateScrollPositionForScrollToCell(), this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId);
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.autoHeight, i = e.cellCount, l = e.cellLayoutManager, s = e.className, a = e.height, d = e.horizontalOverscanSize, u = e.id, f = e.noContentRenderer, h = e.style, p = e.verticalOverscanSize, g = e.width, m = this.state, C = m.isScrolling, w = m.scrollLeft, S = m.scrollTop;
      (this._lastRenderedCellCount !== i || this._lastRenderedCellLayoutManager !== l || this._calculateSizeAndPositionDataOnNextUpdate) && (this._lastRenderedCellCount = i, this._lastRenderedCellLayoutManager = l, this._calculateSizeAndPositionDataOnNextUpdate = !1, l.calculateSizeAndPositionData());
      var M = l.getTotalSize(), z = M.height, R = M.width, P = Math.max(0, w - d), A = Math.max(0, S - p), _ = Math.min(R, w + g + d), $ = Math.min(z, S + a + p), E = a > 0 && g > 0 ? l.cellRenderers({
        height: $ - A,
        isScrolling: C,
        width: _ - P,
        x: P,
        y: A
      }) : [], k = {
        boxSizing: "border-box",
        direction: "ltr",
        height: r ? "auto" : a,
        position: "relative",
        WebkitOverflowScrolling: "touch",
        width: g,
        willChange: "transform"
      }, W = z > a ? this._scrollbarSize : 0, v = R > g ? this._scrollbarSize : 0;
      return k.overflowX = R + W <= g ? "hidden" : "auto", k.overflowY = z + v <= a ? "hidden" : "auto", /* @__PURE__ */ oe.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: Ge("ReactVirtualized__Collection", s),
        id: u,
        onScroll: this._onScroll,
        role: "grid",
        style: zo(zo({}, k), h),
        tabIndex: 0
      }, i > 0 && /* @__PURE__ */ oe.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: z,
          maxHeight: z,
          maxWidth: R,
          overflow: "hidden",
          pointerEvents: C ? "none" : "",
          width: R
        }
      }, E), i === 0 && f());
    }
    /* ---------------------------- Helper methods ---------------------------- */
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function() {
      var e = this;
      this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = setTimeout(function() {
        var r = e.props.isScrollingChange;
        r(!1), e._disablePointerEventsTimeoutId = null, e.setState({
          isScrolling: !1
        });
      }, Ms);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function(e) {
      var r = this, i = e.scrollLeft, l = e.scrollTop, s = e.totalHeight, a = e.totalWidth;
      this._onScrollMemoizer({
        callback: function(u) {
          var f = u.scrollLeft, h = u.scrollTop, p = r.props, g = p.height, m = p.onScroll, C = p.width;
          m({
            clientHeight: g,
            clientWidth: C,
            scrollHeight: s,
            scrollLeft: f,
            scrollTop: h,
            scrollWidth: a
          });
        },
        indices: {
          scrollLeft: i,
          scrollTop: l
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function(e) {
      var r = e.scrollLeft, i = e.scrollTop, l = {
        scrollPositionChangeReason: ct.REQUESTED
      };
      r >= 0 && (l.scrollLeft = r), i >= 0 && (l.scrollTop = i), (r >= 0 && r !== this.state.scrollLeft || i >= 0 && i !== this.state.scrollTop) && this.setState(l);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, r) {
      return e.cellCount === 0 && (r.scrollLeft !== 0 || r.scrollTop !== 0) ? {
        scrollLeft: 0,
        scrollTop: 0,
        scrollPositionChangeReason: ct.REQUESTED
      } : e.scrollLeft !== r.scrollLeft || e.scrollTop !== r.scrollTop ? {
        scrollLeft: e.scrollLeft != null ? e.scrollLeft : r.scrollLeft,
        scrollTop: e.scrollTop != null ? e.scrollTop : r.scrollTop,
        scrollPositionChangeReason: ct.REQUESTED
      } : null;
    }
  }]);
}(oe.PureComponent);
O(on, "defaultProps", {
  "aria-label": "grid",
  horizontalOverscanSize: 0,
  noContentRenderer: function() {
    return null;
  },
  onScroll: function() {
    return null;
  },
  onSectionRendered: function() {
    return null;
  },
  scrollToAlignment: "auto",
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});
on.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": D.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: D.bool,
  /**
   * Number of cells in collection.
   */
  cellCount: D.number.isRequired,
  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: D.object.isRequired,
  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: D.string,
  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: D.number.isRequired,
  /**
   * Optional custom id to attach to root Collection element.
   */
  id: D.string,
  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: D.number.isRequired,
  isScrollingChange: D.func,
  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: D.func.isRequired,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: D.func.isRequired,
  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: D.func.isRequired,
  /**
   * Horizontal offset.
   */
  scrollLeft: D.number,
  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: D.oneOf(["auto", "end", "start", "center"]).isRequired,
  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: D.number.isRequired,
  /**
   * Vertical offset.
   */
  scrollTop: D.number,
  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: D.object,
  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: D.number.isRequired,
  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: D.number.isRequired
} : {};
Mt(on);
var Ps = /* @__PURE__ */ function() {
  function t(o) {
    var n = o.height, e = o.width, r = o.x, i = o.y;
    ve(this, t), this.height = n, this.width = e, this.x = r, this.y = i, this._indexMap = {}, this._indices = [];
  }
  return me(t, [{
    key: "addCellIndex",
    value: function(n) {
      var e = n.index;
      this._indexMap[e] || (this._indexMap[e] = !0, this._indices.push(e));
    }
    /** Get all cell indices that have been added to this section. */
  }, {
    key: "getCellIndices",
    value: function() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);
}(), Es = 100, Ns = /* @__PURE__ */ function() {
  function t() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Es;
    ve(this, t), this._sectionSize = o, this._cellMetadata = [], this._sections = {};
  }
  return me(t, [{
    key: "getCellIndices",
    value: function(n) {
      var e = n.height, r = n.width, i = n.x, l = n.y, s = {};
      return this.getSections({
        height: e,
        width: r,
        x: i,
        y: l
      }).forEach(function(a) {
        return a.getCellIndices().forEach(function(d) {
          s[d] = d;
        });
      }), Object.keys(s).map(function(a) {
        return s[a];
      });
    }
    /** Get size and position information for the cell specified. */
  }, {
    key: "getCellMetadata",
    value: function(n) {
      var e = n.index;
      return this._cellMetadata[e];
    }
    /** Get all Sections overlapping the specified region. */
  }, {
    key: "getSections",
    value: function(n) {
      for (var e = n.height, r = n.width, i = n.x, l = n.y, s = Math.floor(i / this._sectionSize), a = Math.floor((i + r - 1) / this._sectionSize), d = Math.floor(l / this._sectionSize), u = Math.floor((l + e - 1) / this._sectionSize), f = [], h = s; h <= a; h++)
        for (var p = d; p <= u; p++) {
          var g = "".concat(h, ".").concat(p);
          this._sections[g] || (this._sections[g] = new Ps({
            height: this._sectionSize,
            width: this._sectionSize,
            x: h * this._sectionSize,
            y: p * this._sectionSize
          })), f.push(this._sections[g]);
        }
      return f;
    }
    /** Total number of Sections based on the currently registered cells. */
  }, {
    key: "getTotalSectionCount",
    value: function() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function() {
      var n = this;
      return Object.keys(this._sections).map(function(e) {
        return n._sections[e].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
  }, {
    key: "registerCell",
    value: function(n) {
      var e = n.cellMetadatum, r = n.index;
      this._cellMetadata[r] = e, this.getSections(e).forEach(function(i) {
        return i.addCellIndex({
          index: r
        });
      });
    }
  }]);
}();
function $s(t) {
  for (var o = t.cellCount, n = t.cellSizeAndPositionGetter, e = t.sectionSize, r = [], i = new Ns(e), l = 0, s = 0, a = 0; a < o; a++) {
    var d = n({
      index: a
    });
    if (d.height == null || isNaN(d.height) || d.width == null || isNaN(d.width) || d.x == null || isNaN(d.x) || d.y == null || isNaN(d.y))
      throw Error("Invalid metadata returned for cell ".concat(a, `:
        x:`).concat(d.x, ", y:").concat(d.y, ", width:").concat(d.width, ", height:").concat(d.height));
    l = Math.max(l, d.y + d.height), s = Math.max(s, d.x + d.width), r[a] = d, i.registerCell({
      cellMetadatum: d,
      index: a
    });
  }
  return {
    cellMetadata: r,
    height: l,
    sectionManager: i,
    width: s
  };
}
function Mo(t) {
  var o = t.align, n = o === void 0 ? "auto" : o, e = t.cellOffset, r = t.cellSize, i = t.containerSize, l = t.currentOffset, s = e, a = s - i + r;
  switch (n) {
    case "start":
      return s;
    case "end":
      return a;
    case "center":
      return s - (i - r) / 2;
    default:
      return Math.max(a, Math.min(s, l));
  }
}
function Gs(t, o, n) {
  return o = he(o), Ie(t, Dr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Dr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Dr = function() {
    return !!t;
  })();
}
var Ar = /* @__PURE__ */ function(t) {
  function o(n, e) {
    var r;
    return ve(this, o), r = Gs(this, o, [n, e]), r._cellMetadata = [], r._lastRenderedCellIndices = [], r._cellCache = [], r._isScrollingChange = r._isScrollingChange.bind(r), r._setCollectionViewRef = r._setCollectionViewRef.bind(r), r;
  }
  return Re(o, t), me(o, [{
    key: "forceUpdate",
    value: function() {
      this._collectionView !== void 0 && this._collectionView.forceUpdate();
    }
    /** See Collection#recomputeCellSizesAndPositions */
  }, {
    key: "recomputeCellSizesAndPositions",
    value: function() {
      this._cellCache = [], this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */
  }, {
    key: "render",
    value: function() {
      var e = Pe({}, (_s(this.props), this.props));
      return /* @__PURE__ */ oe.createElement(on, Pe({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, e));
    }
    /** CellLayoutManager interface */
  }, {
    key: "calculateSizeAndPositionData",
    value: function() {
      var e = this.props, r = e.cellCount, i = e.cellSizeAndPositionGetter, l = e.sectionSize, s = $s({
        cellCount: r,
        cellSizeAndPositionGetter: i,
        sectionSize: l
      });
      this._cellMetadata = s.cellMetadata, this._sectionManager = s.sectionManager, this._height = s.height, this._width = s.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */
  }, {
    key: "getLastRenderedIndices",
    value: function() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */
  }, {
    key: "getScrollPositionForCell",
    value: function(e) {
      var r = e.align, i = e.cellIndex, l = e.height, s = e.scrollLeft, a = e.scrollTop, d = e.width, u = this.props.cellCount;
      if (i >= 0 && i < u) {
        var f = this._cellMetadata[i];
        s = Mo({
          align: r,
          cellOffset: f.x,
          cellSize: f.width,
          containerSize: d,
          currentOffset: s
        }), a = Mo({
          align: r,
          cellOffset: f.y,
          cellSize: f.height,
          containerSize: l,
          currentOffset: a
        });
      }
      return {
        scrollLeft: s,
        scrollTop: a
      };
    }
  }, {
    key: "getTotalSize",
    value: function() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function(e) {
      var r = this, i = e.height, l = e.isScrolling, s = e.width, a = e.x, d = e.y, u = this.props, f = u.cellGroupRenderer, h = u.cellRenderer;
      return this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: i,
        width: s,
        x: a,
        y: d
      }), f({
        cellCache: this._cellCache,
        cellRenderer: h,
        cellSizeAndPositionGetter: function(g) {
          var m = g.index;
          return r._sectionManager.getCellMetadata({
            index: m
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: l
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function(e) {
      e || (this._cellCache = []);
    }
  }, {
    key: "_setCollectionViewRef",
    value: function(e) {
      this._collectionView = e;
    }
  }]);
}(oe.PureComponent);
O(Ar, "defaultProps", {
  "aria-label": "grid",
  cellGroupRenderer: Ds
});
Ar.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": D.string,
  /**
   * Number of cells in Collection.
   */
  cellCount: D.number.isRequired,
  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: D.func.isRequired,
  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: D.func.isRequired,
  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: D.func.isRequired,
  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: D.number
} : {};
function Ds(t) {
  var o = t.cellCache, n = t.cellRenderer, e = t.cellSizeAndPositionGetter, r = t.indices, i = t.isScrolling;
  return r.map(function(l) {
    var s = e({
      index: l
    }), a = {
      index: l,
      isScrolling: i,
      key: l,
      style: {
        height: s.height,
        left: s.x,
        position: "absolute",
        top: s.y,
        width: s.width
      }
    };
    return i ? (l in o || (o[l] = n(a)), o[l]) : n(a);
  }).filter(function(l) {
    return !!l;
  });
}
function As(t, o, n) {
  return o = he(o), Ie(t, Wr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Wr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wr = function() {
    return !!t;
  })();
}
var Ws = /* @__PURE__ */ function(t) {
  function o(n, e) {
    var r;
    return ve(this, o), r = As(this, o, [n, e]), r._registerChild = r._registerChild.bind(r), r;
  }
  return Re(o, t), me(o, [{
    key: "componentDidUpdate",
    value: function(e) {
      var r = this.props, i = r.columnMaxWidth, l = r.columnMinWidth, s = r.columnCount, a = r.width;
      (i !== e.columnMaxWidth || l !== e.columnMinWidth || s !== e.columnCount || a !== e.width) && this._registeredChild && this._registeredChild.recomputeGridSize();
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.children, i = e.columnMaxWidth, l = e.columnMinWidth, s = e.columnCount, a = e.width, d = l || 1, u = i ? Math.min(i, a) : a, f = a / s;
      f = Math.max(d, f), f = Math.min(u, f), f = Math.floor(f);
      var h = Math.min(a, f * s);
      return r({
        adjustedWidth: h,
        columnWidth: f,
        getColumnWidth: function() {
          return f;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function(e) {
      if (e && typeof e.recomputeGridSize != "function")
        throw Error("Unexpected child type registered; only Grid/MultiGrid children are supported.");
      this._registeredChild = e, this._registeredChild && this._registeredChild.recomputeGridSize();
    }
  }]);
}(oe.PureComponent);
Ws.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: D.func.isRequired,
  /** Optional maximum allowed column width */
  columnMaxWidth: D.number,
  /** Optional minimum allowed column width */
  columnMinWidth: D.number,
  /** Number of columns in Grid or Table child */
  columnCount: D.number.isRequired,
  /** Width of Grid or Table child */
  width: D.number.isRequired
} : {};
function Po(t) {
  var o = t.cellCount, n = t.cellSize, e = t.computeMetadataCallback, r = t.computeMetadataCallbackProps, i = t.nextCellsCount, l = t.nextCellSize, s = t.nextScrollToIndex, a = t.scrollToIndex, d = t.updateScrollOffsetForScrollToIndex;
  (o !== i || (typeof n == "number" || typeof l == "number") && n !== l) && (e(r), a >= 0 && a === s && d());
}
function Us(t, o) {
  if (t == null) return {};
  var n = {};
  for (var e in t) if ({}.hasOwnProperty.call(t, e)) {
    if (o.indexOf(e) !== -1) continue;
    n[e] = t[e];
  }
  return n;
}
function Ct(t, o) {
  if (t == null) return {};
  var n, e, r = Us(t, o);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (e = 0; e < i.length; e++) n = i[e], o.indexOf(n) === -1 && {}.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
var Hs = /* @__PURE__ */ function() {
  function t(o) {
    var n = o.cellCount, e = o.cellSizeGetter, r = o.estimatedCellSize;
    ve(this, t), O(this, "_cellSizeAndPositionData", {}), O(this, "_lastMeasuredIndex", -1), O(this, "_lastBatchedIndex", -1), O(this, "_cellCount", void 0), O(this, "_cellSizeGetter", void 0), O(this, "_estimatedCellSize", void 0), this._cellSizeGetter = e, this._cellCount = n, this._estimatedCellSize = r;
  }
  return me(t, [{
    key: "areOffsetsAdjusted",
    value: function() {
      return !1;
    }
  }, {
    key: "configure",
    value: function(n) {
      var e = n.cellCount, r = n.estimatedCellSize, i = n.cellSizeGetter;
      this._cellCount = e, this._estimatedCellSize = r, this._cellSizeGetter = i;
    }
  }, {
    key: "getCellCount",
    value: function() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */
  }, {
    key: "getSizeAndPositionOfCell",
    value: function(n) {
      if (n < 0 || n >= this._cellCount)
        throw Error("Requested index ".concat(n, " is outside of range 0..").concat(this._cellCount));
      if (n > this._lastMeasuredIndex)
        for (var e = this.getSizeAndPositionOfLastMeasuredCell(), r = e.offset + e.size, i = this._lastMeasuredIndex + 1; i <= n; i++) {
          var l = this._cellSizeGetter({
            index: i
          });
          if (l === void 0 || isNaN(l))
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(l));
          l === null ? (this._cellSizeAndPositionData[i] = {
            offset: r,
            size: 0
          }, this._lastBatchedIndex = n) : (this._cellSizeAndPositionData[i] = {
            offset: r,
            size: l
          }, r += l, this._lastMeasuredIndex = n);
        }
      return this._cellSizeAndPositionData[n];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */
  }, {
    key: "getTotalSize",
    value: function() {
      var n = this.getSizeAndPositionOfLastMeasuredCell(), e = n.offset + n.size, r = this._cellCount - this._lastMeasuredIndex - 1, i = r * this._estimatedCellSize;
      return e + i;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function(n) {
      var e = n.align, r = e === void 0 ? "auto" : e, i = n.containerSize, l = n.currentOffset, s = n.targetIndex;
      if (i <= 0)
        return 0;
      var a = this.getSizeAndPositionOfCell(s), d = a.offset, u = d - i + a.size, f;
      switch (r) {
        case "start":
          f = d;
          break;
        case "end":
          f = u;
          break;
        case "center":
          f = d - (i - a.size) / 2;
          break;
        default:
          f = Math.max(u, Math.min(d, l));
          break;
      }
      var h = this.getTotalSize();
      return Math.max(0, Math.min(h - i, f));
    }
  }, {
    key: "getVisibleCellRange",
    value: function(n) {
      var e = n.containerSize, r = n.offset, i = this.getTotalSize();
      if (i === 0)
        return {};
      var l = r + e, s = this._findNearestCell(r), a = this.getSizeAndPositionOfCell(s);
      r = a.offset + a.size;
      for (var d = s; r < l && d < this._cellCount - 1; )
        d++, r += this.getSizeAndPositionOfCell(d).size;
      return {
        start: s,
        stop: d
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */
  }, {
    key: "resetCell",
    value: function(n) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, n - 1);
    }
  }, {
    key: "_binarySearch",
    value: function(n, e, r) {
      for (; e <= n; ) {
        var i = e + Math.floor((n - e) / 2), l = this.getSizeAndPositionOfCell(i).offset;
        if (l === r)
          return i;
        l < r ? e = i + 1 : l > r && (n = i - 1);
      }
      return e > 0 ? e - 1 : 0;
    }
  }, {
    key: "_exponentialSearch",
    value: function(n, e) {
      for (var r = 1; n < this._cellCount && this.getSizeAndPositionOfCell(n).offset < e; )
        n += r, r *= 2;
      return this._binarySearch(Math.min(n, this._cellCount - 1), Math.floor(n / 2), e);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */
  }, {
    key: "_findNearestCell",
    value: function(n) {
      if (isNaN(n))
        throw Error("Invalid offset ".concat(n, " specified"));
      n = Math.max(0, n);
      var e = this.getSizeAndPositionOfLastMeasuredCell(), r = Math.max(0, this._lastMeasuredIndex);
      return e.offset >= n ? this._binarySearch(r, 0, n) : this._exponentialSearch(r, n);
    }
  }]);
}(), Bs = 15e5, js = 16777100, Fs = function() {
  return typeof window < "u";
}, Vs = function() {
  return !!window.chrome;
}, qs = function() {
  return Fs() && Vs() ? js : Bs;
}, Ks = ["maxScrollSize"], Eo = /* @__PURE__ */ function() {
  function t(o) {
    var n = o.maxScrollSize, e = n === void 0 ? qs() : n, r = Ct(o, Ks);
    ve(this, t), O(this, "_cellSizeAndPositionManager", void 0), O(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new Hs(r), this._maxScrollSize = e;
  }
  return me(t, [{
    key: "areOffsetsAdjusted",
    value: function() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function(n) {
      this._cellSizeAndPositionManager.configure(n);
    }
  }, {
    key: "getCellCount",
    value: function() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */
  }, {
    key: "getOffsetAdjustment",
    value: function(n) {
      var e = n.containerSize, r = n.offset, i = this._cellSizeAndPositionManager.getTotalSize(), l = this.getTotalSize(), s = this._getOffsetPercentage({
        containerSize: e,
        offset: r,
        totalSize: l
      });
      return Math.round(s * (l - i));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function(n) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(n);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */
  }, {
    key: "getTotalSize",
    value: function() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function(n) {
      var e = n.align, r = e === void 0 ? "auto" : e, i = n.containerSize, l = n.currentOffset, s = n.targetIndex;
      l = this._safeOffsetToOffset({
        containerSize: i,
        offset: l
      });
      var a = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: r,
        containerSize: i,
        currentOffset: l,
        targetIndex: s
      });
      return this._offsetToSafeOffset({
        containerSize: i,
        offset: a
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */
  }, {
    key: "getVisibleCellRange",
    value: function(n) {
      var e = n.containerSize, r = n.offset;
      return r = this._safeOffsetToOffset({
        containerSize: e,
        offset: r
      }), this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: e,
        offset: r
      });
    }
  }, {
    key: "resetCell",
    value: function(n) {
      this._cellSizeAndPositionManager.resetCell(n);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function(n) {
      var e = n.containerSize, r = n.offset, i = n.totalSize;
      return i <= e ? 0 : r / (i - e);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function(n) {
      var e = n.containerSize, r = n.offset, i = this._cellSizeAndPositionManager.getTotalSize(), l = this.getTotalSize();
      if (i === l)
        return r;
      var s = this._getOffsetPercentage({
        containerSize: e,
        offset: r,
        totalSize: i
      });
      return Math.round(s * (l - e));
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function(n) {
      var e = n.containerSize, r = n.offset, i = this._cellSizeAndPositionManager.getTotalSize(), l = this.getTotalSize();
      if (i === l)
        return r;
      var s = this._getOffsetPercentage({
        containerSize: e,
        offset: r,
        totalSize: l
      });
      return Math.round(s * (i - e));
    }
  }]);
}(), Wt = -1, je = 1;
function Ys(t) {
  var o = t.cellCount, n = t.overscanCellsCount, e = t.scrollDirection, r = t.startIndex, i = t.stopIndex;
  return e === je ? {
    overscanStartIndex: Math.max(0, r),
    overscanStopIndex: Math.min(o - 1, i + n)
  } : {
    overscanStartIndex: Math.max(0, r - n),
    overscanStopIndex: Math.min(o - 1, i)
  };
}
function No(t) {
  var o = t.cellSize, n = t.cellSizeAndPositionManager, e = t.previousCellsCount, r = t.previousCellSize, i = t.previousScrollToAlignment, l = t.previousScrollToIndex, s = t.previousSize, a = t.scrollOffset, d = t.scrollToAlignment, u = t.scrollToIndex, f = t.size, h = t.sizeJustIncreasedFromZero, p = t.updateScrollIndexCallback, g = n.getCellCount(), m = u >= 0 && u < g, C = f !== s || h || !r || typeof o == "number" && o !== r;
  m && (C || d !== i || u !== l) ? p(u) : !m && g > 0 && (f < s || g < e) && a > n.getTotalSize() - f && p(g - 1);
}
function Xs(t) {
  for (var o = t.cellCache, n = t.cellRenderer, e = t.columnSizeAndPositionManager, r = t.columnStartIndex, i = t.columnStopIndex, l = t.deferredMeasurementCache, s = t.horizontalOffsetAdjustment, a = t.isScrolling, d = t.isScrollingOptOut, u = t.parent, f = t.rowSizeAndPositionManager, h = t.rowStartIndex, p = t.rowStopIndex, g = t.styleCache, m = t.verticalOffsetAdjustment, C = t.visibleColumnIndices, w = t.visibleRowIndices, S = [], M = e.areOffsetsAdjusted() || f.areOffsetsAdjusted(), z = !a && !M, R = h; R <= p; R++)
    for (var P = f.getSizeAndPositionOfCell(R), A = r; A <= i; A++) {
      var _ = e.getSizeAndPositionOfCell(A), $ = A >= C.start && A <= C.stop && R >= w.start && R <= w.stop, E = "".concat(R, "-").concat(A), k = void 0;
      z && g[E] ? k = g[E] : l && !l.has(R, A) ? k = {
        height: "auto",
        left: 0,
        position: "absolute",
        top: 0,
        width: "auto"
      } : (k = {
        height: P.size,
        left: _.offset + s,
        position: "absolute",
        top: P.offset + m,
        width: _.size
      }, g[E] = k);
      var W = {
        columnIndex: A,
        isScrolling: a,
        isVisible: $,
        key: E,
        parent: u,
        rowIndex: R,
        style: k
      }, v = void 0;
      (d || a) && !s && !m ? (o[E] || (o[E] = n(W)), v = o[E]) : v = n(W), !(v == null || v === !1) && (process.env.NODE_ENV !== "production" && Qs(u, v), v.props.role || (v = /* @__PURE__ */ ne.cloneElement(v, {
        role: "gridcell"
      })), S.push(v));
    }
  return S;
}
function Qs(t, o) {
  process.env.NODE_ENV !== "production" && o && (o.type && o.type.__internalCellMeasurerFlag && (o = o.props.children), o && o.props && o.props.style === void 0 && t.__warnedAboutMissingStyle !== !0 && (t.__warnedAboutMissingStyle = !0, console.warn("Rendered cell should include style property for positioning.")));
}
var be;
typeof window < "u" ? be = window : typeof self < "u" ? be = self : be = {};
var Zs = be.requestAnimationFrame || be.webkitRequestAnimationFrame || be.mozRequestAnimationFrame || be.oRequestAnimationFrame || be.msRequestAnimationFrame || function(t) {
  return be.setTimeout(t, 1e3 / 60);
}, Js = be.cancelAnimationFrame || be.webkitCancelAnimationFrame || be.mozCancelAnimationFrame || be.oCancelAnimationFrame || be.msCancelAnimationFrame || function(t) {
  be.clearTimeout(t);
}, $o = Zs, ea = Js, ft = function(o) {
  return ea(o.id);
}, Kn = function(o, n) {
  var e;
  Promise.resolve().then(function() {
    e = Date.now();
  });
  var r = function() {
    Date.now() - e >= n ? o.call() : i.id = $o(r);
  }, i = {
    id: $o(r)
  };
  return i;
};
function Go(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function ke(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Go(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Go(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function ta(t, o, n) {
  return o = he(o), Ie(t, Ur() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Ur() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ur = function() {
    return !!t;
  })();
}
var na = 150, mn = {
  OBSERVED: "observed",
  REQUESTED: "requested"
}, oa = function() {
  return null;
}, Ae = /* @__PURE__ */ function(t) {
  function o(n) {
    var e;
    ve(this, o), e = ta(this, o, [n]), O(e, "_onGridRenderedMemoizer", ht()), O(e, "_onScrollMemoizer", ht(!1)), O(e, "_deferredInvalidateColumnIndex", null), O(e, "_deferredInvalidateRowIndex", null), O(e, "_recomputeScrollLeftFlag", !1), O(e, "_recomputeScrollTopFlag", !1), O(e, "_horizontalScrollBarSize", 0), O(e, "_verticalScrollBarSize", 0), O(e, "_scrollbarPresenceChanged", !1), O(e, "_scrollingContainer", void 0), O(e, "_childrenToDisplay", void 0), O(e, "_columnStartIndex", void 0), O(e, "_columnStopIndex", void 0), O(e, "_rowStartIndex", void 0), O(e, "_rowStopIndex", void 0), O(e, "_renderedColumnStartIndex", 0), O(e, "_renderedColumnStopIndex", 0), O(e, "_renderedRowStartIndex", 0), O(e, "_renderedRowStopIndex", 0), O(e, "_initialScrollTop", void 0), O(e, "_initialScrollLeft", void 0), O(e, "_disablePointerEventsTimeoutId", void 0), O(e, "_styleCache", {}), O(e, "_cellCache", {}), O(e, "_debounceScrollEndedCallback", function() {
      e._disablePointerEventsTimeoutId = null, e.setState({
        isScrolling: !1,
        needToResetStyleCache: !1
      });
    }), O(e, "_invokeOnGridRenderedHelper", function() {
      var l = e.props.onSectionRendered;
      e._onGridRenderedMemoizer({
        callback: l,
        indices: {
          columnOverscanStartIndex: e._columnStartIndex,
          columnOverscanStopIndex: e._columnStopIndex,
          columnStartIndex: e._renderedColumnStartIndex,
          columnStopIndex: e._renderedColumnStopIndex,
          rowOverscanStartIndex: e._rowStartIndex,
          rowOverscanStopIndex: e._rowStopIndex,
          rowStartIndex: e._renderedRowStartIndex,
          rowStopIndex: e._renderedRowStopIndex
        }
      });
    }), O(e, "_setScrollingContainerRef", function(l) {
      e._scrollingContainer = l, typeof e.props.elementRef == "function" ? e.props.elementRef(l) : st(e.props.elementRef) === "object" && (e.props.elementRef.current = l);
    }), O(e, "_onScroll", function(l) {
      l.target === e._scrollingContainer && e.handleScrollEvent(l.target);
    });
    var r = new Eo({
      cellCount: n.columnCount,
      cellSizeGetter: function(s) {
        return o._wrapSizeGetter(n.columnWidth)(s);
      },
      estimatedCellSize: o._getEstimatedColumnSize(n)
    }), i = new Eo({
      cellCount: n.rowCount,
      cellSizeGetter: function(s) {
        return o._wrapSizeGetter(n.rowHeight)(s);
      },
      estimatedCellSize: o._getEstimatedRowSize(n)
    });
    return e.state = {
      instanceProps: {
        columnSizeAndPositionManager: r,
        rowSizeAndPositionManager: i,
        prevColumnWidth: n.columnWidth,
        prevRowHeight: n.rowHeight,
        prevColumnCount: n.columnCount,
        prevRowCount: n.rowCount,
        prevIsScrolling: n.isScrolling === !0,
        prevScrollToColumn: n.scrollToColumn,
        prevScrollToRow: n.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: !1
      },
      isScrolling: !1,
      scrollDirectionHorizontal: je,
      scrollDirectionVertical: je,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: !1
    }, n.scrollToRow > 0 && (e._initialScrollTop = e._getCalculatedScrollTop(n, e.state)), n.scrollToColumn > 0 && (e._initialScrollLeft = e._getCalculatedScrollLeft(n, e.state)), e;
  }
  return Re(o, t), me(o, [{
    key: "getOffsetForCell",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.alignment, i = r === void 0 ? this.props.scrollToAlignment : r, l = e.columnIndex, s = l === void 0 ? this.props.scrollToColumn : l, a = e.rowIndex, d = a === void 0 ? this.props.scrollToRow : a, u = ke(ke({}, this.props), {}, {
        scrollToAlignment: i,
        scrollToColumn: s,
        scrollToRow: d
      });
      return {
        scrollLeft: this._getCalculatedScrollLeft(u),
        scrollTop: this._getCalculatedScrollTop(u)
      };
    }
    /**
     * Gets estimated total rows' height.
     */
  }, {
    key: "getTotalRowsHeight",
    value: function() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */
  }, {
    key: "getTotalColumnsWidth",
    value: function() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */
  }, {
    key: "handleScrollEvent",
    value: function(e) {
      var r = e.scrollLeft, i = r === void 0 ? 0 : r, l = e.scrollTop, s = l === void 0 ? 0 : l;
      if (!(s < 0)) {
        this._debounceScrollEnded();
        var a = this.props, d = a.autoHeight, u = a.autoWidth, f = a.height, h = a.width, p = this.state.instanceProps, g = p.scrollbarSize, m = p.rowSizeAndPositionManager.getTotalSize(), C = p.columnSizeAndPositionManager.getTotalSize(), w = Math.min(Math.max(0, C - h + g), i), S = Math.min(Math.max(0, m - f + g), s);
        if (this.state.scrollLeft !== w || this.state.scrollTop !== S) {
          var M = w !== this.state.scrollLeft ? w > this.state.scrollLeft ? je : Wt : this.state.scrollDirectionHorizontal, z = S !== this.state.scrollTop ? S > this.state.scrollTop ? je : Wt : this.state.scrollDirectionVertical, R = {
            isScrolling: !0,
            scrollDirectionHorizontal: M,
            scrollDirectionVertical: z,
            scrollPositionChangeReason: mn.OBSERVED
          };
          d || (R.scrollTop = S), u || (R.scrollLeft = w), R.needToResetStyleCache = !1, this.setState(R);
        }
        this._invokeOnScrollMemoizer({
          scrollLeft: w,
          scrollTop: S,
          totalColumnsWidth: C,
          totalRowsHeight: m
        });
      }
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(e) {
      var r = e.columnIndex, i = e.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, r) : r, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, i) : i;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */
  }, {
    key: "measureAllCells",
    value: function() {
      var e = this.props, r = e.columnCount, i = e.rowCount, l = this.state.instanceProps;
      l.columnSizeAndPositionManager.getSizeAndPositionOfCell(r - 1), l.rowSizeAndPositionManager.getSizeAndPositionOfCell(i - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.columnIndex, i = r === void 0 ? 0 : r, l = e.rowIndex, s = l === void 0 ? 0 : l, a = this.props, d = a.scrollToColumn, u = a.scrollToRow, f = this.state.instanceProps;
      f.columnSizeAndPositionManager.resetCell(i), f.rowSizeAndPositionManager.resetCell(s), this._recomputeScrollLeftFlag = d >= 0 && (this.state.scrollDirectionHorizontal === je ? i <= d : i >= d), this._recomputeScrollTopFlag = u >= 0 && (this.state.scrollDirectionVertical === je ? s <= u : s >= u), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */
  }, {
    key: "scrollToCell",
    value: function(e) {
      var r = e.columnIndex, i = e.rowIndex, l = this.props.columnCount, s = this.props;
      l > 1 && r !== void 0 && this._updateScrollLeftForScrollToColumn(ke(ke({}, s), {}, {
        scrollToColumn: r
      })), i !== void 0 && this._updateScrollTopForScrollToRow(ke(ke({}, s), {}, {
        scrollToRow: i
      }));
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props, r = e.getScrollbarSize, i = e.height, l = e.scrollLeft, s = e.scrollToColumn, a = e.scrollTop, d = e.scrollToRow, u = e.width, f = this.state.instanceProps;
      if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), f.scrollbarSizeMeasured || this.setState(function(g) {
        var m = ke(ke({}, g), {}, {
          needToResetStyleCache: !1
        });
        return m.instanceProps.scrollbarSize = r(), m.instanceProps.scrollbarSizeMeasured = !0, m;
      }), typeof l == "number" && l >= 0 || typeof a == "number" && a >= 0) {
        var h = o._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: l,
          scrollTop: a
        });
        h && (h.needToResetStyleCache = !1, this.setState(h));
      }
      this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
      var p = i > 0 && u > 0;
      s >= 0 && p && this._updateScrollLeftForScrollToColumn(), d >= 0 && p && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
        scrollLeft: l || 0,
        scrollTop: a || 0,
        totalColumnsWidth: f.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: f.rowSizeAndPositionManager.getTotalSize()
      }), this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */
  }, {
    key: "componentDidUpdate",
    value: function(e, r) {
      var i = this, l = this.props, s = l.autoHeight, a = l.autoWidth, d = l.columnCount, u = l.height, f = l.rowCount, h = l.scrollToAlignment, p = l.scrollToColumn, g = l.scrollToRow, m = l.width, C = this.state, w = C.scrollLeft, S = C.scrollPositionChangeReason, M = C.scrollTop, z = C.instanceProps;
      this._handleInvalidatedGridSize();
      var R = d > 0 && e.columnCount === 0 || f > 0 && e.rowCount === 0;
      S === mn.REQUESTED && (!a && w >= 0 && (w !== this._scrollingContainer.scrollLeft || R) && (this._scrollingContainer.scrollLeft = w), !s && M >= 0 && (M !== this._scrollingContainer.scrollTop || R) && (this._scrollingContainer.scrollTop = M));
      var P = (e.width === 0 || e.height === 0) && u > 0 && m > 0;
      if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : No({
        cellSizeAndPositionManager: z.columnSizeAndPositionManager,
        previousCellsCount: e.columnCount,
        previousCellSize: e.columnWidth,
        previousScrollToAlignment: e.scrollToAlignment,
        previousScrollToIndex: e.scrollToColumn,
        previousSize: e.width,
        scrollOffset: w,
        scrollToAlignment: h,
        scrollToIndex: p,
        size: m,
        sizeJustIncreasedFromZero: P,
        updateScrollIndexCallback: function() {
          return i._updateScrollLeftForScrollToColumn(i.props);
        }
      }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : No({
        cellSizeAndPositionManager: z.rowSizeAndPositionManager,
        previousCellsCount: e.rowCount,
        previousCellSize: e.rowHeight,
        previousScrollToAlignment: e.scrollToAlignment,
        previousScrollToIndex: e.scrollToRow,
        previousSize: e.height,
        scrollOffset: M,
        scrollToAlignment: h,
        scrollToIndex: g,
        size: u,
        sizeJustIncreasedFromZero: P,
        updateScrollIndexCallback: function() {
          return i._updateScrollTopForScrollToRow(i.props);
        }
      }), this._invokeOnGridRenderedHelper(), w !== r.scrollLeft || M !== r.scrollTop) {
        var A = z.rowSizeAndPositionManager.getTotalSize(), _ = z.columnSizeAndPositionManager.getTotalSize();
        this._invokeOnScrollMemoizer({
          scrollLeft: w,
          scrollTop: M,
          totalColumnsWidth: _,
          totalRowsHeight: A
        });
      }
      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._disablePointerEventsTimeoutId && ft(this._disablePointerEventsTimeoutId);
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.autoContainerWidth, i = e.autoHeight, l = e.autoWidth, s = e.className, a = e.containerProps, d = e.containerRole, u = e.containerStyle, f = e.height, h = e.id, p = e.noContentRenderer, g = e.role, m = e.style, C = e.tabIndex, w = e.width, S = this.state, M = S.instanceProps, z = S.needToResetStyleCache, R = this._isScrolling(), P = {
        boxSizing: "border-box",
        direction: "ltr",
        height: i ? "auto" : f,
        position: "relative",
        width: l ? "auto" : w,
        WebkitOverflowScrolling: "touch",
        willChange: "transform"
      };
      z && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
      var A = M.columnSizeAndPositionManager.getTotalSize(), _ = M.rowSizeAndPositionManager.getTotalSize(), $ = _ > f ? M.scrollbarSize : 0, E = A > w ? M.scrollbarSize : 0;
      (E !== this._horizontalScrollBarSize || $ !== this._verticalScrollBarSize) && (this._horizontalScrollBarSize = E, this._verticalScrollBarSize = $, this._scrollbarPresenceChanged = !0), P.overflowX = A + $ <= w ? "hidden" : "auto", P.overflowY = _ + E <= f ? "hidden" : "auto";
      var k = this._childrenToDisplay, W = k.length === 0 && f > 0 && w > 0;
      return /* @__PURE__ */ oe.createElement("div", Pe({
        ref: this._setScrollingContainerRef
      }, a, {
        "aria-label": this.props["aria-label"],
        "aria-readonly": this.props["aria-readonly"],
        className: Ge("ReactVirtualized__Grid", s),
        id: h,
        onScroll: this._onScroll,
        role: g,
        style: ke(ke({}, P), m),
        tabIndex: C
      }), k.length > 0 && /* @__PURE__ */ oe.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: d,
        style: ke({
          width: r ? "auto" : A,
          height: _,
          maxWidth: A,
          maxHeight: _,
          overflow: "hidden",
          pointerEvents: R ? "none" : "",
          position: "relative"
        }, u)
      }, k), W && p());
    }
    /* ---------------------------- Helper methods ---------------------------- */
  }, {
    key: "_calculateChildrenToRender",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, i = e.cellRenderer, l = e.cellRangeRenderer, s = e.columnCount, a = e.deferredMeasurementCache, d = e.height, u = e.overscanColumnCount, f = e.overscanIndicesGetter, h = e.overscanRowCount, p = e.rowCount, g = e.width, m = e.isScrollingOptOut, C = r.scrollDirectionHorizontal, w = r.scrollDirectionVertical, S = r.instanceProps, M = this._initialScrollTop > 0 ? this._initialScrollTop : r.scrollTop, z = this._initialScrollLeft > 0 ? this._initialScrollLeft : r.scrollLeft, R = this._isScrolling(e, r);
      if (this._childrenToDisplay = [], d > 0 && g > 0) {
        var P = S.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: g,
          offset: z
        }), A = S.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: d,
          offset: M
        }), _ = S.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: g,
          offset: z
        }), $ = S.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: d,
          offset: M
        });
        this._renderedColumnStartIndex = P.start, this._renderedColumnStopIndex = P.stop, this._renderedRowStartIndex = A.start, this._renderedRowStopIndex = A.stop;
        var E = f({
          direction: "horizontal",
          cellCount: s,
          overscanCellsCount: u,
          scrollDirection: C,
          startIndex: typeof P.start == "number" ? P.start : 0,
          stopIndex: typeof P.stop == "number" ? P.stop : -1
        }), k = f({
          direction: "vertical",
          cellCount: p,
          overscanCellsCount: h,
          scrollDirection: w,
          startIndex: typeof A.start == "number" ? A.start : 0,
          stopIndex: typeof A.stop == "number" ? A.stop : -1
        }), W = E.overscanStartIndex, v = E.overscanStopIndex, G = k.overscanStartIndex, b = k.overscanStopIndex;
        if (a) {
          if (!a.hasFixedHeight()) {
            for (var L = G; L <= b; L++)
              if (!a.has(L, 0)) {
                W = 0, v = s - 1;
                break;
              }
          }
          if (!a.hasFixedWidth()) {
            for (var x = W; x <= v; x++)
              if (!a.has(0, x)) {
                G = 0, b = p - 1;
                break;
              }
          }
        }
        this._childrenToDisplay = l({
          cellCache: this._cellCache,
          cellRenderer: i,
          columnSizeAndPositionManager: S.columnSizeAndPositionManager,
          columnStartIndex: W,
          columnStopIndex: v,
          deferredMeasurementCache: a,
          horizontalOffsetAdjustment: _,
          isScrolling: R,
          isScrollingOptOut: m,
          parent: this,
          rowSizeAndPositionManager: S.rowSizeAndPositionManager,
          rowStartIndex: G,
          rowStopIndex: b,
          scrollLeft: z,
          scrollTop: M,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: $,
          visibleColumnIndices: P,
          visibleRowIndices: A
        }), this._columnStartIndex = W, this._columnStopIndex = v, this._rowStartIndex = G, this._rowStopIndex = b;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_debounceScrollEnded",
    value: function() {
      var e = this.props.scrollingResetTimeInterval;
      this._disablePointerEventsTimeoutId && ft(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = Kn(this._debounceScrollEndedCallback, e);
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: (
      /**
       * Check for batched CellMeasurer size invalidations.
       * This will occur the first time one or more previously unmeasured cells are rendered.
       */
      function() {
        if (typeof this._deferredInvalidateColumnIndex == "number" && typeof this._deferredInvalidateRowIndex == "number") {
          var e = this._deferredInvalidateColumnIndex, r = this._deferredInvalidateRowIndex;
          this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
            columnIndex: e,
            rowIndex: r
          });
        }
      }
    )
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function(e) {
      var r = this, i = e.scrollLeft, l = e.scrollTop, s = e.totalColumnsWidth, a = e.totalRowsHeight;
      this._onScrollMemoizer({
        callback: function(u) {
          var f = u.scrollLeft, h = u.scrollTop, p = r.props, g = p.height, m = p.onScroll, C = p.width;
          m({
            clientHeight: g,
            clientWidth: C,
            scrollHeight: a,
            scrollLeft: f,
            scrollTop: h,
            scrollWidth: s
          });
        },
        indices: {
          scrollLeft: i,
          scrollTop: l
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return Object.hasOwnProperty.call(e, "isScrolling") ? !!e.isScrolling : !!r.isScrolling;
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function() {
      if (this._scrollbarPresenceChanged) {
        var e = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = !1, e({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",
    value: (
      /**
       * Scroll to the specified offset(s).
       * Useful for animating position changes.
       */
      function(e) {
        var r = e.scrollLeft, i = e.scrollTop, l = o._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: r,
          scrollTop: i
        });
        l && (l.needToResetStyleCache = !1, this.setState(l));
      }
    )
  }, {
    key: "_getCalculatedScrollLeft",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return o._getCalculatedScrollLeft(e, r);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, i = o._getScrollLeftForScrollToColumnStateUpdate(e, r);
      i && (i.needToResetStyleCache = !1, this.setState(i));
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return o._getCalculatedScrollTop(e, r);
    }
  }, {
    key: "_resetStyleCache",
    value: function() {
      var e = this._styleCache, r = this._cellCache, i = this.props.isScrollingOptOut;
      this._cellCache = {}, this._styleCache = {};
      for (var l = this._rowStartIndex; l <= this._rowStopIndex; l++)
        for (var s = this._columnStartIndex; s <= this._columnStopIndex; s++) {
          var a = "".concat(l, "-").concat(s);
          this._styleCache[a] = e[a], i && (this._cellCache[a] = r[a]);
        }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, i = o._getScrollTopForScrollToRowStateUpdate(e, r);
      i && (i.needToResetStyleCache = !1, this.setState(i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, r) {
      var i = {};
      e.columnCount === 0 && r.scrollLeft !== 0 || e.rowCount === 0 && r.scrollTop !== 0 ? (i.scrollLeft = 0, i.scrollTop = 0) : (e.scrollLeft !== r.scrollLeft && e.scrollToColumn < 0 || e.scrollTop !== r.scrollTop && e.scrollToRow < 0) && Object.assign(i, o._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop
      }));
      var l = r.instanceProps;
      i.needToResetStyleCache = !1, (e.columnWidth !== l.prevColumnWidth || e.rowHeight !== l.prevRowHeight) && (i.needToResetStyleCache = !0), l.columnSizeAndPositionManager.configure({
        cellCount: e.columnCount,
        estimatedCellSize: o._getEstimatedColumnSize(e),
        cellSizeGetter: o._wrapSizeGetter(e.columnWidth)
      }), l.rowSizeAndPositionManager.configure({
        cellCount: e.rowCount,
        estimatedCellSize: o._getEstimatedRowSize(e),
        cellSizeGetter: o._wrapSizeGetter(e.rowHeight)
      }), (l.prevColumnCount === 0 || l.prevRowCount === 0) && (l.prevColumnCount = 0, l.prevRowCount = 0), e.autoHeight && e.isScrolling === !1 && l.prevIsScrolling === !0 && Object.assign(i, {
        isScrolling: !1
      });
      var s, a;
      return Po({
        cellCount: l.prevColumnCount,
        cellSize: typeof l.prevColumnWidth == "number" ? l.prevColumnWidth : null,
        computeMetadataCallback: function() {
          return l.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: e,
        nextCellsCount: e.columnCount,
        nextCellSize: typeof e.columnWidth == "number" ? e.columnWidth : null,
        nextScrollToIndex: e.scrollToColumn,
        scrollToIndex: l.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function() {
          s = o._getScrollLeftForScrollToColumnStateUpdate(e, r);
        }
      }), Po({
        cellCount: l.prevRowCount,
        cellSize: typeof l.prevRowHeight == "number" ? l.prevRowHeight : null,
        computeMetadataCallback: function() {
          return l.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: e,
        nextCellsCount: e.rowCount,
        nextCellSize: typeof e.rowHeight == "number" ? e.rowHeight : null,
        nextScrollToIndex: e.scrollToRow,
        scrollToIndex: l.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function() {
          a = o._getScrollTopForScrollToRowStateUpdate(e, r);
        }
      }), l.prevColumnCount = e.columnCount, l.prevColumnWidth = e.columnWidth, l.prevIsScrolling = e.isScrolling === !0, l.prevRowCount = e.rowCount, l.prevRowHeight = e.rowHeight, l.prevScrollToColumn = e.scrollToColumn, l.prevScrollToRow = e.scrollToRow, l.scrollbarSize = e.getScrollbarSize(), l.scrollbarSize === void 0 ? (l.scrollbarSizeMeasured = !1, l.scrollbarSize = 0) : l.scrollbarSizeMeasured = !0, i.instanceProps = l, ke(ke(ke({}, i), s), a);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function(e) {
      return typeof e.columnWidth == "number" ? e.columnWidth : e.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function(e) {
      return typeof e.rowHeight == "number" ? e.rowHeight : e.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",
    value: (
      /**
       * Get the updated state after scrolling to
       * scrollLeft and scrollTop
       */
      function(e) {
        var r = e.prevState, i = e.scrollLeft, l = e.scrollTop, s = {
          scrollPositionChangeReason: mn.REQUESTED
        };
        return typeof i == "number" && i >= 0 && (s.scrollDirectionHorizontal = i > r.scrollLeft ? je : Wt, s.scrollLeft = i), typeof l == "number" && l >= 0 && (s.scrollDirectionVertical = l > r.scrollTop ? je : Wt, s.scrollTop = l), typeof i == "number" && i >= 0 && i !== r.scrollLeft || typeof l == "number" && l >= 0 && l !== r.scrollTop ? s : {};
      }
    )
  }, {
    key: "_wrapSizeGetter",
    value: function(e) {
      return typeof e == "function" ? e : function() {
        return e;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function(e, r) {
      var i = e.columnCount, l = e.height, s = e.scrollToAlignment, a = e.scrollToColumn, d = e.width, u = r.scrollLeft, f = r.instanceProps;
      if (i > 0) {
        var h = i - 1, p = a < 0 ? h : Math.min(h, a), g = f.rowSizeAndPositionManager.getTotalSize(), m = f.scrollbarSizeMeasured && g > l ? f.scrollbarSize : 0;
        return f.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: s,
          containerSize: d - m,
          currentOffset: u,
          targetIndex: p
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function(e, r) {
      var i = r.scrollLeft, l = o._getCalculatedScrollLeft(e, r);
      return typeof l == "number" && l >= 0 && i !== l ? o._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: l,
        scrollTop: -1
      }) : {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function(e, r) {
      var i = e.height, l = e.rowCount, s = e.scrollToAlignment, a = e.scrollToRow, d = e.width, u = r.scrollTop, f = r.instanceProps;
      if (l > 0) {
        var h = l - 1, p = a < 0 ? h : Math.min(h, a), g = f.columnSizeAndPositionManager.getTotalSize(), m = f.scrollbarSizeMeasured && g > d ? f.scrollbarSize : 0;
        return f.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: s,
          containerSize: i - m,
          currentOffset: u,
          targetIndex: p
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function(e, r) {
      var i = r.scrollTop, l = o._getCalculatedScrollTop(e, r);
      return typeof l == "number" && l >= 0 && i !== l ? o._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: -1,
        scrollTop: l
      }) : {};
    }
  }]);
}(oe.PureComponent);
O(Ae, "defaultProps", {
  "aria-label": "grid",
  "aria-readonly": !0,
  autoContainerWidth: !1,
  autoHeight: !1,
  autoWidth: !1,
  cellRangeRenderer: Xs,
  containerRole: "row",
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: $n,
  noContentRenderer: oa,
  onScroll: function() {
  },
  onScrollbarPresenceChange: function() {
  },
  onSectionRendered: function() {
  },
  overscanColumnCount: 0,
  overscanIndicesGetter: Ys,
  overscanRowCount: 10,
  role: "grid",
  scrollingResetTimeInterval: na,
  scrollToAlignment: "auto",
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: !1
});
Mt(Ae);
var ra = 1;
function Hr(t) {
  var o = t.cellCount, n = t.overscanCellsCount, e = t.scrollDirection, r = t.startIndex, i = t.stopIndex;
  return n = Math.max(1, n), e === ra ? {
    overscanStartIndex: Math.max(0, r - 1),
    overscanStopIndex: Math.min(o - 1, i + n)
  } : {
    overscanStartIndex: Math.max(0, r - n),
    overscanStopIndex: Math.min(o - 1, i + 1)
  };
}
function Gn(t, o) {
  (o == null || o > t.length) && (o = t.length);
  for (var n = 0, e = Array(o); n < o; n++) e[n] = t[n];
  return e;
}
function ia(t) {
  if (Array.isArray(t)) return Gn(t);
}
function la(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Br(t, o) {
  if (t) {
    if (typeof t == "string") return Gn(t, o);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Gn(t, o) : void 0;
  }
}
function sa() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aa(t) {
  return ia(t) || la(t) || Br(t) || sa();
}
function ca(t, o, n) {
  return o = he(o), Ie(t, jr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function jr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jr = function() {
    return !!t;
  })();
}
var Et = /* @__PURE__ */ function(t) {
  function o(n, e) {
    var r;
    return ve(this, o), r = ca(this, o, [n, e]), r._loadMoreRowsMemoizer = ht(), r._onRowsRendered = r._onRowsRendered.bind(r), r._registerChild = r._registerChild.bind(r), r;
  }
  return Re(o, t), me(o, [{
    key: "resetLoadMoreRowsCache",
    value: function(e) {
      this._loadMoreRowsMemoizer = ht(), e && this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props.children;
      return e({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function(e) {
      var r = this, i = this.props.loadMoreRows;
      e.forEach(function(l) {
        var s = i(l);
        s && s.then(function() {
          da({
            lastRenderedStartIndex: r._lastRenderedStartIndex,
            lastRenderedStopIndex: r._lastRenderedStopIndex,
            startIndex: l.startIndex,
            stopIndex: l.stopIndex
          }) && r._registeredChild && ha(r._registeredChild, r._lastRenderedStartIndex);
        });
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function(e) {
      var r = e.startIndex, i = e.stopIndex;
      this._lastRenderedStartIndex = r, this._lastRenderedStopIndex = i, this._doStuff(r, i);
    }
  }, {
    key: "_doStuff",
    value: function(e, r) {
      var i, l = this, s = this.props, a = s.isRowLoaded, d = s.minimumBatchSize, u = s.rowCount, f = s.threshold, h = ua({
        isRowLoaded: a,
        minimumBatchSize: d,
        rowCount: u,
        startIndex: Math.max(0, e - f),
        stopIndex: Math.min(u - 1, r + f)
      }), p = (i = []).concat.apply(i, aa(h.map(function(g) {
        var m = g.startIndex, C = g.stopIndex;
        return [m, C];
      })));
      this._loadMoreRowsMemoizer({
        callback: function() {
          l._loadUnloadedRanges(h);
        },
        indices: {
          squashedUnloadedRanges: p
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function(e) {
      this._registeredChild = e;
    }
  }]);
}(oe.PureComponent);
O(Et, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});
Et.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: D.func.isRequired,
  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: D.func.isRequired,
  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: D.func.isRequired,
  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: D.number.isRequired,
  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: D.number.isRequired,
  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: D.number.isRequired
} : {};
function da(t) {
  var o = t.lastRenderedStartIndex, n = t.lastRenderedStopIndex, e = t.startIndex, r = t.stopIndex;
  return !(e > n || r < o);
}
function ua(t) {
  for (var o = t.isRowLoaded, n = t.minimumBatchSize, e = t.rowCount, r = t.startIndex, i = t.stopIndex, l = [], s = null, a = null, d = r; d <= i; d++) {
    var u = o({
      index: d
    });
    u ? a !== null && (l.push({
      startIndex: s,
      stopIndex: a
    }), s = a = null) : (a = d, s === null && (s = d));
  }
  if (a !== null) {
    for (var f = Math.min(Math.max(a, s + n - 1), e - 1), h = a + 1; h <= f && !o({
      index: h
    }); h++)
      a = h;
    l.push({
      startIndex: s,
      stopIndex: a
    });
  }
  if (l.length)
    for (var p = l[0]; p.stopIndex - p.startIndex + 1 < n && p.startIndex > 0; ) {
      var g = p.startIndex - 1;
      if (!o({
        index: g
      }))
        p.startIndex = g;
      else
        break;
    }
  return l;
}
function ha(t) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = typeof t.recomputeGridSize == "function" ? t.recomputeGridSize : t.recomputeRowHeights;
  n ? n.call(t, o) : t.forceUpdate();
}
function fa(t, o, n) {
  return o = he(o), Ie(t, Fr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Fr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Fr = function() {
    return !!t;
  })();
}
var Vr = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = fa(this, o, [].concat(r)), O(n, "Grid", void 0), O(n, "_cellRenderer", function(l) {
      var s = l.parent, a = l.rowIndex, d = l.style, u = l.isScrolling, f = l.isVisible, h = l.key, p = n.props.rowRenderer, g = Object.getOwnPropertyDescriptor(d, "width");
      return g && g.writable && (d.width = "100%"), p({
        index: a,
        style: d,
        isScrolling: u,
        isVisible: f,
        key: h,
        parent: s
      });
    }), O(n, "_setRef", function(l) {
      n.Grid = l;
    }), O(n, "_onScroll", function(l) {
      var s = l.clientHeight, a = l.scrollHeight, d = l.scrollTop, u = n.props.onScroll;
      u({
        clientHeight: s,
        scrollHeight: a,
        scrollTop: d
      });
    }), O(n, "_onSectionRendered", function(l) {
      var s = l.rowOverscanStartIndex, a = l.rowOverscanStopIndex, d = l.rowStartIndex, u = l.rowStopIndex, f = n.props.onRowsRendered;
      f({
        overscanStartIndex: s,
        overscanStopIndex: a,
        startIndex: d,
        stopIndex: u
      });
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "forceUpdateGrid",
    value: function() {
      this.Grid && this.Grid.forceUpdate();
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function(e) {
      var r = e.alignment, i = e.index;
      if (this.Grid) {
        var l = this.Grid.getOffsetForCell({
          alignment: r,
          rowIndex: i,
          columnIndex: 0
        }), s = l.scrollTop;
        return s;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(e) {
      var r = e.columnIndex, i = e.rowIndex;
      this.Grid && this.Grid.invalidateCellSizeAfterRender({
        rowIndex: i,
        columnIndex: r
      });
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function() {
      this.Grid && this.Grid.measureAllCells();
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.columnIndex, i = r === void 0 ? 0 : r, l = e.rowIndex, s = l === void 0 ? 0 : l;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: s,
        columnIndex: i
      });
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: e,
        columnIndex: 0
      });
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToPosition({
        scrollTop: e
      });
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: e
      });
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.className, i = e.noRowsRenderer, l = e.scrollToIndex, s = e.width, a = Ge("ReactVirtualized__List", r);
      return /* @__PURE__ */ oe.createElement(Ae, Pe({}, this.props, {
        autoContainerWidth: !0,
        cellRenderer: this._cellRenderer,
        className: a,
        columnWidth: s,
        columnCount: 1,
        noContentRenderer: i,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: l
      }));
    }
  }]);
}(oe.PureComponent);
O(Vr, "defaultProps", {
  autoHeight: !1,
  estimatedRowSize: 30,
  onScroll: function() {
  },
  noRowsRenderer: function() {
    return null;
  },
  onRowsRendered: function() {
  },
  overscanIndicesGetter: Hr,
  overscanRowCount: 10,
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
function pa(t) {
  if (Array.isArray(t)) return t;
}
function ga(t, o) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var e, r, i, l, s = [], a = !0, d = !1;
    try {
      if (i = (n = n.call(t)).next, o !== 0) for (; !(a = (e = i.call(n)).done) && (s.push(e.value), s.length !== o); a = !0) ;
    } catch (u) {
      d = !0, r = u;
    } finally {
      try {
        if (!a && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (d) throw r;
      }
    }
    return s;
  }
}
function va() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ma(t, o) {
  return pa(t) || ga(t, o) || Br(t, o) || va();
}
function ya(t, o, n, e) {
  for (var r = n + 1; o <= n; ) {
    var i = o + n >>> 1, l = t[i];
    l >= e ? (r = i, n = i - 1) : o = i + 1;
  }
  return r;
}
function wa(t, o, n, e, r) {
  for (var i = n + 1; o <= n; ) {
    var l = o + n >>> 1, s = t[l];
    r(s, e) >= 0 ? (i = l, n = l - 1) : o = l + 1;
  }
  return i;
}
function Sa(t, o, n, e, r) {
  return typeof n == "function" ? wa(t, e === void 0 ? 0 : e | 0, r === void 0 ? t.length - 1 : r | 0, o, n) : ya(t, n === void 0 ? 0 : n | 0, e === void 0 ? t.length - 1 : e | 0, o);
}
function Ca(t, o, n, e) {
  for (var r = n + 1; o <= n; ) {
    var i = o + n >>> 1, l = t[i];
    l > e ? (r = i, n = i - 1) : o = i + 1;
  }
  return r;
}
function _a(t, o, n, e, r) {
  for (var i = n + 1; o <= n; ) {
    var l = o + n >>> 1, s = t[l];
    r(s, e) > 0 ? (i = l, n = l - 1) : o = l + 1;
  }
  return i;
}
function ba(t, o, n, e, r) {
  return typeof n == "function" ? _a(t, e === void 0 ? 0 : e | 0, r === void 0 ? t.length - 1 : r | 0, o, n) : Ca(t, n === void 0 ? 0 : n | 0, e === void 0 ? t.length - 1 : e | 0, o);
}
function xa(t, o, n, e) {
  for (var r = o - 1; o <= n; ) {
    var i = o + n >>> 1, l = t[i];
    l < e ? (r = i, o = i + 1) : n = i - 1;
  }
  return r;
}
function Ta(t, o, n, e, r) {
  for (var i = o - 1; o <= n; ) {
    var l = o + n >>> 1, s = t[l];
    r(s, e) < 0 ? (i = l, o = l + 1) : n = l - 1;
  }
  return i;
}
function Ia(t, o, n, e, r) {
  return typeof n == "function" ? Ta(t, e === void 0 ? 0 : e | 0, r === void 0 ? t.length - 1 : r | 0, o, n) : xa(t, n === void 0 ? 0 : n | 0, e === void 0 ? t.length - 1 : e | 0, o);
}
function Ra(t, o, n, e) {
  for (var r = o - 1; o <= n; ) {
    var i = o + n >>> 1, l = t[i];
    l <= e ? (r = i, o = i + 1) : n = i - 1;
  }
  return r;
}
function ka(t, o, n, e, r) {
  for (var i = o - 1; o <= n; ) {
    var l = o + n >>> 1, s = t[l];
    r(s, e) <= 0 ? (i = l, o = l + 1) : n = l - 1;
  }
  return i;
}
function La(t, o, n, e, r) {
  return typeof n == "function" ? ka(t, e === void 0 ? 0 : e | 0, r === void 0 ? t.length - 1 : r | 0, o, n) : Ra(t, n === void 0 ? 0 : n | 0, e === void 0 ? t.length - 1 : e | 0, o);
}
function Oa(t, o, n, e) {
  for (; o <= n; ) {
    var r = o + n >>> 1, i = t[r];
    if (i === e)
      return r;
    i <= e ? o = r + 1 : n = r - 1;
  }
  return -1;
}
function za(t, o, n, e, r) {
  for (; o <= n; ) {
    var i = o + n >>> 1, l = t[i], s = r(l, e);
    if (s === 0)
      return i;
    s <= 0 ? o = i + 1 : n = i - 1;
  }
  return -1;
}
function Ma(t, o, n, e, r) {
  return typeof n == "function" ? za(t, e === void 0 ? 0 : e | 0, r === void 0 ? t.length - 1 : r | 0, o, n) : Oa(t, n === void 0 ? 0 : n | 0, e === void 0 ? t.length - 1 : e | 0, o);
}
const en = {
  ge: Sa,
  gt: ba,
  lt: Ia,
  le: La,
  eq: Ma
};
var dt = 0, rt = 1, Kt = 2;
function Yn(t, o, n, e, r) {
  this.mid = t, this.left = o, this.right = n, this.leftPoints = e, this.rightPoints = r, this.count = (o ? o.count : 0) + (n ? n.count : 0) + e.length;
}
var Nt = Yn.prototype;
function yn(t, o) {
  t.mid = o.mid, t.left = o.left, t.right = o.right, t.leftPoints = o.leftPoints, t.rightPoints = o.rightPoints, t.count = o.count;
}
function qr(t, o) {
  var n = It(o);
  t.mid = n.mid, t.left = n.left, t.right = n.right, t.leftPoints = n.leftPoints, t.rightPoints = n.rightPoints, t.count = n.count;
}
function Do(t, o) {
  var n = t.intervals([]);
  n.push(o), qr(t, n);
}
function Ao(t, o) {
  var n = t.intervals([]), e = n.indexOf(o);
  return e < 0 ? dt : (n.splice(e, 1), qr(t, n), rt);
}
Nt.intervals = function(t) {
  return t.push.apply(t, this.leftPoints), this.left && this.left.intervals(t), this.right && this.right.intervals(t), t;
};
Nt.insert = function(t) {
  var o = this.count - this.leftPoints.length;
  if (this.count += 1, t[1] < this.mid)
    this.left ? 4 * (this.left.count + 1) > 3 * (o + 1) ? Do(this, t) : this.left.insert(t) : this.left = It([t]);
  else if (t[0] > this.mid)
    this.right ? 4 * (this.right.count + 1) > 3 * (o + 1) ? Do(this, t) : this.right.insert(t) : this.right = It([t]);
  else {
    var n = en.ge(this.leftPoints, t, Xn), e = en.ge(this.rightPoints, t, Qn);
    this.leftPoints.splice(n, 0, t), this.rightPoints.splice(e, 0, t);
  }
};
Nt.remove = function(t) {
  var o = this.count - this.leftPoints;
  if (t[1] < this.mid) {
    if (!this.left)
      return dt;
    var n = this.right ? this.right.count : 0;
    if (4 * n > 3 * (o - 1))
      return Ao(this, t);
    var e = this.left.remove(t);
    return e === Kt ? (this.left = null, this.count -= 1, rt) : (e === rt && (this.count -= 1), e);
  } else if (t[0] > this.mid) {
    if (!this.right)
      return dt;
    var r = this.left ? this.left.count : 0;
    if (4 * r > 3 * (o - 1))
      return Ao(this, t);
    var e = this.right.remove(t);
    return e === Kt ? (this.right = null, this.count -= 1, rt) : (e === rt && (this.count -= 1), e);
  } else {
    if (this.count === 1)
      return this.leftPoints[0] === t ? Kt : dt;
    if (this.leftPoints.length === 1 && this.leftPoints[0] === t) {
      if (this.left && this.right) {
        for (var i = this, l = this.left; l.right; )
          i = l, l = l.right;
        if (i === this)
          l.right = this.right;
        else {
          var s = this.left, e = this.right;
          i.count -= l.count, i.right = l.left, l.left = s, l.right = e;
        }
        yn(this, l), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else this.left ? yn(this, this.left) : yn(this, this.right);
      return rt;
    }
    for (var s = en.ge(this.leftPoints, t, Xn); s < this.leftPoints.length && this.leftPoints[s][0] === t[0]; ++s)
      if (this.leftPoints[s] === t) {
        this.count -= 1, this.leftPoints.splice(s, 1);
        for (var e = en.ge(this.rightPoints, t, Qn); e < this.rightPoints.length && this.rightPoints[e][1] === t[1]; ++e)
          if (this.rightPoints[e] === t)
            return this.rightPoints.splice(e, 1), rt;
      }
    return dt;
  }
};
function Kr(t, o, n) {
  for (var e = 0; e < t.length && t[e][0] <= o; ++e) {
    var r = n(t[e]);
    if (r)
      return r;
  }
}
function Yr(t, o, n) {
  for (var e = t.length - 1; e >= 0 && t[e][1] >= o; --e) {
    var r = n(t[e]);
    if (r)
      return r;
  }
}
function Xr(t, o) {
  for (var n = 0; n < t.length; ++n) {
    var e = o(t[n]);
    if (e)
      return e;
  }
}
Nt.queryPoint = function(t, o) {
  if (t < this.mid) {
    if (this.left) {
      var n = this.left.queryPoint(t, o);
      if (n)
        return n;
    }
    return Kr(this.leftPoints, t, o);
  } else if (t > this.mid) {
    if (this.right) {
      var n = this.right.queryPoint(t, o);
      if (n)
        return n;
    }
    return Yr(this.rightPoints, t, o);
  } else
    return Xr(this.leftPoints, o);
};
Nt.queryInterval = function(t, o, n) {
  if (t < this.mid && this.left) {
    var e = this.left.queryInterval(t, o, n);
    if (e)
      return e;
  }
  if (o > this.mid && this.right) {
    var e = this.right.queryInterval(t, o, n);
    if (e)
      return e;
  }
  return o < this.mid ? Kr(this.leftPoints, o, n) : t > this.mid ? Yr(this.rightPoints, t, n) : Xr(this.leftPoints, n);
};
function Pa(t, o) {
  return t - o;
}
function Xn(t, o) {
  var n = t[0] - o[0];
  return n || t[1] - o[1];
}
function Qn(t, o) {
  var n = t[1] - o[1];
  return n || t[0] - o[0];
}
function It(t) {
  if (t.length === 0)
    return null;
  for (var o = [], n = 0; n < t.length; ++n)
    o.push(t[n][0], t[n][1]);
  o.sort(Pa);
  for (var e = o[o.length >> 1], r = [], i = [], l = [], n = 0; n < t.length; ++n) {
    var s = t[n];
    s[1] < e ? r.push(s) : e < s[0] ? i.push(s) : l.push(s);
  }
  var a = l, d = l.slice();
  return a.sort(Xn), d.sort(Qn), new Yn(e, It(r), It(i), a, d);
}
function Qr(t) {
  this.root = t;
}
var wt = Qr.prototype;
wt.insert = function(t) {
  this.root ? this.root.insert(t) : this.root = new Yn(t[0], null, null, [t], [t]);
};
wt.remove = function(t) {
  if (this.root) {
    var o = this.root.remove(t);
    return o === Kt && (this.root = null), o !== dt;
  }
  return !1;
};
wt.queryPoint = function(t, o) {
  if (this.root)
    return this.root.queryPoint(t, o);
};
wt.queryInterval = function(t, o, n) {
  if (t <= o && this.root)
    return this.root.queryInterval(t, o, n);
};
Object.defineProperty(wt, "count", {
  get: function() {
    return this.root ? this.root.count : 0;
  }
});
Object.defineProperty(wt, "intervals", {
  get: function() {
    return this.root ? this.root.intervals([]) : [];
  }
});
function Ea(t) {
  return new Qr(null);
}
var wn = /* @__PURE__ */ function() {
  function t() {
    ve(this, t), O(this, "_columnSizeMap", {}), O(this, "_intervalTree", Ea()), O(this, "_leftMap", {});
  }
  return me(t, [{
    key: "estimateTotalHeight",
    value: function(n, e, r) {
      var i = n - this.count;
      return this.tallestColumnSize + Math.ceil(i / e) * r;
    }
    // Render all cells visible within the viewport range defined.
  }, {
    key: "range",
    value: function(n, e, r) {
      var i = this;
      this._intervalTree.queryInterval(n, n + e, function(l) {
        var s = ma(l, 3), a = s[0];
        s[1];
        var d = s[2];
        return r(d, i._leftMap[d], a);
      });
    }
  }, {
    key: "setPosition",
    value: function(n, e, r, i) {
      this._intervalTree.insert([r, r + i, n]), this._leftMap[n] = e;
      var l = this._columnSizeMap, s = l[e];
      s === void 0 ? l[e] = r + i : l[e] = Math.max(s, r + i);
    }
  }, {
    key: "count",
    get: function() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function() {
      var n = this._columnSizeMap, e = 0;
      for (var r in n) {
        var i = n[r];
        e = e === 0 ? i : Math.min(e, i);
      }
      return e;
    }
  }, {
    key: "tallestColumnSize",
    get: function() {
      var n = this._columnSizeMap, e = 0;
      for (var r in n) {
        var i = n[r];
        e = Math.max(e, i);
      }
      return e;
    }
  }]);
}();
function Wo(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function Na(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Wo(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Wo(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function $a(t, o, n) {
  return o = he(o), Ie(t, Zr() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function Zr() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Zr = function() {
    return !!t;
  })();
}
var Ga = {}, Da = 150, Jr = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = $a(this, o, [].concat(r)), O(n, "state", {
      isScrolling: !1,
      scrollTop: 0
    }), O(n, "_debounceResetIsScrollingId", void 0), O(n, "_invalidateOnUpdateStartIndex", null), O(n, "_invalidateOnUpdateStopIndex", null), O(n, "_positionCache", new wn()), O(n, "_startIndex", null), O(n, "_startIndexMemoized", null), O(n, "_stopIndex", null), O(n, "_stopIndexMemoized", null), O(n, "_debounceResetIsScrollingCallback", function() {
      n.setState({
        isScrolling: !1
      });
    }), O(n, "_setScrollingContainerRef", function(l) {
      n._scrollingContainer = l;
    }), O(n, "_onScroll", function(l) {
      var s = n.props.height, a = l.currentTarget.scrollTop, d = Math.min(Math.max(0, n._getEstimatedTotalHeight() - s), a);
      a === d && (n._debounceResetIsScrolling(), n.state.scrollTop !== d && n.setState({
        isScrolling: !0,
        scrollTop: d
      }));
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "clearCellPositions",
    value: function() {
      this._positionCache = new wn(), this.forceUpdate();
    }
    // HACK This method signature was intended for Grid
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(e) {
      var r = e.rowIndex;
      this._invalidateOnUpdateStartIndex === null ? (this._invalidateOnUpdateStartIndex = r, this._invalidateOnUpdateStopIndex = r) : (this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, r), this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, r));
    }
  }, {
    key: "recomputeCellPositions",
    value: function() {
      var e = this._positionCache.count - 1;
      this._positionCache = new wn(), this._populatePositionCache(0, e), this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, r) {
      this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback(), this.props.scrollTop !== e.scrollTop && this._debounceResetIsScrolling();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._debounceResetIsScrollingId && ft(this._debounceResetIsScrollingId);
    }
  }, {
    key: "render",
    value: function() {
      var e = this, r = this.props, i = r.autoHeight, l = r.cellCount, s = r.cellMeasurerCache, a = r.cellRenderer, d = r.className, u = r.height, f = r.id, h = r.keyMapper, p = r.overscanByPixels, g = r.role, m = r.style, C = r.tabIndex, w = r.width, S = r.rowDirection, M = this.state, z = M.isScrolling, R = M.scrollTop, P = [], A = this._getEstimatedTotalHeight(), _ = this._positionCache.shortestColumnSize, $ = this._positionCache.count, E = 0, k;
      if (this._positionCache.range(Math.max(0, R - p), u + p * 2, function(G, b, L) {
        typeof k > "u" ? (E = G, k = G) : (E = Math.min(E, G), k = Math.max(k, G)), P.push(a({
          index: G,
          isScrolling: z,
          key: h(G),
          parent: e,
          style: O(O(O(O({
            height: s.getHeight(G)
          }, S === "ltr" ? "left" : "right", b), "position", "absolute"), "top", L), "width", s.getWidth(G))
        }));
      }), _ < R + u + p && $ < l)
        for (var W = Math.min(l - $, Math.ceil((R + u + p - _) / s.defaultHeight * w / s.defaultWidth)), v = $; v < $ + W; v++)
          k = v, P.push(a({
            index: v,
            isScrolling: z,
            key: h(v),
            parent: this,
            style: {
              width: s.getWidth(v)
            }
          }));
      return this._startIndex = E, this._stopIndex = k, /* @__PURE__ */ oe.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: Ge("ReactVirtualized__Masonry", d),
        id: f,
        onScroll: this._onScroll,
        role: g,
        style: Na({
          boxSizing: "border-box",
          direction: "ltr",
          height: i ? "auto" : u,
          overflowX: "hidden",
          overflowY: A < u ? "hidden" : "auto",
          position: "relative",
          width: w,
          WebkitOverflowScrolling: "touch",
          willChange: "transform"
        }, m),
        tabIndex: C
      }, /* @__PURE__ */ oe.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: "100%",
          height: A,
          maxWidth: "100%",
          maxHeight: A,
          overflow: "hidden",
          pointerEvents: z ? "none" : "",
          position: "relative"
        }
      }, P));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function() {
      if (typeof this._invalidateOnUpdateStartIndex == "number") {
        var e = this._invalidateOnUpdateStartIndex, r = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null, this._invalidateOnUpdateStopIndex = null, this._populatePositionCache(e, r), this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function() {
      var e = this.props.scrollingResetTimeInterval;
      this._debounceResetIsScrollingId && ft(this._debounceResetIsScrollingId), this._debounceResetIsScrollingId = Kn(this._debounceResetIsScrollingCallback, e);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function() {
      var e = this.props, r = e.cellCount, i = e.cellMeasurerCache, l = e.width, s = Math.max(1, Math.floor(l / i.defaultWidth));
      return this._positionCache.estimateTotalHeight(r, s, i.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function() {
      var e = this.props, r = e.height, i = e.onScroll, l = this.state.scrollTop;
      this._onScrollMemoized !== l && (i({
        clientHeight: r,
        scrollHeight: this._getEstimatedTotalHeight(),
        scrollTop: l
      }), this._onScrollMemoized = l);
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var e = this.props.onCellsRendered;
        e({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        }), this._startIndexMemoized = this._startIndex, this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function(e, r) {
      for (var i = this.props, l = i.cellMeasurerCache, s = i.cellPositioner, a = e; a <= r; a++) {
        var d = s(a), u = d.left, f = d.top;
        this._positionCache.setPosition(a, u, f, l.getHeight(a));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, r) {
      return e.scrollTop !== void 0 && r.scrollTop !== e.scrollTop ? {
        isScrolling: !0,
        scrollTop: e.scrollTop
      } : null;
    }
  }]);
}(oe.PureComponent);
O(Jr, "defaultProps", {
  autoHeight: !1,
  keyMapper: Aa,
  onCellsRendered: Uo,
  onScroll: Uo,
  overscanByPixels: 20,
  role: "grid",
  scrollingResetTimeInterval: Da,
  style: Ga,
  tabIndex: 0,
  rowDirection: "ltr"
});
function Aa(t) {
  return t;
}
function Uo() {
}
Mt(Jr);
var Sn = /* @__PURE__ */ function() {
  function t() {
    var o = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ve(this, t), O(this, "_cellMeasurerCache", void 0), O(this, "_columnIndexOffset", void 0), O(this, "_rowIndexOffset", void 0), O(this, "columnWidth", function(a) {
      var d = a.index;
      o._cellMeasurerCache.columnWidth({
        index: d + o._columnIndexOffset
      });
    }), O(this, "rowHeight", function(a) {
      var d = a.index;
      o._cellMeasurerCache.rowHeight({
        index: d + o._rowIndexOffset
      });
    });
    var e = n.cellMeasurerCache, r = n.columnIndexOffset, i = r === void 0 ? 0 : r, l = n.rowIndexOffset, s = l === void 0 ? 0 : l;
    this._cellMeasurerCache = e, this._columnIndexOffset = i, this._rowIndexOffset = s;
  }
  return me(t, [{
    key: "clear",
    value: function(n, e) {
      this._cellMeasurerCache.clear(n + this._rowIndexOffset, e + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "defaultHeight",
    get: function() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(n + this._rowIndexOffset, e + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(n + this._rowIndexOffset, e + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.has(n + this._rowIndexOffset, e + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function(n, e, r, i) {
      this._cellMeasurerCache.set(n + this._rowIndexOffset, e + this._columnIndexOffset, r, i);
    }
  }]);
}(), Wa = ["rowIndex"], Ua = ["columnIndex", "rowIndex"], Ha = ["columnIndex"], Ba = ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"];
function Ho(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function pe(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Ho(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ho(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function ja(t, o, n) {
  return o = he(o), Ie(t, ei() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function ei() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ei = function() {
    return !!t;
  })();
}
var Bo = 20, Zn = /* @__PURE__ */ function(t) {
  function o(n, e) {
    var r;
    ve(this, o), r = ja(this, o, [n, e]), O(r, "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: !1,
      showVerticalScrollbar: !1
    }), O(r, "_deferredInvalidateColumnIndex", null), O(r, "_deferredInvalidateRowIndex", null), O(r, "_bottomLeftGridRef", function(a) {
      r._bottomLeftGrid = a;
    }), O(r, "_bottomRightGridRef", function(a) {
      r._bottomRightGrid = a;
    }), O(r, "_cellRendererBottomLeftGrid", function(a) {
      var d = a.rowIndex, u = Ct(a, Wa), f = r.props, h = f.cellRenderer, p = f.fixedRowCount, g = f.rowCount;
      return d === g - p ? /* @__PURE__ */ oe.createElement("div", {
        key: u.key,
        style: pe(pe({}, u.style), {}, {
          height: Bo
        })
      }) : h(pe(pe({}, u), {}, {
        parent: r,
        rowIndex: d + p
      }));
    }), O(r, "_cellRendererBottomRightGrid", function(a) {
      var d = a.columnIndex, u = a.rowIndex, f = Ct(a, Ua), h = r.props, p = h.cellRenderer, g = h.fixedColumnCount, m = h.fixedRowCount;
      return p(pe(pe({}, f), {}, {
        columnIndex: d + g,
        parent: r,
        rowIndex: u + m
      }));
    }), O(r, "_cellRendererTopRightGrid", function(a) {
      var d = a.columnIndex, u = Ct(a, Ha), f = r.props, h = f.cellRenderer, p = f.columnCount, g = f.fixedColumnCount;
      return d === p - g ? /* @__PURE__ */ oe.createElement("div", {
        key: u.key,
        style: pe(pe({}, u.style), {}, {
          width: Bo
        })
      }) : h(pe(pe({}, u), {}, {
        columnIndex: d + g,
        parent: r
      }));
    }), O(r, "_columnWidthRightGrid", function(a) {
      var d = a.index, u = r.props, f = u.columnCount, h = u.fixedColumnCount, p = u.columnWidth, g = r.state, m = g.scrollbarSize, C = g.showHorizontalScrollbar;
      return C && d === f - h ? m : typeof p == "function" ? p({
        index: d + h
      }) : p;
    }), O(r, "_onScroll", function(a) {
      var d = a.scrollLeft, u = a.scrollTop;
      r.setState({
        scrollLeft: d,
        scrollTop: u
      });
      var f = r.props.onScroll;
      f && f(a);
    }), O(r, "_onScrollbarPresenceChange", function(a) {
      var d = a.horizontal, u = a.size, f = a.vertical, h = r.state, p = h.showHorizontalScrollbar, g = h.showVerticalScrollbar;
      if (d !== p || f !== g) {
        r.setState({
          scrollbarSize: u,
          showHorizontalScrollbar: d,
          showVerticalScrollbar: f
        });
        var m = r.props.onScrollbarPresenceChange;
        typeof m == "function" && m({
          horizontal: d,
          size: u,
          vertical: f
        });
      }
    }), O(r, "_onScrollLeft", function(a) {
      var d = a.scrollLeft;
      r._onScroll({
        scrollLeft: d,
        scrollTop: r.state.scrollTop
      });
    }), O(r, "_onScrollTop", function(a) {
      var d = a.scrollTop;
      r._onScroll({
        scrollTop: d,
        scrollLeft: r.state.scrollLeft
      });
    }), O(r, "_rowHeightBottomGrid", function(a) {
      var d = a.index, u = r.props, f = u.fixedRowCount, h = u.rowCount, p = u.rowHeight, g = r.state, m = g.scrollbarSize, C = g.showVerticalScrollbar;
      return C && d === h - f ? m : typeof p == "function" ? p({
        index: d + f
      }) : p;
    }), O(r, "_topLeftGridRef", function(a) {
      r._topLeftGrid = a;
    }), O(r, "_topRightGridRef", function(a) {
      r._topRightGrid = a;
    });
    var i = n.deferredMeasurementCache, l = n.fixedColumnCount, s = n.fixedRowCount;
    return r._maybeCalculateCachedStyles(!0), i && (r._deferredMeasurementCacheBottomLeftGrid = s > 0 ? new Sn({
      cellMeasurerCache: i,
      columnIndexOffset: 0,
      rowIndexOffset: s
    }) : i, r._deferredMeasurementCacheBottomRightGrid = l > 0 || s > 0 ? new Sn({
      cellMeasurerCache: i,
      columnIndexOffset: l,
      rowIndexOffset: s
    }) : i, r._deferredMeasurementCacheTopRightGrid = l > 0 ? new Sn({
      cellMeasurerCache: i,
      columnIndexOffset: l,
      rowIndexOffset: 0
    }) : i), r;
  }
  return Re(o, t), me(o, [{
    key: "forceUpdateGrids",
    value: function() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate(), this._bottomRightGrid && this._bottomRightGrid.forceUpdate(), this._topLeftGrid && this._topLeftGrid.forceUpdate(), this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.columnIndex, i = r === void 0 ? 0 : r, l = e.rowIndex, s = l === void 0 ? 0 : l;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, i) : i, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, s) : s;
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllCells",
    value: function() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells(), this._bottomRightGrid && this._bottomRightGrid.measureAllCells(), this._topLeftGrid && this._topLeftGrid.measureAllCells(), this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.columnIndex, i = r === void 0 ? 0 : r, l = e.rowIndex, s = l === void 0 ? 0 : l, a = this.props, d = a.fixedColumnCount, u = a.fixedRowCount, f = Math.max(0, i - d), h = Math.max(0, s - u);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: i,
        rowIndex: h
      }), this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: f,
        rowIndex: h
      }), this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: i,
        rowIndex: s
      }), this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: f,
        rowIndex: s
      }), this._leftGridWidth = null, this._topGridHeight = null, this._maybeCalculateCachedStyles(!0);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props, r = e.scrollLeft, i = e.scrollTop;
      if (r > 0 || i > 0) {
        var l = {};
        r > 0 && (l.scrollLeft = r), i > 0 && (l.scrollTop = i), this.setState(l);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props, r = e.onScroll, i = e.onSectionRendered;
      e.onScrollbarPresenceChange, e.scrollLeft;
      var l = e.scrollToColumn;
      e.scrollTop;
      var s = e.scrollToRow, a = Ct(e, Ba);
      if (this._prepareForRender(), this.props.width === 0 || this.props.height === 0)
        return null;
      var d = this.state, u = d.scrollLeft, f = d.scrollTop;
      return /* @__PURE__ */ oe.createElement("div", {
        style: this._containerOuterStyle
      }, /* @__PURE__ */ oe.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(a), this._renderTopRightGrid(pe(pe({}, a), {}, {
        onScroll: r,
        scrollLeft: u
      }))), /* @__PURE__ */ oe.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(pe(pe({}, a), {}, {
        onScroll: r,
        scrollTop: f
      })), this._renderBottomRightGrid(pe(pe({}, a), {}, {
        onScroll: r,
        onSectionRendered: i,
        scrollLeft: u,
        scrollToColumn: l,
        scrollToRow: s,
        scrollTop: f
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function(e) {
      var r = e.height, i = this._getTopGridHeight(e);
      return r - i;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function(e) {
      var r = e.fixedColumnCount, i = e.columnWidth;
      if (this._leftGridWidth == null)
        if (typeof i == "function") {
          for (var l = 0, s = 0; s < r; s++)
            l += i({
              index: s
            });
          this._leftGridWidth = l;
        } else
          this._leftGridWidth = i * r;
      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function(e) {
      var r = e.width, i = this._getLeftGridWidth(e);
      return r - i;
    }
  }, {
    key: "_getTopGridHeight",
    value: function(e) {
      var r = e.fixedRowCount, i = e.rowHeight;
      if (this._topGridHeight == null)
        if (typeof i == "function") {
          for (var l = 0, s = 0; s < r; s++)
            l += i({
              index: s
            });
          this._topGridHeight = l;
        } else
          this._topGridHeight = i * r;
      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function() {
      if (typeof this._deferredInvalidateColumnIndex == "number") {
        var e = this._deferredInvalidateColumnIndex, r = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
          columnIndex: e,
          rowIndex: r
        }), this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */
  }, {
    key: "_maybeCalculateCachedStyles",
    value: function(e) {
      var r = this.props, i = r.columnWidth, l = r.enableFixedColumnScroll, s = r.enableFixedRowScroll, a = r.height, d = r.fixedColumnCount, u = r.fixedRowCount, f = r.rowHeight, h = r.style, p = r.styleBottomLeftGrid, g = r.styleBottomRightGrid, m = r.styleTopLeftGrid, C = r.styleTopRightGrid, w = r.width, S = e || a !== this._lastRenderedHeight || w !== this._lastRenderedWidth, M = e || i !== this._lastRenderedColumnWidth || d !== this._lastRenderedFixedColumnCount, z = e || u !== this._lastRenderedFixedRowCount || f !== this._lastRenderedRowHeight;
      (e || S || h !== this._lastRenderedStyle) && (this._containerOuterStyle = pe({
        height: a,
        overflow: "visible",
        // Let :focus outline show through
        width: w
      }, h)), (e || S || z) && (this._containerTopStyle = {
        height: this._getTopGridHeight(this.props),
        position: "relative",
        width: w
      }, this._containerBottomStyle = {
        height: a - this._getTopGridHeight(this.props),
        overflow: "visible",
        // Let :focus outline show through
        position: "relative",
        width: w
      }), (e || p !== this._lastRenderedStyleBottomLeftGrid) && (this._bottomLeftGridStyle = pe({
        left: 0,
        overflowX: "hidden",
        overflowY: l ? "auto" : "hidden",
        position: "absolute"
      }, p)), (e || M || g !== this._lastRenderedStyleBottomRightGrid) && (this._bottomRightGridStyle = pe({
        left: this._getLeftGridWidth(this.props),
        position: "absolute"
      }, g)), (e || m !== this._lastRenderedStyleTopLeftGrid) && (this._topLeftGridStyle = pe({
        left: 0,
        overflowX: "hidden",
        overflowY: "hidden",
        position: "absolute",
        top: 0
      }, m)), (e || M || C !== this._lastRenderedStyleTopRightGrid) && (this._topRightGridStyle = pe({
        left: this._getLeftGridWidth(this.props),
        overflowX: s ? "auto" : "hidden",
        overflowY: "hidden",
        position: "absolute",
        top: 0
      }, C)), this._lastRenderedColumnWidth = i, this._lastRenderedFixedColumnCount = d, this._lastRenderedFixedRowCount = u, this._lastRenderedHeight = a, this._lastRenderedRowHeight = f, this._lastRenderedStyle = h, this._lastRenderedStyleBottomLeftGrid = p, this._lastRenderedStyleBottomRightGrid = g, this._lastRenderedStyleTopLeftGrid = m, this._lastRenderedStyleTopRightGrid = C, this._lastRenderedWidth = w;
    }
  }, {
    key: "_prepareForRender",
    value: function() {
      (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) && (this._leftGridWidth = null), (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) && (this._topGridHeight = null), this._maybeCalculateCachedStyles(), this._lastRenderedColumnWidth = this.props.columnWidth, this._lastRenderedFixedColumnCount = this.props.fixedColumnCount, this._lastRenderedFixedRowCount = this.props.fixedRowCount, this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function(e) {
      var r = e.enableFixedColumnScroll, i = e.fixedColumnCount, l = e.fixedRowCount, s = e.rowCount, a = e.hideBottomLeftGridScrollbar, d = this.state.showVerticalScrollbar;
      if (!i)
        return null;
      var u = d ? 1 : 0, f = this._getBottomGridHeight(e), h = this._getLeftGridWidth(e), p = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, g = a ? h + p : h, m = /* @__PURE__ */ oe.createElement(Ae, Pe({}, e, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: i,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: f,
        onScroll: r ? this._onScrollTop : void 0,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, s - l) + u,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: g
      }));
      return a ? /* @__PURE__ */ oe.createElement("div", {
        className: "BottomLeftGrid_ScrollWrapper",
        style: pe(pe({}, this._bottomLeftGridStyle), {}, {
          height: f,
          width: h,
          overflowY: "hidden"
        })
      }, m) : m;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function(e) {
      var r = e.columnCount, i = e.fixedColumnCount, l = e.fixedRowCount, s = e.rowCount, a = e.scrollToColumn, d = e.scrollToRow;
      return /* @__PURE__ */ oe.createElement(Ae, Pe({}, e, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, r - i),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(e),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, s - l),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: a - i,
        scrollToRow: d - l,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(e)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function(e) {
      var r = e.fixedColumnCount, i = e.fixedRowCount;
      return !r || !i ? null : /* @__PURE__ */ oe.createElement(Ae, Pe({}, e, {
        className: this.props.classNameTopLeftGrid,
        columnCount: r,
        height: this._getTopGridHeight(e),
        ref: this._topLeftGridRef,
        rowCount: i,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(e)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function(e) {
      var r = e.columnCount, i = e.enableFixedRowScroll, l = e.fixedColumnCount, s = e.fixedRowCount, a = e.scrollLeft, d = e.hideTopRightGridScrollbar, u = this.state, f = u.showHorizontalScrollbar, h = u.scrollbarSize;
      if (!s)
        return null;
      var p = f ? 1 : 0, g = this._getTopGridHeight(e), m = this._getRightGridWidth(e), C = f ? h : 0, w = g, S = this._topRightGridStyle;
      d && (w = g + C, S = pe(pe({}, this._topRightGridStyle), {}, {
        left: 0
      }));
      var M = /* @__PURE__ */ oe.createElement(Ae, Pe({}, e, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, r - l) + p,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: w,
        onScroll: i ? this._onScrollLeft : void 0,
        ref: this._topRightGridRef,
        rowCount: s,
        scrollLeft: a,
        style: S,
        tabIndex: null,
        width: m
      }));
      return d ? /* @__PURE__ */ oe.createElement("div", {
        className: "TopRightGrid_ScrollWrapper",
        style: pe(pe({}, this._topRightGridStyle), {}, {
          height: g,
          width: m,
          overflowX: "hidden"
        })
      }, M) : M;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, r) {
      return e.scrollLeft !== r.scrollLeft || e.scrollTop !== r.scrollTop ? {
        scrollLeft: e.scrollLeft != null && e.scrollLeft >= 0 ? e.scrollLeft : r.scrollLeft,
        scrollTop: e.scrollTop != null && e.scrollTop >= 0 ? e.scrollTop : r.scrollTop
      } : null;
    }
  }]);
}(oe.PureComponent);
O(Zn, "defaultProps", {
  classNameBottomLeftGrid: "",
  classNameBottomRightGrid: "",
  classNameTopLeftGrid: "",
  classNameTopRightGrid: "",
  enableFixedColumnScroll: !1,
  enableFixedRowScroll: !1,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: !1,
  hideBottomLeftGridScrollbar: !1
});
Zn.propTypes = process.env.NODE_ENV !== "production" ? {
  classNameBottomLeftGrid: D.string.isRequired,
  classNameBottomRightGrid: D.string.isRequired,
  classNameTopLeftGrid: D.string.isRequired,
  classNameTopRightGrid: D.string.isRequired,
  enableFixedColumnScroll: D.bool.isRequired,
  enableFixedRowScroll: D.bool.isRequired,
  fixedColumnCount: D.number.isRequired,
  fixedRowCount: D.number.isRequired,
  onScrollbarPresenceChange: D.func,
  style: D.object.isRequired,
  styleBottomLeftGrid: D.object.isRequired,
  styleBottomRightGrid: D.object.isRequired,
  styleTopLeftGrid: D.object.isRequired,
  styleTopRightGrid: D.object.isRequired,
  hideTopRightGridScrollbar: D.bool,
  hideBottomLeftGridScrollbar: D.bool
} : {};
Mt(Zn);
function Fa(t, o, n) {
  return o = he(o), Ie(t, ti() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function ti() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ti = function() {
    return !!t;
  })();
}
var Va = /* @__PURE__ */ function(t) {
  function o(n, e) {
    var r;
    return ve(this, o), r = Fa(this, o, [n, e]), r.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    }, r._onScroll = r._onScroll.bind(r), r;
  }
  return Re(o, t), me(o, [{
    key: "render",
    value: function() {
      var e = this.props.children, r = this.state, i = r.clientHeight, l = r.clientWidth, s = r.scrollHeight, a = r.scrollLeft, d = r.scrollTop, u = r.scrollWidth;
      return e({
        clientHeight: i,
        clientWidth: l,
        onScroll: this._onScroll,
        scrollHeight: s,
        scrollLeft: a,
        scrollTop: d,
        scrollWidth: u
      });
    }
  }, {
    key: "_onScroll",
    value: function(e) {
      var r = e.clientHeight, i = e.clientWidth, l = e.scrollHeight, s = e.scrollLeft, a = e.scrollTop, d = e.scrollWidth;
      this.setState({
        clientHeight: r,
        clientWidth: i,
        scrollHeight: l,
        scrollLeft: s,
        scrollTop: a,
        scrollWidth: d
      });
    }
  }]);
}(oe.PureComponent);
Va.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: D.func.isRequired
} : {};
function qa(t) {
  var o = t.dataKey, n = t.rowData;
  return typeof n.get == "function" ? n.get(o) : n[o];
}
function Ka(t) {
  var o = t.cellData;
  return o == null ? "" : String(o);
}
function Ya(t) {
  var o = t.className, n = t.columns, e = t.style;
  return /* @__PURE__ */ oe.createElement("div", {
    className: o,
    role: "row",
    style: e
  }, n);
}
var Le = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: "ASC",
  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: "DESC"
};
function ni(t) {
  var o = t.sortDirection, n = Ge("ReactVirtualized__Table__sortableHeaderIcon", {
    "ReactVirtualized__Table__sortableHeaderIcon--ASC": o === Le.ASC,
    "ReactVirtualized__Table__sortableHeaderIcon--DESC": o === Le.DESC
  });
  return /* @__PURE__ */ oe.createElement("svg", {
    className: n,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, o === Le.ASC ? /* @__PURE__ */ oe.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : /* @__PURE__ */ oe.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /* @__PURE__ */ oe.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
ni.propTypes = process.env.NODE_ENV !== "production" ? {
  sortDirection: D.oneOf([Le.ASC, Le.DESC])
} : {};
function Xa(t) {
  var o = t.dataKey, n = t.label, e = t.sortBy, r = t.sortDirection, i = e === o, l = [/* @__PURE__ */ oe.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof n == "string" ? n : null
  }, n)];
  return i && l.push(/* @__PURE__ */ oe.createElement(ni, {
    key: "SortIndicator",
    sortDirection: r
  })), l;
}
function Qa(t) {
  var o = t.className, n = t.columns, e = t.index, r = t.key, i = t.onRowClick, l = t.onRowDoubleClick, s = t.onRowMouseOut, a = t.onRowMouseOver, d = t.onRowRightClick, u = t.rowData, f = t.style, h = {
    "aria-rowindex": e + 1
  };
  return (i || l || s || a || d) && (h["aria-label"] = "row", h.tabIndex = 0, i && (h.onClick = function(p) {
    return i({
      event: p,
      index: e,
      rowData: u
    });
  }), l && (h.onDoubleClick = function(p) {
    return l({
      event: p,
      index: e,
      rowData: u
    });
  }), s && (h.onMouseOut = function(p) {
    return s({
      event: p,
      index: e,
      rowData: u
    });
  }), a && (h.onMouseOver = function(p) {
    return a({
      event: p,
      index: e,
      rowData: u
    });
  }), d && (h.onContextMenu = function(p) {
    return d({
      event: p,
      index: e,
      rowData: u
    });
  })), /* @__PURE__ */ oe.createElement("div", Pe({}, h, {
    className: o,
    key: r,
    role: "row",
    style: f
  }), n);
}
function Za(t, o, n) {
  return o = he(o), Ie(t, oi() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function oi() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (oi = function() {
    return !!t;
  })();
}
var Rt = /* @__PURE__ */ function(t) {
  function o() {
    return ve(this, o), Za(this, o, arguments);
  }
  return Re(o, t), me(o);
}(oe.Component);
O(Rt, "defaultProps", {
  cellDataGetter: qa,
  cellRenderer: Ka,
  defaultSortDirection: Le.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: Xa,
  style: {}
});
Rt.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Optional aria-label value to set on the column header */
  "aria-label": D.string,
  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: D.func,
  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: D.func,
  /** Optional CSS class to apply to cell */
  className: D.string,
  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: D.object,
  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: D.any.isRequired,
  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: D.oneOf([Le.ASC, Le.DESC]),
  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: D.bool,
  /** Flex grow style; defaults to 0 */
  flexGrow: D.number,
  /** Flex shrink style; defaults to 1 */
  flexShrink: D.number,
  /** Optional CSS class to apply to this column's header */
  headerClassName: D.string,
  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: D.func.isRequired,
  /** Optional inline style to apply to this column's header */
  headerStyle: D.object,
  /** Optional id to set on the column header */
  id: D.string,
  /** Header label for this column */
  label: D.node,
  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: D.number,
  /** Minimum width of column. */
  minWidth: D.number,
  /** Optional inline style to apply to cell */
  style: D.object,
  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: D.number.isRequired
} : {};
function jo(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function He(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? jo(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : jo(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function Ja(t, o, n) {
  return o = he(o), Ie(t, ri() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function ri() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ri = function() {
    return !!t;
  })();
}
var ii = /* @__PURE__ */ function(t) {
  function o(n) {
    var e;
    return ve(this, o), e = Ja(this, o, [n]), e.state = {
      scrollbarWidth: 0
    }, e._createColumn = e._createColumn.bind(e), e._createRow = e._createRow.bind(e), e._onScroll = e._onScroll.bind(e), e._onSectionRendered = e._onSectionRendered.bind(e), e._setRef = e._setRef.bind(e), e._setGridElementRef = e._setGridElementRef.bind(e), e;
  }
  return Re(o, t), me(o, [{
    key: "forceUpdateGrid",
    value: function() {
      this.Grid && this.Grid.forceUpdate();
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function(e) {
      var r = e.alignment, i = e.index;
      if (this.Grid) {
        var l = this.Grid.getOffsetForCell({
          alignment: r,
          rowIndex: i
        }), s = l.scrollTop;
        return s;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(e) {
      var r = e.columnIndex, i = e.rowIndex;
      this.Grid && this.Grid.invalidateCellSizeAfterRender({
        rowIndex: i,
        columnIndex: r
      });
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function() {
      this.Grid && this.Grid.measureAllCells();
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.columnIndex, i = r === void 0 ? 0 : r, l = e.rowIndex, s = l === void 0 ? 0 : l;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: s,
        columnIndex: i
      });
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: e
      });
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToPosition({
        scrollTop: e
      });
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: e
      });
    }
  }, {
    key: "getScrollbarWidth",
    value: function() {
      if (this.GridElement) {
        var e = this.GridElement, r = e.clientWidth || 0, i = e.offsetWidth || 0;
        return i - r;
      }
      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function() {
      var e = this, r = this.props, i = r.children, l = r.className, s = r.disableHeader, a = r.gridClassName, d = r.gridStyle, u = r.headerHeight, f = r.headerRowRenderer, h = r.height, p = r.id, g = r.noRowsRenderer, m = r.rowClassName, C = r.rowStyle, w = r.scrollToIndex, S = r.style, M = r.width, z = this.state.scrollbarWidth, R = s ? h : h - u, P = typeof m == "function" ? m({
        index: -1
      }) : m, A = typeof C == "function" ? C({
        index: -1
      }) : C;
      return this._cachedColumnStyles = [], oe.Children.toArray(i).forEach(function(_, $) {
        var E = e._getFlexStyleForColumn(_, _.props.style || Rt.defaultProps.style);
        e._cachedColumnStyles[$] = He({
          overflow: "hidden"
        }, E);
      }), /* @__PURE__ */ oe.createElement("div", {
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-colcount": oe.Children.toArray(i).length,
        "aria-rowcount": this.props.rowCount,
        className: Ge("ReactVirtualized__Table", l),
        id: p,
        role: "grid",
        style: S
      }, !s && f({
        className: Ge("ReactVirtualized__Table__headerRow", P),
        columns: this._getHeaderColumns(),
        style: He({
          height: u,
          overflow: "hidden",
          paddingRight: z,
          width: M
        }, A)
      }), /* @__PURE__ */ oe.createElement(Ae, Pe({}, this.props, {
        elementRef: this._setGridElementRef,
        "aria-readonly": null,
        autoContainerWidth: !0,
        className: Ge("ReactVirtualized__Table__Grid", a),
        cellRenderer: this._createRow,
        columnWidth: M,
        columnCount: 1,
        height: R,
        id: void 0,
        noContentRenderer: g,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: z,
        scrollToRow: w,
        style: He(He({}, d), {}, {
          overflowX: "hidden"
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function(e) {
      var r = e.column, i = e.columnIndex, l = e.isScrolling, s = e.parent, a = e.rowData, d = e.rowIndex, u = this.props.onColumnClick, f = r.props, h = f.cellDataGetter, p = f.cellRenderer, g = f.className, m = f.columnData, C = f.dataKey, w = f.id, S = h({
        columnData: m,
        dataKey: C,
        rowData: a
      }), M = p({
        cellData: S,
        columnData: m,
        columnIndex: i,
        dataKey: C,
        isScrolling: l,
        parent: s,
        rowData: a,
        rowIndex: d
      }), z = function(_) {
        u && u({
          columnData: m,
          dataKey: C,
          event: _
        });
      }, R = this._cachedColumnStyles[i], P = typeof M == "string" ? M : null;
      return /* @__PURE__ */ oe.createElement("div", {
        "aria-colindex": i + 1,
        "aria-describedby": w,
        className: Ge("ReactVirtualized__Table__rowColumn", g),
        key: "Row" + d + "-Col" + i,
        onClick: z,
        role: "gridcell",
        style: R,
        title: P
      }, M);
    }
  }, {
    key: "_createHeader",
    value: function(e) {
      var r = e.column, i = e.index, l = this.props, s = l.headerClassName, a = l.headerStyle, d = l.onHeaderClick, u = l.sort, f = l.sortBy, h = l.sortDirection, p = r.props, g = p.columnData, m = p.dataKey, C = p.defaultSortDirection, w = p.disableSort, S = p.headerRenderer, M = p.id, z = p.label, R = !w && u, P = Ge("ReactVirtualized__Table__headerColumn", s, r.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: R
      }), A = this._getFlexStyleForColumn(r, He(He({}, a), r.props.headerStyle)), _ = S({
        columnData: g,
        dataKey: m,
        disableSort: w,
        label: z,
        sortBy: f,
        sortDirection: h
      }), $, E, k, W, v;
      if (R || d) {
        var G = f !== m, b = G ? C : h === Le.DESC ? Le.ASC : Le.DESC, L = function(j) {
          R && u({
            defaultSortDirection: C,
            event: j,
            sortBy: m,
            sortDirection: b
          }), d && d({
            columnData: g,
            dataKey: m,
            event: j
          });
        }, x = function(j) {
          (j.key === "Enter" || j.key === " ") && L(j);
        };
        v = r.props["aria-label"] || z || m, W = "none", k = 0, $ = L, E = x;
      }
      return f === m && (W = h === Le.ASC ? "ascending" : "descending"), /* @__PURE__ */ oe.createElement("div", {
        "aria-label": v,
        "aria-sort": W,
        className: P,
        id: M,
        key: "Header-Col" + i,
        onClick: $,
        onKeyDown: E,
        role: "columnheader",
        style: A,
        tabIndex: k
      }, _);
    }
  }, {
    key: "_createRow",
    value: function(e) {
      var r = this, i = e.rowIndex, l = e.isScrolling, s = e.key, a = e.parent, d = e.style, u = this.props, f = u.children, h = u.onRowClick, p = u.onRowDoubleClick, g = u.onRowRightClick, m = u.onRowMouseOver, C = u.onRowMouseOut, w = u.rowClassName, S = u.rowGetter, M = u.rowRenderer, z = u.rowStyle, R = this.state.scrollbarWidth, P = typeof w == "function" ? w({
        index: i
      }) : w, A = typeof z == "function" ? z({
        index: i
      }) : z, _ = S({
        index: i
      }), $ = oe.Children.toArray(f).map(function(W, v) {
        return r._createColumn({
          column: W,
          columnIndex: v,
          isScrolling: l,
          parent: a,
          rowData: _,
          rowIndex: i,
          scrollbarWidth: R
        });
      }), E = Ge("ReactVirtualized__Table__row", P), k = He(He({}, d), {}, {
        height: this._getRowHeight(i),
        overflow: "hidden",
        paddingRight: R
      }, A);
      return M({
        className: E,
        columns: $,
        index: i,
        isScrolling: l,
        key: s,
        onRowClick: h,
        onRowDoubleClick: p,
        onRowRightClick: g,
        onRowMouseOver: m,
        onRowMouseOut: C,
        rowData: _,
        style: k
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */
  }, {
    key: "_getFlexStyleForColumn",
    value: function(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = "".concat(e.props.flexGrow, " ").concat(e.props.flexShrink, " ").concat(e.props.width, "px"), l = He(He({}, r), {}, {
        flex: i,
        msFlex: i,
        WebkitFlex: i
      });
      return e.props.maxWidth && (l.maxWidth = e.props.maxWidth), e.props.minWidth && (l.minWidth = e.props.minWidth), l;
    }
  }, {
    key: "_getHeaderColumns",
    value: function() {
      var e = this, r = this.props, i = r.children, l = r.disableHeader, s = l ? [] : oe.Children.toArray(i);
      return s.map(function(a, d) {
        return e._createHeader({
          column: a,
          index: d
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function(e) {
      var r = this.props.rowHeight;
      return typeof r == "function" ? r({
        index: e
      }) : r;
    }
  }, {
    key: "_onScroll",
    value: function(e) {
      var r = e.clientHeight, i = e.scrollHeight, l = e.scrollTop, s = this.props.onScroll;
      s({
        clientHeight: r,
        scrollHeight: i,
        scrollTop: l
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function(e) {
      var r = e.rowOverscanStartIndex, i = e.rowOverscanStopIndex, l = e.rowStartIndex, s = e.rowStopIndex, a = this.props.onRowsRendered;
      a({
        overscanStartIndex: r,
        overscanStopIndex: i,
        startIndex: l,
        stopIndex: s
      });
    }
  }, {
    key: "_setRef",
    value: function(e) {
      this.Grid = e;
    }
  }, {
    key: "_setGridElementRef",
    value: function(e) {
      this.GridElement = e;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function() {
      var e = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: e
      });
    }
  }]);
}(oe.PureComponent);
O(ii, "defaultProps", {
  disableHeader: !1,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function() {
    return null;
  },
  onRowsRendered: function() {
    return null;
  },
  onScroll: function() {
    return null;
  },
  overscanIndicesGetter: Hr,
  overscanRowCount: 10,
  rowRenderer: Qa,
  headerRowRenderer: Ya,
  rowStyle: {},
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
ii.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is just set on the grid top element. */
  "aria-label": D.string,
  /** This is just set on the grid top element. */
  "aria-labelledby": D.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: D.bool,
  /** One or more Columns describing the data displayed in this row */
  children: function(o) {
    for (var n = oe.Children.toArray(o.children), e = 0; e < n.length; e++) {
      var r = n[e].type;
      if (r !== Rt && !(r.prototype instanceof Rt))
        return new Error("Table only accepts children of type Column");
    }
  },
  /** Optional CSS class name */
  className: D.string,
  /** Disable rendering the header at all */
  disableHeader: D.bool,
  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: D.number.isRequired,
  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: D.string,
  /** Optional inline style to attach to inner Grid element. */
  gridStyle: D.object,
  /** Optional CSS class to apply to all column headers */
  headerClassName: D.string,
  /** Fixed height of header row */
  headerHeight: D.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: D.func,
  /** Optional custom inline style to attach to table header columns. */
  headerStyle: D.object,
  /** Fixed/available height for out DOM element */
  height: D.number.isRequired,
  /** Optional id */
  id: D.string,
  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: D.func,
  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: D.func,
  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: D.func,
  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: D.func,
  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: D.func,
  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: D.func,
  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: D.func,
  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: D.func,
  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: D.func,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: D.func.isRequired,
  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: D.func.isRequired,
  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: D.number.isRequired,
  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: D.oneOfType([D.string, D.func]),
  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: D.func.isRequired,
  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: D.oneOfType([D.number, D.func]).isRequired,
  /** Number of rows in table. */
  rowCount: D.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: D.func,
  /** Optional custom inline style to attach to table rows. */
  rowStyle: D.oneOfType([D.object, D.func]).isRequired,
  /** See Grid#scrollToAlignment */
  scrollToAlignment: D.oneOf(["auto", "end", "start", "center"]).isRequired,
  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: D.number.isRequired,
  /** Vertical offset. */
  scrollTop: D.number,
  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: D.func,
  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: D.string,
  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: D.oneOf([Le.ASC, Le.DESC]),
  /** Optional inline style */
  style: D.object,
  /** Tab index for focus */
  tabIndex: D.number,
  /** Width of list */
  width: D.number.isRequired
} : {};
var Xe = [], xt = null, lt = null;
function li() {
  lt && (lt = null, document.body && xt != null && (document.body.style.pointerEvents = xt), xt = null);
}
function ec() {
  li(), Xe.forEach(function(t) {
    return t.__resetIsScrolling();
  });
}
function tc() {
  lt && ft(lt);
  var t = 0;
  Xe.forEach(function(o) {
    t = Math.max(t, o.props.scrollingResetTimeInterval);
  }), lt = Kn(ec, t);
}
function si(t) {
  t.currentTarget === window && xt == null && document.body && (xt = document.body.style.pointerEvents, document.body.style.pointerEvents = "none"), tc(), Xe.forEach(function(o) {
    o.props.scrollElement === t.currentTarget && o.__handleWindowScrollEvent();
  });
}
function Fo(t, o) {
  Xe.some(function(n) {
    return n.props.scrollElement === o;
  }) || o.addEventListener("scroll", si), Xe.push(t);
}
function Vo(t, o) {
  Xe = Xe.filter(function(n) {
    return n !== t;
  }), Xe.length || (o.removeEventListener("scroll", si), lt && (ft(lt), li()));
}
var Jn = function(o) {
  return o === window;
}, _t = function(o) {
  return o.getBoundingClientRect();
};
function qo(t, o) {
  if (t)
    if (Jn(t)) {
      var n = window, e = n.innerHeight, r = n.innerWidth;
      return {
        height: typeof e == "number" ? e : 0,
        width: typeof r == "number" ? r : 0
      };
    } else
      return _t(t);
  else return {
    height: o.serverHeight,
    width: o.serverWidth
  };
}
function nc(t, o) {
  if (Jn(o) && document.documentElement) {
    var n = document.documentElement, e = _t(t), r = _t(n);
    return {
      top: e.top - r.top,
      left: e.left - r.left
    };
  } else {
    var i = ai(o), l = _t(t), s = _t(o);
    return {
      top: l.top + i.top - s.top,
      left: l.left + i.left - s.left
    };
  }
}
function ai(t) {
  return Jn(t) && document.documentElement ? {
    top: "scrollY" in window ? window.scrollY : document.documentElement.scrollTop,
    left: "scrollX" in window ? window.scrollX : document.documentElement.scrollLeft
  } : {
    top: t.scrollTop,
    left: t.scrollLeft
  };
}
function Ko(t, o) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    o && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function Yo(t) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Ko(Object(n), !0).forEach(function(e) {
      O(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ko(Object(n)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function oc(t, o, n) {
  return o = he(o), Ie(t, ci() ? Reflect.construct(o, n || [], he(t).constructor) : o.apply(t, n));
}
function ci() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ci = function() {
    return !!t;
  })();
}
var rc = 150, di = function() {
  return typeof window < "u" ? window : void 0;
}, rn = /* @__PURE__ */ function(t) {
  function o() {
    var n;
    ve(this, o);
    for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++)
      r[i] = arguments[i];
    return n = oc(this, o, [].concat(r)), O(n, "_window", di()), O(n, "_isMounted", !1), O(n, "_positionFromTop", 0), O(n, "_positionFromLeft", 0), O(n, "_detectElementResize", void 0), O(n, "_child", void 0), O(n, "_windowScrollerRef", /* @__PURE__ */ oe.createRef()), O(n, "state", Yo(Yo({}, qo(n.props.scrollElement, n.props)), {}, {
      isScrolling: !1,
      scrollLeft: 0,
      scrollTop: 0
    })), O(n, "_registerChild", function(l) {
      l && !(l instanceof Element) && console.warn("WindowScroller registerChild expects to be passed Element or null"), n._child = l, n.updatePosition();
    }), O(n, "_onChildScroll", function(l) {
      var s = l.scrollTop;
      if (n.state.scrollTop !== s) {
        var a = n.props.scrollElement;
        a && (typeof a.scrollTo == "function" ? a.scrollTo(0, s + n._positionFromTop) : a.scrollTop = s + n._positionFromTop);
      }
    }), O(n, "_registerResizeListener", function(l) {
      l === window ? window.addEventListener("resize", n._onResize, !1) : n._detectElementResize.addResizeListener(l, n._onResize);
    }), O(n, "_unregisterResizeListener", function(l) {
      l === window ? window.removeEventListener("resize", n._onResize, !1) : l && n._detectElementResize.removeResizeListener(l, n._onResize);
    }), O(n, "_onResize", function() {
      n.updatePosition();
    }), O(n, "__handleWindowScrollEvent", function() {
      if (n._isMounted) {
        var l = n.props.onScroll, s = n.props.scrollElement;
        if (s) {
          var a = ai(s), d = Math.max(0, a.left - n._positionFromLeft), u = Math.max(0, a.top - n._positionFromTop);
          n.setState({
            isScrolling: !0,
            scrollLeft: d,
            scrollTop: u
          }), l({
            scrollLeft: d,
            scrollTop: u
          });
        }
      }
    }), O(n, "__resetIsScrolling", function() {
      n.setState({
        isScrolling: !1
      });
    }), n;
  }
  return Re(o, t), me(o, [{
    key: "updatePosition",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.scrollElement, r = this.props.onResize, i = this.state, l = i.height, s = i.width, a = this._child || this._windowScrollerRef.current;
      if (a instanceof Element && e) {
        var d = nc(a, e);
        this._positionFromTop = d.top, this._positionFromLeft = d.left;
      }
      var u = qo(e, this.props);
      (l !== u.height || s !== u.width) && (this.setState({
        height: u.height,
        width: u.width
      }), r({
        height: u.height,
        width: u.width
      })), this.props.updateScrollTopOnUpdatePosition === !0 && (this.__handleWindowScrollEvent(), this.__resetIsScrolling());
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.props.scrollElement;
      this._detectElementResize = Mr(), this.updatePosition(e), e && (Fo(this, e), this._registerResizeListener(e)), this._isMounted = !0;
    }
  }, {
    key: "componentDidUpdate",
    value: function(e, r) {
      var i = this.props.scrollElement, l = e.scrollElement;
      l !== i && l != null && i != null && (this.updatePosition(i), Vo(this, l), Fo(this, i), this._unregisterResizeListener(l), this._registerResizeListener(i));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var e = this.props.scrollElement;
      e && (Vo(this, e), this._unregisterResizeListener(e)), this._isMounted = !1;
    }
  }, {
    key: "render",
    value: function() {
      var e = this.props.children, r = this.state, i = r.isScrolling, l = r.scrollTop, s = r.scrollLeft, a = r.height, d = r.width;
      return /* @__PURE__ */ oe.createElement("div", {
        ref: this._windowScrollerRef
      }, e({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: a,
        isScrolling: i,
        scrollLeft: s,
        scrollTop: l,
        width: d
      }));
    }
  }]);
}(oe.PureComponent);
O(rn, "defaultProps", {
  onResize: function() {
  },
  onScroll: function() {
  },
  scrollingResetTimeInterval: rc,
  scrollElement: di(),
  serverHeight: 0,
  serverWidth: 0
});
function ic(t) {
  return /* @__PURE__ */ X(
    "svg",
    {
      width: t.boxSize ?? "16",
      height: t.boxSize ?? "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "4",
            y: "3",
            width: "1.5",
            height: "10",
            rx: "0.75",
            fill: t.fill ?? "white"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "11",
            y: "3",
            width: "1.5",
            height: "10",
            rx: "0.75",
            fill: t.fill ?? "white"
          }
        )
      ]
    }
  );
}
function lc(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: t.boxSize ?? "16",
      height: t.boxSize ?? "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c("path", { d: "M8 5L12.5 11H3.5L8 5Z", fill: t.fill ?? "#121212" })
    }
  );
}
const ui = ({
  startIdx: t,
  endIdx: o,
  isAutoPlayVisible: n,
  onClickAutoPlay: e,
  isAutoPlay: r = !0,
  variant: i = "pagination",
  gtmName: l = ""
}) => {
  const { tagGTM: s } = le();
  return /* @__PURE__ */ c(ee, { children: i === "pagination" && /* @__PURE__ */ X(sc, { ...s(`${l}`), children: [
    /* @__PURE__ */ X(ac, { children: [
      /* @__PURE__ */ c(Xo, { children: t }),
      /* @__PURE__ */ c(cc, {}),
      /* @__PURE__ */ c(Xo, { children: o })
    ] }),
    n && /* @__PURE__ */ c(
      dc,
      {
        onClick: e,
        ...s(
          r ? `${l}_auto_pause_button` : `${l}_auto_start_button`
        ),
        children: r ? /* @__PURE__ */ c(ee, { children: /* @__PURE__ */ c(ic, {}) }) : /* @__PURE__ */ c(uc, { children: /* @__PURE__ */ c(lc, { fill: "white" }) })
      }
    )
  ] }) });
}, hi = Fe`
  display: flex;
  align-items: center;
  justify-content: center;
`, sc = q.div`
  width: fit-content;
  display: flex;
`, ac = q.div`
  ${hi}
  max-width: fit-content;
  height: 28px;
  background: ${se.colors.accent_colors.dimmed[1]};
  border-radius: 100px;
  padding: 0 12px;
`, cc = q.div`
  width: 1px;
  height: 10px;
  background: ${se.colors.neutral_colors.white};
  opacity: 0.4;
  margin: 0 8px;
`, Xo = q.p`
  ${se.typography.button.md_m};
  color: ${se.colors.neutral_colors.white};
`, dc = q.div`
  margin-left: 8px;
  width: 28px;
  height: 28px;
  background: ${se.colors.accent_colors.dimmed[1]};
  border-radius: 14px;
  cursor: pointer;
  ${hi}
  & span:nth-of-type(1) {
    margin-right: 5.5px;
  }
`, uc = q.span`
  transform: rotate(90deg);
  margin-left: 6.5px;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
function eo(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.8283 24.0021L30.7083 11.1221C31.0989 10.7316 31.0989 10.0985 30.7083 9.70793C30.3178 9.31741 29.6846 9.31741 29.2941 9.70793L15.7496 23.2524C15.7347 23.2657 15.7201 23.2795 15.7057 23.2938C15.3152 23.6843 15.3152 24.3175 15.7057 24.708L29.2889 38.2912C29.6794 38.6817 30.3126 38.6817 30.7031 38.2912C31.0937 37.9006 31.0937 37.2675 30.7031 36.8769L17.8283 24.0021Z",
          fill: t.fill ?? "#121212"
        }
      )
    }
  );
}
function fi(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.1211 15.9999L19.5302 10.5909C19.823 10.298 19.823 9.82311 19.5302 9.53022C19.2373 9.23732 18.7624 9.23732 18.4695 9.53022L12.5302 15.4695C12.3443 15.6555 12.2764 15.9148 12.3265 16.1543C12.3554 16.2921 12.4233 16.4234 12.5303 16.5304L18.4696 22.4697C18.7625 22.7626 19.2373 22.7626 19.5302 22.4697C19.8231 22.1768 19.8231 21.702 19.5302 21.4091L14.1211 15.9999Z",
          fill: t.fill ?? "#121212"
        }
      )
    }
  );
}
function to(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.1567 23.8403L17.2879 11.109C16.8953 10.7206 16.8953 10.0909 17.2879 9.70245C17.6805 9.31403 18.317 9.31403 18.7097 9.70245L32.2853 23.133C32.4348 23.281 32.5274 23.4639 32.563 23.6553C32.6235 23.9681 32.5314 24.3042 32.2866 24.5464L18.711 37.9769C18.3183 38.3654 17.6818 38.3654 17.2892 37.9769C16.8965 37.5885 16.8965 36.9588 17.2892 36.5704L30.1567 23.8403Z",
          fill: t.fill ?? "#121212"
        }
      )
    }
  );
}
function Qe(t) {
  return /* @__PURE__ */ X(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5302 22.4695C12.2373 22.1766 12.2373 21.7017 12.5302 21.4088L18.4695 15.4696C18.7624 15.1767 19.2373 15.1767 19.5302 15.4696C19.823 15.7625 19.823 16.2373 19.5302 16.5302L13.5909 22.4695C13.298 22.7624 12.8231 22.7624 12.5302 22.4695Z",
            fill: t.fill ?? "#121212"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.5302 16.5302C19.2373 16.8231 18.7625 16.823 18.4696 16.5302L12.5303 10.5909C12.2374 10.298 12.2374 9.82311 12.5303 9.53022C12.8232 9.23732 13.298 9.23732 13.5909 9.53022L19.5302 15.4696C19.823 15.7625 19.823 16.2373 19.5302 16.5302Z",
            fill: t.fill ?? "#121212"
          }
        )
      ]
    }
  );
}
function hc(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.4546 6.2455C22.9274 5.7183 22.0726 5.7183 21.5454 6.2455L10.7454 17.0455C10.2182 17.5727 10.2182 18.4275 10.7454 18.9547L21.5454 29.7547C22.0726 30.2819 22.9274 30.2819 23.4546 29.7547C23.9818 29.2275 23.9818 28.3727 23.4546 27.8455L13.6092 18.0001L23.4546 8.15469C23.9818 7.62748 23.9818 6.77271 23.4546 6.2455Z",
          fill: t.fill ?? "#121212"
        }
      )
    }
  );
}
function fc(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5454 6.2455C13.0726 5.7183 13.9274 5.7183 14.4546 6.2455L25.2546 17.0455C25.7818 17.5727 25.7818 18.4275 25.2546 18.9547L14.4546 29.7547C13.9274 30.2819 13.0726 30.2819 12.5454 29.7547C12.0182 29.2275 12.0182 28.3727 12.5454 27.8455L22.3908 18.0001L12.5454 8.15469C12.0182 7.62748 12.0182 6.77271 12.5454 6.2455Z",
          fill: t.fill ?? "#121212"
        }
      )
    }
  );
}
const pc = qe, Ne = ({
  id: t,
  baseWidth: o,
  baseHeight: n,
  isAutoPlayed: e,
  data: r = [],
  slideIndex: i = -1,
  setSlideIndex: l,
  hasPagination: s = !1,
  isStopBtn: a,
  className: d,
  children: u,
  hasArrow: f = !1,
  arrowType: h = "sm",
  rowNumber: p = 1,
  hasLoop: g = !0,
  hasInfinite: m = !1,
  slidePerNum: C,
  autoDelay: w = 5e3,
  gap: S,
  gtmName: M = "",
  arrowTop: z = 50,
  hasInitialSlide: R = !1,
  pageIndicator: P,
  onSlideChange: A
}) => {
  const _ = t || Ot(), [$, E] = U(1), [k, W] = U(e), [v, G] = U(!1), [b, L] = U(), [x, Z] = U(!1), [j, y] = U(0), N = re(
    () => Math.ceil(n * j / o),
    [n, o, j]
  ), { tagGTM: K } = le(), H = () => {
    W((B) => !B), k ? b == null || b.autoplay.stop() : b == null || b.autoplay.start();
  };
  return ie(() => (b && "activeIndex" in b && Z(!0), () => Z(!1)), [b]), ie(() => {
    b && x && (e && setTimeout(() => {
      b.autoplay.start();
    }, 100), i >= 0 && b.slideTo(i + 1, 0));
  }, [r, x, i, b, e]), /* @__PURE__ */ X(
    vc,
    {
      containerHeight: N,
      onMouseOver: () => G(!0),
      onMouseLeave: () => G(!1),
      ...M ? K(`${M}`) : {},
      children: [
        /* @__PURE__ */ c(
          pc,
          {
            disableHeight: !0,
            onResize: ({ width: B }) => y(B),
            children: (B) => /* @__PURE__ */ c(
              mc,
              {
                containerWidth: j,
                containerHeight: N,
                children: /* @__PURE__ */ c(
                  vt,
                  {
                    modules: [Wn, el],
                    onSwiper: L,
                    spaceBetween: S,
                    slidesPerView: p,
                    slidesPerGroup: C || p,
                    navigation: !0,
                    initialSlide: R ? 0 : void 0,
                    onSlideChange: (I) => {
                      A == null || A(I);
                      let V = I.activeIndex % r.length < 1 ? r.length : I.activeIndex % r.length;
                      R && lr(V) && (V = 1), l && l(V - 1), E(V);
                    },
                    loop: g ? r.length > 1 : !1,
                    autoplay: {
                      delay: w,
                      disableOnInteraction: !1
                    },
                    children: r.map((I, V) => /* @__PURE__ */ c(mt, { children: u({
                      width: j,
                      height: N,
                      index: V,
                      item: I
                    }) }, `${_}-slide-box-${V + 1}`))
                  }
                )
              }
            )
          }
        ),
        f && r.length > 1 && v && /* @__PURE__ */ X(ee, { children: [
          ($ !== 1 || m) && (h === "lg" ? /* @__PURE__ */ c(
            Cn,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slidePrev(),
              ...K(`${M}_prev_button`),
              children: /* @__PURE__ */ c(eo, { fill: "#fff" })
            }
          ) : h === "md" ? /* @__PURE__ */ c(
            Cn,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slidePrev(),
              ...K(`${M}_prev_button`),
              children: /* @__PURE__ */ c(hc, { fill: "#fff" })
            }
          ) : /* @__PURE__ */ c(
            Cn,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slidePrev(),
              ...K(`${M}_prev_button`),
              children: /* @__PURE__ */ c(fi, { fill: "#fff" })
            }
          )),
          ($ !== r.length || m) && (h === "lg" ? /* @__PURE__ */ c(
            _n,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slideNext(),
              ...K(`${M}_next_button`),
              children: /* @__PURE__ */ c(to, { fill: "#fff" })
            }
          ) : h === "md" ? /* @__PURE__ */ c(
            _n,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slideNext(),
              ...K(`${M}_next_button`),
              children: /* @__PURE__ */ c(fc, { fill: "#fff" })
            }
          ) : /* @__PURE__ */ c(
            _n,
            {
              arrowTop: z,
              type: h,
              onClick: () => b == null ? void 0 : b.slideNext(),
              ...K(`${M}_next_button`),
              children: /* @__PURE__ */ c(Qe, { fill: "#fff" })
            }
          ))
        ] }),
        s && r.length > 1 && /* @__PURE__ */ c(gc, { containerHeight: N, children: /* @__PURE__ */ c(
          ui,
          {
            endIdx: r.length,
            startIdx: $,
            isAutoPlayVisible: a,
            isAutoPlay: k,
            onClickAutoPlay: H,
            gtmName: M
          }
        ) })
      ]
    }
  );
}, gc = q.div`
  position: absolute;
  right: ${({ containerHeight: t }) => t && t > 300 ? 28 : 12}px;
  bottom: ${({ containerHeight: t }) => t && t > 300 ? 28 : 16}px;
  z-index: 9;
`, vc = q.div`
  position: relative;
  width: 100%;
  max-width: 1170px;
  ${({ containerHeight: t }) => t && Fe`
      height: ${t}px;
    `}
`, mc = q.div`
  width: ${({ containerWidth: t }) => t}px;
  height: ${({ containerHeight: t }) => t}px;
`, pi = q.div`
  position: absolute;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
  border-radius: 2px;
`, Cn = q(pi)`
  left: 0px;
  padding: ${({ type: t }) => t === "md" ? "10px" : t === "lg" ? "4px" : "4px 5px 4px 3px"};
  background-color: ${({ type: t }) => t === "md" ? "rgba(0,0,0,0.2)" : "rgba(0, 0, 0, 0.45)"};
  top: ${({ arrowTop: t }) => t}%;
`, _n = q(pi)`
  right: 0px;
  padding: ${({ type: t }) => t === "md" ? "10px" : t === "lg" ? "4px" : "4px 5px 4px 3px"};
  background-color: ${({ type: t }) => t === "md" ? "rgba(0,0,0,0.2)" : "rgba(0, 0, 0, 0.45)"};
  top: ${({ arrowTop: t }) => t}%;
`, ye = ({
  children: t,
  onClick: o,
  ...n
}) => {
  const e = ({
    e: r,
    callback: i
  }) => {
    r.stopPropagation(), i && i();
  };
  return /* @__PURE__ */ c(
    yc,
    {
      ...n,
      onClick: (r) => e({ e: r, callback: o }),
      children: t
    }
  );
}, yc = q.button`
  margin: 0;
  display: flex;
  width: 100%;
  height: 100%;
  outline-width: 0;
  border-width: 0;
  text-align: start;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
`, wc = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { items: e } = yt({
    autoConfigData: n
  }), { tagGTM: r } = le();
  return e ? /* @__PURE__ */ X(ge, { space: "default", ...r(t.componentLayoutCd), children: [
    /* @__PURE__ */ c(Sc, { children: /* @__PURE__ */ c(Cc, { children: "BEST" }) }),
    /* @__PURE__ */ c(
      Ne,
      {
        rowNumber: 3,
        slidePerNum: 1,
        isAutoPlayed: !1,
        baseWidth: 1170,
        baseHeight: 250,
        gap: 20,
        hasArrow: e.length > 3,
        hasInfinite: e.length > 3,
        hasLoop: e.length > 3,
        data: e.slice(0, 10),
        children: ({ item: i }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({
              ...Oe(`/goods/${i.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${t.componentLayoutCd}_button`, {
              "good-id": i.id
            }),
            children: /* @__PURE__ */ c(
              Ve,
              {
                imageSize: "c_lg_auto",
                item: i,
                isRecommendTagListVisible: !1
              }
            )
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ c(ee, {});
}, Sc = q.div`
  margin-bottom: 28px;
`, Cc = q.div`
  ${se.typography.subtitle1};
  color: ${se.colors.neutral_colors.primary};
  text-align: center;
`, _c = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { items: e } = yt({
    autoConfigData: n
  }), { tagGTM: r } = le();
  return e ? /* @__PURE__ */ X(ge, { space: "default", ...r(t.componentLayoutCd), children: [
    /* @__PURE__ */ c(bc, { children: /* @__PURE__ */ c(xc, { children: "BEST" }) }),
    /* @__PURE__ */ c(
      Ne,
      {
        rowNumber: 3,
        slidePerNum: 1,
        isAutoPlayed: !1,
        baseWidth: 1170,
        baseHeight: 376,
        gap: 20,
        hasArrow: e.length > 3,
        hasInfinite: e.length > 3,
        hasLoop: e.length > 3,
        data: e.slice(0, 10),
        children: ({ item: i }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({
              ...Oe(`/goods/${i.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${t.componentLayoutCd}_button`, {
              "good-id": i.id
            }),
            children: /* @__PURE__ */ c(
              Ve,
              {
                imageSize: "d_md_tit",
                item: i,
                isRecommendTagListVisible: !1
              }
            )
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ c(ee, {});
}, bc = q.div`
  margin-bottom: 28px;
`, xc = q.div`
  ${se.typography.subtitle1};
  color: ${se.colors.neutral_colors.primary};
  text-align: center;
`, Tc = rn, Ic = qe, Rc = Ae, kc = Pt, Lc = Et, Ut = new Vn({ fixedWidth: !0, defaultHeight: 30 });
function $t({
  isElement: t,
  elementContainerRef: o,
  columnCount: n = 5,
  columnSpace: e = 21,
  rowSpace: r = 21,
  list: i,
  children: l,
  handleNextMore: s = () => {
  },
  onScroll: a,
  cacheClearEffectDeps: d = []
}) {
  const [u, f] = U(0), h = xe(void 0), [p, g] = U(100), [m, C] = U(750), [w, S] = U(!1), [M, z] = U(), R = Y(
    ({ index: k }) => k < u - 1,
    [u]
  ), P = Y(async () => {
    w || (S(!0), s(), S(!1));
  }, [s, w]), A = Y(
    ({ width: k }) => {
      var W;
      g(k / n), C(k), Ut.clearAll(), (W = h.current) == null || W.recomputeGridSize();
    },
    [n]
  ), _ = Y(
    (k) => {
      const { key: W, rowIndex: v, columnIndex: G, style: b, parent: L } = k, x = v * n + G, Z = (m - (n - 1) * e) / n, j = G * e, y = Z * G + j, N = {
        ...b,
        width: Z,
        left: y,
        paddingBottom: r,
        boxSizing: "border-box"
      };
      return /* @__PURE__ */ c(
        kc,
        {
          cache: Ut,
          parent: L,
          columnIndex: G,
          rowIndex: v,
          children: /* @__PURE__ */ c("div", { style: N, children: x < i.length && /* @__PURE__ */ c(ee, { children: l({
            ...k,
            item: i[x],
            index: x
          }) }) }, W)
        },
        W
      );
    },
    [l, n, e, m, i, r]
  ), $ = Y(() => {
    (d == null ? void 0 : d.length) > 0 && setTimeout(() => {
      Ut.clearAll();
    }, 0);
  }, [d == null ? void 0 : d.length]);
  if (ie(() => {
    i.length > 0 && f(Math.ceil(i.length / n));
  }, [n, i]), ie(() => {
    $();
  }, [...d]), sr(i)) return /* @__PURE__ */ c(ee, {});
  const E = /* @__PURE__ */ c(
    Lc,
    {
      isRowLoaded: R,
      loadMoreRows: P,
      rowCount: u,
      threshold: 1,
      children: ({ onRowsRendered: k, registerChild: W }) => /* @__PURE__ */ c(Tc, { scrollElement: M, onScroll: a, children: ({ height: v, scrollTop: G }) => /* @__PURE__ */ c(Ic, { height: v, disableHeight: !0, onResize: A, children: ({ width: b }) => /* @__PURE__ */ c(
        Rc,
        {
          autoHeight: !0,
          width: b,
          height: v,
          scrollTop: G,
          ref: (L) => {
            h.current = L, W(L);
          },
          columnWidth: p,
          columnCount: n,
          rowCount: u,
          rowHeight: Ut.rowHeight,
          cellRenderer: _,
          onSectionRendered: ({ rowStartIndex: L, rowStopIndex: x }) => {
            k({
              startIndex: L,
              stopIndex: x
            });
          },
          style: {
            outline: "none"
          }
        }
      ) }) })
    }
  );
  return t ? /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: (k) => {
            z(k), o == null || o(k);
          },
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "auto"
          },
          children: E
        }
      )
    }
  ) : /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%"
      },
      children: E
    }
  );
}
const Oc = ({
  handleLink: t,
  component: o
}) => {
  const { autoConfigData: n } = o, { items: e, handleMore: r, totalItems: i } = yt({
    autoConfigData: n
  }), { tagGTM: l } = le();
  return e && i > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...l(o.componentLayoutCd), children: /* @__PURE__ */ c(
    $t,
    {
      list: e,
      rowSpace: 40,
      columnSpace: 20,
      columnCount: 3,
      handleNextMore: () => r(),
      children: ({ item: s }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => t({
            ...Oe(`/goods/${s.id}`, "REMODELING")
            // wiseLogParam,
          }),
          ...l(`${o.componentLayoutCd}_button`, {
            "good-id": s.id
          }),
          children: /* @__PURE__ */ c(Ve, { item: s })
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, zc = qe, no = ({
  id: t,
  baseWidth: o,
  gap: n,
  itemWidth: e,
  itemHeight: r = 0,
  isAutoResize: i = !0,
  isCentered: l = !1,
  isPreviewed: s = !1,
  pl: a = 0,
  pr: d = 0,
  data: u = [],
  slideIndex: f = -1,
  setSlideIndex: h,
  handleMore: p,
  className: g,
  children: m,
  hasArrow: C = !1,
  arrowType: w = "sm",
  columnCount: S = 2,
  top: M = 222
}) => {
  const z = t || Ot(), [R, P] = U(0), [A, _] = U(!1), [$, E] = U(!1), [k, W] = U(!1), v = re(
    () => i ? Math.floor(R * n / o) : n,
    [o, R, n, i]
  ), G = re(
    () => i ? Math.floor(R * e / o) : e,
    [o, R, i, e]
  ), b = re(
    () => i ? Math.floor(G * r / e) : r,
    [i, r, e, G]
  ), L = re(() => {
    const N = i ? (R + v + v) / (G + v) : (o + n) / (e + n);
    return s ? N : Math.floor(N);
  }, [
    i,
    R,
    v,
    G,
    o,
    n,
    e,
    s
  ]), [x, Z] = U(), [j, y] = U(!1);
  return ie(() => (x && "activeIndex" in x && y(!0), () => {
    y(!1);
  }), [x]), ie(() => {
    j && u.length > L && W(!0);
  }, [u, W, L, j]), /* @__PURE__ */ X(
    Mc,
    {
      className: g,
      onMouseOver: () => _(!0),
      onMouseLeave: () => _(!1),
      children: [
        /* @__PURE__ */ c(
          zc,
          {
            disableHeight: !0,
            onResize: ({ width: N }) => P(N),
            children: (N) => /* @__PURE__ */ c(
              Pc,
              {
                width: R,
                ...b > 0 ? { height: b } : {},
                children: /* @__PURE__ */ c(
                  vt,
                  {
                    spaceBetween: v,
                    slidesPerView: L,
                    slidesOffsetBefore: a,
                    slidesOffsetAfter: d,
                    centeredSlides: l,
                    onSwiper: Z,
                    onSlideChange: ({ activeIndex: K, isBeginning: H, isEnd: B }) => {
                      E(!H), W(!B);
                    },
                    children: u.map((K, H) => /* @__PURE__ */ c(mt, { children: m({
                      width: G,
                      height: b,
                      index: H,
                      item: K,
                      isActive: H === f
                    }) }, `${z}-slide-box-${H + 1}`))
                  }
                )
              }
            )
          }
        ),
        C && A && /* @__PURE__ */ X(ee, { children: [
          $ && /* @__PURE__ */ c(
            Ec,
            {
              type: w,
              top: M,
              onClick: () => x == null ? void 0 : x.slidePrev(),
              children: w === "md" ? /* @__PURE__ */ c(eo, { fill: "#fff" }) : /* @__PURE__ */ c(fi, { fill: "#fff" })
            }
          ),
          k && /* @__PURE__ */ c(
            Nc,
            {
              type: w,
              top: M,
              onClick: () => x == null ? void 0 : x.slideNext(),
              children: w === "md" ? /* @__PURE__ */ c(to, { fill: "#fff" }) : /* @__PURE__ */ c(Qe, { fill: "#fff" })
            }
          )
        ] })
      ]
    }
  );
}, Mc = q.div`
  width: 100%;
`, Pc = q.div`
  width: ${({ width: t }) => t}px;
`, gi = q.div`
  position: absolute;
  cursor: pointer;
  z-index: 9;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.45);
`, Ec = q(gi)`
  left: 0px;
  top: ${({ top: t }) => `${t}px`};
  padding: ${({ type: t }) => t === "md" ? "4px" : "4px 5px 4px 3px"};
`, Nc = q(gi)`
  right: 0px;
  top: ${({ top: t }) => `${t}px`};
  padding: ${({ type: t }) => t === "md" ? "4px" : "4px 3px 4px 5px"};
`, $c = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { categories: e } = jn({ autoConfigData: n }), { tagGTM: r } = le();
  return e && e.length > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...r(t.componentLayoutCd), children: e.map((i) => {
    const { category: l } = i;
    return /* @__PURE__ */ c(Lt, { children: l.goods.length !== 0 && /* @__PURE__ */ X(ee, { children: [
      /* @__PURE__ */ X(
        Gc,
        {
          onClick: () => o({
            ...Oe(
              `/goods?ctgNo=${l.categoryNo}`,
              "REMODELING"
            )
            // wiseLogParam,
          }),
          ...r(`${t.componentLayoutCd}_category_button`, {
            "category-id": l.categoryNo
          }),
          children: [
            /* @__PURE__ */ c(Dc, { children: l.categoryName }),
            /* @__PURE__ */ c(Qe, {})
          ]
        }
      ),
      /* @__PURE__ */ c(
        no,
        {
          className: Fn,
          baseWidth: 1170,
          itemWidth: 277,
          itemHeight: 242,
          gap: 20,
          data: l.goods.slice(0, 4),
          children: ({ item: s }) => /* @__PURE__ */ c(
            ye,
            {
              onClick: () => o({
                ...Oe(`/goods/${s.id}`, "REMODELING")
                // wiseLogParam,
              }),
              ...r(`${t.componentLayoutCd}_button`, {
                "good-id": s.id
              }),
              children: /* @__PURE__ */ c(
                Ve,
                {
                  imageSize: "c_sm_auto",
                  item: s,
                  isRecommendTagListVisible: !1
                }
              )
            }
          )
        }
      )
    ] }) }, l.categoryNo);
  }) }) : /* @__PURE__ */ c(ee, {});
}, Gc = q.div`
  &:not(:first-child) {
    margin-top: 100px;
  }
  margin-bottom: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`, Dc = q.div`
  ${se.typography.subtitle2};
  color: ${se.colors.neutral_colors.primary};
`, Ac = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { categories: e } = jn({ autoConfigData: n }), { tagGTM: r } = le();
  return e && e.length > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...r(t.componentLayoutCd), children: e.map((i) => {
    const { category: l } = i;
    return /* @__PURE__ */ c(Lt, { children: l.goods.length !== 0 && /* @__PURE__ */ X(ee, { children: [
      /* @__PURE__ */ X(
        Wc,
        {
          onClick: () => o({
            ...Oe(
              `/goods?ctgNo=${l.categoryNo}`,
              "REMODELING"
            )
            // wiseLogParam,
          }),
          ...r(`${t.componentLayoutCd}_category_button`, {
            "category-id": l.categoryNo
          }),
          children: [
            /* @__PURE__ */ c(Uc, { children: l.categoryName }),
            /* @__PURE__ */ c(Qe, {})
          ]
        }
      ),
      /* @__PURE__ */ c(
        no,
        {
          className: Fn,
          baseWidth: 1170,
          itemWidth: 277,
          itemHeight: 277,
          gap: 20,
          top: 120,
          columnCount: 1,
          data: l.goods.slice(0, 4),
          children: ({ item: s }) => /* @__PURE__ */ c(
            ye,
            {
              onClick: () => o({
                ...Oe(`/goods/${s.id}`, "REMODELING")
                // wiseLogParam,
              }),
              ...r(`${t.componentLayoutCd}_button`, {
                "good-id": s.id
              }),
              children: /* @__PURE__ */ c(
                Ve,
                {
                  imageSize: "d_sm_auto",
                  item: s,
                  isRecommendTagListVisible: !1
                }
              )
            }
          )
        }
      )
    ] }) }, l.categoryName);
  }) }) : /* @__PURE__ */ c(ee, {});
}, Wc = q.div`
  &:not(:first-child) {
    margin-top: 100px;
  }
  margin-bottom: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`, Uc = q.div`
  ${se.typography.subtitle2};
  color: ${se.colors.neutral_colors.primary};
`, Hc = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { items: e, totalItems: r, handleMore: i } = yt({
    autoConfigData: n
  }), { tagGTM: l } = le();
  return e && r > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...l(t.componentLayoutCd), children: /* @__PURE__ */ c(
    $t,
    {
      list: e,
      columnSpace: 20,
      columnCount: 4,
      handleNextMore: () => i(),
      children: ({ item: s }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({
            ...Oe(`/goods/${s.id}`, "REMODELING")
            // wiseLogParam,
          }),
          ...l(`${t.componentLayoutCd}_button`, {
            "good-id": s.id
          }),
          children: /* @__PURE__ */ c(Ve, { imageSize: "d_md_auto", item: s })
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, Bc = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { items: e } = yt({
    autoConfigData: n
  }), { tagGTM: r } = le();
  return e && (e == null ? void 0 : e.length) > 0 ? /* @__PURE__ */ X(ge, { space: "default", ...r(t.componentLayoutCd), children: [
    /* @__PURE__ */ c(jc, { children: /* @__PURE__ */ c(Fc, { children: "NEW" }) }),
    /* @__PURE__ */ c(
      Ne,
      {
        rowNumber: 3,
        slidePerNum: 1,
        isAutoPlayed: !1,
        baseWidth: 1170,
        baseHeight: 250,
        gap: 20,
        hasArrow: e.length > 3,
        hasInfinite: e.length > 3,
        hasLoop: e.length > 3,
        data: e.slice(0, 10),
        children: ({ item: i }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({
              ...Oe(`/goods/${i.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${t.componentLayoutCd}`, {
              "good-id": i.id
            }),
            children: /* @__PURE__ */ c(
              Ve,
              {
                imageSize: "c_lg_auto",
                item: i,
                isRecommendTagListVisible: !1
              }
            )
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ c(ee, {});
}, jc = q.div`
  margin-bottom: 28px;
`, Fc = q.div`
  ${se.typography.subtitle1};
  color: ${se.colors.neutral_colors.primary};
  text-align: center;
`, Vc = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { items: e } = yt({
    autoConfigData: n
  }), { tagGTM: r } = le();
  return /* @__PURE__ */ X(ge, { space: "default", ...r(t.componentLayoutCd), children: [
    /* @__PURE__ */ c(qc, { children: /* @__PURE__ */ c(Kc, { children: "NEW" }) }),
    /* @__PURE__ */ c(
      Ne,
      {
        rowNumber: 3,
        slidePerNum: 1,
        isAutoPlayed: !1,
        baseWidth: 1170,
        baseHeight: 376,
        gap: 20,
        hasArrow: e.length > 3,
        hasInfinite: e.length > 3,
        hasLoop: e.length > 3,
        data: e.slice(0, 10),
        children: ({ item: i }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({
              ...Oe(`/goods/${i.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${t.componentLayoutCd}_button`, {
              "good-id": i.id
            }),
            children: /* @__PURE__ */ c(
              Ve,
              {
                imageSize: "d_md_tit",
                item: i,
                isRecommendTagListVisible: !1
              }
            )
          }
        )
      }
    )
  ] });
}, qc = q.div`
  margin-bottom: 28px;
`, Kc = q.div`
  ${se.typography.subtitle1};
  color: ${se.colors.neutral_colors.primary};
  text-align: center;
`, Yc = ({
  component: t,
  handleLink: o
}) => {
  const { autoConfigData: n } = t, { categories: e } = jn({ autoConfigData: n }), { tagGTM: r } = le();
  return e && e.length > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...r(t.componentLayoutCd), children: e.map((i) => {
    const { category: l } = i;
    return /* @__PURE__ */ c(Lt, { children: l.goods.length !== 0 && /* @__PURE__ */ X(ee, { children: [
      /* @__PURE__ */ X(
        Xc,
        {
          onClick: () => o({
            ...Oe(
              `/goods?ctgNo=${l.categoryNo}`,
              "REMODELING"
            )
            // wiseLogParam,
          }),
          ...r(`${t.componentLayoutCd}_category_button`, {
            "category-id": l.categoryNo
          }),
          children: [
            /* @__PURE__ */ c(Qc, { children: l.categoryName }),
            /* @__PURE__ */ c(Qe, {})
          ]
        }
      ),
      /* @__PURE__ */ c(
        Ne,
        {
          rowNumber: 3,
          slidePerNum: 1,
          isAutoPlayed: !1,
          baseWidth: 1170,
          baseHeight: 308,
          gap: 20,
          arrowTop: 45,
          hasArrow: l.goods.length > 3,
          hasInfinite: l.goods.length > 3,
          hasLoop: l.goods.length > 3,
          data: l.goods.slice(0, 5),
          children: ({ item: s }) => /* @__PURE__ */ c(
            ye,
            {
              onClick: () => o({
                ...Oe(`/goods/${s.id}`, "REMODELING")
                // wiseLogParam,
              }),
              ...r(`${t.componentLayoutCd}_button`, {
                "good-id": s.id
              }),
              children: /* @__PURE__ */ c(
                Ve,
                {
                  imageSize: "c_lg_auto",
                  item: s,
                  isRecommendTagListVisible: !1
                }
              )
            }
          )
        }
      )
    ] }) }, l.categoryNo);
  }) }) : /* @__PURE__ */ c(ee, {});
}, Xc = q.div`
  &:not(:first-child) {
    margin-top: 100px;
  }
  margin-bottom: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`, Qc = q.div`
  ${se.typography.subtitle2};
  color: ${se.colors.neutral_colors.primary};
`, Zc = ({
  component: t,
  handleLink: o
}) => {
  var l;
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { ...i(t.componentLayoutCd), children: /* @__PURE__ */ X(Jc, { children: [
    /* @__PURE__ */ X(
      ed,
      {
        onClick: () => {
          var s;
          return o({
            ...(s = t.componentData) == null ? void 0 : s.componentInfo,
            wiseLogParam: e
          });
        },
        ...i(`${t.componentLayoutCd}_more_button`, {
          wlp: e
        }),
        children: [
          /* @__PURE__ */ c(td, { children: (l = t.componentData) == null ? void 0 : l.componentInfo.title }),
          /* @__PURE__ */ c(Qe, {})
        ]
      }
    ),
    /* @__PURE__ */ c(nd, { children: /* @__PURE__ */ c(
      ye,
      {
        onClick: () => o({ ...r[0], wiseLogParam: e }),
        ...i(`${t.componentLayoutCd}_item_button`, {
          wlp: e
        }),
        children: /* @__PURE__ */ c(
          Te,
          {
            width: "1170px",
            height: "480px",
            src: r[0].bannerImgUrl,
            alt: "mainBannerImg"
          }
        )
      }
    ) }),
    /* @__PURE__ */ c(rd, { children: r[0].relProdList.map((s, a) => /* @__PURE__ */ c(
      ye,
      {
        onClick: () => o({
          ...Oe(s.gdsDetailUrl, "REMODELING"),
          wiseLogParam: e
        }),
        ...i(`${t.componentLayoutCd}_item_button`, {
          wlp: e,
          "good-id": s.gdsNo
        }),
        children: /* @__PURE__ */ X(id, { children: [
          /* @__PURE__ */ c(
            Te,
            {
              src: s.imgPathL,
              alt: "bannerImg",
              width: "218px",
              height: "145px",
              objectFit: "cover"
            }
          ),
          /* @__PURE__ */ c(od, { children: s.gdsNm })
        ] })
      },
      `categoryImg${a}`
    )) })
  ] }) }) : /* @__PURE__ */ c(ee, {});
}, Jc = q.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 1170px;
`, ed = q.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 28px;
`, td = q.div`
  color: ${se.colors.accent_colors.primary.default};
  ${se.typography.subtitle2};
`, nd = q.div`
  width: 1170px;
  height: 480px;
  margin-bottom: 20px;
  position: relative;
`, od = q.div`
  display: block;
  width: 100%;
  text-align: left;
  color: ${se.colors.accent_colors.primary.default};
  margin-top: 12px;
  ${se.typography.body2};
`, rd = q.div`
  display: flex;
  overflow: hidden;
  gap: 20px;
  width: 100%;
`, id = q.div`
  width: 100%;
`, ld = ({ component: t, handleLink: o }) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ c(
    Ne,
    {
      isAutoPlayed: !0,
      baseHeight: 530,
      baseWidth: 1170,
      data: r.slice(0, 5),
      hasPagination: !0,
      isStopBtn: !0,
      hasArrow: r.length > 1,
      autoDelay: 5e3,
      children: ({ item: l }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({ ...l, wiseLogParam: e }),
          ...i(`${t.componentLayoutCd}_button`, {
            wlp: e
          }),
          children: /* @__PURE__ */ c(
            Te,
            {
              src: l.bannerImgUrl,
              alt: l.bannerImgUrl,
              width: "1170px",
              height: "530px",
              objectFit: "cover"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, sd = ({ component: t, handleLink: o }) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "default", ...i(t.componentLayoutCd), children: /* @__PURE__ */ X(ad, { children: [
    /* @__PURE__ */ c(cd, { children: "인테리어, 혼자 고민 마시고 한샘에서 상담하세요!" }),
    /* @__PURE__ */ c(dd, { children: r.map((l, s) => /* @__PURE__ */ c(
      ye,
      {
        onClick: () => o({ ...l, wiseLogParam: e }),
        ...i(
          `${t.componentLayoutCd}_${l.bannerNm}_button`,
          {
            wlp: e
          }
        ),
        children: /* @__PURE__ */ c(ud, { children: /* @__PURE__ */ c(
          Te,
          {
            src: l.bannerImgUrl,
            alt: "bannerImg",
            width: "575px",
            height: "280px"
          }
        ) })
      },
      `categoryImg${s}`
    )) })
  ] }) }) : /* @__PURE__ */ c(ee, {});
}, ad = q.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 1170px;
`, cd = q.div`
  color: ${se.colors.accent_colors.primary.default};
  margin-bottom: 28px;
  ${se.typography.subtitle2};
`, dd = q.div`
  display: flex;
  gap: 20px;
  width: 100%;
`, ud = q.div`
  width: 100%;
  height: 280px;
`, hd = ({ component: t, handleLink: o }) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ c(
    Ne,
    {
      baseHeight: 152,
      baseWidth: 1170,
      data: r,
      hasArrow: r.length > 1,
      arrowType: "lg",
      isAutoPlayed: !0,
      hasInfinite: !0,
      gtmName: t.componentLayoutCd + "_slide",
      children: ({ height: l, item: s }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({ ...s, wiseLogParam: e }),
          ...i(`${t.componentLayoutCd}_button`, {
            wlp: e
          }),
          children: /* @__PURE__ */ c(
            Te,
            {
              src: s.bannerImgUrl,
              alt: s.bannerImgUrl,
              width: "1170px",
              height: l,
              objectFit: "cover"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, fd = ({
  component: t,
  handleLink: o
}) => {
  const { componentData: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n == null ? void 0 : n.componentDataList, { tagGTM: i } = le();
  return n != null && n.componentDataList && (r == null ? void 0 : r.length) > 0 ? /* @__PURE__ */ X(ge, { space: "default", ...i(t.componentLayoutCd), children: [
    /* @__PURE__ */ c(pd, { children: "홈리모델링 스타일" }),
    /* @__PURE__ */ c(
      no,
      {
        className: Fn,
        baseWidth: 1e3,
        itemWidth: 680,
        itemHeight: 500,
        pl: 16,
        pr: 16,
        gap: 40,
        isCentered: !0,
        isPreviewed: !0,
        data: r.slice(0, 3),
        hasArrow: !0,
        top: 260,
        slideIndex: 2,
        children: ({ width: l, height: s, item: a }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({ ...a, wiseLogParam: e }),
            ...i(`${t.componentLayoutCd}_button`, {
              wlp: e
            }),
            children: /* @__PURE__ */ c(
              Te,
              {
                src: a.bannerImgUrl,
                alt: a.bannerImgUrl,
                width: l,
                height: s,
                objectFit: "cover"
              }
            )
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ c(ee, {});
}, pd = q.div`
  ${se.typography.subtitle2};
  color: ${se.colors.accent_colors.primary.default};
  padding-bottom: 28px;
`, gd = ({ setCurrentImg: t, data: o }) => {
  const [n, e] = U(0), [r, i] = U("none"), [l, s] = U(!1), [a, d] = U(!1), [u, f] = U(0), [h, p] = U(0), [g, m] = U(!0), [C, w] = U(!1), [S, M] = U(0), { hosts: z } = le(), R = re(() => {
    const k = S === 0 ? o.length - 1 : S - 1, W = S === o.length - 1 ? 0 : S + 1;
    return {
      prevIndex: k,
      nextIndex: W
    };
  }, [S, o]), P = Y(
    (k) => {
      i(k), w(!0), M(
        k === "next" ? R.nextIndex : k === "prev" ? R.prevIndex : S
      ), setTimeout(() => {
        n === 0 && k === "prev" ? e(o.length - 1) : n === o.length - 1 && k === "next" ? e(0) : e(k === "next" ? n + 1 : n - 1), i("none"), p(0), w(!1);
      }, 1e3);
    },
    [
      n,
      o.length,
      R.nextIndex,
      R.prevIndex,
      S
    ]
  ), A = Y(
    (k) => {
      r === "none" && !a && (d(!0), f(k.nativeEvent.x));
    },
    [a, r]
  ), _ = Y(
    (k) => {
      d(!1), a && !C && P(h > 0 ? "next" : "prev");
    },
    [h, a, C, P]
  ), $ = Y(
    (k) => {
      d(!1), Math.abs(u - k.nativeEvent.x) > 10 && !C && P(h > 0 ? "next" : "prev");
    },
    [u, h, C, P]
  ), E = Y(
    (k) => {
      a && p(u - k.nativeEvent.x);
    },
    [u, a]
  );
  return ie(() => {
    let k;
    return g && !a && !C ? k = setInterval(() => {
      P("next");
    }, 5e3) : clearInterval(k), () => {
      clearInterval(k);
    };
  }, [g, a, C]), ie(() => {
    t && t(o[S]);
  }, [o, t, S]), {
    slideState: r,
    autoState: g,
    setAutoState: m,
    handleNext: P,
    setDragState: d,
    setDragInit: f,
    dragInit: u,
    dragState: a,
    setDragMove: p,
    dragMove: h,
    hosts: z,
    current: n,
    hover: l,
    setHover: s,
    eventBlock: C,
    slideIndex: S,
    handleMouseOut: _,
    handleDragStart: A,
    handleDragEnd: $,
    handleDragMove: E
  };
}, vd = ({
  data: t,
  setCurrentImg: o,
  handleLink: n,
  wiseLogParam: e,
  gtmName: r = ""
}) => {
  const {
    autoState: i,
    dragMove: l,
    handleNext: s,
    hosts: a,
    dragState: d,
    setAutoState: u,
    current: f,
    slideState: h,
    hover: p,
    setHover: g,
    eventBlock: m,
    handleDragStart: C,
    slideIndex: w,
    handleMouseOut: S,
    handleDragEnd: M,
    handleDragMove: z
  } = gd({
    data: t,
    setCurrentImg: o
  }), { tagGTM: R } = le();
  return /* @__PURE__ */ X("div", { ...R(r), children: [
    /* @__PURE__ */ X(
      md,
      {
        onMouseDown: C,
        onMouseOut: S,
        onMouseUp: M,
        onMouseMove: z,
        onClick: () => {
          h === "none" && n({
            ...t[f],
            wiseLogParam: e
          });
        },
        onMouseOver: () => {
          g(!0);
        },
        onMouseLeave: () => {
          g(!1);
        },
        state: h === "none",
        ...R(`${r}_${t[f].bannerNm}_button`, {
          wlg: e
        }),
        children: [
          /* @__PURE__ */ c(
            yd,
            {
              src: `${bt(
                a.hanssemMallCDN,
                t[f === 0 ? t.length - 1 : f - 1].bannerImgUrl
              )}`,
              draggable: "false",
              dragX: l,
              dragState: d,
              state: h === "prev"
            }
          ),
          /* @__PURE__ */ c(
            Sd,
            {
              src: `${bt(
                a.hanssemMallCDN,
                t[f].bannerImgUrl
              )}`,
              state: h,
              draggable: "false",
              dragX: l,
              dragState: d
            }
          ),
          /* @__PURE__ */ c(
            wd,
            {
              src: `${bt(
                a.hanssemMallCDN,
                t[f === t.length - 1 ? 0 : f + 1].bannerImgUrl
              )}`,
              draggable: "false",
              dragX: l,
              dragState: d,
              state: h === "next"
            }
          )
        ]
      }
    ),
    p && t.length > 1 && /* @__PURE__ */ X(ee, { children: [
      /* @__PURE__ */ c(
        Cd,
        {
          onClick: () => !m && s("prev"),
          onMouseOver: () => {
            g(!0);
          },
          onMouseLeave: () => {
            g(!1);
          },
          ...R(`${r}_prev_button`),
          children: /* @__PURE__ */ c(eo, { fill: "#fff" })
        }
      ),
      /* @__PURE__ */ c(
        _d,
        {
          onMouseOver: () => {
            g(!0);
          },
          onMouseLeave: () => {
            g(!1);
          },
          onClick: () => !m && s("next"),
          ...R(`${r}_next_button`),
          children: /* @__PURE__ */ c(to, { fill: "#fff" })
        }
      )
    ] }),
    /* @__PURE__ */ c(bd, { children: /* @__PURE__ */ c(xd, { gauge: (w + 1) / t.length * 100 }) }),
    t.length > 1 && /* @__PURE__ */ c(Td, { children: /* @__PURE__ */ c(
      ui,
      {
        endIdx: t.length,
        startIdx: w + 1,
        isAutoPlayVisible: !0,
        isAutoPlay: i,
        onClickAutoPlay: () => u((P) => !P),
        gtmName: r + "_pagination"
      }
    ) })
  ] });
}, md = q.div`
  width: 1170px;
  height: 530px;
  position: relative;
  overflow: hidden;
  cursor: ${({ state: t }) => t ? "pointer" : "default"};
`, yd = q.img`
  width: 1170px;
  height: 530px;
  position: absolute;
  left: -100%;
  top: 0px;
  z-index: 2;

  transform: translateX(
    ${({ state: t, dragState: o, dragX: n }) => o ? `${Number(n) * -1}px` : t ? "1170px" : "0px"}
  );
  transition: ${({ state: t }) => t ? "1000ms" : "0ms"};
`, wd = q.img`
  width: 1170px;
  height: 530px;
  z-index: 2;
  left: 100%;
  position: absolute;
  transform: translateX(
    ${({ state: t, dragState: o, dragX: n }) => o ? `${Number(n) * -1}px` : t ? "-1170px" : "0px"}
  );
  transition: ${({ state: t }) => t ? "1000ms" : "0ms"};
`, Sd = q.img`
  width: 1170px;
  height: 530px;
  position: absolute;
  top: 0px;

  transform: translateX(
    ${({ state: t, dragState: o, dragX: n }) => o ? `${Number(n) * -1 / 2}px` : t === "next" ? "-585px" : t === "prev" ? "585px" : "0px"}
  );

  transition: ${({ state: t }) => t === "none" ? "0ms" : "1000ms"};
`, vi = q.div`
  position: absolute;
  cursor: pointer;
  z-index: 9;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.45);
`, Cd = q(vi)`
  left: 0px;
  padding: '4px';
`, _d = q(vi)`
  right: 0px;
  padding: '4px';
`, bd = q.div`
  position: absolute;
  width: 100%;
  height: 4px;
  bottom: 0px;
  z-index: 9;
  background-color: ${se.colors.neutral_colors.gray[200]};
`, xd = q.div`
  width: ${({ gauge: t }) => t}%;
  background-color: ${se.colors.accent_colors.blue.default};
  transition: 0.3s;
  height: 100%;
`, Td = q.div`
  position: absolute;
  right: 28px;
  bottom: 28px;
  z-index: 9;
`, Id = ({ component: t, handleLink: o }) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), [i, l] = U(), s = () => window.innerWidth / 800, { tagGTM: a } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...a(t.componentLayoutCd), children: /* @__PURE__ */ X(Rd, { children: [
    /* @__PURE__ */ X(Od, { children: [
      /* @__PURE__ */ c(
        Ld,
        {
          scale: s(),
          url: (i == null ? void 0 : i.bannerImgUrl) || (r == null ? void 0 : r[0].bannerImgUrl) || ""
        }
      ),
      /* @__PURE__ */ c(zd, {})
    ] }),
    /* @__PURE__ */ c(kd, { children: /* @__PURE__ */ c(
      vd,
      {
        data: r,
        setCurrentImg: l,
        wiseLogParam: e,
        handleLink: o,
        gtmName: t.componentLayoutCd + "_slide"
      }
    ) })
  ] }) }) : /* @__PURE__ */ c(ee, {});
}, Rd = q.div`
  width: 100vw;
  position: relative;
  /* overflow: hidden; */
  height: 530px;
`, kd = q.div`
  width: 1170px;
  height: 530px;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);

  /* display: none; */
`, Ld = q.div`
  background-image: ${({ url: t }) => `url(${t})`};
  background-repeat: no-repeat;
  background-position: center right;
  background-size: cover;
  delay: 1s;
  transition: 1s;
  filter: blur(7.5px);
  height: ${({ scale: t }) => `calc( 530px * ${t} )`};
  width: ${({ scale: t }) => `calc( 1170px * ${t} )`};
`, Od = q.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  transition: 1s;
`, zd = q.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.15);
`, Md = ({
  component: t,
  handleLink: o
}) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { hosts: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ee, { children: /* @__PURE__ */ c(
    Ne,
    {
      baseHeight: 200,
      baseWidth: 970,
      data: r,
      isAutoPlayed: !0,
      hasArrow: !0,
      hasPagination: !0,
      hasInfinite: !0,
      children: ({ width: l, height: s, item: a, index: d }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({ ...a, wiseLogParam: e }),
          children: /* @__PURE__ */ c(
            Te,
            {
              src: `${bt(i.hanssemMallCDN, a.bannerImgUrl)}`,
              alt: `eventRollingBanner${d}`,
              width: "970px",
              height: "200px",
              objectFit: "cover"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, Pd = ({
  component: t,
  handleLink: o
}) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ c(
    Ne,
    {
      isAutoPlayed: !0,
      baseHeight: 530,
      baseWidth: 1170,
      data: r,
      arrowType: "md",
      hasPagination: !0,
      hasArrow: !0,
      hasInfinite: !0,
      isStopBtn: !0,
      gtmName: t.componentLayoutCd,
      children: ({ item: l, index: s }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({ ...l, wiseLogParam: e }),
          ...i(`${t.componentLayoutCd}_button`, {
            wlp: e
          }),
          children: /* @__PURE__ */ c(
            Te,
            {
              src: l.bannerImgUrl,
              alt: `bigbanner${s}`,
              width: "1170px",
              height: "530px",
              objectFit: "contain"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, Ed = ({
  component: t,
  handleLink: o
}) => {
  var l;
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ c(Nd, { children: /* @__PURE__ */ X(
    $d,
    {
      onClick: () => o({
        ...r[0],
        wiseLogParam: e
      }),
      ...i(`${t.componentLayoutCd}_more_button`, {
        wlp: e
      }),
      children: [
        /* @__PURE__ */ c(
          Te,
          {
            src: (l = r[0]) == null ? void 0 : l.bannerImgUrl,
            alt: "mainBanner",
            width: "1170px",
            height: "583px",
            objectFit: "full"
          }
        ),
        /* @__PURE__ */ c(Gd, { children: r.map(
          (s, a) => a >= 1 && /* @__PURE__ */ c(
            ye,
            {
              onClick: () => o({
                ...s,
                wiseLogParam: e
              }),
              ...i(`${t.componentLayoutCd}_item_button`, {
                wlp: e
              }),
              children: /* @__PURE__ */ X(Dd, { children: [
                /* @__PURE__ */ c(
                  Te,
                  {
                    src: s.bannerImgUrl,
                    alt: `subStore${a}`,
                    width: "100%",
                    height: "200px",
                    objectFit: "cover"
                  }
                ),
                /* @__PURE__ */ c(Ad, { children: s.bannerNm })
              ] })
            },
            `link${a}`
          )
        ) })
      ]
    }
  ) }) }) : /* @__PURE__ */ c(ee, {});
}, Nd = q.div`
  width: 1170px;
  padding-top: 90px;
  padding-bottom: 50px;
  margin-top: 20px;
`, $d = q.div`
  width: 100%;
  height: 583px;
  position: relative;
  cursor: pointer;
`, Gd = q.div`
  display: flex;
  gap: 16px;
  position: absolute;
  right: 0px;
  bottom: 14px;
`, Dd = q.div`
  display: flex;
  width: 200px;
  flex-direction: column;
  align-items: center;
`, Ad = q.div`
  height: 55px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${se.colors.neutral_colors.white};
  border: 1px solid ${se.colors.neutral_colors.gray[200]};
  border-top-width: 0px;
  color: ${se.colors.accent_colors.primary.default};
  ${se.typography.subtitle6};
`, Wd = ({ component: t, handleLink: o }) => {
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { hosts: i, tagGTM: l } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...l(t.componentLayoutCd), children: /* @__PURE__ */ c(
    Ne,
    {
      baseHeight: 152,
      baseWidth: 1170,
      data: r,
      arrowType: "lg",
      isAutoPlayed: !0,
      hasArrow: !0,
      hasInfinite: !0,
      gtmName: t.componentLayoutCd + "_slide",
      children: ({ width: s, height: a, item: d, index: u }) => /* @__PURE__ */ c(
        ye,
        {
          onClick: () => o({ ...d, wiseLogParam: e }),
          ...l(`${t.componentLayoutCd}_item_button`, {
            wlp: e
          }),
          children: /* @__PURE__ */ c(
            Te,
            {
              src: `${bt(i.hanssemMallCDN, d.bannerImgUrl)}`,
              alt: `eventRollingBanner${u}`,
              width: "1170px",
              height: "152px",
              objectFit: "cover"
            }
          )
        },
        `RemodelingBannerTrend_${u}`
      )
    }
  ) }) : /* @__PURE__ */ c(ee, {});
}, Ud = ({
  component: t,
  handleLink: o
}) => {
  var l;
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ X(Hd, { children: [
    /* @__PURE__ */ X(
      Bd,
      {
        onClick: () => {
          var s;
          return o({
            ...(s = t.componentData) == null ? void 0 : s.componentInfo,
            wiseLogParam: e
          });
        },
        ...i(`${t.componentLayoutCd}_more_button`, {
          wlp: e
        }),
        children: [
          /* @__PURE__ */ c(jd, { children: (l = t.componentData) == null ? void 0 : l.componentInfo.title }),
          /* @__PURE__ */ c(Qe, {})
        ]
      }
    ),
    /* @__PURE__ */ c(Fd, { children: r.map((s, a) => /* @__PURE__ */ c(
      ye,
      {
        onClick: () => o({ ...s, wiseLogParam: e }),
        ...i(`${t.componentLayoutCd}_item_button`, {
          wlp: e
        }),
        children: /* @__PURE__ */ c(Vd, { children: /* @__PURE__ */ c(
          Te,
          {
            src: s.bannerImgUrl,
            alt: "bannerImg",
            width: "575px",
            height: "200px"
          }
        ) })
      },
      `item${a}`
    )) })
  ] }) }) : /* @__PURE__ */ c(ee, {});
}, Hd = q.div`
  padding-top: 70px;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 1170px;
`, Bd = q.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 28px;
`, jd = q.div`
  color: ${se.colors.accent_colors.primary.default};
  ${se.typography.subtitle2};
`, Fd = q.div`
  display: flex;
  gap: 20px;
  width: 100%;
`, Vd = q.div`
  width: 100%;
  height: 200px;
`, qd = ({
  component: t,
  handleLink: o
}) => {
  var l;
  const { getComponentDataList: n, wiseLogParam: e } = Ee({
    component: t
  }), r = n(), { tagGTM: i } = le();
  return r && r.length > 0 ? /* @__PURE__ */ c(ge, { space: "none", ...i(t.componentLayoutCd), children: /* @__PURE__ */ X(Kd, { children: [
    /* @__PURE__ */ X(
      Yd,
      {
        onClick: () => {
          var s;
          return o({
            ...(s = t.componentData) == null ? void 0 : s.componentInfo,
            wiseLogParam: e
          });
        },
        ...i(`${t.componentLayoutCd}_more_button`, {
          wlp: e
        }),
        children: [
          /* @__PURE__ */ c(Xd, { children: (l = t.componentData) == null ? void 0 : l.componentInfo.title }),
          /* @__PURE__ */ c(Qe, {})
        ]
      }
    ),
    /* @__PURE__ */ c(
      Ne,
      {
        rowNumber: 3,
        slidePerNum: 1,
        isAutoPlayed: !1,
        baseHeight: 283,
        baseWidth: 1170,
        hasArrow: !0,
        gap: 20,
        hasInfinite: !0,
        data: r,
        gtmName: t.componentLayoutCd + "_slide",
        children: ({ width: s, height: a, item: d, index: u }) => /* @__PURE__ */ c(
          ye,
          {
            onClick: () => o({
              ...Oe(d.gdsDetailUrl, "REMODELING"),
              wiseLogParam: e
            }),
            ...i(`${t.componentLayoutCd}_item_button`, {
              wlp: e,
              "good-id": +d.gdsNo
            }),
            children: /* @__PURE__ */ X(Zd, { children: [
              /* @__PURE__ */ c(
                Te,
                {
                  src: d.imgPathL,
                  alt: "bannerImg",
                  width: "376px",
                  height: "251px",
                  objectFit: "cover"
                }
              ),
              /* @__PURE__ */ c(Qd, { children: d.gdsNm })
            ] })
          },
          `categoryImg${u}`
        )
      }
    )
  ] }) }) : /* @__PURE__ */ c(ee, {});
}, Kd = q.div`
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 1170px;
`, Yd = q.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 28px;
`, Xd = q.div`
  color: ${se.colors.accent_colors.primary.default};
  ${se.typography.subtitle2};
`, Qd = q.div`
  display: block;
  width: 100%;
  text-align: left;
  color: ${se.colors.accent_colors.primary.default};
  margin-top: 12px;
  ${se.typography.body2};
`, Zd = q.div`
  width: 100%;
`, Jd = ({ component: t }) => {
  const { componentData: o } = t, n = o == null ? void 0 : o.componentDataList, { tagGTM: e } = le();
  return n && (n == null ? void 0 : n.length) > 0 ? /* @__PURE__ */ c(
    ge,
    {
      space: "bottom_20",
      ...e(t.componentLayoutCd),
      children: n.map((r, i) => /* @__PURE__ */ c(eu, { children: /* @__PURE__ */ c(
        Te,
        {
          src: r.bannerImgUrl,
          alt: r.bannerImgUrl,
          width: 1170,
          height: 266
        }
      ) }, `RemodelingImgLineDesc-${i}`))
    }
  ) : /* @__PURE__ */ c(ee, {});
}, eu = q.div``, tu = ({ handleIsOnData: t }) => {
  const [o, n] = U([]), { hosts: e, httpClient: r } = le();
  return Vl(() => {
    it(e.hanssemApiGateway, r).getPopupList.exec({ deviceType: "PC" }).then((i) => {
      var l, s;
      i.code === 200 && (i != null && i.data) ? (t((((l = i == null ? void 0 : i.data) == null ? void 0 : l.popupList) || []).length > 0), n(((s = i == null ? void 0 : i.data) == null ? void 0 : s.popupList) || [])) : (t(!1), n([]));
    }).catch(() => {
      t(!1), n([]);
    });
  }), {
    data: o
  };
}, nu = ({
  handleClick: t,
  width: o,
  height: n,
  handleIsOnData: e,
  isAutoPlayed: r,
  isStopBtn: i,
  autoDelay: l
}) => {
  const { data: s } = tu({ handleIsOnData: e }), { tagGTM: a } = le();
  return s.length <= 0 ? /* @__PURE__ */ c(ee, {}) : /* @__PURE__ */ c(ge, { space: "none", ...a("app-main-popup"), children: /* @__PURE__ */ c(
    Ne,
    {
      baseWidth: o,
      baseHeight: n,
      data: s,
      hasPagination: !0,
      hasInitialSlide: !0,
      pageIndicator: "numberStyle",
      isAutoPlayed: r,
      isStopBtn: i,
      autoDelay: l,
      children: ({ width: d, height: u, item: f }) => /* @__PURE__ */ c(
        J,
        {
          width: d,
          height: u,
          onClick: () => t(f.appLinkInfoDto),
          children: /* @__PURE__ */ c(An, { src: f.imageUrl })
        }
      )
    }
  ) });
}, pf = tn(nu), Dn = (t, o) => ({
  getDetail: new ru(t, o),
  like: new Xi(t, o),
  unlike: new Yi(t, o)
}), ou = (t) => {
  var o, n;
  return {
    reviewNo: t.gdsEvalNo,
    writerId: t.custId || "ha********",
    writerTypeCd: t.writerTypeCd,
    score: t.avgScore || 0,
    regDate: Pl(t.regYmdt, "yyyy. MM. dd") || "",
    unitNm: t.unitNm,
    isLike: (t.myLikeCount || 0) > 0,
    likeCount: t.likeCount || 0,
    title: ho(t.gdsEvalTitle) || "",
    contents: ho(t.gdsEvalConts) || "",
    videoUrl: t.videoUrl || "",
    imageUrls: (t.imageInfos || []).sort((e, r) => e.seq < r.seq ? -1 : 1).map((e) => e.imgUrl),
    gdsNo: t.gdsNo,
    gdsNm: t.gdsNm,
    gdsStatCd: t.gdsStatCd || "N",
    imageUrl: t.imageUrl,
    badgeImageUrl: t.badgeImageUrl,
    normalSalePrc: t.normalSalePrc,
    dcPrc: t.dcPrc,
    dcRate: t.dcRate,
    prcViewTypCd: t.prcViewTypCd,
    prcViewTypNm: t.prcViewTypNm,
    isNotiOfStock: t.isNotiOfStock,
    goodsBrandNo: (o = t == null ? void 0 : t.goodsBrandInfoDto) == null ? void 0 : o.brandNo,
    goodsBrandName: (n = t == null ? void 0 : t.goodsBrandInfoDto) == null ? void 0 : n.brandNm
  };
};
class ru {
  constructor(o, n) {
    we(this, "host");
    we(this, "httpClient");
    this.host = o, this.httpClient = n;
  }
  async exec(o) {
    var e, r;
    const n = await new Qi(
      this.host,
      this.httpClient
    ).exec(o);
    return n.code === 200 ? {
      apiResponse: n,
      ...ou({
        ...(e = n.data) == null ? void 0 : e.goodsEvaluationDetailInfo,
        imageInfos: (r = n.data) == null ? void 0 : r.imageInfos
      })
    } : {
      apiResponse: n
    };
  }
}
const iu = ({
  reviewNo: t = 0,
  isLike: o = !1,
  likeCount: n = 0,
  imageInfos: e = [],
  isAuthenticated: r,
  onHandleAction: i
}) => {
  const [l, s] = U(), [a, d] = U(0), [u, f] = U(!1), [h, p] = U(0), [g, m] = U(0), C = xe(null), w = re(() => Math.ceil(e.length / 8), [e]), S = re(() => {
    const $ = [];
    if (e.length < 8)
      $.push(e);
    else
      for (let E = 0; E < w; E++) {
        let k = e.slice(
          E * 8,
          w - 1 === E ? void 0 : 8 * (E + 1)
        );
        k.length < 8 && (k = k.concat(
          Array(8 - k.length).fill(null)
        )), $.push(k);
      }
    return $;
  }, [w, e]), { hosts: M, httpClient: z } = le(), R = Y(() => {
    r ? u ? Dn(M.hanssemApiGateway, z).unlike.exec({ gdsEvalNo: t }).then(($) => {
      $.code === 200 && (f(!1), p((E) => E - 1));
    }) : Dn(M.hanssemApiGateway, z).like.exec({ gdsEvalNo: t }).then(($) => {
      $.code === 200 && (f(!0), p((E) => E + 1));
    }) : i({
      type: "confirm",
      action: "login",
      message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
    });
  }, [
    M.hanssemApiGateway,
    z,
    r,
    u,
    i,
    t
  ]), P = Y(
    ($) => {
      !e || !C.current || (C.current.src = e[$].imgUrl, m($));
    },
    [e]
  ), A = Y(($, E) => E < $ ? "0%" : E >= $ + 1 ? "100%" : `${(E % 1 * 100).toFixed(2)}%`, []), _ = Y(
    ($, E) => /* @__PURE__ */ c(De, { children: [0, 1, 2, 3, 4].map((W) => /* @__PURE__ */ X(
      J,
      {
        position: "relative",
        children: [
          /* @__PURE__ */ c(
            J,
            {
              width: A(W, E),
              height: $,
              overflow: "hidden",
              position: "relative",
              children: /* @__PURE__ */ c(
                fo,
                {
                  size: $,
                  resize: !0,
                  variant: "ic_star_solid",
                  overflow: "hidden",
                  position: "relative",
                  zIndex: yo + 1
                }
              )
            }
          ),
          /* @__PURE__ */ c(
            fo,
            {
              position: "absolute",
              top: 0,
              resize: !0,
              zIndex: yo,
              size: $,
              variant: "ic_star_solid",
              fillColor: "rgb(204, 204, 204)"
            }
          )
        ]
      },
      `reveiw-star-position-${W}`
    )) }),
    [A]
  );
  return ie(() => {
    f(o), p(n);
  }, [o, n]), {
    isLikeInside: u,
    likeCountInside: h,
    activeIndex: g,
    arrImageList: S,
    pageTotalSize: w,
    source: C,
    slideIndex: a,
    swiper: l,
    setSwiper: s,
    setSlideIndex: d,
    setActiveIndex: m,
    handleToggleLikeButton: R,
    handleMouseHoverImage: P,
    goodsReviewStarUI: _
  };
}, lu = ({
  item: t,
  isLogin: o,
  imageInfoList: n,
  onHandleAction: e
}) => {
  const {
    isLikeInside: r,
    likeCountInside: i,
    activeIndex: l,
    pageTotalSize: s,
    arrImageList: a,
    slideIndex: d,
    swiper: u,
    source: f,
    setSwiper: h,
    setSlideIndex: p,
    handleToggleLikeButton: g,
    handleMouseHoverImage: m,
    goodsReviewStarUI: C
  } = iu({
    reviewNo: t.reviewNo,
    isLike: t.isLike,
    likeCount: t.likeCount,
    imageInfos: n,
    isAuthenticated: o,
    onHandleAction: e
  });
  return /* @__PURE__ */ X(De, { height: "100%", width: "100%", children: [
    n && n.length > 0 && /* @__PURE__ */ X(Me, { width: 504, height: "100%", pr: 24, alignment: "start", space: 16, children: [
      /* @__PURE__ */ c(su, { children: /* @__PURE__ */ c(
        J,
        {
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          borderRadius: "2px",
          children: /* @__PURE__ */ c(
            An,
            {
              ref: f,
              src: `${n[0].imgUrl}`
            }
          )
        }
      ) }),
      /* @__PURE__ */ X(De, { space: "flex-start", alignment: "center", width: 480, children: [
        s > 1 && /* @__PURE__ */ c(
          Jt,
          {
            size: "md",
            mr: "4px",
            variant: "ic_arrow_left_bold",
            disabled: d <= 0,
            fillColor: d <= 0 ? "rgb(226, 226, 226)" : void 0,
            onClick: () => u == null ? void 0 : u.slidePrev()
          }
        ),
        /* @__PURE__ */ c(
          Gu,
          {
            gap: 4,
            baseWidth: 416,
            itemWidth: 416,
            itemHeight: 48,
            setSlideIndex: p,
            data: a,
            setSwiper: h,
            children: ({ width: w, height: S, index: M, item: z }) => /* @__PURE__ */ c(De, { width: w, height: S, space: 4, children: z && z.map((R, P) => R && R.imgUrl ? /* @__PURE__ */ c(
              au,
              {
                active: l === M * 8 + P,
                width: S,
                height: S,
                children: /* @__PURE__ */ c(
                  An,
                  {
                    width: S,
                    height: S,
                    src: gr({
                      url: R.imgUrl,
                      w: 110,
                      h: 110,
                      q: 95
                    }),
                    alt: "",
                    onMouseOver: () => m(M * 8 + P)
                  }
                )
              },
              `review-detail-all-image-swiper-list-${M * 8 + P}`
            ) : /* @__PURE__ */ c(
              J,
              {},
              `review-detail-image-swiper-list-empty-${M * 8 + P}`
            )) })
          }
        ),
        s > 1 && /* @__PURE__ */ c(
          Jt,
          {
            size: "md",
            variant: "ic_arrow_right_bold",
            disabled: s === d + 1,
            fillColor: d > 0 ? "rgb(226, 226, 226)" : void 0,
            onClick: () => u == null ? void 0 : u.slideNext()
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ X(Me, { minWidth: 410, width: "100%", height: "100%", children: [
      /* @__PURE__ */ X(
        Me,
        {
          width: "100%",
          alignment: "start",
          space: 8,
          py: 12,
          px: 16,
          borderRadius: "2px",
          backgroundColor: "color_chip.gray.50",
          children: [
            t && C(16, t.score),
            /* @__PURE__ */ c(St, { variant: "label_sm_b", color: "color_chip.gray.600", children: t == null ? void 0 : t.unitNm }),
            /* @__PURE__ */ c(St, { variant: "caption1", color: "color_chip.gray.600", children: t == null ? void 0 : t.regDate })
          ]
        }
      ),
      /* @__PURE__ */ X(De, { py: 16, space: "space-between", height: 60, width: "100%", children: [
        /* @__PURE__ */ c(St, { variant: "caption1", color: "color_chip.gray.600", children: t == null ? void 0 : t.writerId }),
        /* @__PURE__ */ c(
          Un,
          {
            icon: {
              variant: "ic_thumb_up",
              align: "left"
            },
            size: "sm",
            emphasis: r ? "medium" : "low",
            width: "auto",
            colorVariant: "primary",
            onClick: () => g(),
            children: /* @__PURE__ */ X(St, { variant: "label_sm_m", color: "color_chip.primary", children: [
              "도움돼요 ",
              i
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ c(J, { width: "100%", display: "flex", flexGrow: 1, overflow: "auto", children: /* @__PURE__ */ c(St, { variant: "body2", color: "color_chip.primary", children: t.contents }) })
    ] })
  ] });
}, su = q(J)`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  object-fit: contain;
  padding: 0px;
  &::after {
    display: block;
    content: '';
    padding-bottom: 100%;
  }
`, au = q(J)`
  ${({ theme: t }) => Fe`
    border-radius: 2px;
    border: 1px solid ${t.colors.color_chip.white};
    ${(o) => o.active && Fe`
        border: 1px solid ${t.colors.color_chip.primary};
      `}
  `}
`, cu = ({
  selectedReviewNo: t,
  isOpen: o
}) => {
  const [n, e] = U(), [r, i] = U([]), { hosts: l, httpClient: s } = le();
  return ie(() => {
    o && (Dn(l.hanssemApiGateway, s).getDetail.exec({ gdsEvalNo: t }).then((a) => {
      a.apiResponse.code === 200 && e(a);
    }), e({}));
  }, [l, s, o, t]), ie(() => {
    if (n) {
      const a = [];
      (n.imageUrls || []).forEach((d, u) => {
        a.push({
          seq: u,
          imgPath: "",
          imgUrl: d
        });
      }), i(a);
    }
  }, [n]), {
    reviewDetail: n,
    imageInfoList: r
  };
}, du = ({
  selectedReviewNo: t,
  isOpen: o,
  isLogin: n,
  handleClose: e,
  onHandleAction: r
}) => {
  const { reviewDetail: i, imageInfoList: l } = cu({
    selectedReviewNo: t,
    isOpen: o
  });
  return /* @__PURE__ */ c(
    nl,
    {
      isOpen: o,
      handleClose: e,
      popupContentStyledProps: {
        height: "554px"
      },
      size: "xlg",
      title: "상품후기",
      zIndex: ns,
      children: /* @__PURE__ */ c(J, { width: "100%", height: "100%", position: "relative", overflow: "hidden", children: i ? /* @__PURE__ */ c(
        lu,
        {
          item: i,
          isLogin: n,
          imageInfoList: l,
          onHandleAction: r
        }
      ) : /* @__PURE__ */ c(J, { width: "100%", height: "100%" }) })
    }
  );
}, ln = ({
  componentId: t,
  size: o,
  componentGroupDataId: n
}) => {
  const { hosts: e, httpClient: r } = le(), i = Y(
    (g) => (g = g + 1, t != null ? Qt.stringify({
      componentId: t,
      page: g,
      size: o,
      componentGroupDataId: n
    }) : null),
    [o, t, n]
  ), l = Y(
    (g) => it(
      e.hanssemApiGateway,
      r
    ).getTemplateInfiniteComponentsData.exec(
      Qt.parse(
        g
      )
    ),
    [e.hanssemApiGateway, r]
  ), {
    data: s,
    setSize: a,
    size: d,
    isValidating: u
  } = mr(
    i,
    l,
    {
      revalidateIfStale: !1,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1,
      revalidateFirstPage: !1
    }
  ), f = re(() => {
    const g = s != null && s.map ? s == null ? void 0 : s.map((C) => C.data) : void 0, m = g == null ? void 0 : g.map((C) => C == null ? void 0 : C.map((w) => w.content));
    return m && m.length > 0 ? (m == null ? void 0 : m.reduce((C = [], w = []) => C == null ? void 0 : C.concat(w[0]), [])) || [] : [];
  }, [s]), h = re(
    () => {
      var g, m;
      return ((m = Tt((g = Tt(s)) == null ? void 0 : g.data)) == null ? void 0 : m.totalElements) || 0;
    },
    [s]
  ), p = Y(async () => {
    f.length < Number(h) && !u && await a(d + 1);
  }, [u, f.length, a, d, h]);
  return { items: f, handleMore: p };
}, mi = gt({ handleClickUnit: () => {
} }), We = () => {
  const t = kt(mi);
  if (t === void 0)
    throw new Error(
      "useDisplayActionProvider must be used within a DisplayActionProvider"
    );
  return t;
}, uu = ({
  children: t,
  onHandleClick: o
}) => {
  const n = Y(
    (e, r, i) => {
      if (i) {
        o({
          goodsInfo: i,
          isNewWindow: !!e
        });
        return;
      }
      r && o({ applink: r, isNewWindow: !!e });
    },
    [o]
  );
  return /* @__PURE__ */ c(mi.Provider, { value: { handleClickUnit: n }, children: t });
}, yi = gt({
  item: {},
  componentId: 0,
  horizontalType: 0,
  scrollType: "",
  unitType: "",
  isInfinity: !1,
  quickLinkData: [],
  QuickLinkUnit: () => null
}), oo = () => {
  const t = kt(yi);
  if (t === void 0)
    throw new Error(
      "useQuickLinkData must be used within a QuickLinkDataProvider"
    );
  return t;
}, hu = ({
  children: t,
  item: o
}) => {
  var p;
  const { tagGTM: n } = le(), { handleClickUnit: e } = We(), r = o.componentId, i = (p = o.data) == null ? void 0 : p.content.map((g, m) => ({
    ...g,
    gtmIndex: m + 1
  })), {
    horizontalType: l,
    scroll: s,
    unit: a,
    paging: d,
    gtm: u
  } = o.attribute.body, f = d === "infinity", h = ({ item: g }) => {
    var C, w, S;
    const m = n(u.taggtm, {
      ...u,
      index: g.gtmIndex,
      "plan-id": ((C = g.appLinkInfoDto) == null ? void 0 : C.appLinkTarget) === "PLAN" ? (w = g.appLinkInfoDto) == null ? void 0 : w.appLinkVal : void 0,
      "landing-url": (S = g.appLinkInfoDto) == null ? void 0 : S.linkUrl
    });
    return /* @__PURE__ */ X(ee, { children: [
      a === "capsule" && /* @__PURE__ */ c(
        ol,
        {
          img: g.imageUrl,
          title: g.quicklinkName,
          isNewBadge: g.isHighlight,
          handleClick: () => e(g.isNewWindow, g.appLinkInfoDto),
          ...m
        }
      ),
      a === "square" && /* @__PURE__ */ c(
        rl,
        {
          img: g.imageUrl,
          title: g.quicklinkName,
          isNewBadge: g.isHighlight,
          handleClick: () => e(g.isNewWindow, g.appLinkInfoDto),
          ...m
        }
      ),
      a === "circle" && /* @__PURE__ */ c(
        il,
        {
          img: g.imageUrl,
          title: g.quicklinkName,
          isNewBadge: g.isHighlight,
          handleClick: () => e(g.isNewWindow, g.appLinkInfoDto),
          ...m
        }
      )
    ] });
  };
  return /* @__PURE__ */ c(
    yi.Provider,
    {
      value: {
        item: o,
        componentId: r,
        horizontalType: l,
        scrollType: s,
        unitType: a,
        isInfinity: f,
        quickLinkData: i,
        QuickLinkUnit: h
      },
      children: t
    }
  );
}, fu = () => {
  const {
    quickLinkData: t,
    isInfinity: o,
    componentId: n,
    unitType: e,
    horizontalType: r,
    QuickLinkUnit: i
  } = oo(), { items: l, handleMore: s } = o && n ? ln({
    componentId: n,
    size: 20
  }) : {
    items: null,
    handleMore: () => null
  };
  return /* @__PURE__ */ c(J, { width: "100%", children: o ? /* @__PURE__ */ c(
    $t,
    {
      list: l,
      columnCount: r,
      columnSpace: 24,
      rowSpace: 24,
      handleNextMore: () => s(),
      children: ({ item: a }) => /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(i, { item: a }) })
    }
  ) : /* @__PURE__ */ c(
    J,
    {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      pl: e !== "capsule" ? "42px" : 0,
      pr: e !== "capsule" ? "42px" : 0,
      children: /* @__PURE__ */ c(
        sn,
        {
          itemCount: t.length,
          columnCount: e === "capsule" ? 4 : 10,
          space: Pn,
          children: t == null ? void 0 : t.map((a, d) => /* @__PURE__ */ c(i, { item: a }, d))
        }
      )
    }
  ) });
}, pu = () => {
  const [t, o] = U(), [n, e] = U(!0), [r, i] = U(!1), [l, s] = U(!1), a = Y(() => {
    t == null || t.slideNext();
  }, [t]), d = Y(() => {
    t == null || t.slidePrev();
  }, [t]), { quickLinkData: u, QuickLinkUnit: f, unitType: h, horizontalType: p } = oo();
  return /* @__PURE__ */ c(
    gu,
    {
      width: "100%",
      position: "relative",
      pl: h === "capsule" ? 0 : "42px",
      pr: h === "capsule" ? 0 : "42px",
      children: (u == null ? void 0 : u.length) > p ? /* @__PURE__ */ X(
        J,
        {
          width: "100%",
          onMouseOver: () => s(!0),
          onMouseLeave: () => s(!1),
          children: [
            h === "capsule" ? /* @__PURE__ */ c(ee, { children: l && /* @__PURE__ */ X(ee, { children: [
              !n && /* @__PURE__ */ c(
                ze,
                {
                  size: "md",
                  variant: "prev",
                  onClick: d,
                  position: "absolute",
                  top: 23,
                  left: 0,
                  zIndex: 2
                }
              ),
              !r && /* @__PURE__ */ c(
                ze,
                {
                  size: "md",
                  variant: "next",
                  onClick: a,
                  position: "absolute",
                  top: 23,
                  right: 0,
                  zIndex: 2
                }
              )
            ] }) }) : /* @__PURE__ */ X(ee, { children: [
              !n && /* @__PURE__ */ c(
                Jt,
                {
                  size: "xlg",
                  variant: "ic_arrow_left",
                  position: "absolute",
                  top: "clamp(22.5px, calc(22.5px + (35 - 22.5) * ((100vw - 1170px) / (1400 - 1170))), 35px)",
                  left: "0",
                  onClick: d,
                  zIndex: 2
                }
              ),
              !r && /* @__PURE__ */ c(
                Jt,
                {
                  size: "xlg",
                  variant: "ic_arrow_right",
                  position: "absolute",
                  top: "clamp(22.5px, calc(22.5px + (35 - 22.5) * ((100vw - 1170px) / (1400 - 1170))), 35px)",
                  right: "0",
                  onClick: a,
                  zIndex: 2
                }
              )
            ] }),
            /* @__PURE__ */ c(
              Eh,
              {
                baseWidth: h === "capsule" ? 1400 : 1320,
                itemWidth: h === "capsule" ? 332 : 110,
                itemHeight: h === "capsule" ? 100 : 150,
                data: u,
                gap: Pn,
                fixedSlidePerView: p,
                isPreviewed: !0,
                useFixedGap: !0,
                isMaxHeight: !0,
                setSwiperAction: o,
                setIsSwiperBegin: e,
                setIsSwiperEnd: i,
                children: ({ item: g }) => /* @__PURE__ */ c(f, { item: g })
              }
            )
          ]
        }
      ) : /* @__PURE__ */ c(J, { display: "flex", justifyContent: "center", width: "100%", children: /* @__PURE__ */ c(
        sn,
        {
          itemCount: u.length,
          columnCount: h === "capsule" ? 4 : 10,
          space: Pn,
          children: u.map((g, m) => /* @__PURE__ */ c(f, { item: g }, m))
        }
      ) })
    }
  );
}, gu = q(J)``, vu = () => {
  const { scrollType: t } = oo();
  return /* @__PURE__ */ c(ee, { children: t === "horizontal" ? /* @__PURE__ */ c(pu, {}) : /* @__PURE__ */ c(fu, {}) });
}, mu = ({
  horizontalColumnLength: t,
  displayType: o,
  contentData: n,
  contentsRenderer: e,
  gtm: r
}) => {
  const { setIndicatorPercent: i } = zt(), [l, s] = U(), [a, d] = U(!1), u = Y(() => {
    l == null || l.slideNext();
  }, [l]), f = Y(() => {
    l == null || l.slidePrev();
  }, [l]);
  return ie(() => {
    o === "chip" && (l == null || l.slideTo(t, 0));
  }, [l, n, o, t]), /* @__PURE__ */ c(ee, { children: n && n.length > 0 && /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      position: "relative",
      onMouseOver: () => d(!0),
      onMouseLeave: () => d(!1),
      children: [
        /* @__PURE__ */ c(
          Gt,
          {
            baseWidth: 1400,
            baseHeight: 715,
            data: n,
            hasLoop: n.length > t,
            rowNumber: t,
            slidePerNum: t,
            gap: 32,
            setSwiperAction: s,
            setIndicatorPercent: i,
            children: ({ item: h, index: p }) => /* @__PURE__ */ c(Me, { space: Tr, width: "100%", children: h.map((g, m) => /* @__PURE__ */ c(Lt, { children: e(g) }, `${g.linkUrl}`)) })
          }
        ),
        a && t < n.length && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: f,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 10,
              style: { transform: "translateY(-50%)" }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: u,
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 10,
              style: { transform: "translateY(-50%)" }
            }
          )
        ] })
      ]
    }
  ) });
}, yu = ({
  contentData: t,
  isInfinity: o,
  componentId: n,
  componentGroupDataId: e,
  gtm: r,
  unitType: i,
  contentsRenderer: l,
  horizontalColumnLength: s
}) => {
  const {
    items: a,
    handleMore: d
    // gridRef
  } = o && n ? ln({
    componentId: n,
    size: 20,
    componentGroupDataId: e
  }) : {
    items: null,
    handleMore: () => null
    // gridRef: null,
  };
  return /* @__PURE__ */ c(J, { width: "100%", children: o ? /* @__PURE__ */ c(
    $t,
    {
      list: a,
      columnCount: s,
      rowSpace: i === "normal" ? 24 : 10,
      handleNextMore: () => d(),
      children: ({ item: u, key: f, index: h }) => /* @__PURE__ */ c(J, { width: "100%", pl: 16, pr: 16, children: l(u) })
    }
  ) : /* @__PURE__ */ c(
    sn,
    {
      itemCount: s,
      columnCount: s,
      colSpace: Tr,
      rowSpace: i === "normal" ? 80 : 32,
      children: t.map((u, f) => t[f].map((h, p) => /* @__PURE__ */ c(
        J,
        {
          width: "100%",
          children: l(h)
        },
        `${r["component-id"]}-vertical-content-item-${p}`
      )))
    }
  ) });
}, ro = ({
  type: t,
  handleClickChip: o,
  handleSetChipIndex: n,
  handleComponentId: e,
  chipList: r,
  gtm: i,
  children: l,
  selectedChipIndex: s,
  isChipLink: a
}) => {
  var m;
  const { tagGTM: d } = le(), [u, f] = U(r[0]), h = re(
    () => t === "filter" ? ll : sl,
    [t]
  ), { handleClickUnit: p } = We(), g = Y(
    (C, w, S) => {
      o && o(), n && n(w), e && e(C.componentGroupDataId), f(C);
    },
    [o, e, n]
  );
  return ie(() => {
    r && r.length && e && e(r[0].componentGroupDataId);
  }, [r, e]), /* @__PURE__ */ X(ee, { children: [
    /* @__PURE__ */ c(
      J,
      {
        display: "flex",
        justifyContent: "center",
        mb: "32px",
        ...d(i.taggtm, i),
        children: /* @__PURE__ */ c(
          De,
          {
            alignment: "stretch",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: `${rs}px ${os}px`,
            children: r.map((C, w) => /* @__PURE__ */ c(
              h,
              {
                onClick: (S) => g(C, w, S),
                size: "lg",
                isChecked: s === w,
                img: C.chipImageUrl,
                flex: "0 0 auto",
                variant: C.groupTitle1 === "전체" ? "all" : "default",
                children: C.groupTitle1
              },
              `${i["component-id"]}-expanded-chip-content-${w}`
            ))
          }
        )
      }
    ),
    (u == null ? void 0 : u.imageUrl) && /* @__PURE__ */ c(J, { pb: "32px", width: "100%", children: /* @__PURE__ */ c(wr, { img: u.imageUrl }) }),
    l,
    a && u.groupTitle1 !== "전체" && ((m = u == null ? void 0 : u.appLinkInfoDto) == null ? void 0 : m.linkUrl) && /* @__PURE__ */ c(J, { width: "100%", display: "flex", justifyContent: "center", mt: 36, children: /* @__PURE__ */ c(
      Un,
      {
        width: "440px",
        size: "lg",
        emphasis: "low",
        icon: {
          variant: "ic_arrow_right",
          align: "right"
        },
        onClick: () => p(u == null ? void 0 : u.isNewWindow, u),
        children: u.chipLinkButtonTitle
      }
    ) })
  ] });
}, wu = ({
  displayType: t,
  displayData: o,
  horizontalColumnLength: n,
  verticalLineNumber: e,
  unitDirection: r,
  scrollDirection: i,
  dataType: l,
  unitElement: s,
  onHandleClick: a,
  isChip: d,
  scrapContentList: u,
  setScrapContentList: f,
  onHandleAction: h,
  isLogin: p,
  toggleScrap: g,
  unitType: m,
  ratio: C,
  gtm: w,
  componentId: S,
  chipType: M,
  isChipLink: z,
  isInfinity: R,
  contentsDataType: P
}) => {
  const [A, _] = U(0), [$, E] = U(0), [k, W] = U([]), [v, G] = U(0), [b, L] = U(!1), { tagGTM: x } = le(), { handleClickUnit: Z } = We(), { convertedUnitData: j } = nn({
    verticalLineNumber: e,
    horizontalColumnLength: n,
    unitData: k,
    scrollDirection: i
  });
  ie(() => {
    l === "default" && W(o), l === "group" && d && W(
      o[A].data.content
    );
  }, [l, o, d, A]);
  const y = re(() => {
    switch (m) {
      case "normal":
        return C === "square" ? ul : hl;
      case "horizontal":
        return C === "circle" ? cl : dl;
      default:
        return al;
    }
  }, [C, m]), N = Y(
    (I, V) => (u == null ? void 0 : u.find(
      (F) => F.targetNo === I && (F == null ? void 0 : F.scrapGbnCd) === V
    )) !== void 0,
    [u]
  ), K = Y(
    async (I, V) => {
      if (!p) {
        h({
          type: "confirm",
          action: "login",
          message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
        });
        return;
      }
      const T = N(I, V);
      if (await g({
        scrapGbnCd: V,
        targetNo: I,
        targetSubNo: 0,
        isUse: !T
      }) === 200)
        if (T) {
          const Q = u.filter(
            (te) => te.targetNo !== I || te.scrapGbnCd !== V
          );
          f(Q);
        } else
          h({
            type: "toast",
            action: "scrap",
            message: "스크랩이 완료되었습니다."
          }), f([
            ...u,
            { targetNo: I, targetSubNo: 0, scrapGbnCd: V }
          ]);
    },
    [
      p,
      N,
      h,
      u,
      f,
      g
    ]
  ), H = Y(
    (I) => {
      var T;
      const V = {
        flag: m !== "thumbnail" ? I == null ? void 0 : I.tagInfo.map((F) => ({
          variant: F.style === "LINE" ? "line" : "solid",
          textColor: F.textColor,
          color: F.styleColor,
          content: F.name
        })) : [],
        handleClick: () => {
          P === "REVIEW" ? (G(I.contentsNo), L(!0)) : Z(I.isNewWindow, I.appLinkInfoDto);
        },
        img: I == null ? void 0 : I.imageInfo.images[0].imageUrl,
        imgFlags: m !== "thumbnail" ? I == null ? void 0 : I.imageInfo.tagInfo.map((F) => ({
          variant: F.variant,
          textColor: F.textColor,
          color: F.color,
          content: F.content
        })) : [],
        info1: I == null ? void 0 : I.squareMeter,
        info2: I == null ? void 0 : I.cityCountryDistrict,
        info3: I != null && I.planStartDateTime && (I != null && I.planEndDateTime) ? `${mo(
          I == null ? void 0 : I.planStartDateTime
        )} - ${mo(I == null ? void 0 : I.planEndDateTime)}` : void 0,
        infoEct: I == null ? void 0 : I.buildingName,
        profile: I != null && I.sourceName ? {
          img: I == null ? void 0 : I.sourceImageUrl,
          name: I == null ? void 0 : I.sourceName
        } : void 0,
        reviewScore: s.isReviewRating ? ut(I == null ? void 0 : I.reviewRating).toFixed(1) : void 0,
        subTitle: I == null ? void 0 : I.contentsSubTitle,
        title: I == null ? void 0 : I.contentsTitle,
        imgs: I == null ? void 0 : I.imageInfo.images.map((F) => F.imageUrl),
        isShowBookmark: I != null && I.scrapGbnCode ? I == null ? void 0 : I.isScrap : !1,
        // 스크랩 어떻게 해야 할 지 체크 필요
        isCheckedBookmark: N(
          I == null ? void 0 : I.contentsNo,
          I == null ? void 0 : I.scrapGbnCode
        ),
        handleClickBookmark: () => K(I == null ? void 0 : I.contentsNo, I == null ? void 0 : I.scrapGbnCode)
      };
      return /* @__PURE__ */ c(ee, { children: /* @__PURE__ */ c(
        y,
        {
          ...V,
          ...x(w.taggtm, {
            ...w,
            index: I.gtmIndex,
            "content-id": P === "HOMEIDEA" ? I == null ? void 0 : I.contentsNo : void 0,
            "plan-id": P === "PLAN" ? I == null ? void 0 : I.contentsNo : void 0,
            "landing-url": (T = I == null ? void 0 : I.appLinkInfoDto) == null ? void 0 : T.linkUrl
          }),
          opacity: I ? 1 : 0
        },
        `${w["page-id-value"]}-${w["component-id"]}-${w["template-id"]}-${I == null ? void 0 : I.contentsNo}`
      ) });
    },
    [
      y,
      P,
      w,
      K,
      Z,
      N,
      x,
      s.isReviewRating,
      m
    ]
  ), B = () => i === "horizontal" ? /* @__PURE__ */ c(
    mu,
    {
      contentData: j,
      gtm: w,
      horizontalColumnLength: n,
      contentsRenderer: H,
      displayType: t
    }
  ) : /* @__PURE__ */ c(
    yu,
    {
      contentData: j,
      componentId: S,
      componentGroupDataId: d && $ || void 0,
      isInfinity: R,
      unitType: m,
      gtm: w,
      contentsRenderer: H,
      horizontalColumnLength: n
    }
  );
  try {
    return /* @__PURE__ */ X(ee, { children: [
      d && M && /* @__PURE__ */ c(
        ro,
        {
          type: M,
          handleSetChipIndex: _,
          handleComponentId: E,
          selectedChipIndex: A,
          chipList: o,
          gtm: w,
          isChipLink: z,
          children: B()
        }
      ),
      !d && B(),
      /* @__PURE__ */ c(
        du,
        {
          selectedReviewNo: v,
          isOpen: b,
          isLogin: p,
          handleClose: () => L(!1),
          onHandleAction: h
        }
      )
    ] });
  } catch (I) {
    const V = I.message;
    throw new Error(`${S}-${V}`);
  }
}, wi = gt({
  innerWidth: 0
}), Su = () => {
  const t = kt(wi);
  if (t === void 0)
    throw new Error("useResizeProvider must be used within a ResizeProvider");
  return t;
}, Cu = ({ children: t, innerWidth: o }) => /* @__PURE__ */ c(wi.Provider, { value: { innerWidth: o }, children: t }), _u = ({
  id: t,
  baseWidth: o,
  baseHeight: n,
  data: e = [],
  slideIndex: r = -1,
  setSlideIndex: i,
  canZoom: l = !1,
  isCentered: s = !1,
  isAutoPlayed: a = !1,
  speed: d = 1e3,
  autoMs: u = 5e3,
  className: f,
  children: h,
  hasPagination: p,
  hasLineIndicator: g,
  setSwiperAction: m
}) => {
  const [C, w] = U(r + 1), [S, M] = U(), [z, R] = U(!1), [P, A] = U(a), [_, $] = U(0), E = Y(() => {
    A((k) => !k), P ? S == null || S.autoplay.stop() : S == null || S.autoplay.start();
  }, [P, S == null ? void 0 : S.autoplay]);
  return ie(() => {
    $(C / e.length * 100);
  }, [C, e.length]), ie(() => (S && "activeIndex" in S && R(!0), () => {
    R(!1);
  }), [S]), ie(() => {
    S && z && (a && S.autoplay.start(), r >= 0 && S.slideTo(r + 1, 0));
  }, [e, z, r, S, a]), ie(() => {
    m && S && m(S);
  }, [m, S]), /* @__PURE__ */ X(J, { width: "100%", height: "100%", position: "relative", className: f, children: [
    /* @__PURE__ */ c(
      vt,
      {
        effect: "creative",
        creativeEffect: {
          prev: {
            translate: ["-50%", 0, -1]
          },
          next: {
            translate: ["100%", 0, 0]
          }
        },
        grabCursor: !0,
        modules: [Wn, tl],
        spaceBetween: 0,
        slidesPerView: 1,
        zoom: l,
        onSwiper: M,
        centeredSlides: s,
        speed: d,
        onSlideChange: (k) => {
          const { activeIndex: W } = k, v = W % e.length < 1 ? e.length : W % e.length;
          i && i(v - 1), w(v);
        },
        preventInteractionOnTransition: !0,
        loop: e.length > 1,
        autoplay: {
          delay: u,
          disableOnInteraction: !1
        },
        edgeSwipeDetection: "prevent",
        children: e.map((k, W) => /* @__PURE__ */ c(mt, { children: h({
          width: o,
          height: n,
          index: W,
          item: k
        }) }, `${t}-slide-box-${W + 1}`))
      }
    ),
    g && p && e.length > 1 && /* @__PURE__ */ X(
      J,
      {
        position: "relative",
        width: "100%",
        maxWidth: "1400px",
        minWidth: "1170px",
        zIndex: 9,
        left: "50%",
        style: {
          transform: "translateX(-50%)"
        },
        children: [
          /* @__PURE__ */ c(
            Hn,
            {
              position: "absolute",
              bottom: "0",
              variant: "line1",
              percent: _
            }
          ),
          /* @__PURE__ */ c(J, { position: "absolute", bottom: "28px", right: "28px", children: /* @__PURE__ */ c(
            Sr,
            {
              current: C,
              isPlay: P,
              handleClickControls: E,
              total: e.length,
              variant: "number_play"
            }
          ) })
        ]
      }
    )
  ] });
}, bu = ({
  bannerData: t,
  horizontalColumnLength: o,
  isLink: n,
  isMainTitle: e,
  isSubTitle: r,
  componentId: i,
  gtm: l
}) => {
  const [s, a] = U(), [d, u] = U(!1), [f, h] = U(
    t[0].imageUrl
  ), { tagGTM: p } = le(), { handleClickUnit: g } = We(), { innerWidth: m } = Su(), C = xe(null), w = re(() => t.map((R) => R.imageUrl), [t]);
  ie(() => {
    if (s) {
      const R = () => {
        h(w[s.realIndex]);
      };
      return s.on("slideChange", R), () => {
        s.off("slideChange", R);
      };
    }
  }, [s, w]);
  const S = Y(() => {
    s == null || s.slideNext();
  }, [s]), M = Y(() => {
    s == null || s.slidePrev();
  }, [s]), z = re(() => t.length > o, [t.length, o]);
  return /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      height: "715px",
      position: "relative",
      onMouseOver: () => u(!0),
      onMouseLeave: () => u(!1),
      children: [
        d && z && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: M,
              position: "absolute",
              left: 0,
              top: "calc(60.4% - 28px)",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: S,
              position: "absolute",
              right: 0,
              top: "calc(60.4% - 28px)",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          )
        ] }),
        /* @__PURE__ */ c(
          J,
          {
            width: m,
            height: "100%",
            position: "absolute",
            left: "50%",
            zIndex: 1,
            backgroundImage: `url(${f})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            style: {
              filter: "blur(15px)",
              transform: "translateX(-50%)",
              clipPath: "inset(0)"
            }
          }
        ),
        /* @__PURE__ */ c(
          J,
          {
            width: m,
            height: "100%",
            position: "absolute",
            left: "50%",
            zIndex: 2,
            backgroundColor: fl.dark.dimmed_30,
            style: {
              transform: "translateX(-50%)"
            }
          }
        ),
        /* @__PURE__ */ c(
          J,
          {
            ref: C,
            position: "absolute",
            width: m,
            maxWidth: "1920px",
            minWidth: "1170px",
            left: "50%",
            zIndex: 9,
            style: {
              transform: "translateX(-50%)"
            },
            children: t && t.length > 0 && /* @__PURE__ */ c(J, { width: "100%", position: "relative", children: /* @__PURE__ */ c(
              _u,
              {
                isAutoPlayed: !0,
                hasPagination: !0,
                hasLineIndicator: z,
                baseHeight: 715,
                baseWidth: 2100,
                data: t,
                autoMs: 5e3,
                setSwiperAction: a,
                children: ({ item: R, index: P }) => {
                  var A;
                  return /* @__PURE__ */ c(J, { children: /* @__PURE__ */ c(
                    pl,
                    {
                      img: R.imageUrl,
                      mainText1: e ? R == null ? void 0 : R.bannerTitle1 : "",
                      mainText2: e ? R == null ? void 0 : R.bannerTitle2 : "",
                      helperText1: r ? R == null ? void 0 : R.bannerSubTitle1 : "",
                      helperText2: r ? R == null ? void 0 : R.bannerSubTitle2 : "",
                      handleClick: () => n === !0 && g(R.isNewWindow, R.appLinkInfoDto),
                      ...p(l.taggtm, {
                        ...l,
                        index: P + 1,
                        "landing-url": (A = R.appLinkInfoDto) == null ? void 0 : A.linkUrl,
                        "plan-id": R.appLinkInfoDto.appLinkTarget === "PLAN" ? R.appLinkInfoDto.appLinkVal : void 0
                      })
                    }
                  ) }, `${i}_${P}`);
                }
              }
            ) })
          }
        )
      ]
    }
  );
}, xu = ({
  BannerUnit: t,
  displayType: o,
  bannerData: n,
  type: e,
  horizontalColumnLength: r,
  titleType: i,
  titleOutBgColor: l,
  isLink: s,
  isMainTitle: a,
  isSubTitle: d,
  componentId: u,
  gtm: f
}) => {
  const [h, p] = U(), [g, m] = U(!1), { tagGTM: C } = le(), { handleClickUnit: w } = We(), { setIndicatorPercent: S } = zt(), M = Y(() => {
    h == null || h.slideNext();
  }, [h]), z = Y(() => {
    h == null || h.slidePrev();
  }, [h]), R = re(() => n.length > r, [n.length, r]);
  return ie(() => {
    o === "chip" && (h == null || h.slideTo(r, 0));
  }, [
    h,
    n,
    o,
    R,
    r
  ]), /* @__PURE__ */ c(ee, { children: n && n.length > 0 && /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      position: "relative",
      onMouseOver: () => m(!0),
      onMouseLeave: () => m(!1),
      children: [
        /* @__PURE__ */ c(
          Gt,
          {
            baseHeight: 715,
            baseWidth: 1400,
            data: n,
            isAutoPlayed: r === 1,
            autoMs: 5e3,
            hasLoop: R,
            rowNumber: r,
            slidePerNum: r,
            gap: r === 1 ? 0 : 32,
            hasPagination: r === 1,
            setSwiperAction: p,
            setIndicatorPercent: S,
            children: ({ item: P, index: A }) => P.map((_) => {
              var $;
              return /* @__PURE__ */ c(J, { children: /* @__PURE__ */ c(
                t,
                {
                  img: _.imageUrl,
                  mainText1: a ? _ == null ? void 0 : _.bannerTitle1 : "",
                  mainText2: a ? _ == null ? void 0 : _.bannerTitle2 : "",
                  helperText1: d ? _ == null ? void 0 : _.bannerSubTitle1 : "",
                  helperText2: d ? _ == null ? void 0 : _.bannerSubTitle2 : "",
                  mainTitle: a ? _ == null ? void 0 : _.bannerTitle1 : "",
                  subText: d ? _ == null ? void 0 : _.bannerSubTitle1 : "",
                  subTextRight: e === "thin" && r === 2 ? _.bannerSubTitle1 : "",
                  titleType: i,
                  titleOutBgColor: `#${l}`,
                  handleClick: () => s === !0 && w(_.isNewWindow, _.appLinkInfoDto),
                  size: e === "square" && r === 2 && i === "in" || e === "thin" && r === 1 ? "lg" : "md",
                  isMainTitle: a,
                  ...C(f.taggtm, {
                    ...f,
                    index: A + 1,
                    "landing-url": ($ = _.appLinkInfoDto) == null ? void 0 : $.linkUrl,
                    "plan-id": _.appLinkInfoDto.appLinkTarget === "PLAN" ? _.appLinkInfoDto.appLinkVal : void 0
                  })
                }
              ) }, `${u}_${A}`);
            })
          }
        ),
        g && R && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: z,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: M,
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          )
        ] })
      ]
    }
  ) });
}, Tu = ({
  type: t,
  BannerUnit: o,
  bannerData: n,
  titleType: e,
  titleOutBgColor: r,
  horizontalColumnLength: i,
  isInfinity: l,
  isLink: s,
  isMainTitle: a,
  isSubTitle: d,
  componentId: u,
  componentGroupDataId: f,
  gtm: h
}) => {
  var w;
  const { tagGTM: p } = le(), { items: g, handleMore: m } = l && u ? ln({
    componentId: u,
    size: 20,
    componentGroupDataId: f
  }) : { items: null, handleMore: () => null }, { handleClickUnit: C } = We();
  return /* @__PURE__ */ c(J, { width: "100%", ...p(h.taggtm, h), children: n && n.length > 0 && /* @__PURE__ */ c(ee, { children: l ? /* @__PURE__ */ c(
    $t,
    {
      list: g,
      handleNextMore: () => m(),
      columnCount: i,
      columnSpace: 32,
      rowSpace: 32,
      children: ({ item: S, index: M }) => {
        var z;
        return /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(
          o,
          {
            img: S == null ? void 0 : S.imageUrl,
            mainText1: a ? S == null ? void 0 : S.bannerTitle1 : "",
            mainText2: a ? S == null ? void 0 : S.bannerTitle2 : "",
            helperText1: d ? S == null ? void 0 : S.bannerSubTitle1 : "",
            helperText2: d ? S == null ? void 0 : S.bannerSubTitle2 : "",
            titleType: e,
            titleOutBgColor: `#${r}`,
            handleClick: () => s === !0 && C(S.isNewWindow, S.appLinkInfoDto),
            isMainTitle: a,
            ...p(h.taggtm, {
              ...h,
              index: M + 1,
              "landing-url": (z = S.appLinkInfoDto) == null ? void 0 : z.linkUrl,
              "plan-id": S.appLinkInfoDto.appLinkTarget === "PLAN" ? S.appLinkInfoDto.appLinkVal : void 0
            })
          }
        ) }, `${u}_${t}_banner_item`);
      }
    }
  ) : t !== "timer" ? n.map((S, M) => {
    var z;
    return /* @__PURE__ */ c(J, { children: /* @__PURE__ */ c(
      o,
      {
        img: S.imageUrl,
        isMainTitle: a,
        ...p(h.taggtm, {
          ...h,
          index: M + 1,
          "landing-url": (z = S.appLinkInfoDto) == null ? void 0 : z.linkUrl,
          "plan-id": S.appLinkInfoDto.appLinkTarget === "PLAN" ? S.appLinkInfoDto.appLinkVal : void 0
        })
      }
    ) }, `${u}_${M}`);
  }) : n[0].timerEndDatetime && /* @__PURE__ */ c(
    kn,
    {
      date: new Date(n[0].timerEndDatetime),
      title: n[0].bannerTitle1,
      ...p(h.taggtm, {
        ...h,
        index: 0,
        "landing-url": (w = n[0].appLinkInfoDto) == null ? void 0 : w.linkUrl
      })
    }
  ) }) });
}, Iu = ({
  imageUrl: t,
  goodsData: o,
  horizontalColumnLength: n,
  gtm: e,
  focusedTooltipId: r,
  setFocusedTooltipId: i
}) => {
  const { handleClickUnit: l } = We(), { tagGTM: s } = le(), { convertedUnitData: a } = nn({
    verticalLineNumber: 2,
    horizontalColumnLength: 1,
    unitData: o,
    scrollDirection: "horizontal"
  }), d = (h) => {
    i(h.currentTarget.dataset.id);
  }, u = () => {
    i(void 0);
  }, f = Y(
    (h) => {
      const p = o.find(
        (g) => g.id === h.currentTarget.dataset.id
      );
      p && l(
        p.isNewWindow,
        p.appLinkInfoDto,
        p.goodsMallType !== "PLAN" ? {
          isRestock: (p == null ? void 0 : p.gdsStatCd) === "SD" && p.isNotiOfStock,
          gdsNo: p.gdsNo
        } : void 0
      );
    },
    [o, l]
  );
  return /* @__PURE__ */ X(J, { width: "100%", children: [
    n === 1 && /* @__PURE__ */ X(De, { alignment: "start", space: 48, width: "100%", children: [
      /* @__PURE__ */ c(J, { width: 816, children: /* @__PURE__ */ c(
        po,
        {
          img: t,
          data: o,
          zIndex: 1,
          handleMouseEnterOnTooltip: d,
          handleMouseLeaveOnTooltip: u,
          handleClickTooltip: f,
          focusedId: r
        }
      ) }),
      /* @__PURE__ */ c(Me, { space: 24, flex: "grid", width: 536, children: a.map((h, p) => /* @__PURE__ */ c(De, { width: "100%", space: 24, children: a[p].map((g) => {
        var m;
        return /* @__PURE__ */ c(
          Ru,
          {
            onMouseEnter: () => {
              i(g.id);
            },
            onMouseLeave: () => {
              i(void 0);
            },
            isFocused: r === g.id,
            children: /* @__PURE__ */ c(
              Cr,
              {
                img: g.imgUrl ?? "",
                superFlag: g == null ? void 0 : g.badgeImageUrl,
                handleClickBookmark: g.handleClickBookmark,
                isShowBookmark: g.isShowBookmark,
                isCheckedBookmark: g.isCheckedBookmark,
                handleClick: () => l(
                  g.isNewWindow,
                  g.appLinkInfoDto,
                  g.goodsMallType !== "PLAN" ? {
                    isRestock: (g == null ? void 0 : g.gdsStatCd) === "SD" && g.isNotiOfStock,
                    gdsNo: g.gdsNo
                  } : void 0
                ),
                ...s(e.taggtm, {
                  ...e,
                  index: p + 1,
                  "landing-url": (m = g.appLinkInfoDto) == null ? void 0 : m.linkUrl,
                  "good-id": g.gdsNo
                }),
                onlyImage: !0
              }
            )
          },
          g.id
        );
      }) }, p)) })
    ] }),
    n === 2 && /* @__PURE__ */ c(
      po,
      {
        img: t,
        data: o,
        zIndex: 1,
        handleMouseEnterOnTooltip: d,
        handleMouseLeaveOnTooltip: u,
        handleClickTooltip: f,
        focusedId: r
      }
    )
  ] });
}, Ru = q(J)`
  ${({ isFocused: t }) => Fe`
    width: calc(50% - 12px);
    border: 1px solid ${t ? "#121212" : "transparent"};
  `}
`, ku = ({
  groupBannerData: t,
  horizontalColumnLength: o,
  isScrapProduct: n,
  handleClickBookMark: e,
  gtm: r
}) => {
  const [i, l] = U(), [s, a] = U(!1), [d, u] = U(), f = xe(null), h = xe(null), p = re(() => Ei(t[0].data.content[0].gdsNo), [t]);
  ie(() => {
    const M = new IntersectionObserver(
      ([z]) => {
        if (z.isIntersecting) {
          u(p);
          const R = setTimeout(() => {
            u(void 0);
          }, 3e3);
          h.current = R, M.unobserve(z.target);
        }
      },
      { threshold: 0.4 }
    );
    f.current && M.observe(f.current);
  }, [p]), ie(() => {
    h.current && d !== p && (clearTimeout(h.current), h.current = null);
  }, [p, d]);
  const g = Y(() => {
    i == null || i.slideNext();
  }, [i]), m = Y(() => {
    i == null || i.slidePrev();
  }, [i]), C = re(() => t.length > o, [t.length, o]), w = Y((M) => M === "Z", []), S = Y(
    (M, z) => w(M) ? "견적 상담" : z ? Mn(z) : z === 0 ? "0" : "",
    [w]
  );
  return /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      position: "relative",
      onMouseOver: () => a(!0),
      onMouseLeave: () => a(!1),
      ref: f,
      children: [
        /* @__PURE__ */ c(
          Gt,
          {
            baseWidth: 1400,
            baseHeight: 715,
            data: t,
            hasLoop: C,
            rowNumber: o,
            slidePerNum: o,
            gap: 32,
            setSwiperAction: l,
            children: ({ item: M, index: z }) => {
              const R = M.data.content.map((P) => ({
                ...P,
                id: P.gdsNo.toString(),
                coordinate: {
                  x: P.positionX !== void 0 ? P.positionX : 0,
                  y: P.positionY !== void 0 ? P.positionY : 0
                },
                title: P.gdsNm,
                discountRate: P.dcRate !== 0 ? P.dcRate : void 0,
                price: S(P == null ? void 0 : P.prcViewTypCd, P == null ? void 0 : P.dcPrc),
                pricePerUnit: w(P.prcViewTypCd) ? "" : P.prcViewTypNm,
                imgUrl: P.imageUrl,
                badgeImageUrl: P == null ? void 0 : P.badgeImageUrl,
                handleClickBookmark: () => e(
                  P == null ? void 0 : P.gdsNo,
                  P == null ? void 0 : P.scrapGbnCode
                ),
                isShowBookmark: !!P.scrapGbnCode,
                isCheckedBookmark: n(
                  P == null ? void 0 : P.gdsNo,
                  P == null ? void 0 : P.scrapGbnCode
                )
              }));
              return /* @__PURE__ */ c(
                Iu,
                {
                  imageUrl: M.imageUrl,
                  goodsData: R,
                  horizontalColumnLength: o,
                  gtm: r,
                  focusedTooltipId: d,
                  setFocusedTooltipId: u
                }
              );
            }
          }
        ),
        s && C && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: m,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: g,
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          )
        ] })
      ]
    }
  );
}, Lu = ({
  dataType: t,
  displayType: o,
  type: n,
  verticalLineNumber: e,
  horizontalColumnLength: r,
  scrollDirection: i,
  bannerData: l,
  titleType: s,
  titleOutBgColor: a,
  componentId: d,
  isLink: u,
  isChip: f,
  chipType: h,
  isChipLink: p,
  isInfinity: g,
  isMainTitle: m,
  isSubTitle: C,
  isLogin: w,
  scrapProductList: S,
  setScrapProductList: M,
  toggleScrap: z,
  onHandleAction: R,
  onHandleClick: P,
  gtm: A
}) => {
  const [_, $] = U(0), [E, k] = U(0), [W, v] = U([]);
  ie(() => {
    var j, y;
    t === "default" && v(l), t === "group" && f && v(
      (y = (j = l[_]) == null ? void 0 : j.data) == null ? void 0 : y.content
    );
  }, [l, t, f, _]);
  const { convertedUnitData: G } = nn({
    verticalLineNumber: e,
    horizontalColumnLength: r,
    unitData: W,
    scrollDirection: i
  }), b = re(() => {
    switch (n) {
      case "square":
        return On;
      case "horizontal":
        return vl;
      case "band":
        return Ln;
      case "thin":
        return wr;
      default:
        return gl;
    }
  }, [n]), L = Y(
    (j, y) => (S == null ? void 0 : S.find(
      (K) => K.targetNo === j && K.scrapGbnCd === y
    )) !== void 0,
    [S]
  ), x = Y(
    async (j, y) => {
      if (!w) {
        R({
          type: "confirm",
          action: "login",
          message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
        });
        return;
      }
      const N = L(j, y);
      if (await z({
        scrapGbnCd: y,
        targetNo: j,
        targetSubNo: 0,
        isUse: !N
      }) === 200)
        if (N) {
          const H = S.filter(
            (B) => B.targetNo !== j || B.scrapGbnCd !== y
          );
          M(H);
        } else
          R({
            type: "toast",
            action: "scrap",
            message: "스크랩이 완료되었습니다."
          }), M([
            ...S,
            { targetNo: j, targetSubNo: 0, scrapGbnCd: y }
          ]);
    },
    [
      w,
      L,
      R,
      S,
      M,
      z
    ]
  ), Z = Y(() => i === "horizontal" ? n === "main" ? /* @__PURE__ */ c(
    bu,
    {
      bannerData: l,
      horizontalColumnLength: r,
      titleType: s,
      titleOutBgColor: a,
      componentId: d,
      isLink: u,
      isMainTitle: m,
      isSubTitle: C,
      gtm: A
    }
  ) : /* @__PURE__ */ c(
    xu,
    {
      type: n,
      displayType: o,
      BannerUnit: b,
      bannerData: G,
      horizontalColumnLength: r,
      titleType: s,
      titleOutBgColor: a,
      componentId: d,
      isLink: u,
      isMainTitle: m,
      isSubTitle: C,
      gtm: A
    }
  ) : /* @__PURE__ */ c(
    Tu,
    {
      type: n,
      BannerUnit: b,
      bannerData: l,
      horizontalColumnLength: r,
      titleType: s,
      titleOutBgColor: a,
      isLink: u,
      componentId: d,
      componentGroupDataId: f ? E : void 0,
      isInfinity: g,
      isMainTitle: m,
      isSubTitle: C,
      gtm: A
    }
  ), [
    b,
    l,
    E,
    d,
    G,
    o,
    A,
    r,
    f,
    g,
    u,
    m,
    C,
    i,
    a,
    s,
    n
  ]);
  try {
    return /* @__PURE__ */ X(J, { children: [
      o === "group" && /* @__PURE__ */ c(
        ku,
        {
          groupBannerData: l,
          horizontalColumnLength: r,
          isScrapProduct: L,
          handleClickBookMark: x,
          gtm: A
        }
      ),
      o === "chip" && f && h && /* @__PURE__ */ c(
        ro,
        {
          type: h,
          handleSetChipIndex: $,
          handleComponentId: k,
          selectedChipIndex: _,
          chipList: l,
          gtm: A,
          isChipLink: p,
          children: Z()
        }
      ),
      o === "gallery" && Z()
    ] });
  } catch (j) {
    const y = j.message;
    throw new Error(`${d}-${y}`);
  }
}, Yt = ({
  horizontalColumnLength: t,
  productData: o,
  displayType: n,
  gtm: e,
  productRenderer: r
}) => {
  const [i, l] = U(), [s, a] = U(!1), { setIndicatorPercent: d } = zt(), u = Y(() => {
    i == null || i.slideNext();
  }, [i]), f = Y(() => {
    i == null || i.slidePrev();
  }, [i]);
  return ie(() => {
    n === "chip" && (i == null || i.slideTo(t, 0));
  }, [i, n, t, o]), /* @__PURE__ */ c(ee, { children: o && o.length > 0 && /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      position: "relative",
      onMouseOver: () => a(!0),
      onMouseLeave: () => a(!1),
      children: [
        /* @__PURE__ */ c(
          Gt,
          {
            baseHeight: 864,
            baseWidth: 1400,
            data: o,
            rowNumber: t,
            slidePerNum: t,
            gap: t === 1 ? 0 : n === "group" ? Ye : qt,
            hasLoop: o.length > t,
            setSwiperAction: l,
            setIndicatorPercent: d,
            children: ({ item: h, index: p }) => /* @__PURE__ */ c(
              Me,
              {
                width: "100%",
                space: Ye,
                alignment: "center",
                children: h.map((g, m) => /* @__PURE__ */ c(
                  J,
                  {
                    width: "100%",
                    children: r(g)
                  },
                  `${e["component-id"]}-horizontal-product-item-${m}`
                ))
              },
              `${e["component-id"]}-horizontal-product-${p}`
            )
          }
        ),
        s && o.length > t && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: f,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: u,
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 10,
              style: {
                transform: "translateY(-50%)"
              }
            }
          )
        ] })
      ]
    }
  ) });
}, Xt = ({
  type: t,
  horizontalColumnLength: o,
  productData: n,
  componentId: e,
  componentGroupDataId: r,
  displayType: i,
  gtm: l,
  isInfinity: s,
  productRenderer: a
}) => {
  const d = re(() => t === "normal" ? 80 : i === "group" ? Ye : qt, [t, i]), { items: u, handleMore: f } = s && e ? ln({
    componentId: e,
    size: 40,
    componentGroupDataId: r
  }) : { items: null, handleMore: () => null };
  return /* @__PURE__ */ c(J, { width: "100%", children: s ? u && u.length > 0 && /* @__PURE__ */ c(
    Bu,
    {
      list: u,
      handleNextMore: () => f(),
      columnCount: o,
      columnSpace: qt,
      rowSpace: t === "normal" ? 80 : 32,
      children: ({ item: h, columnIndex: p, rowIndex: g }) => {
        var C;
        const m = {
          ...h,
          goodsTagInfoDtoList: (C = h == null ? void 0 : h.goodsTagInfoDtoList) == null ? void 0 : C.map((w) => ({
            variant: (w == null ? void 0 : w.style) === "SOLID" ? "solid" : "line",
            color: w == null ? void 0 : w.styleColor,
            content: w == null ? void 0 : w.name,
            textColor: w == null ? void 0 : w.textColor
          }))
        };
        return /* @__PURE__ */ c(
          J,
          {
            width: "100%",
            children: a(m)
          },
          `${l["component-id"]}-vertical-product-item-${g}`
        );
      }
    }
  ) : /* @__PURE__ */ c(
    sn,
    {
      itemCount: o,
      columnCount: o,
      colSpace: i === "group" ? Ye : qt,
      rowSpace: d,
      children: n.map((h, p) => n[p].map((g, m) => /* @__PURE__ */ c(
        J,
        {
          width: "100%",
          children: a(g)
        },
        `${l["component-id"]}-vertical-product-item-${m}`
      )))
    }
  ) });
}, Ou = ({
  type: t,
  groupData: o,
  horizontalColumnLength: n,
  verticalLineNumber: e,
  scrollDirection: r,
  groupScroll: i,
  bannerType: l,
  componentId: s,
  displayType: a,
  gtm: d,
  productRenderer: u,
  isScrapProduct: f,
  handleClickBookMark: h
}) => {
  const [p, g] = U(), [m, C] = U(!1), { tagGTM: w } = le(), { handleClickUnit: S } = We(), M = vo(2, 1, "horizontal", o), z = Y(
    (b) => vo(
      e,
      n,
      r,
      b.data.content
    ),
    [n, r, e]
  ), R = re(() => l === "BAND_BANNER" ? o.length > 2 : o.length > 1, [l, o.length]), P = Y(() => {
    p == null || p.slideNext();
  }, [p]), A = Y(() => {
    p == null || p.slidePrev();
  }, [p]), _ = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        De,
        {
          width: "100%",
          space: 48,
          children: [
            /* @__PURE__ */ c(J, { width: "50%", children: /* @__PURE__ */ c(
              On,
              {
                img: b.imageUrl,
                mainText1: b.groupTitle1,
                mainText2: b.groupTitle2,
                helperText1: b.groupSubTitle1,
                helperText2: b.groupSubTitle2,
                size: "lg",
                zIndex: 1,
                handleClick: () => S(
                  b.isNewWindow,
                  b.appLinkInfoDto
                ),
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "plan-id": b.appLinkInfoDto.appLinkTarget === "PLAN" ? b.appLinkInfoDto.appLinkVal : void 0,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ) }),
            /* @__PURE__ */ c(J, { width: "50%", children: /* @__PURE__ */ c(
              Xt,
              {
                type: t,
                productData: z(b),
                productRenderer: u,
                horizontalColumnLength: n,
                componentId: s,
                displayType: a,
                gtm: d,
                isScrapProduct: f,
                handleClickBookMark: h
              }
            ) })
          ]
        },
        `${d["component-id"]}-horizontal-square-group-product-${L}`
      );
    },
    [
      u,
      s,
      z,
      a,
      d,
      h,
      S,
      n,
      f,
      w,
      t
    ]
  ), $ = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        Me,
        {
          width: "100%",
          space: Ye,
          children: [
            /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(
              Ln,
              {
                img: b.imageUrl,
                mainText1: b.groupTitle1,
                mainText2: b.groupTitle2,
                helperText1: b.groupSubTitle1,
                handleClick: () => S(
                  b.isNewWindow,
                  b.appLinkInfoDto
                ),
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "plan-id": b.appLinkInfoDto.appLinkTarget === "PLAN" ? b.appLinkInfoDto.appLinkVal : void 0,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ) }),
            /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(
              Xt,
              {
                type: t,
                productData: z(b),
                productRenderer: u,
                horizontalColumnLength: n,
                componentId: s,
                displayType: a,
                gtm: d,
                isScrapProduct: f,
                handleClickBookMark: h
              }
            ) })
          ]
        },
        `${d["component-id"]}-horizontal-band-group-product-${L}`
      );
    },
    [
      u,
      s,
      z,
      a,
      d,
      h,
      S,
      n,
      f,
      w,
      t
    ]
  ), E = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        Me,
        {
          space: 32,
          width: "100%",
          children: [
            b.timerEndDatetime && /* @__PURE__ */ c(
              kn,
              {
                date: new Date(b.timerEndDatetime),
                title: b.groupTitle1,
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ),
            /* @__PURE__ */ c(
              Yt,
              {
                productRenderer: u,
                productData: z(b),
                horizontalColumnLength: n,
                verticalLineNumber: e,
                scrollDirection: r,
                displayType: a,
                gtm: d
              }
            )
          ]
        },
        `${d["component-id"]}-horizontal-timer-group-product-${L}`
      );
    },
    [
      u,
      z,
      a,
      d,
      n,
      r,
      w,
      e
    ]
  ), k = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        De,
        {
          width: "100%",
          alignment: t === "normal" ? "center" : "start",
          space: 48,
          children: [
            /* @__PURE__ */ c(J, { width: "50%", children: /* @__PURE__ */ c(
              On,
              {
                img: b.imageUrl,
                mainText1: b.groupTitle1,
                mainText2: b.groupTitle2,
                helperText1: b.groupSubTitle1,
                helperText2: b.groupSubTitle2,
                size: "lg",
                zIndex: 1,
                handleClick: () => S(
                  b.isNewWindow,
                  b.appLinkInfoDto
                ),
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "plan-id": b.appLinkInfoDto.appLinkTarget === "PLAN" ? b.appLinkInfoDto.appLinkVal : void 0,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ) }),
            /* @__PURE__ */ c(J, { width: "50%", children: /* @__PURE__ */ c(
              Yt,
              {
                productRenderer: u,
                productData: z(b),
                horizontalColumnLength: n,
                verticalLineNumber: e,
                scrollDirection: r,
                displayType: a,
                gtm: d
              }
            ) })
          ]
        },
        `${d["component-id"]}-vertical-square-group-product-${L}`
      );
    },
    [
      u,
      z,
      a,
      d,
      S,
      n,
      r,
      w,
      t,
      e
    ]
  ), W = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        Me,
        {
          alignment: "start",
          width: "50%",
          space: Ye,
          children: [
            /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(
              Ln,
              {
                img: b.imageUrl,
                mainText1: b.groupTitle1,
                mainText2: b.groupTitle2,
                helperText1: b.groupSubTitle1,
                zIndex: 1,
                handleClick: () => S(
                  b.isNewWindow,
                  b.appLinkInfoDto
                ),
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "plan-id": b.appLinkInfoDto.appLinkTarget === "PLAN" ? b.appLinkInfoDto.appLinkVal : void 0,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ) }),
            /* @__PURE__ */ c(
              Yt,
              {
                productRenderer: u,
                productData: z(b),
                horizontalColumnLength: n,
                verticalLineNumber: e,
                scrollDirection: r,
                displayType: a,
                gtm: d
              }
            )
          ]
        },
        `${d["component-id"]}-vertical-band-group-product-${L}`
      );
    },
    [
      u,
      z,
      a,
      d,
      S,
      n,
      r,
      w,
      e
    ]
  ), v = Y(
    (b, L) => {
      var x;
      return /* @__PURE__ */ X(
        Me,
        {
          width: "100%",
          space: Ye,
          children: [
            b.timerEndDatetime && /* @__PURE__ */ c(
              kn,
              {
                date: new Date(b.timerEndDatetime),
                title: b.groupTitle1,
                ...w(d.taggtm, {
                  ...d,
                  index: L,
                  "landing-url": (x = b.appLinkInfoDto) == null ? void 0 : x.linkUrl
                })
              }
            ),
            /* @__PURE__ */ c(J, { width: "100%", children: /* @__PURE__ */ c(
              Xt,
              {
                type: t,
                productData: z(b),
                productRenderer: u,
                horizontalColumnLength: n,
                componentId: s,
                displayType: a,
                gtm: d,
                isScrapProduct: f,
                handleClickBookMark: h
              }
            ) })
          ]
        },
        `${d["component-id"]}-vertical-timer-group-product-${L}`
      );
    },
    [
      u,
      s,
      z,
      a,
      d,
      h,
      n,
      f,
      w,
      t
    ]
  ), G = re(() => l === "BANNER" ? _ : l === "BAND_BANNER" ? $ : E, [$, _, E, l]);
  return /* @__PURE__ */ c(ee, { children: l === "TIMER" ? o.map(
    (b, L) => r === "horizontal" ? G(b, L) : v(b, L)
  ) : i === "horizontal" ? /* @__PURE__ */ X(
    J,
    {
      width: "100%",
      position: "relative",
      onMouseOver: () => C(!0),
      onMouseLeave: () => C(!1),
      children: [
        /* @__PURE__ */ c(
          Gt,
          {
            baseHeight: 864,
            baseWidth: 1400,
            data: o,
            hasLoop: R,
            rowNumber: l === "BAND_BANNER" ? 2 : 1,
            gap: 48,
            setSwiperAction: g,
            children: ({ item: b, index: L }) => /* @__PURE__ */ c(ee, { children: G(b, L) })
          }
        ),
        m && (l === "BAND_BANNER" ? o.length > 2 : o.length > 1) && /* @__PURE__ */ X(ee, { children: [
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "prev",
              onClick: A,
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 10,
              style: { transform: "translateY(-50%)" }
            }
          ),
          /* @__PURE__ */ c(
            ze,
            {
              size: "md",
              variant: "next",
              onClick: P,
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 10,
              style: { transform: "translateY(-50%)" }
            }
          )
        ] })
      ]
    }
  ) : /* @__PURE__ */ c(Me, { space: Ye, width: "100%", children: l === "BANNER" ? o.map(
    (b, L) => k(b, L)
  ) : M.map((b, L) => /* @__PURE__ */ c(De, { space: 48, width: "100%", alignment: "start", children: M[L].map(
    (x, Z) => W(x, Z)
  ) }, L)) }) });
}, zu = ({
  dataType: t,
  displayType: o,
  type: n,
  productData: e,
  groupData: r,
  scrollDirection: i,
  verticalLineNumber: l,
  horizontalColumnLength: s,
  unitElement: a,
  bannerType: d,
  componentId: u,
  gtm: f,
  groupScroll: h,
  isChip: p,
  chipType: g,
  isChipLink: m,
  isInfinity: C,
  scrapProductList: w,
  setScrapProductList: S,
  toggleScrap: M,
  onHandleAction: z,
  isLogin: R,
  isPrice: P
}) => {
  const { tagGTM: A } = le(), [_, $] = U(0), [E, k] = U(0), [W, v] = U(
    []
  ), { handleClickUnit: G } = We(), { convertedUnitData: b } = nn({
    verticalLineNumber: l,
    horizontalColumnLength: s,
    unitData: W,
    scrollDirection: i
  });
  ie(() => {
    t === "default" && v(e), t === "group" && p && v(
      e[_].data.content
    );
  }, [t, p, e, _]);
  const L = re(() => {
    switch (n) {
      case "normal":
        return yl;
      case "horizontal":
        return ml;
      default:
        return Cr;
    }
  }, [n]), x = Y(
    (T, F, Q, te) => {
      if (!(!T || !Q))
        return Q !== te ? `${Mn(Q)}${F}` : void 0;
    },
    []
  ), Z = Y(
    (T, F) => {
      if (!(!T || !F))
        return F;
    },
    []
  ), j = Y(
    (T) => {
      if (a != null && a.isReviewRating)
        return T || void 0;
    },
    [a == null ? void 0 : a.isReviewRating]
  ), y = Y(
    (T) => {
      if (a != null && a.isReviewRating)
        return T || void 0;
    },
    [a == null ? void 0 : a.isReviewRating]
  ), N = Y((T) => T === "Z", []), K = Y(
    (T, F) => N(T) ? "견적 상담" : F ? Mn(F) : F === 0 ? "0" : "",
    [N]
  ), H = Y(
    (T, F) => (w == null ? void 0 : w.find(
      (te) => te.targetNo === T && te.scrapGbnCd === F
    )) !== void 0,
    [w]
  ), B = Y(
    async (T, F) => {
      if (!R) {
        z({
          type: "confirm",
          action: "login",
          message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
        });
        return;
      }
      const Q = H(T, F);
      if (await M({
        scrapGbnCd: F,
        targetNo: T,
        targetSubNo: 0,
        isUse: !Q
      }) === 200)
        if (Q) {
          const ce = w.filter(
            (ae) => ae.targetNo !== T || ae.scrapGbnCd !== F
          );
          S(ce);
        } else
          z({
            type: "toast",
            action: "scrap",
            message: "스크랩이 완료되었습니다."
          }), S([
            ...w,
            { targetNo: T, targetSubNo: 0, scrapGbnCd: F }
          ]);
    },
    [
      R,
      H,
      z,
      w,
      S,
      M
    ]
  ), I = Y(
    (T) => {
      var F, Q, te, ce;
      return /* @__PURE__ */ c(
        L,
        {
          img: T.imageUrl,
          brandName: a.isBrand ? (F = T == null ? void 0 : T.goodsBrandInfoDto) == null ? void 0 : F.brandNm : void 0,
          isShowADFlag: a == null ? void 0 : a.isAdvertiseFlag,
          productTitle: T.gdsNm,
          originalPrice: x(
            a.isNormalPrice,
            T == null ? void 0 : T.prcViewTypNm,
            T == null ? void 0 : T.normalSalePrc,
            T == null ? void 0 : T.dcPrc
          ),
          discountRate: Z(
            a.isDiscountRate,
            T == null ? void 0 : T.dcRate
          ),
          finalPrice: K(T == null ? void 0 : T.prcViewTypCd, T == null ? void 0 : T.dcPrc),
          finalPricePerUnit: N(T == null ? void 0 : T.prcViewTypCd) ? "" : T.prcViewTypNm,
          reviewScore: n === "thumbnail" ? void 0 : j((Q = T == null ? void 0 : T.goodsEvaluationStatInfoDto) == null ? void 0 : Q.totAvgScore),
          reviewCount: n === "thumbnail" ? void 0 : y((te = T == null ? void 0 : T.goodsEvaluationStatInfoDto) == null ? void 0 : te.totCnt),
          ranking: a != null && a.isRankingNumber ? T.gtmIndex : void 0,
          superFlag: T == null ? void 0 : T.badgeImageUrl,
          flag: a.isFlag ? T == null ? void 0 : T.goodsTagInfoDtoList : void 0,
          isShowRestockAlert: (T == null ? void 0 : T.gdsStatCd) === "SD" && (T == null ? void 0 : T.isNotiOfStock),
          isShowSoldOut: (T == null ? void 0 : T.gdsStatCd) === "SD",
          handleClickBookmark: () => B(T == null ? void 0 : T.gdsNo, T == null ? void 0 : T.scrapGbnCode),
          isShowBookmark: T.scrapGbnCode ? a == null ? void 0 : a.isScrap : !1,
          isCheckedBookmark: H(T == null ? void 0 : T.gdsNo, T == null ? void 0 : T.scrapGbnCode),
          handleClick: () => G(
            T.isNewWindow,
            T.appLinkInfoDto,
            T.goodsMallType !== "PLAN" ? {
              isRestock: (T == null ? void 0 : T.gdsStatCd) === "SD" && T.isNotiOfStock,
              gdsNo: T.gdsNo
            } : void 0
          ),
          isShowPriceInfo: P,
          ...A(f.taggtm, {
            ...f,
            "good-id": T.goodsMallType !== "PLAN" ? T.gdsNo : void 0,
            "landing-url": (ce = T.appLinkInfoDto) == null ? void 0 : ce.linkUrl,
            "plan-id": T.goodsMallType === "PLAN" ? T.gdsNo : void 0,
            index: T.gtmIndex
          })
        }
      );
    },
    [
      L,
      x,
      Z,
      f,
      B,
      G,
      N,
      P,
      H,
      K,
      y,
      j,
      A,
      n,
      a == null ? void 0 : a.isAdvertiseFlag,
      a.isBrand,
      a.isDiscountRate,
      a.isFlag,
      a.isNormalPrice,
      a == null ? void 0 : a.isRankingNumber,
      a == null ? void 0 : a.isScrap
    ]
  ), V = Y(() => i === "horizontal" ? /* @__PURE__ */ c(
    Yt,
    {
      productRenderer: I,
      productData: b,
      horizontalColumnLength: s,
      verticalLineNumber: l,
      scrollDirection: i,
      displayType: o,
      gtm: f
    }
  ) : /* @__PURE__ */ c(
    Xt,
    {
      type: n,
      productRenderer: I,
      productData: b,
      horizontalColumnLength: s,
      componentGroupDataId: p && E || void 0,
      isInfinity: C,
      displayType: o,
      componentId: u,
      isScrapProduct: H,
      handleClickBookMark: B,
      gtm: f
    }
  ), [
    I,
    E,
    u,
    b,
    o,
    f,
    B,
    s,
    p,
    C,
    H,
    i,
    n,
    l
  ]);
  try {
    return /* @__PURE__ */ X(
      J,
      {
        ...A(f.taggtm, {
          ...f
        }),
        children: [
          o === "group" && /* @__PURE__ */ c(
            Ou,
            {
              type: n,
              groupData: r,
              bannerType: d,
              productRenderer: I,
              horizontalColumnLength: s,
              verticalLineNumber: l,
              scrollDirection: i,
              groupScroll: h,
              componentId: u,
              displayType: o,
              gtm: f,
              isScrapProduct: H,
              handleClickBookMark: B
            }
          ),
          o === "chip" && p && g && /* @__PURE__ */ c(
            ro,
            {
              type: g,
              handleSetChipIndex: $,
              handleComponentId: k,
              selectedChipIndex: _,
              chipList: e,
              gtm: f,
              isChipLink: m,
              children: V()
            }
          ),
          o === "gallery" && V()
        ]
      }
    );
  } catch (T) {
    const F = T.message;
    throw new Error(`${u}-${F}`);
  }
}, Mu = ({
  title: t,
  subTitle: o,
  moreView: n,
  tooltip: e,
  className: r,
  as: i,
  gtm: l
}) => {
  const { tagGTM: s } = le(), { handleClickUnit: a } = We(), d = re(() => {
    if (n.isUse && n.appLinkInfoDto.linkUrl)
      return {
        variant: "moreBtn",
        content: n.buttonName,
        handleClick: () => a(n.isNewWindow, n.appLinkInfoDto)
      };
    if (e.isUse && e.title && e.desc)
      return {
        variant: "tooltip",
        content: e.title,
        message: e.desc || "",
        icon: e.iconType || "ic_question"
      };
  }, [
    a,
    n,
    e.desc,
    e.iconType,
    e.isUse,
    e.title
  ]);
  return /* @__PURE__ */ c(ge, { space: "none", children: /* @__PURE__ */ c(
    wl,
    {
      title: t.data1,
      subTitle: o.data1 || "",
      rightArea: d,
      className: r,
      as: i,
      ...s(l.taggtm, {
        ...l,
        "landing-url": n.appLinkInfoDto.linkUrl
      })
    }
  ) });
}, Pu = ({ landing: t, indicator: o, gtm: n }) => {
  const { tagGTM: e } = le(), { indicatorPercent: r } = zt(), { handleClickUnit: i } = We();
  return /* @__PURE__ */ X(J, { ...e(n.taggtm, n), children: [
    t.isUse && /* @__PURE__ */ c(J, { width: "100%", display: "flex", justifyContent: "center", pt: 36, children: /* @__PURE__ */ c(
      Un,
      {
        width: "440px",
        size: "lg",
        emphasis: "low",
        icon: {
          variant: "ic_arrow_right",
          align: "right"
        },
        onClick: () => i(t.isNewWindow, t.appLinkInfoDto),
        ...e(n.taggtm, {
          ...n,
          "landing-url": t.appLinkInfoDto.linkUrl
        }),
        children: t.buttonName
      }
    ) }),
    o.isUse && r !== void 0 && /* @__PURE__ */ c(J, { pt: 36, display: "flex", justifyContent: "center", children: /* @__PURE__ */ c(
      Hn,
      {
        variant: "line5",
        percent: r,
        width: "440px"
      }
    ) })
  ] });
}, Si = ({
  apiType: t = "display-info",
  handleLink: o,
  dispTemplateNo: n,
  templateApiCd: e,
  ctgNo: r,
  custNo: i,
  pcId: l,
  snbCd: s,
  sort: a,
  channelCd: d,
  abTestGroup: u
}) => {
  const { template: f } = jl({
    apiType: t,
    dispTemplateNo: n,
    templateApiCd: e,
    ctgNo: r,
    custNo: i,
    pcId: l,
    snbCd: s,
    sort: a,
    channelCd: d,
    abTestGroup: u
  });
  return /* @__PURE__ */ c(Eu, { children: f == null ? void 0 : f.dispComponentList.map((h, p) => /* @__PURE__ */ X(
    Nu,
    {
      children: [
        h.componentLayoutCd === "remodeling_auto_best_goods_list" && /* @__PURE__ */ c(
          wc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_new_goods_list" && /* @__PURE__ */ c(
          Bc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_lineup_goods_list" && /* @__PURE__ */ c(
          $c,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_part_midcate_goods_list" && /* @__PURE__ */ c(
          Yc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_goods_list" && /* @__PURE__ */ c(
          Oc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_best_tag_material_goods_list" && /* @__PURE__ */ c(
          _c,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_new_tag_material_goods_list" && /* @__PURE__ */ c(
          Vc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_material_cate_goods_list" && /* @__PURE__ */ c(
          Ac,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_auto_material_goods_list" && /* @__PURE__ */ c(
          Hc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner+goods_list" && /* @__PURE__ */ c(
          Zc,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_big" && /* @__PURE__ */ c(
          ld,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_consult" && /* @__PURE__ */ c(
          sd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_event" && /* @__PURE__ */ c(
          hd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_homestyle" && /* @__PURE__ */ c(
          fd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_rolling" && /* @__PURE__ */ c(
          Id,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_rolling_event" && /* @__PURE__ */ c(
          Md,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_rolling_start" && /* @__PURE__ */ c(
          Pd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_store_info_list" && /* @__PURE__ */ c(
          Ed,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_trend" && /* @__PURE__ */ c(
          Wd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_banner_where_start" && /* @__PURE__ */ c(
          Ud,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_goods_week_new_arrival" && /* @__PURE__ */ c(
          qd,
          {
            component: h,
            handleLink: o
          }
        ),
        h.componentLayoutCd === "remodeling_img_line_desc" && /* @__PURE__ */ c(
          Jd,
          {
            component: h,
            handleLink: o
          }
        )
      ]
    },
    `${f.templateApiCd}-${f.dispTemplateNo}-${h.dispComponentNo}-${p + 1}`
  )) });
}, Eu = q.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`, Nu = q.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`, gf = ({
  module: t,
  viewType: o,
  typeValue: n,
  ...e
}) => {
  const { gnbList: r } = Bl({ viewType: o, typeValue: n }), i = re(
    () => ar(r, { module: t }),
    [r, t]
  );
  return i ? /* @__PURE__ */ c(Si, { dispTemplateNo: i.dispTemplateNo, ...e }) : /* @__PURE__ */ c(ee, {});
}, vf = ({
  module: t,
  typeValue: o,
  ...n
}) => {
  const { templateInfo: e } = Fl({ typeValue: o }), r = re(
    () => ar(e, { key: t }),
    [t, e]
  ), i = re(() => {
    const l = { ...n };
    return r && (lr(ut(r.value)) ? l.templateApiCd = r.value : l.dispTemplateNo = r.value), l;
  }, [r, n]);
  return r ? /* @__PURE__ */ c(Si, { ...i }) : /* @__PURE__ */ c(ee, {});
}, $u = qe, Gu = ({
  id: t,
  baseWidth: o,
  gap: n,
  itemWidth: e,
  itemHeight: r = 0,
  isAutoResize: i = !0,
  isCentered: l = !1,
  isPreviewed: s = !1,
  pl: a = 0,
  pr: d = 0,
  data: u = [],
  slideIndex: f = -1,
  setSlideIndex: h,
  handleMore: p,
  setSwiper: g,
  className: m,
  children: C
}) => {
  const w = t || Ot(), [S, M] = U(0), z = re(
    () => i ? Math.floor(S * n / o) : n,
    [o, S, n, i]
  ), R = re(
    () => i ? Math.floor(S * e / o) : e,
    [o, S, i, e]
  ), P = re(
    () => i ? Math.floor(R * r / e) : r,
    [i, r, e, R]
  ), A = re(() => {
    const W = i ? (S + z + z) / (R + z) : (o + n) / (e + n);
    return s ? W : Math.floor(W);
  }, [
    i,
    S,
    z,
    R,
    o,
    n,
    e,
    s
  ]), [_, $] = U(), [E, k] = U(!1);
  return ie(() => (_ && "activeIndex" in _ && k(!0), () => {
    k(!1);
  }), [_]), ie(() => {
    _ && E && f >= 0 && _.slideTo(f + 1, 0);
  }, [u, p, E, f, _]), /* @__PURE__ */ c(J, { width: "100%", className: m, children: /* @__PURE__ */ c(
    $u,
    {
      disableHeight: !0,
      onResize: ({ width: W }) => M(W),
      children: (W) => /* @__PURE__ */ c(
        J,
        {
          width: S,
          ...P > 0 ? { height: P } : {},
          children: /* @__PURE__ */ c(
            vt,
            {
              spaceBetween: z,
              slidesPerView: A,
              slidesOffsetBefore: a,
              slidesOffsetAfter: d,
              centeredSlides: l,
              onSwiper: (v) => {
                $(v), g == null || g(v);
              },
              onSlideChange: ({ activeIndex: v, isEnd: G }) => {
                h && h(v), G && p && p();
              },
              edgeSwipeDetection: "prevent",
              ...P < 1 ? { autoHeight: !0 } : {},
              children: u.map((v, G) => /* @__PURE__ */ c(mt, { children: C({
                width: R,
                height: P,
                index: G,
                item: v,
                isActive: G === f
              }) }, `${w}-swiper-list-${G + 1}`))
            }
          )
        }
      )
    }
  ) });
}, Du = rn, Au = qe, Wu = Ae, Uu = Pt, Hu = Et, Ht = new Vn({ fixedWidth: !0, defaultHeight: 30 });
function Bu({
  isElement: t,
  elementContainerRef: o,
  columnCount: n = 5,
  columnSpace: e = 21,
  rowSpace: r = 21,
  list: i,
  children: l,
  handleNextMore: s = () => {
  },
  onScroll: a,
  cacheClearEffectDeps: d = []
}) {
  const [u, f] = U(0), h = xe(void 0), [p, g] = U(100), [m, C] = U(750), [w, S] = U(!0), [M, z] = U(), [R, P] = U({ index: 0 }), A = Y(
    ({ index: v }) => v < u - 1,
    [u]
  ), _ = Y(async () => {
    w || (S(!0), s());
  }, [s, w]);
  ie(() => {
    A(R) && w && S(!1);
  }, [R, w, A]), ie(() => {
    console.log("isLoading", w);
  }, [w]);
  const $ = Y(
    ({ width: v }) => {
      var G;
      g(v / n), C(v), Ht.clearAll(), (G = h.current) == null || G.recomputeGridSize();
    },
    [n]
  ), E = Y(
    (v) => {
      const { key: G, rowIndex: b, columnIndex: L, style: x, parent: Z } = v, j = b * n + L, y = (m - (n - 1) * e) / n, N = L * e, K = y * L + N, H = {
        ...x,
        width: y,
        left: K,
        paddingBottom: r,
        boxSizing: "border-box"
      };
      return /* @__PURE__ */ c(
        Uu,
        {
          cache: Ht,
          parent: Z,
          columnIndex: L,
          rowIndex: b,
          children: /* @__PURE__ */ c("div", { style: H, children: j < i.length && /* @__PURE__ */ c(ee, { children: l({ ...v, item: i[j] }) }) }, G)
        },
        G
      );
    },
    [l, n, e, m, i, r]
  ), k = Y(() => {
    (d == null ? void 0 : d.length) > 0 && setTimeout(() => {
      Ht.clearAll();
    }, 0);
  }, [d == null ? void 0 : d.length]);
  if (ie(() => {
    i.length > 0 && f(Math.ceil(i.length / n));
  }, [n, i]), ie(() => {
    k();
  }, [...d]), sr(i)) return /* @__PURE__ */ c(ee, {});
  const W = /* @__PURE__ */ c(
    Hu,
    {
      isRowLoaded: (v) => (P(v), A(v)),
      loadMoreRows: _,
      rowCount: u,
      threshold: 1,
      children: ({ onRowsRendered: v, registerChild: G }) => /* @__PURE__ */ c(Du, { scrollElement: M, onScroll: a, children: ({ height: b, scrollTop: L }) => /* @__PURE__ */ c(Au, { height: b, disableHeight: !0, onResize: $, children: ({ width: x }) => /* @__PURE__ */ c(
        Wu,
        {
          autoHeight: !0,
          width: x,
          height: b,
          scrollTop: L,
          ref: (Z) => {
            h.current = Z, G(Z);
          },
          columnWidth: p,
          columnCount: n,
          rowCount: u,
          rowHeight: Ht.rowHeight,
          cellRenderer: E,
          onSectionRendered: ({ rowStartIndex: Z, rowStopIndex: j }) => {
            v({
              startIndex: Z,
              stopIndex: j
            });
          },
          style: {
            outline: "none"
          }
        }
      ) }) })
    }
  );
  return t ? /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: (v) => {
            z(v), o == null || o(v);
          },
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "auto"
          },
          children: W
        }
      )
    }
  ) : /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%"
      },
      children: W
    }
  );
}
const ju = qe, Fu = Ae, Vu = Vr, Qo = Pt, qu = Et, Ku = rn;
function Yu({
  isElement: t = !1,
  elementContainerRef: o,
  columnCount: n = 1,
  columnSpace: e = 0,
  rowSpace: r = 0,
  list: i = [],
  handleNextMore: l = () => {
  },
  children: s,
  onScroll: a
}, d) {
  const u = re(() => n <= 1, [n]), f = re(
    () => new Vn({
      fixedWidth: !0,
      defaultWidth: 1,
      defaultHeight: 1
    }),
    []
  ), [h, p] = U(0), g = Y(
    ({ index: G }) => G < h - 1,
    [h]
  ), [m, C] = U(!1), w = Y(async () => {
    m || (C(!0), l(), C(!1));
  }, [l, m]), [S, M] = U(0), [z, R] = U(0), P = Y(
    ({ width: G }) => {
      var b;
      M(G), R((G - e * (n - 1)) / n), (b = $.current) == null || b.recomputeGridSize();
    },
    [n, e]
  ), A = Y(
    (G) => {
      const { key: b, index: L, parent: x, style: Z } = G;
      return /* @__PURE__ */ c(
        Qo,
        {
          parent: x,
          columnIndex: 0,
          rowIndex: L,
          cache: f,
          children: ({ measure: j, registerChild: y }) => /* @__PURE__ */ c(
            "div",
            {
              ref: y,
              style: {
                ...Z,
                paddingBottom: L === h - 1 ? 0 : r
              },
              children: /* @__PURE__ */ c(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: L < i.length && /* @__PURE__ */ c(ee, { children: s({
                    ...G,
                    measure: j,
                    item: i[L],
                    containerWidth: S,
                    fixedWidth: z
                  }) })
                }
              )
            }
          )
        },
        b
      );
    },
    [f, s, S, z, i, h, r]
  ), _ = Y(
    (G) => {
      const { key: b, rowIndex: L, parent: x, columnIndex: Z, style: j } = G, y = L * n + Z;
      return /* @__PURE__ */ c(
        Qo,
        {
          parent: x,
          columnIndex: Z,
          rowIndex: L,
          cache: f,
          children: ({ measure: N, registerChild: K }) => /* @__PURE__ */ c(
            "div",
            {
              ref: K,
              style: {
                ...j,
                paddingRight: e,
                paddingBottom: L === h - 1 ? 0 : r
              },
              children: /* @__PURE__ */ c(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: y < i.length && /* @__PURE__ */ c(ee, { children: s({
                    ...G,
                    measure: N,
                    item: i[y],
                    containerWidth: S,
                    fixedWidth: z
                  }) })
                }
              )
            }
          )
        },
        b
      );
    },
    [
      f,
      s,
      n,
      e,
      S,
      z,
      i,
      h,
      r
    ]
  ), $ = xe(void 0), [E, k] = U();
  ie(() => {
    i.length > 0 && p(u ? i.length : Math.ceil(i.length / n));
  }, [n, u, i.length]);
  const W = re(
    () => /* @__PURE__ */ c(
      qu,
      {
        isRowLoaded: g,
        loadMoreRows: w,
        rowCount: h,
        threshold: 1,
        children: ({ onRowsRendered: G, registerChild: b }) => /* @__PURE__ */ c(ee, { children: /* @__PURE__ */ c(Ku, { scrollElement: E, onScroll: a, children: ({ height: L, isScrolling: x, onChildScroll: Z, scrollTop: j }) => /* @__PURE__ */ c(ju, { height: L, disableHeight: !0, onResize: P, children: ({ width: y }) => u ? /* @__PURE__ */ c(
          Vu,
          {
            autoHeight: !0,
            width: y,
            height: L,
            isScrolling: x,
            onScroll: (N) => Z(N),
            scrollTop: j,
            rowHeight: f.rowHeight,
            rowCount: h,
            rowRenderer: A,
            deferredMeasurementCache: f,
            style: {
              outline: "none",
              overflowX: "hidden"
            },
            ref: (N) => {
              b(N);
            },
            onRowsRendered: G
          }
        ) : /* @__PURE__ */ c(
          Fu,
          {
            autoHeight: !0,
            width: y,
            height: L,
            isScrolling: x,
            onScroll: (N) => Z(N),
            scrollTop: j,
            ref: (N) => {
              $.current = N, b(N);
            },
            columnWidth: z + e,
            rowHeight: f.rowHeight,
            columnCount: n,
            rowCount: h,
            cellRenderer: _,
            deferredMeasurementCache: f,
            onSectionRendered: ({
              rowStartIndex: N,
              rowStopIndex: K
            }) => {
              G({
                startIndex: N,
                stopIndex: K
              });
            },
            style: {
              outline: "none",
              overflowX: "hidden"
            }
          }
        ) }) }) })
      }
    ),
    [
      f,
      _,
      n,
      e,
      E,
      z,
      u,
      g,
      w,
      P,
      a,
      h,
      A
    ]
  ), v = Y(() => {
    f.clearAll();
  }, [f]);
  return Oi(d, () => ({
    clearCache: v
  })), t ? /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: (G) => {
            k(G), o == null || o(G);
          },
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "auto"
          },
          children: W
        }
      )
    }
  ) : /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: "100%",
        height: "100%"
      },
      children: W
    }
  );
}
const mf = rr(Yu), Ke = "react-horizontal-scrolling-menu", pt = "-separator", Xu = `${Ke}-${pt}`, Qu = `${Ke}--item`, Zu = `${Ke}--scroll-container`, Ju = `${Ke}--wrapper`, eh = `${Ke}--inner-wrapper`, th = `${Ke}--header`, nh = `${Ke}--arrow-left`, oh = `${Ke}--arrow-right`, rh = `${Ke}--footer`, ih = "itemId", io = "data-key", lo = "data-index";
function lh({ className: t = "", children: o, onScroll: n = () => {
}, scrollRef: e }) {
  const r = ne.useMemo(() => `${Zu} ${t}`, [t]);
  return ne.createElement("div", { className: r, onScroll: n, ref: e }, o);
}
var sh = ne.memo(function({ className: t, id: o, index: n, refs: e }) {
  const r = ne.useRef(null);
  return e[n] = r, ne.createElement("div", Object.assign({ className: t }, { [io]: o, [lo]: n }, { ref: r }));
}), ah = ne.memo(function({ children: t, className: o, id: n, index: e, refs: r }) {
  const i = ne.useRef(null);
  return r[String(e)] = i, ne.createElement("div", Object.assign({ className: o }, { [io]: n, [lo]: e }, { ref: i }), t);
});
function Zo(t) {
  return typeof t == "object" && t != null && t.nodeType === 1;
}
function Jo(t, o) {
  return (!o || t !== "hidden") && t !== "visible" && t !== "clip";
}
function bn(t, o) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var n = getComputedStyle(t, null);
    return Jo(n.overflowY, o) || Jo(n.overflowX, o) || function(e) {
      var r = function(i) {
        if (!i.ownerDocument || !i.ownerDocument.defaultView) return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(e);
      return !!r && (r.clientHeight < e.scrollHeight || r.clientWidth < e.scrollWidth);
    }(t);
  }
  return !1;
}
function Bt(t, o, n, e, r, i, l, s) {
  return i < t && l > o || i > t && l < o ? 0 : i <= t && s <= n || l >= o && s >= n ? i - t - e : l > o && s < n || i < t && s > n ? l - o + r : 0;
}
var xn, er = function(t, o) {
  var n = window, e = o.scrollMode, r = o.block, i = o.inline, l = o.boundary, s = o.skipOverflowHiddenElements, a = typeof l == "function" ? l : function(Ze) {
    return Ze !== l;
  };
  if (!Zo(t)) throw new TypeError("Invalid target");
  for (var d, u, f = document.scrollingElement || document.documentElement, h = [], p = t; Zo(p) && a(p); ) {
    if ((p = (u = (d = p).parentElement) == null ? d.getRootNode().host || null : u) === f) {
      h.push(p);
      break;
    }
    p != null && p === document.body && bn(p) && !bn(document.documentElement) || p != null && bn(p, s) && h.push(p);
  }
  for (var g = n.visualViewport ? n.visualViewport.width : innerWidth, m = n.visualViewport ? n.visualViewport.height : innerHeight, C = window.scrollX || pageXOffset, w = window.scrollY || pageYOffset, S = t.getBoundingClientRect(), M = S.height, z = S.width, R = S.top, P = S.right, A = S.bottom, _ = S.left, $ = r === "start" || r === "nearest" ? R : r === "end" ? A : R + M / 2, E = i === "center" ? _ + z / 2 : i === "end" ? P : _, k = [], W = 0; W < h.length; W++) {
    var v = h[W], G = v.getBoundingClientRect(), b = G.height, L = G.width, x = G.top, Z = G.right, j = G.bottom, y = G.left;
    if (e === "if-needed" && R >= 0 && _ >= 0 && A <= m && P <= g && R >= x && A <= j && _ >= y && P <= Z) return k;
    var N = getComputedStyle(v), K = parseInt(N.borderLeftWidth, 10), H = parseInt(N.borderTopWidth, 10), B = parseInt(N.borderRightWidth, 10), I = parseInt(N.borderBottomWidth, 10), V = 0, T = 0, F = "offsetWidth" in v ? v.offsetWidth - v.clientWidth - K - B : 0, Q = "offsetHeight" in v ? v.offsetHeight - v.clientHeight - H - I : 0, te = "offsetWidth" in v ? v.offsetWidth === 0 ? 0 : L / v.offsetWidth : 0, ce = "offsetHeight" in v ? v.offsetHeight === 0 ? 0 : b / v.offsetHeight : 0;
    if (f === v) V = r === "start" ? $ : r === "end" ? $ - m : r === "nearest" ? Bt(w, w + m, m, H, I, w + $, w + $ + M, M) : $ - m / 2, T = i === "start" ? E : i === "center" ? E - g / 2 : i === "end" ? E - g : Bt(C, C + g, g, K, B, C + E, C + E + z, z), V = Math.max(0, V + w), T = Math.max(0, T + C);
    else {
      V = r === "start" ? $ - x - H : r === "end" ? $ - j + I + Q : r === "nearest" ? Bt(x, j, b, H, I + Q, $, $ + M, M) : $ - (x + b / 2) + Q / 2, T = i === "start" ? E - y - K : i === "center" ? E - (y + L / 2) + F / 2 : i === "end" ? E - Z + B + F : Bt(y, Z, L, K, B + F, E, E + z, z);
      var ae = v.scrollLeft, Ce = v.scrollTop;
      $ += Ce - (V = Math.max(0, Math.min(Ce + V / ce, v.scrollHeight - b / ce + Q))), E += ae - (T = Math.max(0, Math.min(ae + T / te, v.scrollWidth - L / te + F)));
    }
    k.push({ el: v, top: V, left: T });
  }
  return k;
};
function tr(t) {
  return t === Object(t) && Object.keys(t).length !== 0;
}
function nr(t, o) {
  var n = t.isConnected || t.ownerDocument.documentElement.contains(t);
  if (tr(o) && typeof o.behavior == "function") return o.behavior(n ? er(t, o) : []);
  if (n) {
    var e = function(r) {
      return r === !1 ? { block: "end", inline: "nearest" } : tr(r) ? r : { block: "start", inline: "nearest" };
    }(o);
    return function(r, i) {
      i === void 0 && (i = "auto");
      var l = "scrollBehavior" in document.body.style;
      r.forEach(function(s) {
        var a = s.el, d = s.top, u = s.left;
        a.scroll && l ? a.scroll({ top: d, left: u, behavior: i }) : (a.scrollTop = d, a.scrollLeft = u);
      });
    }(er(t, e), e.behavior);
  }
}
var Ci = function() {
  return xn || (xn = "performance" in window ? performance.now.bind(performance) : Date.now), xn();
};
function _i(t) {
  var o = Ci(), n = Math.min((o - t.startTime) / t.duration, 1), e = t.ease(n), r = t.startX + (t.x - t.startX) * e, i = t.startY + (t.y - t.startY) * e;
  t.method(r, i), r !== t.x || i !== t.y ? requestAnimationFrame(function() {
    return _i(t);
  }) : t.cb();
}
function ch(t, o, n, e, r, i) {
  var l, s, a, d;
  e === void 0 && (e = 600), r === void 0 && (r = function(u) {
    return 1 + --u * u * u * u * u;
  }), l = t, s = t.scrollLeft, a = t.scrollTop, d = function(u, f) {
    t.scrollLeft = Math.ceil(u), t.scrollTop = Math.ceil(f);
  }, _i({ scrollable: l, method: d, startTime: Ci(), startX: s, startY: a, x: o, y: n, duration: e, ease: r, cb: i });
}
var dh = function(t, o) {
  var n = o || {};
  return function(e) {
    return e && !e.behavior || e.behavior === "smooth";
  }(n) ? nr(t, { block: n.block, inline: n.inline, scrollMode: n.scrollMode, boundary: n.boundary, behavior: function(e) {
    return Promise.all(e.reduce(function(r, i) {
      var l = i.el, s = i.left, a = i.top, d = l.scrollLeft, u = l.scrollTop;
      return d === s && u === a ? r : [].concat(r, [new Promise(function(f) {
        return ch(l, s, a, n.duration, n.ease, function() {
          return f({ el: l, left: [d, s], top: [u, a] });
        });
      })]);
    }, []));
  } }) : Promise.resolve(nr(t, o));
};
const uh = (t) => Object.values(t).map((o) => o.current).filter(Boolean);
function Tn(t, o, n, e, r, i) {
  var l;
  const s = ((l = t == null ? void 0 : t.entry) === null || l === void 0 ? void 0 : l.target) || t, a = o || "smooth";
  if (s) return i ? s == null ? void 0 : s.scrollIntoView({ behavior: a, inline: n || "end", block: e || "nearest" }) : dh(s, Object.assign({ behavior: a, inline: n || "end", block: e || "nearest", duration: 500 }, r));
}
const hh = (t) => document.querySelector(`[${io}='${t}']`), fh = (t) => document.querySelector(`[${lo}='${t}']`);
function jt(t) {
  return ne.isValidElement(t) && t || typeof t == "function" && ne.createElement(t, null) || null;
}
const bi = (t) => t.filter((o) => !new RegExp(`.*${pt}$`).test(o)), xi = (t) => {
  var o;
  return String(((o = t == null ? void 0 : t.props) === null || o === void 0 ? void 0 : o[ih]) || String((t == null ? void 0 : t.key) || "").replace(/^\.\$/, ""));
};
function ph({ children: t, itemClassName: o = "", refs: n, separatorClassName: e = "" }) {
  const r = ne.Children.toArray(t).filter(Boolean), i = r.length, l = ne.useMemo(() => `${Qu} ${o}`, [o]), s = ne.useMemo(() => `${Xu} ${e}`, [e]);
  return ne.createElement(ne.Fragment, null, r.map((a, d) => {
    const u = xi(a), f = u + pt, h = d + 1 === i;
    return [ne.createElement(ah, { className: l, id: u, key: "menuItem__" + u, refs: n, index: d }, a), !h && ne.createElement(sh, { className: s, id: f, refs: n, key: f, index: d + 0.1 })];
  }));
}
const gh = typeof window < "u" ? ne.useLayoutEffect : ne.useEffect;
function vh({ items: t, itemsChanged: o, refs: n, options: e }) {
  const r = ne.useRef(), [i, l] = ne.useState([]), s = ne.useRef(+setTimeout(() => {
  }, 0)), a = ne.useCallback((d) => {
    t.set(function(u, f) {
      return [...u].map((h) => {
        var p, g, m, C;
        const w = h.target, S = String((g = (p = w == null ? void 0 : w.dataset) === null || p === void 0 ? void 0 : p.key) !== null && g !== void 0 ? g : "");
        return [S, { index: String((C = (m = w == null ? void 0 : w.dataset) === null || m === void 0 ? void 0 : m.index) !== null && C !== void 0 ? C : ""), key: S, entry: h, visible: h.intersectionRatio >= f.ratio }];
      });
    }(d, e)), clearTimeout(s.current), s.current = +setTimeout(() => requestAnimationFrame(() => {
      l((u) => {
        const f = t.getVisible().map((h) => h[1].key);
        return JSON.stringify(u) !== JSON.stringify(f) ? f : u;
      });
    }), e.throttle);
  }, [t, e]);
  return gh(() => {
    const d = uh(n), u = r.current || new IntersectionObserver(a, e);
    return r.current = u, d.forEach((f) => u.observe(f)), () => {
      clearTimeout(s.current), u.disconnect(), r.current = void 0;
    };
  }, [a, o, e, n]), i;
}
const mh = (t) => ne.Children.toArray(t).map(xi).filter(Boolean);
class yh extends Map {
  toArr() {
    return this.sort([...this]);
  }
  toItems() {
    return this.toArr().map(([o]) => o);
  }
  toItemsWithoutSeparators() {
    return bi(this.toItems());
  }
  toItemsKeys() {
    return this.toItems();
  }
  sort(o) {
    return o.sort(([, n], [, e]) => +n.index - +e.index);
  }
  set(o, n) {
    return Array.isArray(o) ? this.sort(o).forEach(([e, r]) => {
      super.set(String(e), r);
    }) : super.set(String(o), n), this;
  }
  first() {
    var o;
    return (o = this.toArr()[0]) === null || o === void 0 ? void 0 : o[1];
  }
  last() {
    var o, n;
    return (n = (o = this.toArr().slice(-1)) === null || o === void 0 ? void 0 : o[0]) === null || n === void 0 ? void 0 : n[1];
  }
  filter(o) {
    return this.toArr().filter(o);
  }
  find(o) {
    return this.toArr().find(o);
  }
  findIndex(o) {
    return this.toArr().findIndex(o);
  }
  getCurrentPos(o, n) {
    const e = this.toArr().filter((i) => {
      var l;
      return n ? !(!((l = i == null ? void 0 : i[0]) === null || l === void 0) && l.includes(pt)) : i;
    }), r = e.findIndex(([i, l]) => i === o || l === o);
    return [e, r];
  }
  prev(o, n) {
    var e;
    const [r, i] = this.getCurrentPos(o, !!n);
    return i !== -1 ? (e = r[i - 1]) === null || e === void 0 ? void 0 : e[1] : void 0;
  }
  next(o, n) {
    var e;
    const [r, i] = this.getCurrentPos(o, !!n);
    return i !== -1 ? (e = r[i + 1]) === null || e === void 0 ? void 0 : e[1] : void 0;
  }
  getVisible() {
    return this.filter((o) => o[1].visible);
  }
  getVisibleElements() {
    return this.filter((o) => !o[0].includes(pt) && o[1].visible);
  }
}
const or = { ratio: 0.9, rootMargin: "5px", threshold: [0.05, 0.5, 0.75, 0.95], throttle: 100 }, wh = ne.createContext({}), Sh = { current: {} }, Ft = () => {
};
function Ch({ LeftArrow: t, RightArrow: o, children: n, Header: e, Footer: r, transitionDuration: i = 500, transitionEase: l, transitionBehavior: s, onInit: a = Ft, onUpdate: d = Ft, onMouseDown: u, onMouseUp: f, onMouseMove: h, onScroll: p = Ft, onTouchMove: g, onTouchStart: m, onTouchEnd: C, onWheel: w = Ft, options: S = or, scrollContainerClassName: M = "", itemClassName: z = "", separatorClassName: R = "", wrapperClassName: P = "", apiRef: A = Sh, RTL: _, noPolyfill: $ }) {
  const E = jt(t), k = jt(o), W = jt(e), v = jt(r), G = ne.useRef(null), [b] = ne.useState({}), L = ne.useMemo(() => Object.assign(Object.assign(Object.assign({}, or), S), { root: G.current }), [S, G.current]), x = ne.useRef(new yh()).current, Z = function(Q, te) {
    const [ce, ae] = ne.useState(""), Ce = ne.useMemo(() => mh(Q), [Q]);
    return ne.useEffect(() => {
      const Ze = Ce.filter(Boolean).join("");
      te.toItemsWithoutSeparators().filter((Ue) => !Ce.includes(Ue)).forEach((Ue) => {
        var Je, et;
        const an = ((Je = te.last()) === null || Je === void 0 ? void 0 : Je.key) === Ue && ((et = te.prev(Ue)) === null || et === void 0 ? void 0 : et.key) || "";
        te.delete(an), te.delete(`${Ue}${pt}`), te.delete(Ue);
      }), ae(Ze);
    }, [Ce, te]), ce;
  }(n, x), j = vh(ne.useMemo(() => ({ items: x, itemsChanged: Z, options: L, refs: b }), [x, Z, b, L])), y = !!j.length, N = ne.useMemo(() => function(Q, te = [], ce, ae, Ce, Ze) {
    var Ue, Je;
    const et = bi(te), an = !!(!((Ue = Q.first()) === null || Ue === void 0) && Ue.visible), Ii = !!(!((Je = Q.last()) === null || Je === void 0) && Je.visible), so = (ue) => {
      var fe;
      return (fe = Q.find((Se) => Se[1].key === String(ue))) === null || fe === void 0 ? void 0 : fe[1];
    }, ao = () => {
      var ue, fe;
      return Q.prev((fe = (ue = Q.getVisible()) === null || ue === void 0 ? void 0 : ue[0]) === null || fe === void 0 ? void 0 : fe[1]);
    }, co = () => {
      var ue, fe, Se, _e;
      return Q.next((_e = (Se = (fe = (ue = Q.getVisible()) === null || ue === void 0 ? void 0 : ue.slice) === null || fe === void 0 ? void 0 : fe.call(ue, -1)) === null || Se === void 0 ? void 0 : Se[0]) === null || _e === void 0 ? void 0 : _e[1]);
    };
    return { getItemById: so, getItemElementById: hh, getItemByIndex: (ue) => {
      var fe;
      return (fe = Q.find((Se) => String(Se[1].index) === String(ue))) === null || fe === void 0 ? void 0 : fe[1];
    }, getItemElementByIndex: fh, getNextItem: co, getNextElement: () => {
      var ue, fe, Se, _e;
      return Q.next((_e = (Se = (fe = (ue = Q.getVisibleElements()) === null || ue === void 0 ? void 0 : ue.slice) === null || fe === void 0 ? void 0 : fe.call(ue, -1)) === null || Se === void 0 ? void 0 : Se[0]) === null || _e === void 0 ? void 0 : _e[1], !0);
    }, getPrevItem: ao, getPrevElement: () => {
      var ue, fe;
      return Q.prev((fe = (ue = Q.getVisibleElements()) === null || ue === void 0 ? void 0 : ue[0]) === null || fe === void 0 ? void 0 : fe[1], !0);
    }, isFirstItemVisible: an, isItemVisible: (ue) => et.includes(String(ue)), isLastItem: (ue) => Q.last() === so(ue), isLastItemVisible: Ii, scrollNext: (ue, fe, Se, { duration: _e, ease: $e, boundary: tt = ce == null ? void 0 : ce.current } = {}) => {
      const nt = ue ?? (ae == null ? void 0 : ae.behavior);
      return Tn(co(), nt, fe || "start", Se || "nearest", { boundary: tt, duration: _e ?? (ae == null ? void 0 : ae.duration), ease: $e ?? (ae == null ? void 0 : ae.ease) }, Ce || Ze);
    }, scrollPrev: (ue, fe, Se, { duration: _e, ease: $e, boundary: tt = ce == null ? void 0 : ce.current } = {}) => {
      const nt = ue ?? (ae == null ? void 0 : ae.behavior);
      return Tn(ao(), nt, fe || "end", Se || "nearest", { boundary: tt, duration: _e ?? (ae == null ? void 0 : ae.duration), ease: $e ?? (ae == null ? void 0 : ae.ease) }, Ce || Ze);
    }, scrollToItem: (ue, fe, Se, _e, $e) => {
      var tt, nt;
      return Tn(ue, fe ?? (ae == null ? void 0 : ae.behavior), Se, _e, Object.assign(Object.assign({ boundary: ce == null ? void 0 : ce.current }, $e), { duration: (tt = $e == null ? void 0 : $e.duration) !== null && tt !== void 0 ? tt : ae == null ? void 0 : ae.duration, ease: (nt = $e == null ? void 0 : $e.ease) !== null && nt !== void 0 ? nt : ae == null ? void 0 : ae.ease }), Ze);
    }, visibleElements: et, visibleElementsWithSeparators: te, visibleItems: te, visibleItemsWithoutSeparators: et };
  }(x, j, G, { duration: i, ease: l, behavior: s }, _, $), [x, j, Z, _, $]), K = ne.useCallback(() => Object.assign(Object.assign({}, N), { initComplete: y, items: x, visibleElementsWithSeparators: j, scrollContainer: G }), [N, y, x, j, G]), [H, B] = ne.useState(K);
  (function({ cb: Q = () => {
  }, condition: te, hash: ce }) {
    ne.useEffect(() => {
      te && Q();
    }, [ce, te]);
  })({ cb: () => d(H), condition: function({ cb: Q, condition: te }) {
    const [ce, ae] = ne.useState(!1);
    return ne.useEffect(() => {
      te && !ce && (ae(!0), Q());
    }, [te, ce]), ce;
  }({ cb: () => a(H), condition: y }), hash: JSON.stringify(j.concat(String(H == null ? void 0 : H.isFirstItemVisible)).concat(String(H == null ? void 0 : H.isLastItemVisible))) }), ne.useEffect(() => B(K()), [K]), A.current = H;
  const I = ne.useCallback((Q) => p(H, Q), [p, H]), V = ne.useCallback((Q) => w(H, Q), [w, H]), T = ne.useMemo(() => `${Ju} ${P}`, [P]), F = ne.useMemo(() => `${M}${_ ? " rtl" : ""}`, [_, M]);
  return ne.createElement("div", { className: T, onWheel: V, onMouseDown: u == null ? void 0 : u(H), onMouseUp: f == null ? void 0 : f(H), onMouseMove: h == null ? void 0 : h(H), onTouchStart: m == null ? void 0 : m(H), onTouchMove: g == null ? void 0 : g(H), onTouchEnd: C == null ? void 0 : C(H) }, ne.createElement(wh.Provider, { value: H }, ne.createElement("div", { className: th }, W), ne.createElement("div", { className: eh }, ne.createElement("div", { className: nh }, E), ne.createElement(lh, { className: F, onScroll: I, scrollRef: G }, ne.createElement(ph, { refs: b, itemClassName: z, separatorClassName: R }, n)), ne.createElement("div", { className: oh }, k)), ne.createElement("div", { className: rh }, v)));
}
const yf = ({
  space: t = 8,
  children: o,
  ...n
}) => /* @__PURE__ */ c(_h, { space: t, children: /* @__PURE__ */ c(Ch, { ...n, children: o }) }), _h = q.div`
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
    display: none;
  }

  .react-horizontal-scrolling-menu--scroll-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overscroll-behavior: none;
  }
  ${({ space: t = 8 }) => Fe`
    .react-horizontal-scrolling-menu--item {
      padding-right: ${zl(t)};
    }
    .react-horizontal-scrolling-menu--item:last-child {
      padding-right: 0;
    }
  `}
`, wf = ({
  totalItems: t,
  perView: o
}) => {
  const n = xe(null), [e, r] = U([]), i = re(
    () => t > 0 ? Math.floor(((cn(e) || 0) + 1) / t * 100) : 100,
    [t, e]
  ), l = re(() => (Tt(e) || 0) > 0, [e]), s = re(
    () => (cn(e) || 0) < t - 1,
    [t, e]
  ), a = Y(() => {
    var m, C;
    const f = Tt(e) || 0, h = f - o < 0 ? 0 : f - o;
    (C = n == null ? void 0 : n.current) == null || C.scrollToItem(
      (m = n == null ? void 0 : n.current) == null ? void 0 : m.getItemByIndex(h),
      "smooth",
      "start",
      "start"
    );
    const p = h, g = p + o < t ? p + o : t - 1;
    r(dn(p, g));
  }, [o, t, e]), d = Y(() => {
    var m, C;
    const f = cn(e) || 0, h = f + 1 < t ? f + 1 : t - 1;
    (C = n == null ? void 0 : n.current) == null || C.scrollToItem(
      (m = n == null ? void 0 : n.current) == null ? void 0 : m.getItemByIndex(h),
      "smooth",
      "start",
      "start"
    );
    const p = h + o < t ? h + o : t, g = p - o < 0 ? 0 : p - o;
    r(dn(g, p));
  }, [o, t, e]), u = Y(
    (f, h) => {
      h.deltaY < 0 ? d() : h.deltaY > 0 && a();
    },
    [d, a]
  );
  return ie(() => {
    e.length <= 0 && r(dn(0, o < t ? o : t));
  }, [o, t, e.length]), {
    scrollRef: n,
    visibles: e,
    percent: i,
    hasPrev: l,
    handlePrev: a,
    hasNext: s,
    handleNext: d,
    onWheel: u
  };
}, bh = ne.createContext({}), Ti = !0;
function xh({ baseColor: t, highlightColor: o, width: n, height: e, borderRadius: r, circle: i, direction: l, duration: s, enableAnimation: a = Ti, customHighlightBackground: d }) {
  const u = {};
  return l === "rtl" && (u["--animation-direction"] = "reverse"), typeof s == "number" && (u["--animation-duration"] = `${s}s`), a || (u["--pseudo-element-display"] = "none"), (typeof n == "string" || typeof n == "number") && (u.width = n), (typeof e == "string" || typeof e == "number") && (u.height = e), (typeof r == "string" || typeof r == "number") && (u.borderRadius = r), i && (u.borderRadius = "50%"), typeof t < "u" && (u["--base-color"] = t), typeof o < "u" && (u["--highlight-color"] = o), typeof d == "string" && (u["--custom-highlight-background"] = d), u;
}
function Th({ count: t = 1, wrapper: o, className: n, containerClassName: e, containerTestId: r, circle: i = !1, style: l, ...s }) {
  var a, d, u;
  const f = ne.useContext(bh), h = { ...s };
  for (const [M, z] of Object.entries(s))
    typeof z > "u" && delete h[M];
  const p = {
    ...f,
    ...h,
    circle: i
  }, g = {
    ...l,
    ...xh(p)
  };
  let m = "react-loading-skeleton";
  n && (m += ` ${n}`);
  const C = (a = p.inline) !== null && a !== void 0 ? a : !1, w = [], S = Math.ceil(t);
  for (let M = 0; M < S; M++) {
    let z = g;
    if (S > t && M === S - 1) {
      const P = (d = z.width) !== null && d !== void 0 ? d : "100%", A = t % 1, _ = typeof P == "number" ? P * A : `calc(${P} * ${A})`;
      z = { ...z, width: _ };
    }
    const R = ne.createElement("span", { className: m, style: z, key: M }, "‌");
    C ? w.push(R) : w.push(ne.createElement(
      ne.Fragment,
      { key: M },
      R,
      ne.createElement("br", null)
    ));
  }
  return ne.createElement("span", { className: e, "data-testid": r, "aria-live": "polite", "aria-busy": (u = p.enableAnimation) !== null && u !== void 0 ? u : Ti }, o ? w.map((M, z) => ne.createElement(o, { key: z }, M)) : w);
}
function Ih({
  isSkeleton: t,
  children: o,
  containerStyle: n,
  containerW100P: e,
  containerH100P: r,
  containerWH100P: i,
  className: l,
  style: s,
  borderRadius: a = 0,
  ...d
}) {
  const u = re(() => i ? {
    width: "100%",
    height: "100%"
  } : e ? {
    width: "100%"
  } : r ? {
    height: "100%"
  } : {}, [r, e, i]);
  return t ? /* @__PURE__ */ c(
    Rh,
    {
      style: {
        ...u,
        ...n,
        borderRadius: a
      },
      className: l,
      children: /* @__PURE__ */ c(
        Th,
        {
          style: {
            display: "flex",
            alignItems: "center",
            ...s,
            borderRadius: a
          },
          ...d
        }
      )
    }
  ) : /* @__PURE__ */ c(ee, { children: o });
}
const Rh = q.div`
  display: inline-block;
`;
function kh(t) {
  return (o) => {
    t.forEach((n) => {
      typeof n == "function" ? n(o) : n != null && (n.current = o);
    });
  };
}
const Lh = ({ imgFit: t, w: o, h: n, q: e, src: r, imageScale: i = 1, ...l }, s) => {
  const a = xe(null), d = kh([s, a]), [u, f] = U(!1), [h, p] = U(!1), g = Y(
    (C) => {
      var w;
      f(!0), p(!1), (w = l == null ? void 0 : l.onLoad) == null || w.call(l, C);
    },
    [l]
  ), m = Y(
    (C) => {
      var w;
      f(!1), p(!0), (w = l == null ? void 0 : l.onError) == null || w.call(l, C);
    },
    [l]
  );
  return /* @__PURE__ */ c(
    "div",
    {
      style: {
        width: o || "100%",
        height: n || "100%",
        boxSizing: "border-box"
      },
      children: /* @__PURE__ */ X(
        "div",
        {
          style: {
            width: o || "100%",
            height: n || "100%",
            position: "relative"
          },
          children: [
            /* @__PURE__ */ c(
              Ih,
              {
                isSkeleton: !u,
                duration: h ? 0 : void 0,
                style: {
                  width: o || "100%",
                  height: n || "100%"
                },
                containerStyle: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: o || "100%",
                  height: n || "100%"
                }
              }
            ),
            !h && /* @__PURE__ */ c(
              zh,
              {
                ...l,
                ref: d,
                src: gr({
                  url: r || "",
                  w: o && o * i,
                  h: n && n * i,
                  q: e
                }),
                imgFit: t,
                onLoad: g,
                onError: m
              }
            ),
            h && /* @__PURE__ */ c(
              "div",
              {
                style: {
                  width: o || "100%",
                  height: n || "100%",
                  backgroundColor: "#efefef"
                }
              }
            )
          ]
        }
      )
    }
  );
}, An = tn(rr(Lh)), Oh = q.img`
  ${({ imgFit: t }) => Fe`
    width: 100%;
    height: 100%;
    object-fit: ${t};
  `}
`, zh = tn(Oh), Mh = ({
  itemLength: t,
  fixedSlidePerView: o
}) => {
  const { setIndicatorPercent: n } = zt(), [e, r] = U(1), i = re(() => o || 1, [o]);
  return ie(() => {
    const s = i * e, a = s >= t ? 100 : s / t * 100;
    n(a);
  }, [t, i, n, e]), { handleScroll: Y((s) => {
    r(s.snapIndex + 1);
  }, []) };
}, Ph = qe, Eh = ({
  id: t,
  baseWidth: o,
  gap: n,
  itemWidth: e,
  itemHeight: r = 0,
  isAutoResize: i = !0,
  isCentered: l = !1,
  isPreviewed: s = !1,
  pl: a = 0,
  pr: d = 0,
  data: u = [],
  slideIndex: f = -1,
  setSlideIndex: h,
  handleMore: p,
  onTouchStart: g,
  onTouchEnd: m,
  onTouchCancel: C,
  className: w,
  children: S,
  isMoveFirstIndex: M = !1,
  useFixedGap: z,
  isMaxHeight: R = !1,
  fixedSlidePerView: P,
  setSwiperAction: A,
  setIsSwiperBegin: _,
  setIsSwiperEnd: $
}) => {
  const { handleScroll: E } = Mh({
    itemLength: u.length,
    fixedSlidePerView: P
  }), k = re(() => t || Ot(), [t]), [W, v] = U(0), G = xe(null), [b, L] = U(0), x = re(
    () => i ? Math.floor(W * n / o) : n,
    [o, W, n, i]
  ), Z = re(
    () => i ? Math.floor(W * e / o) : e,
    [o, W, i, e]
  ), j = re(
    () => i ? Math.floor(Z * r / e) : r,
    [i, r, e, Z]
  ), y = re(() => {
    const I = i ? (W + x) / (Z + x) : (o + n) / (e + n);
    return s ? I : Math.floor(I);
  }, [
    i,
    W,
    x,
    Z,
    o,
    n,
    e,
    s
  ]), [N, K] = U(), [H, B] = U(!1);
  return ie(() => (N && "activeIndex" in N && B(!0), () => {
    B(!1);
  }), [N]), ie(() => {
    N && H && f >= 0 && N.slideTo(f + 1, 0);
  }, [u, p, H, f, N]), ie(() => {
    M && N && N.slideTo(0, 0);
  }, [u]), ie(() => {
    A && N && A(N);
  }, [A, N]), ie(() => {
    const I = () => {
      if (G.current && G.current.swiper) {
        const V = G.current.swiper.slides;
        let T = 0;
        V.forEach((F) => {
          const Q = F.clientHeight;
          Q > T && (T = Q);
        }), L(T);
      }
    };
    return R && G.current && G.current.swiper && (G.current.swiper.on("init", I), G.current.swiper.on("imagesReady", I), G.current.swiper.on("resize", I)), () => {
      G.current && G.current.swiper && (G.current.swiper.off("init", I), G.current.swiper.off("imagesReady", I), G.current.swiper.off("resize", I));
    };
  }, []), /* @__PURE__ */ c(J, { width: "100%", className: w, children: /* @__PURE__ */ c(
    Ph,
    {
      disableHeight: !0,
      onResize: ({ width: I }) => {
        v(I);
      },
      children: (I) => /* @__PURE__ */ c(
        J,
        {
          width: W,
          ...j > 0 ? { height: j } : {},
          children: /* @__PURE__ */ c(
            vt,
            {
              spaceBetween: z ? n : x,
              ref: G,
              slidesPerView: P || y,
              slidesOffsetBefore: a,
              slidesOffsetAfter: d,
              centeredSlides: l,
              onSwiper: K,
              onSlideChange: ({ activeIndex: V, isEnd: T, isBeginning: F }) => {
                h && h(V), T && p && p(), _ && _(F), $ && $(T);
              },
              edgeSwipeDetection: "prevent",
              onTouchStart: g,
              onTouchEnd: m,
              onTouchCancel: C,
              onActiveIndexChange: (V) => E(V),
              style: { height: b || "auto" },
              ...j < 1 ? { autoHeight: !0 } : {},
              children: u.map((V, T) => /* @__PURE__ */ c(mt, { children: S({
                width: Z,
                height: j,
                index: T,
                item: V,
                isActive: T === f
              }) }, `${k}-slide-list-${T + 1}`))
            }
          )
        }
      )
    }
  ) });
}, Nh = qe, Gt = ({
  id: t,
  baseWidth: o,
  baseHeight: n,
  isAutoPlayed: e = !1,
  data: r = [],
  slideIndex: i = -1,
  setSlideIndex: l,
  className: s,
  children: a,
  rowNumber: d = 1,
  hasLoop: u = !0,
  slidePerNum: f,
  autoMs: h = 5e3,
  gap: p,
  gtmName: g = "",
  hasInitialSlide: m = !1,
  hasPagination: C = !1,
  hasLineIndicator: w = !1,
  setSwiperAction: S,
  setIndicatorPercent: M
}) => {
  const z = re(() => t || Ot(), [t]), { tagGTM: R } = le(), [P, A] = U(1), [_, $] = U(e), [E, k] = U(), [W, v] = U(!1), [G, b] = U(0), L = re(
    () => Math.ceil(n * G / o),
    [n, o, G]
  ), [x, Z] = U(0), j = Y(() => {
    $((I) => !I), _ ? E == null || E.autoplay.stop() : E == null || E.autoplay.start();
  }, [_, E == null ? void 0 : E.autoplay]);
  ie(() => (E && "activeIndex" in E && v(!0), () => v(!1)), [E]), ie(() => {
    !E || !W || (e && E.autoplay.start(), i >= 0 && E.slideTo(i + 1, 0));
  }, [r, W, i, E, e]), ie(() => {
    S && E && S(E);
  }, [S, E]);
  const [y, N] = U(!0), [K, H] = U(0), B = re(
    () => f || d,
    [d, f]
  );
  return ie(() => {
    const I = B + K, V = I >= r.length ? 100 : I / r.length * 100;
    Z(V), M && M(V);
  }, [r.length, B, K, M]), /* @__PURE__ */ X(J, { width: "100%", className: s, ...R(`${g}`), children: [
    /* @__PURE__ */ c(
      Nh,
      {
        disableHeight: !0,
        onResize: ({ width: I }) => b(I),
        children: (I) => /* @__PURE__ */ c(J, { width: G, children: /* @__PURE__ */ c(
          vt,
          {
            modules: [Wn],
            centeredSlides: !1,
            onSwiper: k,
            spaceBetween: p,
            slidesPerView: d,
            slidesPerGroup: f || d,
            initialSlide: m ? 0 : void 0,
            loopFillGroupWithBlank: !0,
            onSlideChange: ({ activeIndex: V, realIndex: T }) => {
              y ? (H(0), N(!1)) : H(T);
              let F = V % r.length < 1 ? r.length : V % r.length;
              m && isNaN(F) && (F = 1), l && l(F - 1), A(F);
            },
            loop: u,
            autoplay: {
              delay: h,
              disableOnInteraction: !1
            },
            children: r.map((V, T) => /* @__PURE__ */ c(mt, { children: a({
              width: G,
              height: L,
              index: T,
              item: V
            }) }, `${z}-slide-box-${T + 1}`))
          }
        ) })
      }
    ),
    w && /* @__PURE__ */ c(
      Hn,
      {
        position: "absolute",
        width: "73%",
        bottom: "0",
        left: "13.5%",
        zIndex: 1,
        variant: "line1",
        percent: x
      }
    ),
    C && r.length > 1 && /* @__PURE__ */ c(J, { position: "absolute", bottom: "16px", right: "16px", zIndex: 9, children: /* @__PURE__ */ c(
      Sr,
      {
        current: P,
        isPlay: _,
        handleClickControls: j,
        total: r.length,
        variant: "number"
      }
    ) })
  ] });
}, $h = gt(null), In = {
  didCatch: !1,
  error: null
};
class Vt extends zi {
  constructor(o) {
    super(o), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = In;
  }
  static getDerivedStateFromError(o) {
    return {
      didCatch: !0,
      error: o
    };
  }
  resetErrorBoundary() {
    const {
      error: o
    } = this.state;
    if (o !== null) {
      for (var n, e, r = arguments.length, i = new Array(r), l = 0; l < r; l++)
        i[l] = arguments[l];
      (n = (e = this.props).onReset) === null || n === void 0 || n.call(e, {
        args: i,
        reason: "imperative-api"
      }), this.setState(In);
    }
  }
  componentDidCatch(o, n) {
    var e, r;
    (e = (r = this.props).onError) === null || e === void 0 || e.call(r, o, n);
  }
  componentDidUpdate(o, n) {
    const {
      didCatch: e
    } = this.state, {
      resetKeys: r
    } = this.props;
    if (e && n.error !== null && Gh(o.resetKeys, r)) {
      var i, l;
      (i = (l = this.props).onReset) === null || i === void 0 || i.call(l, {
        next: r,
        prev: o.resetKeys,
        reason: "keys"
      }), this.setState(In);
    }
  }
  render() {
    const {
      children: o,
      fallbackRender: n,
      FallbackComponent: e,
      fallback: r
    } = this.props, {
      didCatch: i,
      error: l
    } = this.state;
    let s = o;
    if (i) {
      const a = {
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        s = n(a);
      else if (e)
        s = uo(e, a);
      else if (r !== void 0)
        s = r;
      else
        throw l;
    }
    return uo($h.Provider, {
      value: {
        didCatch: i,
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function Gh() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== o.length || t.some((n, e) => !Object.is(n, o[e]));
}
const Sf = ({
  pageIdentificationValue: t,
  onHandleClick: o,
  categoryNo: n,
  isLogin: e,
  data: r,
  onHandleAction: i,
  onTouchCancel: l,
  onTouchEnd: s,
  onTouchStart: a,
  style: d,
  componentIdList: u,
  templateId: f,
  componentDataDate: h,
  rdId: p,
  isPreview: g = !1,
  isDataRetry: m = !1,
  ...C
}) => {
  var E;
  const { hosts: w, httpClient: S } = le(), [M, z] = U([]), { data: R } = Zt(
    `displayComponents_${p || t}_${n || ""}`,
    () => it(
      w.hanssemApiGateway,
      S
    ).getTemplateComponents.exec({
      pageIdentificationValue: t,
      categoryNo: n,
      componentIdList: u,
      templateId: f,
      componentDataDate: h,
      isPreview: g,
      rdId: p
    }),
    {
      fallbackData: r,
      revalidateIfStale: m,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1
    }
  ), { data: P } = Zt(
    e ? `scrap_data_${t}_${n || ""}` : null,
    () => it(
      w.hanssemApiGateway,
      S
    ).getScraps.exec(),
    {
      revalidateIfStale: m,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1
    }
  );
  console.log(R), ie(() => {
    P && z(P.data);
  }, [P]);
  const A = Y(
    async (k) => (await it(
      w.hanssemApiGateway,
      S
    ).requestScraps.exec(k)).code,
    [w.hanssemApiGateway, S]
  ), [_, $] = U(0);
  return ie(() => {
    const k = () => {
      $(window.innerWidth);
    };
    return k(), window.addEventListener("resize", k), () => {
      window.removeEventListener("resize", k);
    };
  }, []), !(R != null && R.data) || !((E = R == null ? void 0 : R.data) != null && E.length) ? /* @__PURE__ */ c(ee, {}) : /* @__PURE__ */ c(uu, { onHandleClick: o, children: /* @__PURE__ */ c(Cu, { innerWidth: _, children: /* @__PURE__ */ c(Me, { space: 100, width: "100%", style: { ...d }, children: (R == null ? void 0 : R.data) && (R == null ? void 0 : R.data.map((k) => {
    var L, x;
    const { header: W, body: v, footer: G } = k.attribute, b = k.backGroundColorType !== "FFFFFF";
    try {
      return /* @__PURE__ */ c(
        Vt,
        {
          onError: Dt,
          FallbackComponent: () => /* @__PURE__ */ c(ee, {}),
          children: /* @__PURE__ */ X(
            J,
            {
              width: "100%",
              pt: b ? "40px" : 0,
              pb: b ? "40px" : 0,
              position: "relative",
              children: [
                b && /* @__PURE__ */ c(
                  Dh,
                  {
                    innerWidth: _,
                    backgroundColor: El(k.backGroundColorType)
                  }
                ),
                /* @__PURE__ */ X(Ol, { children: [
                  W.title.isUse && /* @__PURE__ */ c(Mu, { ...W }),
                  ((x = (L = k == null ? void 0 : k.data) == null ? void 0 : L.content) == null ? void 0 : x.length) > 0 ? (() => {
                    var Z, j, y, N;
                    switch (k.componentType) {
                      case "QUICKLINK":
                        return /* @__PURE__ */ c(hu, { item: k, children: /* @__PURE__ */ c(vu, {}) });
                      case "BANNER":
                        return /* @__PURE__ */ c(
                          Vt,
                          {
                            onError: Dt,
                            fallback: /* @__PURE__ */ c(ee, {}),
                            children: /* @__PURE__ */ c(
                              Lu,
                              {
                                type: v.unit,
                                displayType: v.display,
                                dataType: k.dataType,
                                bannerData: (Z = k == null ? void 0 : k.data) == null ? void 0 : Z.content,
                                verticalLineNumber: v.verticalType,
                                horizontalColumnLength: v.horizontalType,
                                scrollDirection: v.scroll,
                                titleType: v.titleType,
                                titleOutBgColor: v.titleOutBgColor,
                                gtm: v.gtm,
                                componentId: k.componentId,
                                isInfinity: v.isInfinity,
                                isChip: v.display === "chip" && k.dataType === "group",
                                chipType: v.chipUnit.chipUnitType,
                                isChipLink: v.chipUnit.isChipLink,
                                isLink: v.bannerLink.isUse,
                                isMainTitle: v.unitElement.isMainTitle,
                                isSubTitle: v.unitElement.isSubTitle,
                                isLogin: e,
                                scrapProductList: M,
                                setScrapProductList: z,
                                toggleScrap: A,
                                onHandleAction: i,
                                onHandleClick: o
                              }
                            )
                          }
                        );
                      case "GOODS":
                        return /* @__PURE__ */ c(
                          Vt,
                          {
                            onError: Dt,
                            FallbackComponent: () => /* @__PURE__ */ c(ee, {}),
                            children: k.componentType === "GOODS" && /* @__PURE__ */ c(
                              zu,
                              {
                                displayType: v.display,
                                productData: (j = k == null ? void 0 : k.data) == null ? void 0 : j.content,
                                groupData: (y = k == null ? void 0 : k.data) == null ? void 0 : y.content,
                                verticalLineNumber: v.verticalType,
                                horizontalColumnLength: v.horizontalType,
                                scrollDirection: v.scroll,
                                bannerType: (N = v == null ? void 0 : v.groupUnit) == null ? void 0 : N.groupUnitType,
                                dataType: k.dataType,
                                groupScroll: v == null ? void 0 : v.groupScroll,
                                unitElement: v.unitElement,
                                gtm: v.gtm,
                                componentId: k.componentId,
                                type: v.unit,
                                isChip: v.display === "chip" && k.dataType === "group",
                                chipType: v.chipUnit.chipUnitType,
                                isChipLink: v.chipUnit.isChipLink,
                                isInfinity: v.isInfinity,
                                scrapProductList: M,
                                setScrapProductList: z,
                                toggleScrap: A,
                                onHandleAction: i,
                                isLogin: e,
                                isPrice: v.unitElement.isPrice
                              }
                            )
                          }
                        );
                      default:
                        return /* @__PURE__ */ c(
                          Vt,
                          {
                            onError: Dt,
                            fallback: /* @__PURE__ */ c(ee, {}),
                            children: /* @__PURE__ */ c(
                              wu,
                              {
                                displayData: k.data.content,
                                contentsDataType: v.contentsData.contentsDataType,
                                displayType: v.display,
                                horizontalColumnLength: v.horizontalType,
                                verticalLineNumber: v.verticalType,
                                unitDirection: v.unit === "normal" ? "vertical" : "horizontal",
                                scrollDirection: v.scroll,
                                dataType: k.dataType,
                                unitElement: v.unitElement,
                                onHandleClick: o,
                                isChip: v.display === "chip" && k.dataType === "group",
                                scrapContentList: M,
                                setScrapContentList: z,
                                onHandleAction: i,
                                isLogin: e,
                                toggleScrap: A,
                                unitType: v.unit,
                                ratio: v.thumbnail,
                                gtm: v.gtm,
                                componentId: k.componentId,
                                chipType: v.chipUnit.chipUnitType,
                                isChipLink: v.chipUnit.isChipLink,
                                isInfinity: v.isInfinity
                              }
                            )
                          }
                        );
                    }
                  })() : null,
                  /* @__PURE__ */ c(Pu, { ...G })
                ] })
              ]
            }
          )
        },
        `${k.componentName}-${k.componentId}`
      );
    } catch (Z) {
      const j = Z.message;
      return console.error(
        `${j} new display service error ${k == null ? void 0 : k.componentId}`
      ), /* @__PURE__ */ c(ee, {});
    }
  })) }) }) });
}, Dh = q(J)`
  position: absolute;
  width: ${({ innerWidth: t }) => t}px;
  min-width: ${is}px;
  height: 100%;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  background-color: #${({ backgroundColor: t }) => t};
  z-index: -1;
`, sn = ({
  itemCount: t,
  columnCount: o,
  space: n,
  colSpace: e,
  rowSpace: r,
  children: i
}) => /* @__PURE__ */ c(
  Ah,
  {
    itemCount: t,
    columnCount: o,
    space: n,
    colSpace: e,
    rowSpace: r,
    children: i
  }
), Ah = q(J)`
  display: grid;
  ${({ itemCount: t, columnCount: o, space: n = 0, colSpace: e = 0, rowSpace: r = 0 }) => {
  const i = t < o ? t : o, s = `calc(${`calc(100% - ${(n || e) * (o - 1)}px)`} / ${o})`, a = `${(n || e) * (t - 1)}px`, d = `calc(${s} * ${t} + ${a})`;
  return `
      grid-template-columns: repeat(${i}, 1fr);
      column-gap: ${n || e}px;
      row-gap: ${n || r}px;
      width: ${t < o ? d : "100%"};
    `;
}}
`;
export {
  yo as BASE_Z_INDEX,
  Lu as Banner,
  os as CHIP_X_GAP,
  rs as CHIP_Y_GAP,
  is as CONTAINER_MIN_WIDTH,
  Tr as CONTENT_SPACE,
  Zl as CSS,
  Ve as Card,
  Nl as ClientGatewayRefineTemplateComponents,
  $l as ClientGatewayTemplateInfiniteComponents,
  Gl as ClientGetScraps,
  Dl as ClientRequestScraps,
  wu as Content,
  uf as CustomScroll,
  ff as DRAWER_Z_INDEX,
  nf as DisplayComponentProvider,
  Jl as FlagSquare,
  Pu as Footer,
  Ye as GROUP_PRODUCT_SPACE,
  gf as GnbTemplate,
  $t as GridInfiniteScroller,
  hf as HEADER_Z_INDEX,
  Mu as Header,
  Ol as HorizontalPercentProvider,
  yf as HorizontalScroll,
  ot as IMAGE_SIZE,
  Ih as IfSkeleton,
  vf as InformedTemplate,
  mf as ListInfiniteScroller,
  An as LoadImage,
  ts as MAX_Z_INDEX,
  pf as MainPopupContent,
  Fn as NO_SWIPE_AREA,
  Sf as NewDisplayService,
  Gt as NewDisplaySlideBox,
  Eh as NewDisplaySlideList,
  Bu as NewGridInfiniteScroller,
  ns as POPUP_Z_INDEX,
  qt as PRODUCT_SPACE,
  ui as Pagination,
  zu as Product,
  Pn as QUICK_LINK_SPACE,
  vu as QuickLink,
  wc as RemodelingAutoBestGoodsList,
  _c as RemodelingAutoBestTagMaterialGoodsList,
  Oc as RemodelingAutoGoodsList,
  $c as RemodelingAutoLineupGoodsList,
  Ac as RemodelingAutoMaterialCateGoodsList,
  Hc as RemodelingAutoMaterialGoodsList,
  Bc as RemodelingAutoNewGoodsList,
  Vc as RemodelingAutoNewTagMaterialGoodsList,
  Yc as RemodelingAutoPartMidcateGoodsList,
  ld as RemodelingBannerBig,
  sd as RemodelingBannerConsult,
  hd as RemodelingBannerEvent,
  Zc as RemodelingBannerGoodsList,
  fd as RemodelingBannerHomestyle,
  Id as RemodelingBannerRolling,
  Md as RemodelingBannerRollingEvent,
  Pd as RemodelingBannerRollingStart,
  Ed as RemodelingBannerStoreInfoList,
  Wd as RemodelingBannerTrend,
  Ud as RemodelingBannerWhereStart,
  qd as RemodelingGoodsWeekNewArrival,
  Jd as RemodelingImgLineDesc,
  sn as ResponsiveGridContainer,
  du as ReviewDetailAllPopup,
  Al as ServerGatewayTemplateComponents,
  Wl as ServerGatewayTemplateInfiniteComponents,
  Ul as ServerGetScraps,
  Hl as ServerRequestScraps,
  Ne as SlideBox,
  no as SlideList,
  Gu as SwiperList,
  Si as Template,
  Mn as addCommas,
  lf as calculateDaysBetween,
  xr as componentGateway,
  zl as convertNumberPx,
  Bn as displayGateway,
  it as displayServiceGateway,
  sf as displayServiceServerGateway,
  rf as filterStyleProps,
  Pl as formatDateTime,
  mo as formatDateToYYMMDD,
  Dt as handleLogError,
  Ml as parseDateTime,
  Be as removeUndefinedValues,
  of as scrapGateway,
  El as setColor,
  at as tagNameReverse,
  se as theme,
  vo as unitMashup,
  tf as useClipboard,
  Ee as useComponent,
  le as useDisplayComponent,
  cf as useDisplayService,
  df as useDisplayServiceInfinite,
  Vl as useEffectOnce,
  Bl as useGnb,
  wf as useHorizontalPagingScroll,
  zt as useHorizontalPercent,
  yt as useRemodelingGoodsDisplay,
  jn as useRemodelingGoodsMashup,
  jl as useTemplate,
  Fl as useTemplateInfo,
  nn as useUnitMashUp,
  af as useWindowScrollDirection
};
